var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};
var _eventPromises, _asyncListeners, _socketClient, _localMediaHandler, _sfuHandler, _a2, _permissions, _theme, _roomNodeClient, _localMediaHandler2, _meetingViewType, _theme2, _permissions2, _isPinned, _b, _theme3, _permissions3, _socketService, _roomNodeClient2, _localMediaHandler3, _c, _isPinned2, _roomNodeClient3, _self, _eventEmitter2, _listeners2, _roomNodeClient4, _self2, _roomNodeClient5, _self3, _consumerPeerMap, _roomNodeClient6, _self4, _pluginSocketHandler, _roomNodeClient7, _socketServerName, _self5, _participants, _chat, _authToken, _self6, _chatSocketHandler, _roomNodeClient8, _socketServerName2, _roomNodeClient9, _socketServerName3, _d, _pluginSocketHandler2, _roomNodeClient10, _socketServerName4, _chatSocketHandler2, _e, _roomNodeClient11, _self7, _roomNodeClient12, _self8, _roomNodeClient13, _self9, _participants2, _roomNodeClient14, _self10, _participants3, _availableDevices, _f, _localMediaHandler4, _middlewareWebWorker, _localMediaUtils, _g, _url2, _sockrates, _peerId, _generateId, generateId_fn, _self11, _roomNodeClient15, _self12, _self13, _roomNodeClient16, _roomNodeClient17, _self14, _h, _socketService2, _i, _controller;
import log from "loglevel";
import { v4 } from "uuid";
import axios from "axios";
import Bowser from "bowser";
import { io } from "socket.io-client";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { SemanticAttributes } from "@opentelemetry/semantic-conventions";
import opentelemetry, { ROOT_CONTEXT } from "@opentelemetry/api";
import { Resource } from "@opentelemetry/resources";
import { Device } from "@dytesdk/mediasoup-client";
import { MessageType as MessageType$2, PbLong as PbLong$1, typeofJsonValue as typeofJsonValue$1 } from "@protobuf-ts/runtime";
var EventCategory;
(function(EventCategory2) {
  EventCategory2[EventCategory2["MAJOR_EVENT"] = 0] = "MAJOR_EVENT";
  EventCategory2[EventCategory2["MINOR_EVENT"] = 1] = "MINOR_EVENT";
})(EventCategory || (EventCategory = {}));
var Event;
(function(Event2) {
  Event2["PRECALL_TEST_BEGIN"] = "precall_begin";
  Event2["PRECALL_TEST_COMPLETE"] = "precall_end";
  Event2["CALL_JOIN_BEGIN"] = "call_join";
  Event2["NET_QUALITY_TEST_BEGIN"] = "net_quality_test_begin";
  Event2["NET_QUALITY_TEST_END"] = "net_quality_test_end";
  Event2["WEBSOCKET_CONNECTED"] = "websocket_connected";
  Event2["TRANSPORT_CONNECTED"] = "transport_connected";
  Event2["AUDIO_ON"] = "audio_on";
  Event2["AUDIO_OFF"] = "audio_off";
  Event2["VIDEO_ON"] = "video_on";
  Event2["VIDEO_OFF"] = "video_off";
  Event2["PARTICIPANT_ROLE"] = "participant_role";
  Event2["PING_STAT"] = "ping_stat";
  Event2["DISCONNECT"] = "disconnect";
  Event2["RECONNECT_ATTEMPT"] = "reconnect_attempt";
  Event2["SCREENSHARE_START_REQUESTED"] = "screenshare_start_requested";
  Event2["SCREENSHARE_STARTED"] = "screenshare_started";
  Event2["SCREENSHARE_STOPPED"] = "screenshare_stopped";
  Event2["TAB_CHANGE"] = "tab_change";
  Event2["BROWSER_BACKGROUNDED"] = "browser_backgrounded";
  Event2["BROWSER_FOREGROUNDED"] = "browser_foregrounded";
  Event2["DOMINANT_SPEAKER"] = "dominant_speaker";
  Event2["AUDIO_DEVICES_UPDATES"] = "audio_devices_updates";
  Event2["VIDEO_DEVICES_UPDATES"] = "video_devices_updates";
  Event2["SPEAKER_DEVICES_UPDATES"] = "speaker_devices_updates";
  Event2["SELECTED_MICROHPONE_UPDATE"] = "selected_microphone_update";
  Event2["SELECTED_CAMERA_UPDATE"] = "selected_camera_update";
  Event2["SELECTED_SPEAKER_UPDATE"] = "selected_speaker_update";
  Event2["MEDIA_PERMISSION"] = "camera_permission";
  Event2["LEGACY_SWITCH"] = "legacy_switch";
  Event2["AUDIO_PLAY_FAILED"] = "audio_play_failed";
  Event2["VIDEO_PLAY_FAILED"] = "video_play_failed";
  Event2["AUDIO_TRACK_MUTED"] = "audio_track_muted";
  Event2["VIDEO_TRACK_MUTED"] = "video_track_muted";
})(Event || (Event = {}));
var EventCategoryMap = new Map([
  [Event.PRECALL_TEST_BEGIN, EventCategory.MINOR_EVENT],
  [Event.PRECALL_TEST_COMPLETE, EventCategory.MINOR_EVENT],
  [Event.CALL_JOIN_BEGIN, EventCategory.MAJOR_EVENT],
  [Event.NET_QUALITY_TEST_BEGIN, EventCategory.MINOR_EVENT],
  [Event.NET_QUALITY_TEST_END, EventCategory.MINOR_EVENT],
  [Event.WEBSOCKET_CONNECTED, EventCategory.MINOR_EVENT],
  [Event.TRANSPORT_CONNECTED, EventCategory.MAJOR_EVENT],
  [Event.AUDIO_ON, EventCategory.MINOR_EVENT],
  [Event.AUDIO_OFF, EventCategory.MINOR_EVENT],
  [Event.VIDEO_ON, EventCategory.MINOR_EVENT],
  [Event.VIDEO_OFF, EventCategory.MINOR_EVENT],
  [Event.PARTICIPANT_ROLE, EventCategory.MINOR_EVENT],
  [Event.PING_STAT, EventCategory.MAJOR_EVENT],
  [Event.DISCONNECT, EventCategory.MAJOR_EVENT],
  [Event.RECONNECT_ATTEMPT, EventCategory.MAJOR_EVENT],
  [Event.SCREENSHARE_START_REQUESTED, EventCategory.MINOR_EVENT],
  [Event.SCREENSHARE_STARTED, EventCategory.MINOR_EVENT],
  [Event.SCREENSHARE_STOPPED, EventCategory.MINOR_EVENT],
  [Event.TAB_CHANGE, EventCategory.MINOR_EVENT],
  [Event.BROWSER_BACKGROUNDED, EventCategory.MINOR_EVENT],
  [Event.BROWSER_FOREGROUNDED, EventCategory.MINOR_EVENT],
  [Event.DOMINANT_SPEAKER, EventCategory.MINOR_EVENT],
  [Event.AUDIO_DEVICES_UPDATES, EventCategory.MINOR_EVENT],
  [Event.VIDEO_DEVICES_UPDATES, EventCategory.MINOR_EVENT],
  [Event.SPEAKER_DEVICES_UPDATES, EventCategory.MINOR_EVENT],
  [Event.SELECTED_MICROHPONE_UPDATE, EventCategory.MINOR_EVENT],
  [Event.SELECTED_CAMERA_UPDATE, EventCategory.MINOR_EVENT],
  [Event.SELECTED_SPEAKER_UPDATE, EventCategory.MINOR_EVENT],
  [Event.MEDIA_PERMISSION, EventCategory.MINOR_EVENT],
  [Event.LEGACY_SWITCH, EventCategory.MINOR_EVENT],
  [Event.AUDIO_PLAY_FAILED, EventCategory.MINOR_EVENT],
  [Event.VIDEO_PLAY_FAILED, EventCategory.MINOR_EVENT],
  [Event.AUDIO_TRACK_MUTED, EventCategory.MINOR_EVENT],
  [Event.VIDEO_TRACK_MUTED, EventCategory.MINOR_EVENT]
]);
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function commonjsRequire(path) {
  throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var events$1 = { exports: {} };
var R$1 = typeof Reflect === "object" ? Reflect : null;
var ReflectApply$1 = R$1 && typeof R$1.apply === "function" ? R$1.apply : function ReflectApply(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys$1;
if (R$1 && typeof R$1.ownKeys === "function") {
  ReflectOwnKeys$1 = R$1.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys$1 = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys$1 = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning$1(warning) {
  if (console && console.warn)
    console.warn(warning);
}
var NumberIsNaN$1 = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};
function EventEmitter$2() {
  EventEmitter$2.init.call(this);
}
events$1.exports = EventEmitter$2;
events$1.exports.once = once2;
EventEmitter$2.EventEmitter = EventEmitter$2;
EventEmitter$2.prototype._events = void 0;
EventEmitter$2.prototype._eventsCount = 0;
EventEmitter$2.prototype._maxListeners = void 0;
var defaultMaxListeners$1 = 10;
function checkListener$1(listener) {
  if (typeof listener !== "function") {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}
Object.defineProperty(EventEmitter$2, "defaultMaxListeners", {
  enumerable: true,
  get: function() {
    return defaultMaxListeners$1;
  },
  set: function(arg) {
    if (typeof arg !== "number" || arg < 0 || NumberIsNaN$1(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
    }
    defaultMaxListeners$1 = arg;
  }
});
EventEmitter$2.init = function() {
  if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter$2.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== "number" || n < 0 || NumberIsNaN$1(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
  }
  this._maxListeners = n;
  return this;
};
function _getMaxListeners$1(that) {
  if (that._maxListeners === void 0)
    return EventEmitter$2.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter$2.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners$1(this);
};
EventEmitter$2.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++)
    args.push(arguments[i]);
  var doError = type === "error";
  var events2 = this._events;
  if (events2 !== void 0)
    doError = doError && events2.error === void 0;
  else if (!doError)
    return false;
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      throw er;
    }
    var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
    err.context = er;
    throw err;
  }
  var handler = events2[type];
  if (handler === void 0)
    return false;
  if (typeof handler === "function") {
    ReflectApply$1(handler, this, args);
  } else {
    var len = handler.length;
    var listeners3 = arrayClone$1(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply$1(listeners3[i], this, args);
  }
  return true;
};
function _addListener$1(target, type, listener, prepend) {
  var m;
  var events2;
  var existing;
  checkListener$1(listener);
  events2 = target._events;
  if (events2 === void 0) {
    events2 = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    if (events2.newListener !== void 0) {
      target.emit("newListener", type, listener.listener ? listener.listener : listener);
      events2 = target._events;
    }
    existing = events2[type];
  }
  if (existing === void 0) {
    existing = events2[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events2[type] = prepend ? [listener, existing] : [existing, listener];
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }
    m = _getMaxListeners$1(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      w.name = "MaxListenersExceededWarning";
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning$1(w);
    }
  }
  return target;
}
EventEmitter$2.prototype.addListener = function addListener(type, listener) {
  return _addListener$1(this, type, listener, false);
};
EventEmitter$2.prototype.on = EventEmitter$2.prototype.addListener;
EventEmitter$2.prototype.prependListener = function prependListener(type, listener) {
  return _addListener$1(this, type, listener, true);
};
function onceWrapper$1() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap$1(target, type, listener) {
  var state = { fired: false, wrapFn: void 0, target, type, listener };
  var wrapped = onceWrapper$1.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter$2.prototype.once = function once(type, listener) {
  checkListener$1(listener);
  this.on(type, _onceWrap$1(this, type, listener));
  return this;
};
EventEmitter$2.prototype.prependOnceListener = function prependOnceListener(type, listener) {
  checkListener$1(listener);
  this.prependListener(type, _onceWrap$1(this, type, listener));
  return this;
};
EventEmitter$2.prototype.removeListener = function removeListener(type, listener) {
  var list, events2, position, i, originalListener;
  checkListener$1(listener);
  events2 = this._events;
  if (events2 === void 0)
    return this;
  list = events2[type];
  if (list === void 0)
    return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = Object.create(null);
    else {
      delete events2[type];
      if (events2.removeListener)
        this.emit("removeListener", type, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0)
      return this;
    if (position === 0)
      list.shift();
    else {
      spliceOne$1(list, position);
    }
    if (list.length === 1)
      events2[type] = list[0];
    if (events2.removeListener !== void 0)
      this.emit("removeListener", type, originalListener || listener);
  }
  return this;
};
EventEmitter$2.prototype.off = EventEmitter$2.prototype.removeListener;
EventEmitter$2.prototype.removeAllListeners = function removeAllListeners(type) {
  var listeners3, events2, i;
  events2 = this._events;
  if (events2 === void 0)
    return this;
  if (events2.removeListener === void 0) {
    if (arguments.length === 0) {
      this._events = Object.create(null);
      this._eventsCount = 0;
    } else if (events2[type] !== void 0) {
      if (--this._eventsCount === 0)
        this._events = Object.create(null);
      else
        delete events2[type];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys = Object.keys(events2);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners3 = events2[type];
  if (typeof listeners3 === "function") {
    this.removeListener(type, listeners3);
  } else if (listeners3 !== void 0) {
    for (i = listeners3.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners3[i]);
    }
  }
  return this;
};
function _listeners$1(target, type, unwrap) {
  var events2 = target._events;
  if (events2 === void 0)
    return [];
  var evlistener = events2[type];
  if (evlistener === void 0)
    return [];
  if (typeof evlistener === "function")
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners$1(evlistener) : arrayClone$1(evlistener, evlistener.length);
}
EventEmitter$2.prototype.listeners = function listeners(type) {
  return _listeners$1(this, type, true);
};
EventEmitter$2.prototype.rawListeners = function rawListeners(type) {
  return _listeners$1(this, type, false);
};
EventEmitter$2.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type);
  } else {
    return listenerCount$1.call(emitter, type);
  }
};
EventEmitter$2.prototype.listenerCount = listenerCount$1;
function listenerCount$1(type) {
  var events2 = this._events;
  if (events2 !== void 0) {
    var evlistener = events2[type];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener !== void 0) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter$2.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys$1(this._events) : [];
};
function arrayClone$1(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}
function spliceOne$1(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}
function unwrapListeners$1(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function once2(emitter, name) {
  return new Promise(function(resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === "function") {
        emitter.removeListener("error", errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener$1(emitter, name, resolver, { once: true });
    if (name !== "error") {
      addErrorHandlerIfEventEmitter$1(emitter, errorListener, { once: true });
    }
  });
}
function addErrorHandlerIfEventEmitter$1(emitter, handler, flags) {
  if (typeof emitter.on === "function") {
    eventTargetAgnosticAddListener$1(emitter, "error", handler, flags);
  }
}
function eventTargetAgnosticAddListener$1(emitter, name, listener, flags) {
  if (typeof emitter.on === "function") {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === "function") {
    emitter.addEventListener(name, function wrapListener(arg) {
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
var EventEmitter$3 = events$1.exports;
var __extends$a = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var EventStore = function() {
  function EventStore2() {
    this.currentChunk = {
      entries: []
    };
    this.flushedChunks = [];
  }
  EventStore2.prototype.add = function(entry) {
    this.currentChunk.entries.push(entry);
  };
  EventStore2.prototype.flush = function() {
    var chunk = this.currentChunk;
    this.currentChunk = {
      entries: []
    };
    this.flushedChunks.push(chunk);
    return chunk;
  };
  return EventStore2;
}();
var EventHandler = function(_super) {
  __extends$a(EventHandler2, _super);
  function EventHandler2(connection) {
    var _this = _super.call(this) || this;
    _this.connection = connection;
    _this.eventStore = new EventStore();
    return _this;
  }
  EventHandler2.prototype.callEvent = function(entry) {
    entry.timestamp = new Date();
    this.eventStore.add(entry);
    this.emit(entry.event, entry.metaData);
    if (EventCategoryMap.get(entry.event) === EventCategory.MAJOR_EVENT) {
      var chunk = this.eventStore.flush();
      this.connection.sendChunk(chunk);
    }
  };
  return EventHandler2;
}(EventEmitter$3);
var BrowserTypes;
(function(BrowserTypes2) {
  BrowserTypes2["CHROMIUM"] = "chromum";
  BrowserTypes2["FIREFOX"] = "firefox";
  BrowserTypes2["SAFARI"] = "safari";
})(BrowserTypes || (BrowserTypes = {}));
var ClientEnvType;
(function(ClientEnvType2) {
  ClientEnvType2["DEV"] = "dev";
  ClientEnvType2["STAGING"] = "staging";
  ClientEnvType2["PRODUCTION"] = "production";
})(ClientEnvType || (ClientEnvType = {}));
var MediaDeviceType;
(function(MediaDeviceType2) {
  MediaDeviceType2["AUDIO"] = "AUDIO";
  MediaDeviceType2["VIDEO"] = "VIDEO";
  MediaDeviceType2["SPEAKER"] = "SPEAKER";
})(MediaDeviceType || (MediaDeviceType = {}));
var PermissionEnum;
(function(PermissionEnum2) {
  PermissionEnum2[PermissionEnum2["INIT"] = 0] = "INIT";
  PermissionEnum2[PermissionEnum2["ACCEPTED"] = 1] = "ACCEPTED";
  PermissionEnum2[PermissionEnum2["DENIED"] = 2] = "DENIED";
  PermissionEnum2[PermissionEnum2["SYS_DENIED"] = 3] = "SYS_DENIED";
  PermissionEnum2[PermissionEnum2["FAILED"] = 4] = "FAILED";
  PermissionEnum2[PermissionEnum2["NOTFOUND"] = 5] = "NOTFOUND";
  PermissionEnum2[PermissionEnum2["NOT_APPLICABLE"] = 6] = "NOT_APPLICABLE";
})(PermissionEnum || (PermissionEnum = {}));
var __extends$9 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var Connector = function() {
  function Connector2() {
  }
  Connector2.prototype.authenticate = function(data) {
    this.authInfo = data;
  };
  return Connector2;
}();
var QueuedConnector = function(_super) {
  __extends$9(QueuedConnector2, _super);
  function QueuedConnector2(flushInterval) {
    if (flushInterval === void 0) {
      flushInterval = 5e3;
    }
    var _this = _super.call(this) || this;
    _this.chunkQueue = {
      entries: []
    };
    _this.flushInterval = flushInterval;
    return _this;
  }
  QueuedConnector2.prototype.sendChunk = function(data) {
    this.sendChunkToServer(data);
  };
  return QueuedConnector2;
}(Connector);
var __extends$8 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$8 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$7 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var PubSubConnector = function(_super) {
  __extends$8(PubSubConnector2, _super);
  function PubSubConnector2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PubSubConnector2.prototype.sendChunk = function(data) {
    _super.prototype.sendChunk.call(this, data);
  };
  PubSubConnector2.prototype.sendChunkToServer = function(data) {
    return __awaiter$8(this, void 0, void 0, function() {
      return __generator$7(this, function(_a3) {
        return [2, false];
      });
    });
  };
  return PubSubConnector2;
}(QueuedConnector);
var querystring = {};
var buffer = {};
var base64Js = {};
base64Js.byteLength = byteLength;
base64Js.toByteArray = toByteArray;
base64Js.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i];
  revLookup[code.charCodeAt(i)] = i;
}
revLookup["-".charCodeAt(0)] = 62;
revLookup["_".charCodeAt(0)] = 63;
function getLens(b64) {
  var len = b64.length;
  if (len % 4 > 0) {
    throw new Error("Invalid string. Length must be a multiple of 4");
  }
  var validLen = b64.indexOf("=");
  if (validLen === -1)
    validLen = len;
  var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
  return [validLen, placeHoldersLen];
}
function byteLength(b64) {
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
  return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
  var tmp;
  var lens = getLens(b64);
  var validLen = lens[0];
  var placeHoldersLen = lens[1];
  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
  var curByte = 0;
  var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
  var i;
  for (i = 0; i < len; i += 4) {
    tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
    arr[curByte++] = tmp >> 16 & 255;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 2) {
    tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
    arr[curByte++] = tmp & 255;
  }
  if (placeHoldersLen === 1) {
    tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
    arr[curByte++] = tmp >> 8 & 255;
    arr[curByte++] = tmp & 255;
  }
  return arr;
}
function tripletToBase64(num) {
  return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
}
function encodeChunk(uint8, start, end) {
  var tmp;
  var output = [];
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16 & 16711680) + (uint8[i + 1] << 8 & 65280) + (uint8[i + 2] & 255);
    output.push(tripletToBase64(tmp));
  }
  return output.join("");
}
function fromByteArray(uint8) {
  var tmp;
  var len = uint8.length;
  var extraBytes = len % 3;
  var parts = [];
  var maxChunkLength = 16383;
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
  }
  if (extraBytes === 1) {
    tmp = uint8[len - 1];
    parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "==");
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1];
    parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "=");
  }
  return parts.join("");
}
var ieee754 = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
ieee754.read = function(buffer2, offset, isLE, mLen, nBytes) {
  var e, m;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = -7;
  var i = isLE ? nBytes - 1 : 0;
  var d = isLE ? -1 : 1;
  var s = buffer2[offset + i];
  i += d;
  e = s & (1 << -nBits) - 1;
  s >>= -nBits;
  nBits += eLen;
  for (; nBits > 0; e = e * 256 + buffer2[offset + i], i += d, nBits -= 8) {
  }
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer2[offset + i], i += d, nBits -= 8) {
  }
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : (s ? -1 : 1) * Infinity;
  } else {
    m = m + Math.pow(2, mLen);
    e = e - eBias;
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
ieee754.write = function(buffer2, value, offset, isLE, mLen, nBytes) {
  var e, m, c;
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
  var i = isLE ? 0 : nBytes - 1;
  var d = isLE ? 1 : -1;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  value = Math.abs(value);
  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0;
    e = eMax;
  } else {
    e = Math.floor(Math.log(value) / Math.LN2);
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * Math.pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer2[offset + i] = m & 255, i += d, m /= 256, mLen -= 8) {
  }
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer2[offset + i] = e & 255, i += d, e /= 256, eLen -= 8) {
  }
  buffer2[offset + i - d] |= s * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(exports) {
  const base64 = base64Js;
  const ieee754$1 = ieee754;
  const customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
  exports.Buffer = Buffer2;
  exports.SlowBuffer = SlowBuffer;
  exports.INSPECT_MAX_BYTES = 50;
  const K_MAX_LENGTH = 2147483647;
  exports.kMaxLength = K_MAX_LENGTH;
  Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
  if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
    console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
  }
  function typedArraySupport() {
    try {
      const arr = new Uint8Array(1);
      const proto = { foo: function() {
        return 42;
      } };
      Object.setPrototypeOf(proto, Uint8Array.prototype);
      Object.setPrototypeOf(arr, proto);
      return arr.foo() === 42;
    } catch (e) {
      return false;
    }
  }
  Object.defineProperty(Buffer2.prototype, "parent", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.buffer;
    }
  });
  Object.defineProperty(Buffer2.prototype, "offset", {
    enumerable: true,
    get: function() {
      if (!Buffer2.isBuffer(this))
        return void 0;
      return this.byteOffset;
    }
  });
  function createBuffer(length) {
    if (length > K_MAX_LENGTH) {
      throw new RangeError('The value "' + length + '" is invalid for option "size"');
    }
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function Buffer2(arg, encodingOrOffset, length) {
    if (typeof arg === "number") {
      if (typeof encodingOrOffset === "string") {
        throw new TypeError('The "string" argument must be of type string. Received type number');
      }
      return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
  }
  Buffer2.poolSize = 8192;
  function from(value, encodingOrOffset, length) {
    if (typeof value === "string") {
      return fromString(value, encodingOrOffset);
    }
    if (ArrayBuffer.isView(value)) {
      return fromArrayView(value);
    }
    if (value == null) {
      throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) {
      return fromArrayBuffer(value, encodingOrOffset, length);
    }
    if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) {
      return fromArrayBuffer(value, encodingOrOffset, length);
    }
    if (typeof value === "number") {
      throw new TypeError('The "value" argument must not be of type number. Received type number');
    }
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) {
      return Buffer2.from(valueOf, encodingOrOffset, length);
    }
    const b = fromObject(value);
    if (b)
      return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") {
      return Buffer2.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    }
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
  }
  Buffer2.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
  };
  Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
  Object.setPrototypeOf(Buffer2, Uint8Array);
  function assertSize(size) {
    if (typeof size !== "number") {
      throw new TypeError('"size" argument must be of type number');
    } else if (size < 0) {
      throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
  }
  function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) {
      return createBuffer(size);
    }
    if (fill !== void 0) {
      return typeof encoding === "string" ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    }
    return createBuffer(size);
  }
  Buffer2.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
  };
  function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
  }
  Buffer2.allocUnsafe = function(size) {
    return allocUnsafe(size);
  };
  Buffer2.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
  };
  function fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") {
      encoding = "utf8";
    }
    if (!Buffer2.isEncoding(encoding)) {
      throw new TypeError("Unknown encoding: " + encoding);
    }
    const length = byteLength2(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) {
      buf = buf.slice(0, actual);
    }
    return buf;
  }
  function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for (let i = 0; i < length; i += 1) {
      buf[i] = array[i] & 255;
    }
    return buf;
  }
  function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
      const copy = new Uint8Array(arrayView);
      return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
  }
  function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) {
      throw new RangeError('"offset" is outside of buffer bounds');
    }
    if (array.byteLength < byteOffset + (length || 0)) {
      throw new RangeError('"length" is outside of buffer bounds');
    }
    let buf;
    if (byteOffset === void 0 && length === void 0) {
      buf = new Uint8Array(array);
    } else if (length === void 0) {
      buf = new Uint8Array(array, byteOffset);
    } else {
      buf = new Uint8Array(array, byteOffset, length);
    }
    Object.setPrototypeOf(buf, Buffer2.prototype);
    return buf;
  }
  function fromObject(obj) {
    if (Buffer2.isBuffer(obj)) {
      const len = checked(obj.length) | 0;
      const buf = createBuffer(len);
      if (buf.length === 0) {
        return buf;
      }
      obj.copy(buf, 0, 0, len);
      return buf;
    }
    if (obj.length !== void 0) {
      if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
        return createBuffer(0);
      }
      return fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) {
      return fromArrayLike(obj.data);
    }
  }
  function checked(length) {
    if (length >= K_MAX_LENGTH) {
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
    }
    return length | 0;
  }
  function SlowBuffer(length) {
    if (+length != length) {
      length = 0;
    }
    return Buffer2.alloc(+length);
  }
  Buffer2.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer2.prototype;
  };
  Buffer2.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array))
      a = Buffer2.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array))
      b = Buffer2.from(b, b.offset, b.byteLength);
    if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
      throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    }
    if (a === b)
      return 0;
    let x = a.length;
    let y = b.length;
    for (let i = 0, len = Math.min(x, y); i < len; ++i) {
      if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
      }
    }
    if (x < y)
      return -1;
    if (y < x)
      return 1;
    return 0;
  };
  Buffer2.isEncoding = function isEncoding(encoding) {
    switch (String(encoding).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return true;
      default:
        return false;
    }
  };
  Buffer2.concat = function concat(list, length) {
    if (!Array.isArray(list)) {
      throw new TypeError('"list" argument must be an Array of Buffers');
    }
    if (list.length === 0) {
      return Buffer2.alloc(0);
    }
    let i;
    if (length === void 0) {
      length = 0;
      for (i = 0; i < list.length; ++i) {
        length += list[i].length;
      }
    }
    const buffer2 = Buffer2.allocUnsafe(length);
    let pos = 0;
    for (i = 0; i < list.length; ++i) {
      let buf = list[i];
      if (isInstance(buf, Uint8Array)) {
        if (pos + buf.length > buffer2.length) {
          if (!Buffer2.isBuffer(buf))
            buf = Buffer2.from(buf);
          buf.copy(buffer2, pos);
        } else {
          Uint8Array.prototype.set.call(buffer2, buf, pos);
        }
      } else if (!Buffer2.isBuffer(buf)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      } else {
        buf.copy(buffer2, pos);
      }
      pos += buf.length;
    }
    return buffer2;
  };
  function byteLength2(string, encoding) {
    if (Buffer2.isBuffer(string)) {
      return string.length;
    }
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
      return string.byteLength;
    }
    if (typeof string !== "string") {
      throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    }
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0)
      return 0;
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "ascii":
        case "latin1":
        case "binary":
          return len;
        case "utf8":
        case "utf-8":
          return utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return len * 2;
        case "hex":
          return len >>> 1;
        case "base64":
          return base64ToBytes(string).length;
        default:
          if (loweredCase) {
            return mustMatch ? -1 : utf8ToBytes(string).length;
          }
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.byteLength = byteLength2;
  function slowToString(encoding, start, end) {
    let loweredCase = false;
    if (start === void 0 || start < 0) {
      start = 0;
    }
    if (start > this.length) {
      return "";
    }
    if (end === void 0 || end > this.length) {
      end = this.length;
    }
    if (end <= 0) {
      return "";
    }
    end >>>= 0;
    start >>>= 0;
    if (end <= start) {
      return "";
    }
    if (!encoding)
      encoding = "utf8";
    while (true) {
      switch (encoding) {
        case "hex":
          return hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
          return utf8Slice(this, start, end);
        case "ascii":
          return asciiSlice(this, start, end);
        case "latin1":
        case "binary":
          return latin1Slice(this, start, end);
        case "base64":
          return base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return utf16leSlice(this, start, end);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = (encoding + "").toLowerCase();
          loweredCase = true;
      }
    }
  }
  Buffer2.prototype._isBuffer = true;
  function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
  }
  Buffer2.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    }
    for (let i = 0; i < len; i += 2) {
      swap(this, i, i + 1);
    }
    return this;
  };
  Buffer2.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    }
    for (let i = 0; i < len; i += 4) {
      swap(this, i, i + 3);
      swap(this, i + 1, i + 2);
    }
    return this;
  };
  Buffer2.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) {
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    }
    for (let i = 0; i < len; i += 8) {
      swap(this, i, i + 7);
      swap(this, i + 1, i + 6);
      swap(this, i + 2, i + 5);
      swap(this, i + 3, i + 4);
    }
    return this;
  };
  Buffer2.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0)
      return "";
    if (arguments.length === 0)
      return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
  };
  Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
  Buffer2.prototype.equals = function equals(b) {
    if (!Buffer2.isBuffer(b))
      throw new TypeError("Argument must be a Buffer");
    if (this === b)
      return true;
    return Buffer2.compare(this, b) === 0;
  };
  Buffer2.prototype.inspect = function inspect() {
    let str = "";
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max)
      str += " ... ";
    return "<Buffer " + str + ">";
  };
  if (customInspectSymbol) {
    Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
  }
  Buffer2.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) {
      target = Buffer2.from(target, target.offset, target.byteLength);
    }
    if (!Buffer2.isBuffer(target)) {
      throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    }
    if (start === void 0) {
      start = 0;
    }
    if (end === void 0) {
      end = target ? target.length : 0;
    }
    if (thisStart === void 0) {
      thisStart = 0;
    }
    if (thisEnd === void 0) {
      thisEnd = this.length;
    }
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
      throw new RangeError("out of range index");
    }
    if (thisStart >= thisEnd && start >= end) {
      return 0;
    }
    if (thisStart >= thisEnd) {
      return -1;
    }
    if (start >= end) {
      return 1;
    }
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target)
      return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for (let i = 0; i < len; ++i) {
      if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
      }
    }
    if (x < y)
      return -1;
    if (y < x)
      return 1;
    return 0;
  };
  function bidirectionalIndexOf(buffer2, val, byteOffset, encoding, dir) {
    if (buffer2.length === 0)
      return -1;
    if (typeof byteOffset === "string") {
      encoding = byteOffset;
      byteOffset = 0;
    } else if (byteOffset > 2147483647) {
      byteOffset = 2147483647;
    } else if (byteOffset < -2147483648) {
      byteOffset = -2147483648;
    }
    byteOffset = +byteOffset;
    if (numberIsNaN(byteOffset)) {
      byteOffset = dir ? 0 : buffer2.length - 1;
    }
    if (byteOffset < 0)
      byteOffset = buffer2.length + byteOffset;
    if (byteOffset >= buffer2.length) {
      if (dir)
        return -1;
      else
        byteOffset = buffer2.length - 1;
    } else if (byteOffset < 0) {
      if (dir)
        byteOffset = 0;
      else
        return -1;
    }
    if (typeof val === "string") {
      val = Buffer2.from(val, encoding);
    }
    if (Buffer2.isBuffer(val)) {
      if (val.length === 0) {
        return -1;
      }
      return arrayIndexOf(buffer2, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
      val = val & 255;
      if (typeof Uint8Array.prototype.indexOf === "function") {
        if (dir) {
          return Uint8Array.prototype.indexOf.call(buffer2, val, byteOffset);
        } else {
          return Uint8Array.prototype.lastIndexOf.call(buffer2, val, byteOffset);
        }
      }
      return arrayIndexOf(buffer2, [val], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
  }
  function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== void 0) {
      encoding = String(encoding).toLowerCase();
      if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
        if (arr.length < 2 || val.length < 2) {
          return -1;
        }
        indexSize = 2;
        arrLength /= 2;
        valLength /= 2;
        byteOffset /= 2;
      }
    }
    function read(buf, i2) {
      if (indexSize === 1) {
        return buf[i2];
      } else {
        return buf.readUInt16BE(i2 * indexSize);
      }
    }
    let i;
    if (dir) {
      let foundIndex = -1;
      for (i = byteOffset; i < arrLength; i++) {
        if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
          if (foundIndex === -1)
            foundIndex = i;
          if (i - foundIndex + 1 === valLength)
            return foundIndex * indexSize;
        } else {
          if (foundIndex !== -1)
            i -= i - foundIndex;
          foundIndex = -1;
        }
      }
    } else {
      if (byteOffset + valLength > arrLength)
        byteOffset = arrLength - valLength;
      for (i = byteOffset; i >= 0; i--) {
        let found = true;
        for (let j = 0; j < valLength; j++) {
          if (read(arr, i + j) !== read(val, j)) {
            found = false;
            break;
          }
        }
        if (found)
          return i;
      }
    }
    return -1;
  }
  Buffer2.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
  };
  Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
  };
  Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
  };
  function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) {
      length = remaining;
    } else {
      length = Number(length);
      if (length > remaining) {
        length = remaining;
      }
    }
    const strLen = string.length;
    if (length > strLen / 2) {
      length = strLen / 2;
    }
    let i;
    for (i = 0; i < length; ++i) {
      const parsed = parseInt(string.substr(i * 2, 2), 16);
      if (numberIsNaN(parsed))
        return i;
      buf[offset + i] = parsed;
    }
    return i;
  }
  function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
  }
  function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
  }
  function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
  }
  function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
  }
  Buffer2.prototype.write = function write(string, offset, length, encoding) {
    if (offset === void 0) {
      encoding = "utf8";
      length = this.length;
      offset = 0;
    } else if (length === void 0 && typeof offset === "string") {
      encoding = offset;
      length = this.length;
      offset = 0;
    } else if (isFinite(offset)) {
      offset = offset >>> 0;
      if (isFinite(length)) {
        length = length >>> 0;
        if (encoding === void 0)
          encoding = "utf8";
      } else {
        encoding = length;
        length = void 0;
      }
    } else {
      throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    }
    const remaining = this.length - offset;
    if (length === void 0 || length > remaining)
      length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) {
      throw new RangeError("Attempt to write outside buffer bounds");
    }
    if (!encoding)
      encoding = "utf8";
    let loweredCase = false;
    for (; ; ) {
      switch (encoding) {
        case "hex":
          return hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
          return utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
          return asciiWrite(this, string, offset, length);
        case "base64":
          return base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ucs2Write(this, string, offset, length);
        default:
          if (loweredCase)
            throw new TypeError("Unknown encoding: " + encoding);
          encoding = ("" + encoding).toLowerCase();
          loweredCase = true;
      }
    }
  };
  Buffer2.prototype.toJSON = function toJSON() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) {
      return base64.fromByteArray(buf);
    } else {
      return base64.fromByteArray(buf.slice(start, end));
    }
  }
  function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while (i < end) {
      const firstByte = buf[i];
      let codePoint = null;
      let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
      if (i + bytesPerSequence <= end) {
        let secondByte, thirdByte, fourthByte, tempCodePoint;
        switch (bytesPerSequence) {
          case 1:
            if (firstByte < 128) {
              codePoint = firstByte;
            }
            break;
          case 2:
            secondByte = buf[i + 1];
            if ((secondByte & 192) === 128) {
              tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
              if (tempCodePoint > 127) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 3:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
              if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                codePoint = tempCodePoint;
              }
            }
            break;
          case 4:
            secondByte = buf[i + 1];
            thirdByte = buf[i + 2];
            fourthByte = buf[i + 3];
            if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
              tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
              if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                codePoint = tempCodePoint;
              }
            }
        }
      }
      if (codePoint === null) {
        codePoint = 65533;
        bytesPerSequence = 1;
      } else if (codePoint > 65535) {
        codePoint -= 65536;
        res.push(codePoint >>> 10 & 1023 | 55296);
        codePoint = 56320 | codePoint & 1023;
      }
      res.push(codePoint);
      i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
  }
  const MAX_ARGUMENTS_LENGTH = 4096;
  function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) {
      return String.fromCharCode.apply(String, codePoints);
    }
    let res = "";
    let i = 0;
    while (i < len) {
      res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    }
    return res;
  }
  function asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for (let i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i] & 127);
    }
    return ret;
  }
  function latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for (let i = start; i < end; ++i) {
      ret += String.fromCharCode(buf[i]);
    }
    return ret;
  }
  function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0)
      start = 0;
    if (!end || end < 0 || end > len)
      end = len;
    let out = "";
    for (let i = start; i < end; ++i) {
      out += hexSliceLookupTable[buf[i]];
    }
    return out;
  }
  function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    for (let i = 0; i < bytes.length - 1; i += 2) {
      res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    }
    return res;
  }
  Buffer2.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === void 0 ? len : ~~end;
    if (start < 0) {
      start += len;
      if (start < 0)
        start = 0;
    } else if (start > len) {
      start = len;
    }
    if (end < 0) {
      end += len;
      if (end < 0)
        end = 0;
    } else if (end > len) {
      end = len;
    }
    if (end < start)
      end = start;
    const newBuf = this.subarray(start, end);
    Object.setPrototypeOf(newBuf, Buffer2.prototype);
    return newBuf;
  };
  function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0)
      throw new RangeError("offset is not uint");
    if (offset + ext > length)
      throw new RangeError("Trying to access beyond buffer length");
  }
  Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while (++i < byteLength3 && (mul *= 256)) {
      val += this[offset + i] * mul;
    }
    return val;
  };
  Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      checkOffset(offset, byteLength3, this.length);
    }
    let val = this[offset + --byteLength3];
    let mul = 1;
    while (byteLength3 > 0 && (mul *= 256)) {
      val += this[offset + --byteLength3] * mul;
    }
    return val;
  };
  Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    return this[offset];
  };
  Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
  };
  Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
  };
  Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 16777216;
  };
  Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] * 16777216 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
  };
  Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const lo = first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
  });
  Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
  });
  Buffer2.prototype.readIntLE = function readIntLE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while (++i < byteLength3 && (mul *= 256)) {
      val += this[offset + i] * mul;
    }
    mul *= 128;
    if (val >= mul)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readIntBE = function readIntBE(offset, byteLength3, noAssert) {
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert)
      checkOffset(offset, byteLength3, this.length);
    let i = byteLength3;
    let mul = 1;
    let val = this[offset + --i];
    while (i > 0 && (mul *= 256)) {
      val += this[offset + --i] * mul;
    }
    mul *= 128;
    if (val >= mul)
      val -= Math.pow(2, 8 * byteLength3);
    return val;
  };
  Buffer2.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 1, this.length);
    if (!(this[offset] & 128))
      return this[offset];
    return (255 - this[offset] + 1) * -1;
  };
  Buffer2.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 32768 ? val | 4294901760 : val;
  };
  Buffer2.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
  };
  Buffer2.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
  };
  Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const val = this[offset + 4] + this[offset + 5] * 2 ** 8 + this[offset + 6] * 2 ** 16 + (last << 24);
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 2 ** 8 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
  });
  Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === void 0 || last === void 0) {
      boundsError(offset, this.length - 8);
    }
    const val = (first << 24) + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 8 + last);
  });
  Buffer2.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, true, 23, 4);
  };
  Buffer2.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 4, this.length);
    return ieee754$1.read(this, offset, false, 23, 4);
  };
  Buffer2.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, true, 52, 8);
  };
  Buffer2.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert)
      checkOffset(offset, 8, this.length);
    return ieee754$1.read(this, offset, false, 52, 8);
  };
  function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer2.isBuffer(buf))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min)
      throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
  }
  Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 255;
    while (++i < byteLength3 && (mul *= 256)) {
      this[offset + i] = value / mul & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength3 = byteLength3 >>> 0;
    if (!noAssert) {
      const maxBytes = Math.pow(2, 8 * byteLength3) - 1;
      checkInt(this, value, offset, byteLength3, maxBytes, 0);
    }
    let i = byteLength3 - 1;
    let mul = 1;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul *= 256)) {
      this[offset + i] = value / mul & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 255, 0);
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 65535, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 4294967295, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(4294967295));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
  }
  function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(4294967295));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(4294967295));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
  }
  Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
  });
  Buffer2.prototype.writeIntLE = function writeIntLE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      const limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 255;
    while (++i < byteLength3 && (mul *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeIntBE = function writeIntBE(value, offset, byteLength3, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      const limit = Math.pow(2, 8 * byteLength3 - 1);
      checkInt(this, value, offset, byteLength3, limit - 1, -limit);
    }
    let i = byteLength3 - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 255;
    while (--i >= 0 && (mul *= 256)) {
      if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
        sub = 1;
      }
      this[offset + i] = (value / mul >> 0) - sub & 255;
    }
    return offset + byteLength3;
  };
  Buffer2.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 1, 127, -128);
    if (value < 0)
      value = 255 + value + 1;
    this[offset] = value & 255;
    return offset + 1;
  };
  Buffer2.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    return offset + 2;
  };
  Buffer2.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 2, 32767, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 255;
    return offset + 2;
  };
  Buffer2.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    this[offset] = value & 255;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
  };
  Buffer2.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert)
      checkInt(this, value, offset, 4, 2147483647, -2147483648);
    if (value < 0)
      value = 4294967295 + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 255;
    return offset + 4;
  };
  Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length)
      throw new RangeError("Index out of range");
    if (offset < 0)
      throw new RangeError("Index out of range");
  }
  function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 4);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
  }
  Buffer2.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
  };
  function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
      checkIEEE754(buf, value, offset, 8);
    }
    ieee754$1.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
  }
  Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
  };
  Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
  };
  Buffer2.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer2.isBuffer(target))
      throw new TypeError("argument should be a Buffer");
    if (!start)
      start = 0;
    if (!end && end !== 0)
      end = this.length;
    if (targetStart >= target.length)
      targetStart = target.length;
    if (!targetStart)
      targetStart = 0;
    if (end > 0 && end < start)
      end = start;
    if (end === start)
      return 0;
    if (target.length === 0 || this.length === 0)
      return 0;
    if (targetStart < 0) {
      throw new RangeError("targetStart out of bounds");
    }
    if (start < 0 || start >= this.length)
      throw new RangeError("Index out of range");
    if (end < 0)
      throw new RangeError("sourceEnd out of bounds");
    if (end > this.length)
      end = this.length;
    if (target.length - targetStart < end - start) {
      end = target.length - targetStart + start;
    }
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") {
      this.copyWithin(targetStart, start, end);
    } else {
      Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    }
    return len;
  };
  Buffer2.prototype.fill = function fill(val, start, end, encoding) {
    if (typeof val === "string") {
      if (typeof start === "string") {
        encoding = start;
        start = 0;
        end = this.length;
      } else if (typeof end === "string") {
        encoding = end;
        end = this.length;
      }
      if (encoding !== void 0 && typeof encoding !== "string") {
        throw new TypeError("encoding must be a string");
      }
      if (typeof encoding === "string" && !Buffer2.isEncoding(encoding)) {
        throw new TypeError("Unknown encoding: " + encoding);
      }
      if (val.length === 1) {
        const code2 = val.charCodeAt(0);
        if (encoding === "utf8" && code2 < 128 || encoding === "latin1") {
          val = code2;
        }
      }
    } else if (typeof val === "number") {
      val = val & 255;
    } else if (typeof val === "boolean") {
      val = Number(val);
    }
    if (start < 0 || this.length < start || this.length < end) {
      throw new RangeError("Out of range index");
    }
    if (end <= start) {
      return this;
    }
    start = start >>> 0;
    end = end === void 0 ? this.length : end >>> 0;
    if (!val)
      val = 0;
    let i;
    if (typeof val === "number") {
      for (i = start; i < end; ++i) {
        this[i] = val;
      }
    } else {
      const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding);
      const len = bytes.length;
      if (len === 0) {
        throw new TypeError('The value "' + val + '" is invalid for argument "value"');
      }
      for (i = 0; i < end - start; ++i) {
        this[i + start] = bytes[i % len];
      }
    }
    return this;
  };
  const errors = {};
  function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
      constructor() {
        super();
        Object.defineProperty(this, "message", {
          value: getMessage.apply(this, arguments),
          writable: true,
          configurable: true
        });
        this.name = `${this.name} [${sym}]`;
        this.stack;
        delete this.name;
      }
      get code() {
        return sym;
      }
      set code(value) {
        Object.defineProperty(this, "code", {
          configurable: true,
          enumerable: true,
          value,
          writable: true
        });
      }
      toString() {
        return `${this.name} [${sym}]: ${this.message}`;
      }
    };
  }
  E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) {
      return `${name} is outside of buffer bounds`;
    }
    return "Attempt to access memory outside buffer bounds";
  }, RangeError);
  E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
  }, TypeError);
  E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) {
      received = addNumericalSeparator(String(input));
    } else if (typeof input === "bigint") {
      received = String(input);
      if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) {
        received = addNumericalSeparator(received);
      }
      received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
  }, RangeError);
  function addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for (; i >= start + 4; i -= 3) {
      res = `_${val.slice(i - 3, i)}${res}`;
    }
    return `${val.slice(0, i)}${res}`;
  }
  function checkBounds(buf, offset, byteLength3) {
    validateNumber(offset, "offset");
    if (buf[offset] === void 0 || buf[offset + byteLength3] === void 0) {
      boundsError(offset, buf.length - (byteLength3 + 1));
    }
  }
  function checkIntBI(value, min, max, buf, offset, byteLength3) {
    if (value > max || value < min) {
      const n = typeof min === "bigint" ? "n" : "";
      let range;
      if (byteLength3 > 3) {
        if (min === 0 || min === BigInt(0)) {
          range = `>= 0${n} and < 2${n} ** ${(byteLength3 + 1) * 8}${n}`;
        } else {
          range = `>= -(2${n} ** ${(byteLength3 + 1) * 8 - 1}${n}) and < 2 ** ${(byteLength3 + 1) * 8 - 1}${n}`;
        }
      } else {
        range = `>= ${min}${n} and <= ${max}${n}`;
      }
      throw new errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    checkBounds(buf, offset, byteLength3);
  }
  function validateNumber(value, name) {
    if (typeof value !== "number") {
      throw new errors.ERR_INVALID_ARG_TYPE(name, "number", value);
    }
  }
  function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
      validateNumber(value, type);
      throw new errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) {
      throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    }
    throw new errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
  }
  const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
  function base64clean(str) {
    str = str.split("=")[0];
    str = str.trim().replace(INVALID_BASE64_RE, "");
    if (str.length < 2)
      return "";
    while (str.length % 4 !== 0) {
      str = str + "=";
    }
    return str;
  }
  function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for (let i = 0; i < length; ++i) {
      codePoint = string.charCodeAt(i);
      if (codePoint > 55295 && codePoint < 57344) {
        if (!leadSurrogate) {
          if (codePoint > 56319) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          } else if (i + 1 === length) {
            if ((units -= 3) > -1)
              bytes.push(239, 191, 189);
            continue;
          }
          leadSurrogate = codePoint;
          continue;
        }
        if (codePoint < 56320) {
          if ((units -= 3) > -1)
            bytes.push(239, 191, 189);
          leadSurrogate = codePoint;
          continue;
        }
        codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
      } else if (leadSurrogate) {
        if ((units -= 3) > -1)
          bytes.push(239, 191, 189);
      }
      leadSurrogate = null;
      if (codePoint < 128) {
        if ((units -= 1) < 0)
          break;
        bytes.push(codePoint);
      } else if (codePoint < 2048) {
        if ((units -= 2) < 0)
          break;
        bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
      } else if (codePoint < 65536) {
        if ((units -= 3) < 0)
          break;
        bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else if (codePoint < 1114112) {
        if ((units -= 4) < 0)
          break;
        bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
      } else {
        throw new Error("Invalid code point");
      }
    }
    return bytes;
  }
  function asciiToBytes(str) {
    const byteArray = [];
    for (let i = 0; i < str.length; ++i) {
      byteArray.push(str.charCodeAt(i) & 255);
    }
    return byteArray;
  }
  function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for (let i = 0; i < str.length; ++i) {
      if ((units -= 2) < 0)
        break;
      c = str.charCodeAt(i);
      hi = c >> 8;
      lo = c % 256;
      byteArray.push(lo);
      byteArray.push(hi);
    }
    return byteArray;
  }
  function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
  }
  function blitBuffer(src, dst, offset, length) {
    let i;
    for (i = 0; i < length; ++i) {
      if (i + offset >= dst.length || i >= src.length)
        break;
      dst[i + offset] = src[i];
    }
    return i;
  }
  function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
  }
  function numberIsNaN(obj) {
    return obj !== obj;
  }
  const hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for (let i = 0; i < 16; ++i) {
      const i16 = i * 16;
      for (let j = 0; j < 16; ++j) {
        table[i16 + j] = alphabet[i] + alphabet[j];
      }
    }
    return table;
  }();
  function defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn;
  }
  function BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
  }
})(buffer);
(function(exports) {
  var QueryString = exports;
  var Buffer2 = buffer.Buffer;
  QueryString.unescapeBuffer = function(s, decodeSpaces) {
    var out = new Buffer2(s.length);
    var state = 0;
    var n, m, hexchar;
    for (var inIndex = 0, outIndex = 0; inIndex <= s.length; inIndex++) {
      var c = inIndex < s.length ? s.charCodeAt(inIndex) : NaN;
      switch (state) {
        case 0:
          switch (c) {
            case 37:
              n = 0;
              m = 0;
              state = 1;
              break;
            case 43:
              if (decodeSpaces)
                c = 32;
            default:
              out[outIndex++] = c;
              break;
          }
          break;
        case 1:
          hexchar = c;
          if (c >= 48 && c <= 57) {
            n = c - 48;
          } else if (c >= 65 && c <= 70) {
            n = c - 65 + 10;
          } else if (c >= 97 && c <= 102) {
            n = c - 97 + 10;
          } else {
            out[outIndex++] = 37;
            out[outIndex++] = c;
            state = 0;
            break;
          }
          state = 2;
          break;
        case 2:
          state = 0;
          if (c >= 48 && c <= 57) {
            m = c - 48;
          } else if (c >= 65 && c <= 70) {
            m = c - 65 + 10;
          } else if (c >= 97 && c <= 102) {
            m = c - 97 + 10;
          } else {
            out[outIndex++] = 37;
            out[outIndex++] = hexchar;
            out[outIndex++] = c;
            break;
          }
          out[outIndex++] = 16 * n + m;
          break;
      }
    }
    return out.slice(0, outIndex - 1);
  };
  function qsUnescape(s, decodeSpaces) {
    try {
      return decodeURIComponent(s);
    } catch (e) {
      return QueryString.unescapeBuffer(s, decodeSpaces).toString();
    }
  }
  QueryString.unescape = qsUnescape;
  var hexTable = new Array(256);
  for (var i = 0; i < 256; ++i)
    hexTable[i] = "%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase();
  QueryString.escape = function(str) {
    if (typeof str !== "string")
      str += "";
    var out = "";
    var lastPos = 0;
    for (var i2 = 0; i2 < str.length; ++i2) {
      var c = str.charCodeAt(i2);
      if (c === 33 || c === 45 || c === 46 || c === 95 || c === 126 || c >= 39 && c <= 42 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122) {
        continue;
      }
      if (i2 - lastPos > 0)
        out += str.slice(lastPos, i2);
      if (c < 128) {
        lastPos = i2 + 1;
        out += hexTable[c];
        continue;
      }
      if (c < 2048) {
        lastPos = i2 + 1;
        out += hexTable[192 | c >> 6] + hexTable[128 | c & 63];
        continue;
      }
      if (c < 55296 || c >= 57344) {
        lastPos = i2 + 1;
        out += hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
        continue;
      }
      ++i2;
      var c2;
      if (i2 < str.length)
        c2 = str.charCodeAt(i2) & 1023;
      else
        throw new URIError("URI malformed");
      lastPos = i2 + 1;
      c = 65536 + ((c & 1023) << 10 | c2);
      out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
    }
    if (lastPos === 0)
      return str;
    if (lastPos < str.length)
      return out + str.slice(lastPos);
    return out;
  };
  var stringifyPrimitive = function(v) {
    if (typeof v === "string")
      return v;
    if (typeof v === "number" && isFinite(v))
      return "" + v;
    if (typeof v === "boolean")
      return v ? "true" : "false";
    return "";
  };
  QueryString.stringify = QueryString.encode = function(obj, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var encode = QueryString.escape;
    if (options && typeof options.encodeURIComponent === "function") {
      encode = options.encodeURIComponent;
    }
    if (obj !== null && typeof obj === "object") {
      var keys = Object.keys(obj);
      var len = keys.length;
      var flast = len - 1;
      var fields = "";
      for (var i2 = 0; i2 < len; ++i2) {
        var k = keys[i2];
        var v = obj[k];
        var ks = encode(stringifyPrimitive(k)) + eq;
        if (Array.isArray(v)) {
          var vlen = v.length;
          var vlast = vlen - 1;
          for (var j = 0; j < vlen; ++j) {
            fields += ks + encode(stringifyPrimitive(v[j]));
            if (j < vlast)
              fields += sep;
          }
          if (vlen && i2 < flast)
            fields += sep;
        } else {
          fields += ks + encode(stringifyPrimitive(v));
          if (i2 < flast)
            fields += sep;
        }
      }
      return fields;
    }
    return "";
  };
  QueryString.parse = QueryString.decode = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) {
      return obj;
    }
    if (typeof sep !== "string")
      sep += "";
    var eqLen = eq.length;
    var sepLen = sep.length;
    var maxKeys = 1e3;
    if (options && typeof options.maxKeys === "number") {
      maxKeys = options.maxKeys;
    }
    var pairs = Infinity;
    if (maxKeys > 0)
      pairs = maxKeys;
    var decode = QueryString.unescape;
    if (options && typeof options.decodeURIComponent === "function") {
      decode = options.decodeURIComponent;
    }
    var customDecode = decode !== qsUnescape;
    var keys = [];
    var lastPos = 0;
    var sepIdx = 0;
    var eqIdx = 0;
    var key = "";
    var value = "";
    var keyEncoded = customDecode;
    var valEncoded = customDecode;
    var encodeCheck = 0;
    for (var i2 = 0; i2 < qs.length; ++i2) {
      var code2 = qs.charCodeAt(i2);
      if (code2 === sep.charCodeAt(sepIdx)) {
        if (++sepIdx === sepLen) {
          var end = i2 - sepIdx + 1;
          if (eqIdx < eqLen) {
            if (lastPos < end)
              key += qs.slice(lastPos, end);
          } else if (lastPos < end)
            value += qs.slice(lastPos, end);
          if (keyEncoded)
            key = decodeStr(key, decode);
          if (valEncoded)
            value = decodeStr(value, decode);
          if (keys.indexOf(key) === -1) {
            obj[key] = value;
            keys[keys.length] = key;
          } else {
            var curValue = obj[key];
            if (curValue instanceof Array)
              curValue[curValue.length] = value;
            else
              obj[key] = [curValue, value];
          }
          if (--pairs === 0)
            break;
          keyEncoded = valEncoded = customDecode;
          encodeCheck = 0;
          key = value = "";
          lastPos = i2 + 1;
          sepIdx = eqIdx = 0;
        }
        continue;
      } else {
        sepIdx = 0;
        if (!valEncoded) {
          if (code2 === 37) {
            encodeCheck = 1;
          } else if (encodeCheck > 0 && (code2 >= 48 && code2 <= 57 || code2 >= 65 && code2 <= 70 || code2 >= 97 && code2 <= 102)) {
            if (++encodeCheck === 3)
              valEncoded = true;
          } else {
            encodeCheck = 0;
          }
        }
      }
      if (eqIdx < eqLen) {
        if (code2 === eq.charCodeAt(eqIdx)) {
          if (++eqIdx === eqLen) {
            var end = i2 - eqIdx + 1;
            if (lastPos < end)
              key += qs.slice(lastPos, end);
            encodeCheck = 0;
            lastPos = i2 + 1;
          }
          continue;
        } else {
          eqIdx = 0;
          if (!keyEncoded) {
            if (code2 === 37) {
              encodeCheck = 1;
            } else if (encodeCheck > 0 && (code2 >= 48 && code2 <= 57 || code2 >= 65 && code2 <= 70 || code2 >= 97 && code2 <= 102)) {
              if (++encodeCheck === 3)
                keyEncoded = true;
            } else {
              encodeCheck = 0;
            }
          }
        }
      }
      if (code2 === 43) {
        if (eqIdx < eqLen) {
          if (i2 - lastPos > 0)
            key += qs.slice(lastPos, i2);
          key += "%20";
          keyEncoded = true;
        } else {
          if (i2 - lastPos > 0)
            value += qs.slice(lastPos, i2);
          value += "%20";
          valEncoded = true;
        }
        lastPos = i2 + 1;
      }
    }
    if (pairs > 0 && (lastPos < qs.length || eqIdx > 0)) {
      if (lastPos < qs.length) {
        if (eqIdx < eqLen)
          key += qs.slice(lastPos);
        else if (sepIdx < sepLen)
          value += qs.slice(lastPos);
      }
      if (keyEncoded)
        key = decodeStr(key, decode);
      if (valEncoded)
        value = decodeStr(value, decode);
      if (keys.indexOf(key) === -1) {
        obj[key] = value;
        keys[keys.length] = key;
      } else {
        var curValue = obj[key];
        if (curValue instanceof Array)
          curValue[curValue.length] = value;
        else
          obj[key] = [curValue, value];
      }
    }
    return obj;
  };
  function decodeStr(s, decoder) {
    try {
      return decoder(s);
    } catch (e) {
      return QueryString.unescape(s, true);
    }
  }
})(querystring);
var sha256 = { exports: {} };
var core = { exports: {} };
(function(module, exports) {
  (function(root, factory) {
    {
      module.exports = factory();
    }
  })(commonjsGlobal, function() {
    var CryptoJS = CryptoJS || function(Math2, undefined$1) {
      var crypto;
      if (typeof window !== "undefined" && window.crypto) {
        crypto = window.crypto;
      }
      if (typeof self !== "undefined" && self.crypto) {
        crypto = self.crypto;
      }
      if (typeof globalThis !== "undefined" && globalThis.crypto) {
        crypto = globalThis.crypto;
      }
      if (!crypto && typeof window !== "undefined" && window.msCrypto) {
        crypto = window.msCrypto;
      }
      if (!crypto && typeof commonjsGlobal !== "undefined" && commonjsGlobal.crypto) {
        crypto = commonjsGlobal.crypto;
      }
      if (!crypto && typeof commonjsRequire === "function") {
        try {
          crypto = require("crypto");
        } catch (err) {
        }
      }
      var cryptoSecureRandomInt = function() {
        if (crypto) {
          if (typeof crypto.getRandomValues === "function") {
            try {
              return crypto.getRandomValues(new Uint32Array(1))[0];
            } catch (err) {
            }
          }
          if (typeof crypto.randomBytes === "function") {
            try {
              return crypto.randomBytes(4).readInt32LE();
            } catch (err) {
            }
          }
        }
        throw new Error("Native crypto module could not be used to get secure random number.");
      };
      var create = Object.create || function() {
        function F() {
        }
        return function(obj) {
          var subtype;
          F.prototype = obj;
          subtype = new F();
          F.prototype = null;
          return subtype;
        };
      }();
      var C = {};
      var C_lib = C.lib = {};
      var Base = C_lib.Base = function() {
        return {
          extend: function(overrides) {
            var subtype = create(this);
            if (overrides) {
              subtype.mixIn(overrides);
            }
            if (!subtype.hasOwnProperty("init") || this.init === subtype.init) {
              subtype.init = function() {
                subtype.$super.init.apply(this, arguments);
              };
            }
            subtype.init.prototype = subtype;
            subtype.$super = this;
            return subtype;
          },
          create: function() {
            var instance2 = this.extend();
            instance2.init.apply(instance2, arguments);
            return instance2;
          },
          init: function() {
          },
          mixIn: function(properties) {
            for (var propertyName in properties) {
              if (properties.hasOwnProperty(propertyName)) {
                this[propertyName] = properties[propertyName];
              }
            }
            if (properties.hasOwnProperty("toString")) {
              this.toString = properties.toString;
            }
          },
          clone: function() {
            return this.init.prototype.extend(this);
          }
        };
      }();
      var WordArray = C_lib.WordArray = Base.extend({
        init: function(words, sigBytes) {
          words = this.words = words || [];
          if (sigBytes != undefined$1) {
            this.sigBytes = sigBytes;
          } else {
            this.sigBytes = words.length * 4;
          }
        },
        toString: function(encoder) {
          return (encoder || Hex).stringify(this);
        },
        concat: function(wordArray) {
          var thisWords = this.words;
          var thatWords = wordArray.words;
          var thisSigBytes = this.sigBytes;
          var thatSigBytes = wordArray.sigBytes;
          this.clamp();
          if (thisSigBytes % 4) {
            for (var i = 0; i < thatSigBytes; i++) {
              var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 255;
              thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
            }
          } else {
            for (var j = 0; j < thatSigBytes; j += 4) {
              thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
            }
          }
          this.sigBytes += thatSigBytes;
          return this;
        },
        clamp: function() {
          var words = this.words;
          var sigBytes = this.sigBytes;
          words[sigBytes >>> 2] &= 4294967295 << 32 - sigBytes % 4 * 8;
          words.length = Math2.ceil(sigBytes / 4);
        },
        clone: function() {
          var clone2 = Base.clone.call(this);
          clone2.words = this.words.slice(0);
          return clone2;
        },
        random: function(nBytes) {
          var words = [];
          for (var i = 0; i < nBytes; i += 4) {
            words.push(cryptoSecureRandomInt());
          }
          return new WordArray.init(words, nBytes);
        }
      });
      var C_enc = C.enc = {};
      var Hex = C_enc.Hex = {
        stringify: function(wordArray) {
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var hexChars = [];
          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            hexChars.push((bite >>> 4).toString(16));
            hexChars.push((bite & 15).toString(16));
          }
          return hexChars.join("");
        },
        parse: function(hexStr) {
          var hexStrLength = hexStr.length;
          var words = [];
          for (var i = 0; i < hexStrLength; i += 2) {
            words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
          }
          return new WordArray.init(words, hexStrLength / 2);
        }
      };
      var Latin1 = C_enc.Latin1 = {
        stringify: function(wordArray) {
          var words = wordArray.words;
          var sigBytes = wordArray.sigBytes;
          var latin1Chars = [];
          for (var i = 0; i < sigBytes; i++) {
            var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
            latin1Chars.push(String.fromCharCode(bite));
          }
          return latin1Chars.join("");
        },
        parse: function(latin1Str) {
          var latin1StrLength = latin1Str.length;
          var words = [];
          for (var i = 0; i < latin1StrLength; i++) {
            words[i >>> 2] |= (latin1Str.charCodeAt(i) & 255) << 24 - i % 4 * 8;
          }
          return new WordArray.init(words, latin1StrLength);
        }
      };
      var Utf8 = C_enc.Utf8 = {
        stringify: function(wordArray) {
          try {
            return decodeURIComponent(escape(Latin1.stringify(wordArray)));
          } catch (e) {
            throw new Error("Malformed UTF-8 data");
          }
        },
        parse: function(utf8Str) {
          return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
        }
      };
      var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
        reset: function() {
          this._data = new WordArray.init();
          this._nDataBytes = 0;
        },
        _append: function(data) {
          if (typeof data == "string") {
            data = Utf8.parse(data);
          }
          this._data.concat(data);
          this._nDataBytes += data.sigBytes;
        },
        _process: function(doFlush) {
          var processedWords;
          var data = this._data;
          var dataWords = data.words;
          var dataSigBytes = data.sigBytes;
          var blockSize = this.blockSize;
          var blockSizeBytes = blockSize * 4;
          var nBlocksReady = dataSigBytes / blockSizeBytes;
          if (doFlush) {
            nBlocksReady = Math2.ceil(nBlocksReady);
          } else {
            nBlocksReady = Math2.max((nBlocksReady | 0) - this._minBufferSize, 0);
          }
          var nWordsReady = nBlocksReady * blockSize;
          var nBytesReady = Math2.min(nWordsReady * 4, dataSigBytes);
          if (nWordsReady) {
            for (var offset = 0; offset < nWordsReady; offset += blockSize) {
              this._doProcessBlock(dataWords, offset);
            }
            processedWords = dataWords.splice(0, nWordsReady);
            data.sigBytes -= nBytesReady;
          }
          return new WordArray.init(processedWords, nBytesReady);
        },
        clone: function() {
          var clone2 = Base.clone.call(this);
          clone2._data = this._data.clone();
          return clone2;
        },
        _minBufferSize: 0
      });
      C_lib.Hasher = BufferedBlockAlgorithm.extend({
        cfg: Base.extend(),
        init: function(cfg) {
          this.cfg = this.cfg.extend(cfg);
          this.reset();
        },
        reset: function() {
          BufferedBlockAlgorithm.reset.call(this);
          this._doReset();
        },
        update: function(messageUpdate) {
          this._append(messageUpdate);
          this._process();
          return this;
        },
        finalize: function(messageUpdate) {
          if (messageUpdate) {
            this._append(messageUpdate);
          }
          var hash2 = this._doFinalize();
          return hash2;
        },
        blockSize: 512 / 32,
        _createHelper: function(hasher) {
          return function(message, cfg) {
            return new hasher.init(cfg).finalize(message);
          };
        },
        _createHmacHelper: function(hasher) {
          return function(message, key) {
            return new C_algo.HMAC.init(hasher, key).finalize(message);
          };
        }
      });
      var C_algo = C.algo = {};
      return C;
    }(Math);
    return CryptoJS;
  });
})(core);
(function(module, exports) {
  (function(root, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal, function(CryptoJS) {
    (function(Math2) {
      var C = CryptoJS;
      var C_lib = C.lib;
      var WordArray = C_lib.WordArray;
      var Hasher = C_lib.Hasher;
      var C_algo = C.algo;
      var H = [];
      var K = [];
      (function() {
        function isPrime(n2) {
          var sqrtN = Math2.sqrt(n2);
          for (var factor = 2; factor <= sqrtN; factor++) {
            if (!(n2 % factor)) {
              return false;
            }
          }
          return true;
        }
        function getFractionalBits(n2) {
          return (n2 - (n2 | 0)) * 4294967296 | 0;
        }
        var n = 2;
        var nPrime = 0;
        while (nPrime < 64) {
          if (isPrime(n)) {
            if (nPrime < 8) {
              H[nPrime] = getFractionalBits(Math2.pow(n, 1 / 2));
            }
            K[nPrime] = getFractionalBits(Math2.pow(n, 1 / 3));
            nPrime++;
          }
          n++;
        }
      })();
      var W = [];
      var SHA2562 = C_algo.SHA256 = Hasher.extend({
        _doReset: function() {
          this._hash = new WordArray.init(H.slice(0));
        },
        _doProcessBlock: function(M, offset) {
          var H2 = this._hash.words;
          var a = H2[0];
          var b = H2[1];
          var c = H2[2];
          var d = H2[3];
          var e = H2[4];
          var f = H2[5];
          var g = H2[6];
          var h = H2[7];
          for (var i = 0; i < 64; i++) {
            if (i < 16) {
              W[i] = M[offset + i] | 0;
            } else {
              var gamma0x = W[i - 15];
              var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
              var gamma1x = W[i - 2];
              var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
              W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
            }
            var ch = e & f ^ ~e & g;
            var maj = a & b ^ a & c ^ b & c;
            var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
            var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
            var t1 = h + sigma1 + ch + K[i] + W[i];
            var t2 = sigma0 + maj;
            h = g;
            g = f;
            f = e;
            e = d + t1 | 0;
            d = c;
            c = b;
            b = a;
            a = t1 + t2 | 0;
          }
          H2[0] = H2[0] + a | 0;
          H2[1] = H2[1] + b | 0;
          H2[2] = H2[2] + c | 0;
          H2[3] = H2[3] + d | 0;
          H2[4] = H2[4] + e | 0;
          H2[5] = H2[5] + f | 0;
          H2[6] = H2[6] + g | 0;
          H2[7] = H2[7] + h | 0;
        },
        _doFinalize: function() {
          var data = this._data;
          var dataWords = data.words;
          var nBitsTotal = this._nDataBytes * 8;
          var nBitsLeft = data.sigBytes * 8;
          dataWords[nBitsLeft >>> 5] |= 128 << 24 - nBitsLeft % 32;
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math2.floor(nBitsTotal / 4294967296);
          dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
          data.sigBytes = dataWords.length * 4;
          this._process();
          return this._hash;
        },
        clone: function() {
          var clone2 = Hasher.clone.call(this);
          clone2._hash = this._hash.clone();
          return clone2;
        }
      });
      C.SHA256 = Hasher._createHelper(SHA2562);
      C.HmacSHA256 = Hasher._createHmacHelper(SHA2562);
    })(Math);
    return CryptoJS.SHA256;
  });
})(sha256);
var SHA256 = sha256.exports;
var hmacSha256 = { exports: {} };
var hmac$1 = { exports: {} };
(function(module, exports) {
  (function(root, factory) {
    {
      module.exports = factory(core.exports);
    }
  })(commonjsGlobal, function(CryptoJS) {
    (function() {
      var C = CryptoJS;
      var C_lib = C.lib;
      var Base = C_lib.Base;
      var C_enc = C.enc;
      var Utf8 = C_enc.Utf8;
      var C_algo = C.algo;
      C_algo.HMAC = Base.extend({
        init: function(hasher, key) {
          hasher = this._hasher = new hasher.init();
          if (typeof key == "string") {
            key = Utf8.parse(key);
          }
          var hasherBlockSize = hasher.blockSize;
          var hasherBlockSizeBytes = hasherBlockSize * 4;
          if (key.sigBytes > hasherBlockSizeBytes) {
            key = hasher.finalize(key);
          }
          key.clamp();
          var oKey = this._oKey = key.clone();
          var iKey = this._iKey = key.clone();
          var oKeyWords = oKey.words;
          var iKeyWords = iKey.words;
          for (var i = 0; i < hasherBlockSize; i++) {
            oKeyWords[i] ^= 1549556828;
            iKeyWords[i] ^= 909522486;
          }
          oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
          this.reset();
        },
        reset: function() {
          var hasher = this._hasher;
          hasher.reset();
          hasher.update(this._iKey);
        },
        update: function(messageUpdate) {
          this._hasher.update(messageUpdate);
          return this;
        },
        finalize: function(messageUpdate) {
          var hasher = this._hasher;
          var innerHash = hasher.finalize(messageUpdate);
          hasher.reset();
          var hmac2 = hasher.finalize(this._oKey.clone().concat(innerHash));
          return hmac2;
        }
      });
    })();
  });
})(hmac$1);
(function(module, exports) {
  (function(root, factory, undef) {
    {
      module.exports = factory(core.exports, sha256.exports, hmac$1.exports);
    }
  })(commonjsGlobal, function(CryptoJS) {
    return CryptoJS.HmacSHA256;
  });
})(hmacSha256);
var hmacSHA256 = hmacSha256.exports;
function lru(size) {
  return new LruCache(size);
}
function LruCache(size) {
  this.capacity = size | 0;
  this.map = Object.create(null);
  this.list = new DoublyLinkedList();
}
LruCache.prototype.get = function(key) {
  var node = this.map[key];
  if (node == null)
    return void 0;
  this.used(node);
  return node.val;
};
LruCache.prototype.set = function(key, val) {
  var node = this.map[key];
  if (node != null) {
    node.val = val;
  } else {
    if (!this.capacity)
      this.prune();
    if (!this.capacity)
      return false;
    node = new DoublyLinkedNode(key, val);
    this.map[key] = node;
    this.capacity--;
  }
  this.used(node);
  return true;
};
LruCache.prototype.used = function(node) {
  this.list.moveToFront(node);
};
LruCache.prototype.prune = function() {
  var node = this.list.pop();
  if (node != null) {
    delete this.map[node.key];
    this.capacity += 1;
  }
};
function DoublyLinkedList() {
  this.firstNode = null;
  this.lastNode = null;
}
DoublyLinkedList.prototype.moveToFront = function(node) {
  if (this.firstNode == node)
    return;
  this.remove(node);
  if (this.firstNode == null) {
    this.firstNode = node;
    this.lastNode = node;
    node.prev = null;
    node.next = null;
  } else {
    node.prev = null;
    node.next = this.firstNode;
    node.next.prev = node;
    this.firstNode = node;
  }
};
DoublyLinkedList.prototype.pop = function() {
  var lastNode = this.lastNode;
  if (lastNode != null) {
    this.remove(lastNode);
  }
  return lastNode;
};
DoublyLinkedList.prototype.remove = function(node) {
  if (this.firstNode == node) {
    this.firstNode = node.next;
  } else if (node.prev != null) {
    node.prev.next = node.next;
  }
  if (this.lastNode == node) {
    this.lastNode = node.prev;
  } else if (node.next != null) {
    node.next.prev = node.prev;
  }
};
function DoublyLinkedNode(key, val) {
  this.key = key;
  this.val = val;
  this.prev = null;
  this.next = null;
}
if (!querystring) {
  console.error("Error in callstats, querystring module undefined");
}
var credentialsCache = lru(1e3);
function hmac(key, string, encoding) {
  return hmacSHA256(string, key);
}
function hash$1(string, encoding) {
  return SHA256(string);
}
function encodeRfc3986(urlEncodedString) {
  return urlEncodedString.replace(/[!'()*]/g, function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
  });
}
function encodeRfc3986Full(str) {
  return encodeRfc3986(encodeURIComponent(str));
}
var HEADERS_TO_IGNORE = {
  authorization: true,
  connection: true,
  "x-amzn-trace-id": true,
  "user-agent": true,
  expect: true,
  "presigned-expires": true,
  range: true
};
function _RequestSigner(request, credentials) {
  if (typeof request === "string")
    request = new URL(request);
  var headers = request.headers = request.headers || {};
  var hostParts = (!this.service || !this.region) && this.matchHost(request.hostname || request.host || headers.Host || headers.host);
  this.request = request;
  this.credentials = credentials || this.defaultCredentials();
  this.service = request.service || hostParts[0] || "";
  this.region = request.region || hostParts[1] || "us-east-1";
  if (this.service === "email")
    this.service = "ses";
  if (!request.method && request.body)
    request.method = "POST";
  if (!headers.Host && !headers.host) {
    headers.Host = request.hostname || request.host || this.createHost();
    if (request.port)
      headers.Host += ":" + request.port;
  }
  if (!request.hostname && !request.host)
    request.hostname = headers.Host || headers.host;
  this.isCodeCommitGit = this.service === "codecommit" && request.method === "GIT";
}
_RequestSigner.prototype.matchHost = function(host) {
  var match = (host || "").match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com(\.cn)?$/);
  var hostParts = (match || []).slice(1, 3);
  if (hostParts[1] === "es")
    hostParts = hostParts.reverse();
  if (hostParts[1] == "s3") {
    hostParts[0] = "s3";
    hostParts[1] = "us-east-1";
  } else {
    for (var i = 0; i < 2; i += 1) {
      if (/^s3-/.test(hostParts[i])) {
        hostParts[1] = hostParts[i].slice(3);
        hostParts[0] = "s3";
        break;
      }
    }
  }
  return hostParts;
};
_RequestSigner.prototype.isSingleRegion = function() {
  if (["s3", "sdb"].indexOf(this.service) >= 0 && this.region === "us-east-1")
    return true;
  return ["cloudfront", "ls", "route53", "iam", "importexport", "sts"].indexOf(this.service) >= 0;
};
_RequestSigner.prototype.createHost = function() {
  var region = this.isSingleRegion() ? "" : "." + this.region;
  var subdomain = this.service === "ses" ? "email" : this.service;
  return subdomain + region + ".amazonaws.com";
};
_RequestSigner.prototype.prepareRequest = function() {
  try {
    this.parsePath();
  } catch (e) {
    console.error("Error in callstats:", e);
  }
  var request = this.request;
  var headers = request.headers;
  var query;
  if (request.signQuery) {
    this.parsedPath.query = query = this.parsedPath.query || {};
    if (this.credentials.sessionToken)
      query["X-Amz-Security-Token"] = this.credentials.sessionToken;
    if (this.service === "s3" && !query["X-Amz-Expires"])
      query["X-Amz-Expires"] = 86400;
    if (query["X-Amz-Date"])
      this.datetime = query["X-Amz-Date"];
    else
      query["X-Amz-Date"] = this.getDateTime();
    query["X-Amz-Algorithm"] = "AWS4-HMAC-SHA256";
    query["X-Amz-Credential"] = this.credentials.accessKeyId + "/" + this.credentialString();
    query["X-Amz-SignedHeaders"] = this.signedHeaders();
  } else {
    if (!request.doNotModifyHeaders && !this.isCodeCommitGit) {
      if (request.body && !headers["Content-Type"] && !headers["content-type"])
        headers["Content-Type"] = "application/x-www-form-urlencoded; charset=utf-8";
      if (request.body && !headers["Content-Length"] && !headers["content-length"])
        headers["Content-Length"] = Buffer.byteLength(request.body);
      if (this.credentials.sessionToken && !headers["X-Amz-Security-Token"] && !headers["x-amz-security-token"])
        headers["X-Amz-Security-Token"] = this.credentials.sessionToken;
      if (this.service === "s3" && !headers["X-Amz-Content-Sha256"] && !headers["x-amz-content-sha256"])
        headers["X-Amz-Content-Sha256"] = hash$1(this.request.body || "");
      if (headers["X-Amz-Date"] || headers["x-amz-date"])
        this.datetime = headers["X-Amz-Date"] || headers["x-amz-date"];
      else
        headers["X-Amz-Date"] = this.getDateTime();
    }
    delete headers.Authorization;
    delete headers.authorization;
  }
};
_RequestSigner.prototype.sign = function() {
  if (!this.parsedPath)
    this.prepareRequest();
  if (this.request.signQuery) {
    this.parsedPath.query["X-Amz-Signature"] = this.signature();
  } else {
    this.request.headers.Authorization = this.authHeader();
  }
  this.request.path = this.formatPath();
  return this.request;
};
_RequestSigner.prototype.getDateTime = function() {
  if (!this.datetime) {
    var headers = this.request.headers;
    var date = new Date(headers.Date || headers.date || new Date());
    this.datetime = date.toISOString().replace(/[:\-]|\.\d{3}/g, "");
    if (this.isCodeCommitGit)
      this.datetime = this.datetime.slice(0, -1);
  }
  return this.datetime;
};
_RequestSigner.prototype.getDate = function() {
  return this.getDateTime().substr(0, 8);
};
_RequestSigner.prototype.authHeader = function() {
  return [
    "AWS4-HMAC-SHA256 Credential=" + this.credentials.accessKeyId + "/" + this.credentialString(),
    "SignedHeaders=" + this.signedHeaders(),
    "Signature=" + this.signature()
  ].join(", ");
};
_RequestSigner.prototype.signature = function() {
  var date = this.getDate();
  var cacheKey = [this.credentials.secretAccessKey, date, this.region, this.service].join();
  var kDate;
  var kRegion;
  var kService;
  var kCredentials = credentialsCache.get(cacheKey);
  if (!kCredentials) {
    kDate = hmac("AWS4" + this.credentials.secretAccessKey, date);
    kRegion = hmac(kDate, this.region);
    kService = hmac(kRegion, this.service);
    kCredentials = hmac(kService, "aws4_request");
    credentialsCache.set(cacheKey, kCredentials);
  }
  return hmac(kCredentials, this.stringToSign());
};
_RequestSigner.prototype.stringToSign = function() {
  return [
    "AWS4-HMAC-SHA256",
    this.getDateTime(),
    this.credentialString(),
    hash$1(this.canonicalString())
  ].join("\n");
};
_RequestSigner.prototype.canonicalString = function() {
  if (!this.parsedPath)
    this.prepareRequest();
  var pathStr = this.parsedPath.path;
  var query = this.parsedPath.query;
  var headers = this.request.headers;
  var queryStr = "";
  var normalizePath = this.service !== "s3";
  var decodePath = this.service === "s3" || this.request.doNotEncodePath;
  var decodeSlashesInPath = this.service === "s3";
  var firstValOnly = this.service === "s3";
  var bodyHash;
  if (this.service === "s3" && this.request.signQuery) {
    bodyHash = "UNSIGNED-PAYLOAD";
  } else if (this.isCodeCommitGit) {
    bodyHash = "";
  } else {
    bodyHash = headers["X-Amz-Content-Sha256"] || headers["x-amz-content-sha256"] || hash$1(this.request.body || "");
  }
  if (query) {
    var reducedQuery_1 = Object.keys(query).reduce(function(obj, key) {
      if (!key)
        return obj;
      obj[encodeRfc3986Full(key)] = !Array.isArray(query[key]) ? query[key] : firstValOnly ? query[key][0] : query[key];
      return obj;
    }, {});
    var encodedQueryPieces_1 = [];
    Object.keys(reducedQuery_1).sort().forEach(function(key) {
      if (!Array.isArray(reducedQuery_1[key])) {
        encodedQueryPieces_1.push(key + "=" + encodeRfc3986Full(reducedQuery_1[key]));
      } else {
        reducedQuery_1[key].map(encodeRfc3986Full).sort().forEach(function(val) {
          encodedQueryPieces_1.push(key + "=" + val);
        });
      }
    });
    queryStr = encodedQueryPieces_1.join("&");
  }
  if (pathStr !== "/") {
    if (normalizePath)
      pathStr = pathStr.replace(/\/{2,}/g, "/");
    pathStr = pathStr.split("/").reduce(function(path, piece) {
      if (normalizePath && piece === "..") {
        path.pop();
      } else if (!normalizePath || piece !== ".") {
        if (decodePath)
          piece = decodeURIComponent(piece.replace(/\+/g, " "));
        path.push(encodeRfc3986Full(piece));
      }
      return path;
    }, []).join("/");
    if (pathStr[0] !== "/")
      pathStr = "/" + pathStr;
    if (decodeSlashesInPath)
      pathStr = pathStr.replace(/%2F/g, "/");
  }
  return [
    this.request.method || "GET",
    pathStr,
    queryStr,
    this.canonicalHeaders() + "\n",
    this.signedHeaders(),
    bodyHash
  ].join("\n");
};
_RequestSigner.prototype.canonicalHeaders = function() {
  var headers = this.request.headers;
  function trimAll(header) {
    return header.toString().trim().replace(/\s+/g, " ");
  }
  return Object.keys(headers).filter(function(key) {
    return HEADERS_TO_IGNORE[key.toLowerCase()] == null;
  }).sort(function(a, b) {
    return a.toLowerCase() < b.toLowerCase() ? -1 : 1;
  }).map(function(key) {
    return key.toLowerCase() + ":" + trimAll(headers[key]);
  }).join("\n");
};
_RequestSigner.prototype.signedHeaders = function() {
  return Object.keys(this.request.headers).map(function(key) {
    return key.toLowerCase();
  }).filter(function(key) {
    return HEADERS_TO_IGNORE[key] == null;
  }).sort().join(";");
};
_RequestSigner.prototype.credentialString = function() {
  return [
    this.getDate(),
    this.region,
    this.service,
    "aws4_request"
  ].join("/");
};
_RequestSigner.prototype.defaultCredentials = function() {
  var env = process.env;
  return {
    accessKeyId: env.AWS_ACCESS_KEY_ID || env.AWS_ACCESS_KEY,
    secretAccessKey: env.AWS_SECRET_ACCESS_KEY || env.AWS_SECRET_KEY,
    sessionToken: env.AWS_SESSION_TOKEN
  };
};
_RequestSigner.prototype.parsePath = function() {
  var path = this.request.path || "/";
  if (/[^0-9A-Za-z;,/?:@&=+$\-_.!~*'()#%]/.test(path)) {
    path = encodeURI(decodeURI(path));
  }
  var queryIx = path.indexOf("?");
  var query = null;
  if (queryIx >= 0) {
    query = querystring.parse(path.slice(queryIx + 1));
    path = path.slice(0, queryIx);
  }
  this.parsedPath = {
    path,
    query
  };
};
_RequestSigner.prototype.formatPath = function() {
  var path = this.parsedPath.path;
  var query = this.parsedPath.query;
  if (!query)
    return path;
  if (query[""] != null)
    delete query[""];
  return path + "?" + encodeRfc3986(querystring.stringify(query));
};
var RequestSigner = _RequestSigner;
var sign = function(request, credentials) {
  return new RequestSigner(request, credentials).sign();
};
var __extends$7 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$7 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$6 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var SQSConnector = function(_super) {
  __extends$7(SQSConnector2, _super);
  function SQSConnector2(env) {
    var _this = _super.call(this) || this;
    if (env === ClientEnvType.DEV)
      _this.logger = console;
    else
      _this.logger = { log: function(e) {
      }, error: function(e) {
      } };
    _this.config = {
      region: "ap-south-1",
      credentials: {
        accessKeyId: atob("QUtJQTVZQUhSS1pSQklZTjdXVTc="),
        secretAccessKey: atob("YVpIM2Y5SHlHZnp6ZDZ4OHg5SkhaZzlUcGVPS2Z0cE92MUk3bE1HKw==")
      }
    };
    if (env === ClientEnvType.PRODUCTION) {
      _this.config.queue = "/944908621410/Callstats-Queue";
    } else {
      _this.config.queue = "/944908621410/Callstats-Queue";
    }
    return _this;
  }
  SQSConnector2.prototype.sendChunk = function(data) {
    _super.prototype.sendChunk.call(this, data);
  };
  SQSConnector2.prototype.sendChunkToServer = function(data) {
    return __awaiter$7(this, void 0, void 0, function() {
      var packet, params, opts, command, error_1;
      return __generator$6(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            this.logger.log("finalCHUNK:", data);
            packet = {
              payload: data,
              peerId: this.authInfo.peerId
            };
            params = new URLSearchParams({
              Action: "SendMessage",
              MessageBody: JSON.stringify(packet)
            });
            _a3.label = 1;
          case 1:
            _a3.trys.push([1, 3, , 4]);
            opts = sign({
              service: "sqs",
              region: this.config.region,
              path: this.config.queue + "/?" + params.toString()
            }, this.config.credentials);
            command = "https://" + opts.hostname + opts.path;
            return [4, fetch(command, opts)];
          case 2:
            _a3.sent();
            return [2, true];
          case 3:
            error_1 = _a3.sent();
            this.logger.error("Error in SQSConnector.sendChunkToServer", error_1);
            return [2, false];
          case 4:
            return [2];
        }
      });
    });
  };
  return SQSConnector2;
}(PubSubConnector);
var __extends$6 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$6 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$5 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$3 = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var CallTest = function() {
  function CallTest2(config2) {
    this.constrainOfferToRemoveVideoFec = false;
    var pc1 = new RTCPeerConnection(config2);
    var pc2 = new RTCPeerConnection(config2);
    this.pc1 = pc1;
    this.pc2 = pc2;
    this.iceCandidateFilter = CallTest2.noFilter;
    this.pc1.addEventListener("icecandidate", this.onIceCandidate.bind(this, this.pc2));
    this.pc2.addEventListener("icecandidate", this.onIceCandidate.bind(this, this.pc1));
  }
  CallTest2.parseCandidate = function(text) {
    var candidateStr = "candidate:";
    var pos = text.indexOf(candidateStr) + candidateStr.length;
    var fields = text.substr(pos).split(" ");
    return {
      type: fields[7],
      protocol: fields[2],
      address: fields[4]
    };
  };
  CallTest2.isNotHostCandidate = function(candidate) {
    return candidate.type !== "host";
  };
  CallTest2.isHost = function(candidate) {
    return candidate.type === "host";
  };
  CallTest2.isRelay = function(candidate) {
    return candidate.type === "relay";
  };
  CallTest2.isReflexive = function(candidate) {
    return candidate.type === "srflx";
  };
  CallTest2.noFilter = function(parsed) {
    return true;
  };
  CallTest2.prototype.onIceCandidate = function(otherPeer, event) {
    if (event.candidate) {
      var parsed = CallTest2.parseCandidate(event.candidate.candidate);
      if (this.iceCandidateFilter(parsed)) {
        otherPeer.addIceCandidate(event.candidate);
      }
    }
  };
  CallTest2.prototype.setIceCandidateFilter = function(filter) {
    this.iceCandidateFilter = filter;
  };
  CallTest2.prototype.constrainVideoBitrate = function(maxVideoBitrateKbps) {
    this.constrainVideoBitrateKbps = maxVideoBitrateKbps;
  };
  CallTest2.prototype.disableVideoFec = function() {
    this.constrainOfferToRemoveVideoFec = true;
  };
  CallTest2.prototype.gotOffer = function(offer) {
    if (this.constrainOfferToRemoveVideoFec) {
      offer.sdp = offer.sdp.replace(/(m=video 1 [^\r]+)(116 117)(\r\n)/g, "$1\r\n");
      offer.sdp = offer.sdp.replace(/a=rtpmap:116 red\/90000\r\n/g, "");
      offer.sdp = offer.sdp.replace(/a=rtpmap:117 ulpfec\/90000\r\n/g, "");
      offer.sdp = offer.sdp.replace(/a=rtpmap:98 rtx\/90000\r\n/g, "");
      offer.sdp = offer.sdp.replace(/a=fmtp:98 apt=116\r\n/g, "");
    }
    this.pc1.setLocalDescription(offer);
    this.pc2.setRemoteDescription(offer);
    this.pc2.createAnswer().then(this.gotAnswer.bind(this), this.reportFatal.bind(this));
  };
  CallTest2.prototype.gotAnswer = function(answer) {
    if (this.constrainVideoBitrateKbps) {
      answer.sdp = answer.sdp.replace(/a=mid:video\r\n/g, "a=mid:video\r\nb=AS:" + this.constrainVideoBitrateKbps + "\r\n");
    }
    this.pc2.setLocalDescription(answer);
    this.pc1.setRemoteDescription(answer);
  };
  CallTest2.prototype.establishConnection = function() {
    this.pc1.createOffer().then(this.gotOffer.bind(this), this.reportFatal.bind(this));
  };
  CallTest2.prototype.reportFatal = function(reason) {
    console.error("Error:", reason);
  };
  CallTest2.prototype.getRoundTripTime = function() {
    return __awaiter$6(this, void 0, void 0, function() {
      var _a3, sendStats, recieveStats, sendPairStats, recievePairStats, rtt;
      return __generator$5(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, Promise.all([this.pc1.getStats(), this.pc2.getStats()])];
          case 1:
            _a3 = __read$3.apply(void 0, [_b2.sent(), 2]), sendStats = _a3[0], recieveStats = _a3[1];
            sendStats.forEach(function(e) {
              if (e.type === "candidate-pair" && e.nominated === true && e.bytesSent > 0) {
                sendPairStats = e;
              }
            });
            recieveStats.forEach(function(e) {
              if (e.type === "candidate-pair" && e.nominated === true && e.bytesReceived > 0) {
                recievePairStats = e;
              }
            });
            if (sendPairStats && recievePairStats) {
              try {
                if (sendPairStats.currentRoundTripTime && recievePairStats.currentRoundTripTime) {
                  return [2, {
                    rtt: sendPairStats.currentRoundTripTime,
                    backendRTT: recievePairStats.currentRoundTripTime
                  }];
                }
                rtt = (recievePairStats.lastPacketReceivedTimestamp - sendPairStats.lastPacketSentTimestamp) / 1e3;
                return [2, {
                  rtt,
                  backendRTT: rtt
                }];
              } catch (_c2) {
                return [2, void 0];
              }
            }
            return [2, void 0];
        }
      });
    });
  };
  CallTest2.prototype.close = function() {
    this.pc1.close();
    this.pc2.close();
  };
  return CallTest2;
}();
var SimpleCallTest = function(_super) {
  __extends$6(SimpleCallTest2, _super);
  function SimpleCallTest2(config2) {
    var _this = _super.call(this) || this;
    _this.call = new CallTest(config2);
    return _this;
  }
  SimpleCallTest2.prototype.start = function(timeout) {
    if (timeout === void 0) {
      timeout = 1e4;
    }
    this.call.establishConnection();
    this.timeOut = setTimeout(this.testFailed.bind(this), timeout);
  };
  SimpleCallTest2.prototype.testComplete = function(data) {
    clearTimeout(this.timeOut);
    this.call.close();
    this.emit("done", data);
  };
  SimpleCallTest2.prototype.testFailed = function(error) {
    console.warn("Test failed, ", error);
    this.call.close();
    this.emit("failed", error);
  };
  return SimpleCallTest2;
}(EventEmitter$3);
var __extends$5 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var BYTES_TO_BITS = 8;
var BITS_TO_KILOBITS = 1 / 1e3;
var DataThroughputTest = function(_super) {
  __extends$5(DataThroughputTest2, _super);
  function DataThroughputTest2(config2) {
    var _this = _super.call(this, config2) || this;
    _this.sentPayloadBytes = 0;
    _this.recievedPayloadBytes = 0;
    _this.lastReceivedPayloadBytes = 0;
    _this.stopSending = false;
    _this.testProgress = 0;
    _this.samplePacket = "";
    _this.finalBitrateSum = 0;
    _this.bitRateSampels = 0;
    _this.maxNumberOfPacketsToSend = 0;
    _this.bytesToKeepBuffered = 0;
    _this.testDurationSeconds = 5;
    _this.call.setIceCandidateFilter(CallTest.isNotHostCandidate);
    _this.senderChannel = _this.call.pc1.createDataChannel(null);
    for (var i = 0; i < 1024 * 256; i += 1) {
      _this.samplePacket += "h";
    }
    _this.maxNumberOfPacketsToSend = 1;
    _this.bytesToKeepBuffered = 1024 * _this.maxNumberOfPacketsToSend;
    _this.testDurationSeconds = 4;
    _this.senderChannel.addEventListener("open", _this.sendingStep.bind(_this));
    _this.call.pc2.addEventListener("datachannel", _this.onRecieverChannel.bind(_this));
    return _this;
  }
  DataThroughputTest2.prototype.sendingStep = function() {
    var now = new Date();
    if (!this.startTime) {
      this.startTime = now;
      this.lastBitrateMeasureTime = now;
    }
    for (var i = 0; i !== this.maxNumberOfPacketsToSend; i += 1) {
      if (this.senderChannel.bufferedAmount >= this.bytesToKeepBuffered) {
        break;
      }
      this.sentPayloadBytes += this.samplePacket.length;
      try {
        this.senderChannel.send(this.samplePacket);
      } catch (_a3) {
      }
    }
    var duration = now.getTime() - this.startTime.getTime();
    if (duration >= 1e3 * this.testDurationSeconds) {
      this.stopSending = true;
      this.testProgress = 100;
    } else {
      this.testProgress = duration / (10 * this.testDurationSeconds);
      setTimeout(this.sendingStep.bind(this), 1);
    }
  };
  DataThroughputTest2.prototype.onMessageRecieved = function(event) {
    this.recievedPayloadBytes += event.data.length;
    var now = new Date();
    var duration = now.getTime() - this.lastBitrateMeasureTime.getTime();
    if (duration >= 1e3) {
      var deltaBytes = this.recievedPayloadBytes - this.lastReceivedPayloadBytes;
      var bitrate = deltaBytes * BYTES_TO_BITS / (duration / 1e3);
      this.finalBitrateSum += bitrate;
      this.bitRateSampels += 1;
      this.lastReceivedPayloadBytes = this.recievedPayloadBytes;
      this.lastBitrateMeasureTime = now;
    }
    if (this.stopSending && this.sentPayloadBytes === this.recievedPayloadBytes) {
      var averageBitrate = this.finalBitrateSum / this.bitRateSampels;
      this.testComplete({
        throughput: Math.round(averageBitrate * BITS_TO_KILOBITS)
      });
    }
  };
  DataThroughputTest2.prototype.testComplete = function(data) {
    var _this = this;
    this.call.getRoundTripTime().then(function(_a3) {
      var rtt = _a3.rtt, backendRTT = _a3.backendRTT;
      return _super.prototype.testComplete.call(_this, {
        RTT: rtt,
        backendRTT,
        throughput: data.throughput
      });
    });
  };
  DataThroughputTest2.prototype.onRecieverChannel = function(event) {
    this.recieveChannel = event.channel;
    this.recieveChannel.addEventListener("message", this.onMessageRecieved.bind(this));
  };
  return DataThroughputTest2;
}(SimpleCallTest);
var __extends$4 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ConnectivityTest = function(_super) {
  __extends$4(ConnectivityTest2, _super);
  function ConnectivityTest2(config2, filter) {
    if (filter === void 0) {
      filter = CallTest.noFilter;
    }
    var _this = _super.call(this, config2) || this;
    _this.call.setIceCandidateFilter(filter);
    var ch1 = _this.call.pc1.createDataChannel(null);
    _this.ch1 = ch1;
    ch1.addEventListener("open", function() {
      ch1.send("hello");
    });
    ch1.addEventListener("message", _this.onCh1Recieve.bind(_this));
    _this.call.pc2.addEventListener("datachannel", _this.dataChannelHandler.bind(_this));
    return _this;
  }
  ConnectivityTest2.prototype.onCh1Recieve = function(event) {
    if (event.data !== "world") {
      this.hangup("Invalid data transmitted.");
    } else {
      this.testComplete({
        connectivity: true
      });
    }
  };
  ConnectivityTest2.prototype.onCh2Recieve = function(event) {
    if (event.data !== "hello") {
      this.hangup("Invalid data transmitted.");
    } else {
      try {
        this.ch2.send("world");
      } catch (_a3) {
      }
    }
  };
  ConnectivityTest2.prototype.dataChannelHandler = function(event) {
    var ch2 = event.channel;
    this.ch2 = ch2;
    ch2.addEventListener("message", this.onCh2Recieve.bind(this));
  };
  ConnectivityTest2.prototype.hangup = function(errorMessage) {
    this.testFailed(errorMessage);
  };
  return ConnectivityTest2;
}(SimpleCallTest);
var HostConnectivityTest = function(_super) {
  __extends$4(HostConnectivityTest2, _super);
  function HostConnectivityTest2(config2) {
    return _super.call(this, config2, CallTest.isHost) || this;
  }
  return HostConnectivityTest2;
}(ConnectivityTest);
var RelayConnectivityTest = function(_super) {
  __extends$4(RelayConnectivityTest2, _super);
  function RelayConnectivityTest2(config2) {
    return _super.call(this, config2, CallTest.isRelay) || this;
  }
  return RelayConnectivityTest2;
}(ConnectivityTest);
var ReflexiveConnectivityTest = function(_super) {
  __extends$4(ReflexiveConnectivityTest2, _super);
  function ReflexiveConnectivityTest2(config2) {
    return _super.call(this, config2, CallTest.isReflexive) || this;
  }
  return ReflexiveConnectivityTest2;
}(ConnectivityTest);
var __awaiter$5 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$4 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var IPDetailsManager = function() {
  function IPDetailsManager2() {
    this.ipInformation = null;
  }
  IPDetailsManager2.prototype.getIPDetails = function() {
    return __awaiter$5(this, void 0, void 0, function() {
      var response, _a3;
      return __generator$4(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            if (!!this.ipInformation)
              return [3, 3];
            return [4, fetch("https://location-service.dyte.io/?token=3c493932b0624c", {
              method: "POST"
            })];
          case 1:
            response = _b2.sent();
            _a3 = this;
            return [4, response.json()];
          case 2:
            _a3.ipInformation = _b2.sent();
            _b2.label = 3;
          case 3:
            return [2, this.ipInformation];
        }
      });
    });
  };
  return IPDetailsManager2;
}();
var ipDetails = new IPDetailsManager();
var __assign$2 = globalThis && globalThis.__assign || function() {
  __assign$2 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$2.apply(this, arguments);
};
var __awaiter$4 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$3 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$2 = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __values$3 = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i >= o.length)
          o = void 0;
        return { value: o && o[i++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var FALLBACK_ICE_SERVERS = [
  {
    urls: "turn:turn.dyte.in:443?transport=tcp",
    username: "dyte",
    credential: "dytein",
    credentialType: "password"
  },
  {
    urls: "turn:turn.dyte.in:3478?transport=udp",
    username: "dyte",
    credential: "dytein",
    credentialType: "password"
  }
];
function parseIpLocation(loc) {
  var _a3 = __read$2(loc.split(","), 2), latitude = _a3[0], longitude = _a3[1];
  return {
    coords: {
      latitude: Number(latitude),
      longitude: Number(longitude)
    }
  };
}
var ParsedRTCStats = function() {
  function ParsedRTCStats2() {
    this.outboundVideoRtp = new Map();
    this.inboundVideoRtp = new Map();
    this.outboundAudioRtp = new Map();
    this.inboundAudioRtp = new Map();
    this.remoteInboundRtp = new Map();
    this.producerStreamMap = new Map();
    this.consumerStreamMap = new Map();
    this.staleProducerStreamMap = false;
    this.staleConsumerStreamMap = false;
  }
  return ParsedRTCStats2;
}();
var Measurements = function() {
  function Measurements2() {
    this.outboundProducerMap = new Map();
    this.inboundConsumerMap = new Map();
    this.consumerPeerIdMap = new Map();
    this.overallProducingTransportsStatsMap = {};
    this.overallConsumingTransportsStatsMap = {};
    this.overallConsumersStatsMap = {};
    this.overallProducersStatsMap = {};
    this.consumerIdsWithFreezedVideo = new Set();
    this.consumerIdsWithFreezedAudio = new Set();
    this.producerIdsWithFreezedVideo = new Set();
    this.producerIdsWithFreezedAudio = new Set();
    this.freezedProducingTransportIds = new Set();
    this.freezedConsumingTransportIds = new Set();
  }
  Measurements2.prototype.registerProducer = function(producer) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, this.generateProducerStreamMap(producer)];
          case 1:
            _a3.sent();
            producer.observer.on("close", this.deregisterProducer.bind(this, producer));
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.processInboundConsumerVideoStats = function(consumerId, overallStatsForConsumer, streamStatsData) {
    var _a3, _b2;
    var consumerMediaStates = ((_b2 = (_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.consumerSharedMediaStatesMap) === null || _b2 === void 0 ? void 0 : _b2.get(consumerId)) || {};
    if (overallStatsForConsumer.totalVideoPacketsReceived === streamStatsData.packetsReceived) {
      this.consumerIdsWithFreezedVideo.add(consumerId);
      if (this.callStatsInstance && consumerMediaStates.video) {
        this.callStatsInstance.logger.log("video freezed for consumer id:", consumerId);
        this.callStatsInstance.eventHandler.emit("consumer_video_status", "pause", consumerId);
      }
    } else {
      overallStatsForConsumer.totalVideoPacketsReceived = streamStatsData.packetsReceived;
      if (this.consumerIdsWithFreezedVideo.has(consumerId)) {
        this.consumerIdsWithFreezedVideo.delete(consumerId);
        if (this.callStatsInstance && consumerMediaStates.video) {
          this.callStatsInstance.logger.log("video working fine for consumer id:", consumerId);
          this.callStatsInstance.eventHandler.emit("consumer_video_status", "resume", consumerId);
        }
      }
    }
  };
  Measurements2.prototype.processInboundConsumerAudioStats = function(consumerId, overallStatsForConsumer, streamStatsData) {
    var _a3, _b2;
    var consumerMediaStates = ((_b2 = (_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.consumerSharedMediaStatesMap) === null || _b2 === void 0 ? void 0 : _b2.get(consumerId)) || {};
    if (overallStatsForConsumer.totalAudioPacketsReceived === streamStatsData.packetsReceived) {
      this.consumerIdsWithFreezedAudio.add(consumerId);
      if (this.callStatsInstance && consumerMediaStates.audio) {
        this.callStatsInstance.logger.log("audio freezed for consumer id:", consumerId);
        this.callStatsInstance.eventHandler.emit("consumer_audio_status", "pause", consumerId);
      }
    } else {
      overallStatsForConsumer.totalAudioPacketsReceived = streamStatsData.packetsReceived;
      if (this.consumerIdsWithFreezedAudio.has(consumerId)) {
        this.consumerIdsWithFreezedAudio.delete(consumerId);
        if (this.callStatsInstance && consumerMediaStates.audio) {
          this.callStatsInstance.logger.log("audio working fine for consumer id:", consumerId);
          this.callStatsInstance.eventHandler.emit("consumer_audio_status", "resume", consumerId);
        }
      }
    }
  };
  Measurements2.prototype.processOutboundProducerVideoStats = function(producerId, overallStatsForProducer, streamStatsData) {
    var _a3;
    var currentUserMediaStates = ((_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.currentUserMediaStates) || {};
    if (overallStatsForProducer.totalVideoPacketsSent === streamStatsData.packetsSent) {
      this.producerIdsWithFreezedVideo.add(producerId);
      if (this.callStatsInstance && currentUserMediaStates.video) {
        this.callStatsInstance.logger.log("video freezed for producer id:", producerId);
        this.callStatsInstance.eventHandler.emit("producer_video_status", "pause", producerId);
      }
    } else {
      overallStatsForProducer.totalVideoPacketsSent = streamStatsData.packetsSent;
      if (this.producerIdsWithFreezedVideo.has(producerId)) {
        this.producerIdsWithFreezedVideo.delete(producerId);
        if (this.callStatsInstance && currentUserMediaStates.video) {
          this.callStatsInstance.logger.log("video working fine for producer id:", producerId);
          this.callStatsInstance.eventHandler.emit("producer_video_status", "resume", producerId);
        }
      }
    }
  };
  Measurements2.prototype.processOutboundProducerAudioStats = function(producerId, overallStatsForProducer, streamStatsData) {
    var _a3;
    var currentUserMediaStates = ((_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.currentUserMediaStates) || {};
    if (overallStatsForProducer.totalAudioPacketsSent === streamStatsData.packetsSent) {
      this.producerIdsWithFreezedAudio.add(producerId);
      if (this.callStatsInstance && currentUserMediaStates.audio) {
        this.callStatsInstance.logger.log("audio freezed for producer id:", producerId);
        this.callStatsInstance.eventHandler.emit("producer_audio_status", "pause", producerId);
      }
    } else {
      overallStatsForProducer.totalAudioPacketsSent = streamStatsData.packetsSent;
      if (this.producerIdsWithFreezedAudio.has(producerId)) {
        this.producerIdsWithFreezedAudio.delete(producerId);
        if (this.callStatsInstance && currentUserMediaStates.audio) {
          this.callStatsInstance.logger.log("audio working fine for producer id:", producerId);
          this.callStatsInstance.eventHandler.emit("producer_audio_status", "resume", producerId);
        }
      }
    }
  };
  Measurements2.prototype.processProducingTransportStats = function(transportId, overallStatsForTransport, transportStatsData) {
    var _a3;
    var currentUserMediaStates = ((_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.currentUserMediaStates) || {};
    var audioIsOn = currentUserMediaStates.audio, videoIsOn = currentUserMediaStates.video, screenIsOn = currentUserMediaStates.screen;
    var isAnyProducerActivityOn = audioIsOn || videoIsOn || screenIsOn;
    if (overallStatsForTransport.totalPacketsSent === transportStatsData.packetsSent) {
      this.freezedProducingTransportIds.add(transportId);
      if (this.callStatsInstance && isAnyProducerActivityOn) {
        this.callStatsInstance.logger.log("producing transport freezed for transport id:", transportId);
        this.callStatsInstance.eventHandler.emit("producing_transport_status", "pause", transportId);
      }
    } else {
      overallStatsForTransport.totalPacketsSent = transportStatsData.packetsSent;
      if (this.freezedProducingTransportIds.has(transportId)) {
        this.freezedProducingTransportIds.delete(transportId);
        if (this.callStatsInstance && isAnyProducerActivityOn) {
          this.callStatsInstance.logger.log("producing transport working fine for transport id:", transportId);
          this.callStatsInstance.eventHandler.emit("producing_transport_status", "resume", transportId);
        }
      }
    }
  };
  Measurements2.prototype.processConsumingTransportStats = function(transportId, overallStatsForTransport, streamStatsData) {
    var _a3, _b2;
    var combindConsumerStates = Array.from(((_b2 = (_a3 = this === null || this === void 0 ? void 0 : this.callStatsInstance) === null || _a3 === void 0 ? void 0 : _a3.consumerSharedMediaStatesMap) === null || _b2 === void 0 ? void 0 : _b2.values()) || []);
    var isAnyConsumerActivityOn = !!combindConsumerStates.reduce(function(acc, val) {
      return acc || val.audio || val.video || val.screen;
    }, false);
    if (overallStatsForTransport.totalPacketsReceived === streamStatsData.packetsSent) {
      this.freezedConsumingTransportIds.add(transportId);
      if (this.callStatsInstance && isAnyConsumerActivityOn) {
        this.callStatsInstance.logger.log("consuming transport freezed for transport id:", transportId);
        this.callStatsInstance.eventHandler.emit("consuming_transport_status", "pause", transportId);
      }
    } else {
      overallStatsForTransport.totalPacketsReceived = streamStatsData.packetsSent;
      if (this.freezedConsumingTransportIds.has(transportId)) {
        this.freezedConsumingTransportIds.delete(transportId);
        if (this.callStatsInstance && isAnyConsumerActivityOn) {
          this.callStatsInstance.logger.log("consuming transport working fine for transport id:", transportId);
          this.callStatsInstance.eventHandler.emit("consuming_transport_status", "resume", transportId);
        }
      }
    }
  };
  Measurements2.prototype.registerConsumer = function(consumer) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, this.generateConsumerStreamMap(consumer)];
          case 1:
            _a3.sent();
            this.consumerPeerIdMap.set(consumer.id, {
              producerId: consumer.producerId,
              peerId: consumer.appData.peerId
            });
            consumer.observer.on("close", this.deregisterConsumer.bind(this, consumer));
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.generateProducerStreamMap = function(producer, parse) {
    if (parse === void 0) {
      parse = false;
    }
    return __awaiter$4(this, void 0, void 0, function() {
      var stat, result, _a3, _b2, entry;
      var e_1, _c2;
      return __generator$3(this, function(_d2) {
        switch (_d2.label) {
          case 0:
            return [4, producer.getStats()];
          case 1:
            stat = _d2.sent();
            result = parse ? this.getProducerStatsFromReport(this.parseRTCReport(stat, ["outbound-rtp", "remote-inbound-rtp"], false, producer.id))[0] : void 0;
            try {
              for (_a3 = __values$3(stat.values()), _b2 = _a3.next(); !_b2.done; _b2 = _a3.next()) {
                entry = _b2.value;
                switch (entry.type) {
                  case "outbound-rtp": {
                    this.outboundProducerMap.set(entry.id, producer.id);
                    break;
                  }
                  default:
                    break;
                }
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (_b2 && !_b2.done && (_c2 = _a3.return))
                  _c2.call(_a3);
              } finally {
                if (e_1)
                  throw e_1.error;
              }
            }
            return [2, result];
        }
      });
    });
  };
  Measurements2.prototype.generateConsumerStreamMap = function(consumer, parse) {
    if (parse === void 0) {
      parse = false;
    }
    return __awaiter$4(this, void 0, void 0, function() {
      var stat, result, _a3, _b2, entry;
      var e_2, _c2;
      return __generator$3(this, function(_d2) {
        switch (_d2.label) {
          case 0:
            return [4, consumer.getStats()];
          case 1:
            stat = _d2.sent();
            result = parse ? this.getConsumerStatsFromReport(this.parseRTCReport(stat, ["inbound-rtp"], false, consumer.id))[0] : void 0;
            try {
              for (_a3 = __values$3(stat.values()), _b2 = _a3.next(); !_b2.done; _b2 = _a3.next()) {
                entry = _b2.value;
                switch (entry.type) {
                  case "inbound-rtp": {
                    this.inboundConsumerMap.set(entry.id, consumer.id);
                    break;
                  }
                  default:
                    break;
                }
              }
            } catch (e_2_1) {
              e_2 = { error: e_2_1 };
            } finally {
              try {
                if (_b2 && !_b2.done && (_c2 = _a3.return))
                  _c2.call(_a3);
              } finally {
                if (e_2)
                  throw e_2.error;
              }
            }
            return [2, result];
        }
      });
    });
  };
  Measurements2.prototype.deregisterProducer = function(producer) {
    var _this = this;
    this.outboundProducerMap.forEach(function(value, key) {
      if (value === producer.id) {
        _this.outboundProducerMap.delete(key);
      }
    });
  };
  Measurements2.prototype.deregisterConsumer = function(consumer) {
    var _this = this;
    this.inboundConsumerMap.forEach(function(value, key) {
      if (value === consumer.id) {
        _this.inboundConsumerMap.delete(key);
      }
    });
    this.consumerPeerIdMap.delete(consumer.id);
  };
  Measurements2.prototype.parseRTCReport = function(report, filters, onceOnly, ownerId, transportInfo) {
    var e_3, _a3;
    if (filters === void 0) {
      filters = [];
    }
    if (onceOnly === void 0) {
      onceOnly = false;
    }
    if (ownerId === void 0) {
      ownerId = void 0;
    }
    if (transportInfo === void 0) {
      transportInfo = void 0;
    }
    var stat = report;
    var result = new ParsedRTCStats();
    var filtersSet = filters.length ? new Set(filters) : void 0;
    try {
      for (var _b2 = __values$3(stat.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var entry = _c2.value;
        if (filtersSet) {
          if (filtersSet.size === 0) {
            break;
          } else if (!filtersSet.has(entry.type)) {
            continue;
          } else if (onceOnly) {
            filtersSet.delete(entry.type);
          }
        }
        switch (entry.type) {
          case "candidate-pair": {
            if (entry.nominated === true && entry.selected === true) {
              var candidateStats = entry;
              var data = {
                bytesReceived: candidateStats.bytesReceived,
                bytesSent: candidateStats.bytesSent,
                currentRoundTripTime: candidateStats.currentRoundTripTime,
                totalRoundTripTime: candidateStats.totalRoundTripTime,
                availableOutgoingBitrate: candidateStats.availableOutgoingBitrate
              };
              result.candidatePair = data;
              break;
            }
            break;
          }
          case "transport": {
            var transportStats = entry;
            if (transportInfo) {
              if (transportInfo.producing) {
                if (!this.overallProducingTransportsStatsMap[transportInfo.id]) {
                  this.overallProducingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsSent: 0
                  };
                }
              }
              if (transportInfo.consuming) {
                if (!this.overallConsumingTransportsStatsMap[transportInfo.id]) {
                  this.overallConsumingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsReceived: 0
                  };
                }
              }
            }
            var data = {
              bytesReceived: transportStats.bytesReceived,
              bytesSent: transportStats.bytesSent,
              packetsSent: transportStats.packetsSent,
              packetsReceived: transportStats.packetsReceived,
              dtlsCipher: transportStats.dtlsCipher,
              dtlsState: transportStats["dtlsState"],
              iceRole: transportStats["iceRole"]
            };
            result.transport = data;
            if (transportInfo) {
              if (transportInfo.producing) {
                var overallStatsForTransport = this.overallProducingTransportsStatsMap[transportInfo.id];
                this.processProducingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
              if (transportInfo.consuming) {
                var overallStatsForTransport = this.overallConsumingTransportsStatsMap[transportInfo.id];
                this.processConsumingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
            }
            break;
          }
          case "remote-inbound-rtp": {
            var rtpStreamStats = entry;
            var data = {
              jitter: rtpStreamStats.jitter,
              fractionLost: rtpStreamStats.fractionLost,
              roundTripTime: rtpStreamStats.roundTripTime,
              roundTripTimeMeasurements: rtpStreamStats.roundTripTimeMeasurements,
              totalRoundTripTime: rtpStreamStats.totalRoundTripTime,
              packetsLost: rtpStreamStats.packetsLost
            };
            result.remoteInboundRtp.set(rtpStreamStats.localId, data);
            break;
          }
          case "outbound-rtp": {
            var rtpStreamStats = entry;
            var producerId = ownerId || this.outboundProducerMap.get(entry.id);
            if (!this.overallProducersStatsMap[producerId]) {
              this.overallProducersStatsMap[producerId] = {
                totalVideoPacketsSent: 0,
                totalAudioPacketsSent: 0
              };
            }
            var overallStatsForProducer = this.overallProducersStatsMap[producerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.outboundProducerMap.has(entry.id)) {
                result.staleProducerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("outbound-rtp");
                }
                break;
              }
              if (!result.producerStreamMap.has(producerId)) {
                result.producerStreamMap.set(producerId, {
                  outboundVideoRtpId: [],
                  outboundAudioRtpId: []
                });
              }
              var outboundData = {
                bytesSent: rtpStreamStats.bytesSent,
                packetsSent: rtpStreamStats.packetsSent,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$2({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesEncoded: videoRtpStreamStats.framesEncoded, framesDropped: videoRtpStreamStats.framesDropped, framesPerSecond: videoRtpStreamStats.framesPerSecond, framesSent: videoRtpStreamStats.framesSent, keyFramesEncoded: videoRtpStreamStats.keyFramesEncoded, firCount: videoRtpStreamStats.firCount, encoderImplementation: videoRtpStreamStats.encoderImplementation, hugeFramesSent: videoRtpStreamStats.hugeFramesSent, pliCount: videoRtpStreamStats.pliCount, qpSum: videoRtpStreamStats.qpSum, qualityLimitationDurations: videoRtpStreamStats.qualityLimitationDurations, qualityLimitationReason: videoRtpStreamStats.qualityLimitationReason, qualityLimitationResolutionChanges: videoRtpStreamStats.qualityLimitationResolutionChanges, totalEncodeTime: videoRtpStreamStats.totalEncodeTime, totalPacketSendDelay: videoRtpStreamStats.totalEncodeTime, retransmittedBytesSent: videoRtpStreamStats.retransmittedBytesSent, retransmittedPacketsSent: videoRtpStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundVideoRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundVideoRtpId.push(entry.id);
                this.processOutboundProducerVideoStats(producerId, overallStatsForProducer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$2({ retransmittedBytesSent: audioStreamStats.retransmittedBytesSent, retransmittedPacketsSent: audioStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundAudioRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundAudioRtpId.push(entry.id);
                this.processOutboundProducerAudioStats(producerId, overallStatsForProducer, data);
              }
            } else {
            }
            break;
          }
          case "inbound-rtp": {
            var rtpStreamStats = entry;
            var consumerId = ownerId || this.inboundConsumerMap.get(entry.id);
            if (rtpStreamStats.ssrc === 1234) {
              break;
            }
            if (!this.overallConsumersStatsMap[consumerId]) {
              this.overallConsumersStatsMap[consumerId] = {
                totalVideoPacketsReceived: 0,
                totalAudioPacketsReceived: 0
              };
            }
            var overallStatsForConsumer = this.overallConsumersStatsMap[consumerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.inboundConsumerMap.has(entry.id)) {
                result.staleConsumerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("inbound-rtp");
                }
                break;
              }
              if (!result.consumerStreamMap.has(consumerId)) {
                result.consumerStreamMap.set(consumerId, {
                  inboundVideoRtpId: [],
                  inboundAudioRtpId: []
                });
              }
              var inboundData = {
                bytesReceived: rtpStreamStats.bytesReceived,
                packetsReceived: rtpStreamStats.packetsReceived,
                packetsLost: rtpStreamStats.packetsLost,
                jitter: rtpStreamStats.jitter,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$2({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesDecoded: videoRtpStreamStats.framesDecoded, framesDropped: videoRtpStreamStats.framesDropped, framesPerSecond: videoRtpStreamStats.framesPerSecond, framesReceived: videoRtpStreamStats.framesReceived, keyFramesDecoded: videoRtpStreamStats.keyFramesDecoded, firCount: videoRtpStreamStats.firCount, decoderImplementation: videoRtpStreamStats.decoderImplementation }, inboundData);
                result.inboundVideoRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundVideoRtpId.push(entry.id);
                this.processInboundConsumerVideoStats(consumerId, overallStatsForConsumer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$2({ audioLevel: audioStreamStats.audioLevel, concealedSampels: audioStreamStats.concealedSampels, concealmentEvents: audioStreamStats.concealmentEvents, jitterBufferDelay: audioStreamStats.jitterBufferDelay, jitterBufferEmittedCount: audioStreamStats.jitterBufferEmittedCount, totalAudioEnergy: audioStreamStats.totalAudioEnergy, totalSamplesDuration: audioStreamStats.totalSamplesDuration, totalSamplesReceived: audioStreamStats.totalSamplesReceived }, inboundData);
                result.inboundAudioRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundAudioRtpId.push(entry.id);
                this.processInboundConsumerAudioStats(consumerId, overallStatsForConsumer, data);
              }
            } else {
            }
            break;
          }
          default:
            break;
        }
      }
    } catch (e_3_1) {
      e_3 = { error: e_3_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a3 = _b2.return))
          _a3.call(_b2);
      } finally {
        if (e_3)
          throw e_3.error;
      }
    }
    result.outboundVideoRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    result.outboundAudioRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    if (result.candidatePair) {
      if (result.transport) {
        result.transport.totalRoundTripTime = result.candidatePair.totalRoundTripTime;
        result.transport.availableOutgoingBitrate = result.candidatePair.availableOutgoingBitrate;
        result.transport.roundTripTime = result.candidatePair.currentRoundTripTime;
      } else {
        result.transport = {
          bytesReceived: result.candidatePair.bytesReceived,
          bytesSent: result.candidatePair.bytesSent,
          totalRoundTripTime: result.candidatePair.totalRoundTripTime,
          availableOutgoingBitrate: result.candidatePair.availableOutgoingBitrate,
          roundTripTime: result.candidatePair.currentRoundTripTime
        };
      }
    }
    if (result.transport && !result.transport.roundTripTime) {
      var rtt_1 = 0;
      var totalRTT_1 = 0;
      result.remoteInboundRtp.forEach(function(value, key) {
        if (value.roundTripTime && value.roundTripTime > rtt_1) {
          rtt_1 = value.roundTripTime;
          totalRTT_1 = value.totalRoundTripTime;
        }
      });
      result.transport.roundTripTime = rtt_1;
      result.transport.totalRoundTripTime = totalRTT_1;
    }
    return result;
  };
  Measurements2.prototype.getProducersReport = function(producers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var producerPromises;
      var _this = this;
      return __generator$3(this, function(_a3) {
        producerPromises = producers.map(function(producer) {
          return _this.generateProducerStreamMap(producer, true);
        });
        return [2, producerPromises.length > 0 ? Promise.all(producerPromises) : void 0];
      });
    });
  };
  Measurements2.prototype.getConsumersReport = function(consumers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var consumerPromises;
      var _this = this;
      return __generator$3(this, function(_a3) {
        consumerPromises = consumers.map(function(consumer) {
          return _this.generateConsumerStreamMap(consumer, true);
        });
        return [2, consumerPromises.length > 0 ? Promise.all(consumerPromises) : void 0];
      });
    });
  };
  Measurements2.prototype.getTransportReport = function(transport) {
    return __awaiter$4(this, void 0, void 0, function() {
      return __generator$3(this, function(_a3) {
        return [2, transport.getStats()];
      });
    });
  };
  Measurements2.prototype.getProcessedStats = function(transport, consuming, producing) {
    return __awaiter$4(this, void 0, void 0, function() {
      var transportStats, transportInfo, stat, result, transportReport, producerReport, consumerReport;
      return __generator$3(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            return [4, this.getTransportReport(transport)];
          case 1:
            transportStats = _a3.sent();
            transportInfo = { producing, consuming, id: transport.id };
            stat = transportStats;
            result = this.parseRTCReport(stat, ["transport", "candidate-pair", "inbound-rtp", "outbound-rtp", "remote-inbound-rtp"], false, void 0, transportInfo);
            if (!result) {
              return [2, void 0];
            }
            transportReport = {
              stats: result.transport,
              transportId: transport.id,
              consuming,
              producing
            };
            producerReport = result.staleProducerStreamMap ? void 0 : this.getProducerStatsFromReport(result);
            consumerReport = result.staleConsumerStreamMap ? void 0 : this.getConsumerStatsFromReport(result);
            return [2, {
              transportReport,
              producerReport,
              consumerReport
            }];
        }
      });
    });
  };
  Measurements2.prototype.getProducerStatsFromReport = function(report) {
    var producerReport = [];
    try {
      report.producerStreamMap.forEach(function(value, key) {
        producerReport.push({
          producerId: key,
          videoStats: value.outboundVideoRtpId.map(function(id) {
            return report.outboundVideoRtp.get(id);
          }),
          audioStats: value.outboundAudioRtpId.map(function(id) {
            return report.outboundAudioRtp.get(id);
          })
        });
      });
    } catch (error) {
      console.error("getProducersReport: ", error, report);
    }
    return producerReport;
  };
  Measurements2.prototype.getConsumerStatsFromReport = function(report) {
    var _this = this;
    var consumerReport = [];
    try {
      report.consumerStreamMap.forEach(function(value, key) {
        var _a3 = _this.consumerPeerIdMap.get(key), peerId = _a3.peerId, producerId = _a3.producerId;
        consumerReport.push({
          consumerId: key,
          peerId,
          producerId,
          videoStats: value.inboundVideoRtpId.map(function(id) {
            return report.inboundVideoRtp.get(id);
          }),
          audioStats: value.inboundAudioRtpId.map(function(id) {
            return report.inboundAudioRtp.get(id);
          })
        });
      });
    } catch (error) {
      console.error("getConsumersReport: ", error, report);
    }
    return consumerReport;
  };
  Measurements2.prototype.getUserLocation = function() {
    return __awaiter$4(this, void 0, void 0, function() {
      var promise;
      return __generator$3(this, function(_a3) {
        promise = new Promise(function(resolve, reject) {
          try {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition(function(position) {
                resolve(position);
              });
            } else {
              reject();
            }
          } catch (e) {
            reject(e);
          }
        });
        return [2, promise];
      });
    });
  };
  Measurements2.prototype.getConnectivity = function(iceServers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var config_1, hostPromise, relayPromise, reflexivePromise, _a3, host, relay, reflexive;
      return __generator$3(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            _c2.trys.push([0, 2, , 3]);
            config_1 = {
              iceServers: iceServers || FALLBACK_ICE_SERVERS
            };
            hostPromise = new Promise(function(resolve, reject) {
              try {
                var test_1 = new HostConnectivityTest(config_1);
                test_1.addListener("done", resolve);
                test_1.addListener("failed", function() {
                  resolve({ connectivity: false });
                });
                test_1.start(2e3);
              } catch (e) {
                reject(e);
              }
            });
            relayPromise = new Promise(function(resolve, reject) {
              try {
                var test_2 = new RelayConnectivityTest(config_1);
                test_2.addListener("done", resolve);
                test_2.addListener("failed", function() {
                  resolve({ connectivity: false });
                });
                test_2.start(2e3);
              } catch (e) {
                reject(e);
              }
            });
            reflexivePromise = new Promise(function(resolve, reject) {
              try {
                var test_3 = new ReflexiveConnectivityTest(config_1);
                test_3.addListener("done", resolve);
                test_3.addListener("failed", function() {
                  resolve({ connectivity: false });
                });
                test_3.start(2e3);
              } catch (e) {
                reject(e);
              }
            });
            return [4, Promise.all([hostPromise, relayPromise, reflexivePromise])];
          case 1:
            _a3 = __read$2.apply(void 0, [_c2.sent(), 3]), host = _a3[0], relay = _a3[1], reflexive = _a3[2];
            return [2, {
              host: host === null || host === void 0 ? void 0 : host.connectivity,
              relay: relay === null || relay === void 0 ? void 0 : relay.connectivity,
              reflexive: reflexive === null || reflexive === void 0 ? void 0 : reflexive.connectivity
            }];
          case 2:
            _c2.sent();
            return [2, {
              host: false,
              relay: false,
              reflexive: false
            }];
          case 3:
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.getThroughput = function(iceServers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var throughPutPromise, results;
      return __generator$3(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            _b2.trys.push([0, 2, , 3]);
            throughPutPromise = new Promise(function(resolve, reject) {
              try {
                var config2 = {
                  iceServers: iceServers || FALLBACK_ICE_SERVERS
                };
                var test_4 = new DataThroughputTest(config2);
                test_4.addListener("done", resolve);
                test_4.addListener("failed", reject);
                test_4.start(1e4);
              } catch (e) {
                reject(e);
              }
            });
            return [4, throughPutPromise];
          case 1:
            results = _b2.sent();
            return [2, {
              throughput: results.throughput,
              fractionalLoss: 0,
              RTT: results.RTT,
              jitter: 0,
              backendRTT: results.backendRTT
            }];
          case 2:
            _b2.sent();
            return [2, void 0];
          case 3:
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.getIPDetails = function() {
    return __awaiter$4(this, void 0, void 0, function() {
      var _a3;
      return __generator$3(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            _c2.trys.push([0, 3, , 4]);
            if (!!this.ipDetails)
              return [3, 2];
            _a3 = this;
            return [4, ipDetails.getIPDetails()];
          case 1:
            _a3.ipDetails = _c2.sent();
            _c2.label = 2;
          case 2:
            return [2, this.ipDetails];
          case 3:
            _c2.sent();
            return [2, void 0];
          case 4:
            return [2];
        }
      });
    });
  };
  Measurements2.prototype.getNetworkQuality = function(iceServers) {
    return __awaiter$4(this, void 0, void 0, function() {
      var _a3, connectivity, throughput, measurements;
      return __generator$3(this, function(_b2) {
        switch (_b2.label) {
          case 0:
            return [4, Promise.all([
              this.getConnectivity(iceServers),
              this.getThroughput(iceServers)
            ])];
          case 1:
            _a3 = __read$2.apply(void 0, [_b2.sent(), 2]), connectivity = _a3[0], throughput = _a3[1];
            measurements = {
              connectivity,
              throughput: throughput === null || throughput === void 0 ? void 0 : throughput.throughput,
              fractionalLoss: throughput === null || throughput === void 0 ? void 0 : throughput.fractionalLoss,
              RTT: throughput === null || throughput === void 0 ? void 0 : throughput.RTT,
              jitter: throughput === null || throughput === void 0 ? void 0 : throughput.jitter,
              backendRTT: throughput === null || throughput === void 0 ? void 0 : throughput.backendRTT
            };
            return [2, measurements];
        }
      });
    });
  };
  Measurements2.prototype.getNetworkInfo = function(iceServers) {
    var _a3;
    return __awaiter$4(this, void 0, void 0, function() {
      var _b2, connectivity, throughput, ipDetails2, measurements;
      return __generator$3(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            return [4, Promise.all([
              this.getConnectivity(iceServers),
              this.getThroughput(iceServers),
              this.getIPDetails()
            ])];
          case 1:
            _b2 = __read$2.apply(void 0, [_c2.sent(), 3]), connectivity = _b2[0], throughput = _b2[1], ipDetails2 = _b2[2];
            measurements = {
              ipDetails: ipDetails2,
              effectiveNetworkType: (_a3 = navigator.connection) === null || _a3 === void 0 ? void 0 : _a3.effectiveType,
              location: ipDetails2.loc ? parseIpLocation(ipDetails2.loc) : void 0,
              turnConnectivity: connectivity ? connectivity.host || connectivity.relay || connectivity.reflexive : false,
              connectivity,
              throughput: throughput === null || throughput === void 0 ? void 0 : throughput.throughput,
              fractionalLoss: throughput === null || throughput === void 0 ? void 0 : throughput.fractionalLoss,
              RTT: throughput === null || throughput === void 0 ? void 0 : throughput.RTT,
              jitter: throughput === null || throughput === void 0 ? void 0 : throughput.jitter,
              backendRTT: throughput === null || throughput === void 0 ? void 0 : throughput.backendRTT
            };
            return [2, measurements];
        }
      });
    });
  };
  return Measurements2;
}();
var __extends$3 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var ChromeMeasurements = function(_super) {
  __extends$3(ChromeMeasurements2, _super);
  function ChromeMeasurements2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return ChromeMeasurements2;
}(Measurements);
var __extends$2 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign$1 = globalThis && globalThis.__assign || function() {
  __assign$1 = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign$1.apply(this, arguments);
};
var __awaiter$3 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$2 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __read$1 = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray$1 = globalThis && globalThis.__spreadArray || function(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
    to[j] = from[i];
  return to;
};
var __values$2 = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i >= o.length)
          o = void 0;
        return { value: o && o[i++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var FirefoxMeasurements = function(_super) {
  __extends$2(FirefoxMeasurements2, _super);
  function FirefoxMeasurements2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.producerMap = new Map();
    _this.consumerMap = new Map();
    return _this;
  }
  FirefoxMeasurements2.prototype.registerProducer = function(producer) {
    return __awaiter$3(this, void 0, void 0, function() {
      return __generator$2(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            this.producerMap.set(producer.id, producer);
            return [4, this.generateProducerStreamMap(producer)];
          case 1:
            _a3.sent();
            producer.observer.on("close", this.deregisterProducer.bind(this, producer));
            return [2];
        }
      });
    });
  };
  FirefoxMeasurements2.prototype.registerConsumer = function(consumer) {
    return __awaiter$3(this, void 0, void 0, function() {
      return __generator$2(this, function(_a3) {
        switch (_a3.label) {
          case 0:
            this.consumerMap.set(consumer.id, consumer);
            return [4, this.generateConsumerStreamMap(consumer)];
          case 1:
            _a3.sent();
            this.consumerPeerIdMap.set(consumer.id, {
              producerId: consumer.producerId,
              peerId: consumer.appData.peerId
            });
            consumer.observer.on("close", this.deregisterConsumer.bind(this, consumer));
            return [2];
        }
      });
    });
  };
  FirefoxMeasurements2.prototype.generateConsumerStreamMap = function(consumer, parse) {
    if (parse === void 0) {
      parse = false;
    }
    return __awaiter$3(this, void 0, void 0, function() {
      var stat, report, statsObj, result, _a3, _b2, entry;
      var e_1, _c2;
      return __generator$2(this, function(_d2) {
        switch (_d2.label) {
          case 0:
            return [4, consumer.getStats()];
          case 1:
            stat = _d2.sent();
            report = this.parseRTCReport(stat, ["inbound-rtp"], false, consumer.id);
            statsObj = __spreadArray$1([], __read$1(report.consumerStreamMap.values()))[0];
            result = parse ? this.getConsumerStatsFromParsedConsumerStats(report, statsObj, consumer.id) : void 0;
            try {
              for (_a3 = __values$2(stat.values()), _b2 = _a3.next(); !_b2.done; _b2 = _a3.next()) {
                entry = _b2.value;
                switch (entry.type) {
                  case "inbound-rtp": {
                    this.inboundConsumerMap.set(entry.id, consumer.id);
                    break;
                  }
                  default:
                    break;
                }
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (_b2 && !_b2.done && (_c2 = _a3.return))
                  _c2.call(_a3);
              } finally {
                if (e_1)
                  throw e_1.error;
              }
            }
            return [2, result];
        }
      });
    });
  };
  FirefoxMeasurements2.prototype.deregisterProducer = function(producer) {
    var _this = this;
    this.producerMap.delete(producer.id);
    this.outboundProducerMap.forEach(function(value, key) {
      if (value === producer.id) {
        _this.outboundProducerMap.delete(key);
      }
    });
  };
  FirefoxMeasurements2.prototype.deregisterConsumer = function(consumer) {
    var _this = this;
    this.consumerMap.delete(consumer.id);
    this.inboundConsumerMap.forEach(function(value, key) {
      if (value === consumer.id) {
        _this.inboundConsumerMap.delete(key);
      }
    });
    this.consumerPeerIdMap.delete(consumer.id);
  };
  FirefoxMeasurements2.prototype.parseRTCReport = function(report, filters, onceOnly, ownerId, transportInfo) {
    var e_2, _a3;
    if (filters === void 0) {
      filters = [];
    }
    if (onceOnly === void 0) {
      onceOnly = false;
    }
    if (ownerId === void 0) {
      ownerId = void 0;
    }
    if (transportInfo === void 0) {
      transportInfo = void 0;
    }
    var stat = report;
    var result = new ParsedRTCStats();
    var filtersSet = filters.length ? new Set(filters) : void 0;
    try {
      for (var _b2 = __values$2(stat.values()), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var entry = _c2.value;
        if (filtersSet) {
          if (filtersSet.size === 0) {
            break;
          } else if (!filtersSet.has(entry.type)) {
            continue;
          } else if (onceOnly) {
            filtersSet.delete(entry.type);
          }
        }
        switch (entry.type) {
          case "candidate-pair": {
            if (entry.nominated === true && entry.selected === true) {
              var candidateStats = entry;
              var data = {
                bytesReceived: candidateStats.bytesReceived,
                bytesSent: candidateStats.bytesSent,
                currentRoundTripTime: candidateStats.currentRoundTripTime,
                totalRoundTripTime: candidateStats.totalRoundTripTime,
                availableOutgoingBitrate: candidateStats.availableOutgoingBitrate
              };
              result.candidatePair = data;
              break;
            }
            break;
          }
          case "transport": {
            var transportStats = entry;
            if (transportInfo) {
              if (transportInfo.producing) {
                if (!this.overallProducingTransportsStatsMap[transportInfo.id]) {
                  this.overallProducingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsSent: 0
                  };
                }
              }
              if (transportInfo.consuming) {
                if (!this.overallConsumingTransportsStatsMap[transportInfo.id]) {
                  this.overallConsumingTransportsStatsMap[transportInfo.id] = {
                    totalPacketsReceived: 0
                  };
                }
              }
            }
            var data = {
              bytesReceived: transportStats.bytesReceived,
              bytesSent: transportStats.bytesSent,
              packetsSent: transportStats.packetsSent,
              packetsReceived: transportStats.packetsReceived,
              dtlsCipher: transportStats.dtlsCipher,
              dtlsState: transportStats.dtlsState,
              iceRole: transportStats.iceRole
            };
            result.transport = data;
            if (transportInfo) {
              if (transportInfo.producing) {
                var overallStatsForTransport = this.overallProducingTransportsStatsMap[transportInfo.id];
                this.processProducingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
              if (transportInfo.consuming) {
                var overallStatsForTransport = this.overallConsumingTransportsStatsMap[transportInfo.id];
                this.processConsumingTransportStats(transportInfo.id, overallStatsForTransport, data);
              }
            }
            break;
          }
          case "remote-inbound-rtp": {
            var rtpStreamStats = entry;
            var data = {
              jitter: rtpStreamStats.jitter,
              fractionLost: rtpStreamStats.fractionLost,
              roundTripTime: rtpStreamStats.roundTripTime,
              roundTripTimeMeasurements: rtpStreamStats.roundTripTimeMeasurements,
              totalRoundTripTime: rtpStreamStats.totalRoundTripTime,
              packetsLost: rtpStreamStats.packetsLost
            };
            result.remoteInboundRtp.set(rtpStreamStats.localId, data);
            break;
          }
          case "outbound-rtp": {
            var rtpStreamStats = entry;
            var producerId = ownerId || this.outboundProducerMap.get(entry.id);
            if (!this.overallProducersStatsMap[producerId]) {
              this.overallProducersStatsMap[producerId] = {
                totalVideoPacketsSent: 0,
                totalAudioPacketsSent: 0
              };
            }
            var overallStatsForProducer = this.overallProducersStatsMap[producerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.outboundProducerMap.has(entry.id)) {
                result.staleProducerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("outbound-rtp");
                }
                break;
              }
              if (!result.producerStreamMap.has(producerId)) {
                result.producerStreamMap.set(producerId, {
                  outboundVideoRtpId: [],
                  outboundAudioRtpId: []
                });
              }
              var outboundData = {
                bytesSent: rtpStreamStats.bytesSent,
                packetsSent: rtpStreamStats.packetsSent,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$1({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesEncoded: videoRtpStreamStats.framesEncoded, framesDropped: videoRtpStreamStats.framesDropped ? videoRtpStreamStats.framesDropped : videoRtpStreamStats.droppedFrames, framesPerSecond: videoRtpStreamStats.framesPerSecond ? videoRtpStreamStats.framesPerSecond : videoRtpStreamStats.framerateMean, framesSent: videoRtpStreamStats.framesSent, keyFramesEncoded: videoRtpStreamStats.keyFramesEncoded, firCount: videoRtpStreamStats.firCount, encoderImplementation: videoRtpStreamStats.encoderImplementation, hugeFramesSent: videoRtpStreamStats.hugeFramesSent, pliCount: videoRtpStreamStats.pliCount, qpSum: videoRtpStreamStats.qpSum, qualityLimitationReason: videoRtpStreamStats.qualityLimitationReason, qualityLimitationDurations: videoRtpStreamStats.qualityLimitationDurations, qualityLimitationResolutionChanges: videoRtpStreamStats.qualityLimitationResolutionChanges, totalEncodeTime: videoRtpStreamStats.totalEncodeTime, totalPacketSendDelay: videoRtpStreamStats.totalEncodeTime, retransmittedBytesSent: videoRtpStreamStats.retransmittedBytesSent, retransmittedPacketsSent: videoRtpStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundVideoRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundVideoRtpId.push(entry.id);
                this.processOutboundProducerVideoStats(producerId, overallStatsForProducer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$1({ retransmittedBytesSent: audioStreamStats.retransmittedBytesSent, retransmittedPacketsSent: audioStreamStats.retransmittedPacketsSent }, outboundData);
                result.outboundAudioRtp.set(entry.id, data);
                result.producerStreamMap.get(producerId).outboundAudioRtpId.push(entry.id);
                this.processOutboundProducerAudioStats(producerId, overallStatsForProducer, data);
              }
            } else {
            }
            break;
          }
          case "inbound-rtp": {
            var rtpStreamStats = entry;
            var consumerId = ownerId || this.inboundConsumerMap.get(entry.id);
            if (!this.overallConsumersStatsMap[consumerId]) {
              this.overallConsumersStatsMap[consumerId] = {
                totalVideoPacketsReceived: 0,
                totalAudioPacketsReceived: 0
              };
            }
            var overallStatsForConsumer = this.overallConsumersStatsMap[consumerId];
            if (["video", "audio"].includes(rtpStreamStats.mediaType)) {
              if (!this.inboundConsumerMap.has(entry.id)) {
                result.staleConsumerStreamMap = true;
                if (filtersSet) {
                  filtersSet.delete("inbound-rtp");
                }
                break;
              }
              if (!result.consumerStreamMap.has(consumerId)) {
                result.consumerStreamMap.set(consumerId, {
                  inboundVideoRtpId: [],
                  inboundAudioRtpId: []
                });
              }
              var inboundData = {
                bytesReceived: rtpStreamStats.bytesReceived,
                packetsReceived: rtpStreamStats.packetsReceived,
                packetsLost: rtpStreamStats.packetsLost,
                jitter: rtpStreamStats.jitter,
                nackCount: rtpStreamStats.nackCount
              };
              if (rtpStreamStats.mediaType === "video") {
                if (rtpStreamStats.decoderImplementation === "unknown") {
                  break;
                }
                var videoRtpStreamStats = rtpStreamStats;
                var data = __assign$1({ frameHeight: videoRtpStreamStats.frameHeight, frameWidth: videoRtpStreamStats.frameWidth, framesDecoded: videoRtpStreamStats.framesDecoded, framesDropped: videoRtpStreamStats.framesDropped ? videoRtpStreamStats.framesDropped : videoRtpStreamStats.droppedFrames, framesPerSecond: videoRtpStreamStats.framesPerSecond ? videoRtpStreamStats.framesPerSecond : videoRtpStreamStats.framerateMean, framesReceived: videoRtpStreamStats.framesReceived, keyFramesDecoded: videoRtpStreamStats.keyFramesDecoded, firCount: videoRtpStreamStats.firCount, decoderImplementation: videoRtpStreamStats.decoderImplementation }, inboundData);
                result.inboundVideoRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundVideoRtpId.push(entry.id);
                this.processInboundConsumerVideoStats(consumerId, overallStatsForConsumer, data);
              } else if (rtpStreamStats.mediaType === "audio") {
                var audioStreamStats = rtpStreamStats;
                var data = __assign$1({ audioLevel: audioStreamStats.audioLevel, concealedSampels: audioStreamStats.concealedSampels, concealmentEvents: audioStreamStats.concealmentEvents, jitterBufferDelay: audioStreamStats.jitterBufferDelay, jitterBufferEmittedCount: audioStreamStats.jitterBufferEmittedCount, totalAudioEnergy: audioStreamStats.totalAudioEnergy, totalSamplesDuration: audioStreamStats.totalSamplesDuration, totalSamplesReceived: audioStreamStats.totalSamplesReceived }, inboundData);
                result.inboundAudioRtp.set(entry.id, data);
                result.consumerStreamMap.get(consumerId).inboundAudioRtpId.push(entry.id);
                this.processInboundConsumerAudioStats(consumerId, overallStatsForConsumer, data);
              }
            } else {
            }
            break;
          }
          default:
            break;
        }
      }
    } catch (e_2_1) {
      e_2 = { error: e_2_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a3 = _b2.return))
          _a3.call(_b2);
      } finally {
        if (e_2)
          throw e_2.error;
      }
    }
    result.outboundVideoRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    result.outboundAudioRtp.forEach(function(value, key) {
      value.remoteData = result.remoteInboundRtp.get(key);
    });
    if (result.candidatePair) {
      if (result.transport) {
        result.transport.bytesReceived = result.candidatePair.bytesReceived;
        result.transport.bytesSent = result.candidatePair.bytesSent;
        result.transport.totalRoundTripTime = result.candidatePair.totalRoundTripTime;
        result.transport.availableOutgoingBitrate = result.candidatePair.availableOutgoingBitrate;
        result.transport.roundTripTime = result.candidatePair.currentRoundTripTime;
      } else {
        result.transport = {
          bytesReceived: result.candidatePair.bytesReceived,
          bytesSent: result.candidatePair.bytesSent,
          totalRoundTripTime: result.candidatePair.totalRoundTripTime,
          availableOutgoingBitrate: result.candidatePair.availableOutgoingBitrate,
          roundTripTime: result.candidatePair.currentRoundTripTime
        };
      }
    }
    if (result.transport && !result.transport.roundTripTime) {
      var rtt_1 = 0;
      var totalRTT_1 = 0;
      result.remoteInboundRtp.forEach(function(value, key) {
        if (value.roundTripTime && value.roundTripTime > rtt_1) {
          rtt_1 = value.roundTripTime;
          totalRTT_1 = value.totalRoundTripTime;
        }
      });
      result.transport.roundTripTime = rtt_1;
      result.transport.totalRoundTripTime = totalRTT_1;
    }
    return result;
  };
  FirefoxMeasurements2.prototype.getProducerStatsFromReport = function(report) {
    var _this = this;
    var producerReport = [];
    try {
      report.producerStreamMap.forEach(function(value, key) {
        var producer = _this.producerMap.get(key);
        var track = producer.track.getSettings();
        var videoStats = value.outboundVideoRtpId.map(function(id) {
          var val = report.outboundVideoRtp.get(id);
          if (!val.frameHeight) {
            val.frameHeight = track.height;
            val.frameWidth = track.width;
            val.framesPerSecond = track.frameRate;
          }
          return val;
        });
        var entry = {
          producerId: key,
          videoStats,
          audioStats: value.outboundAudioRtpId.map(function(id) {
            return report.outboundAudioRtp.get(id);
          })
        };
        producerReport.push(entry);
      });
    } catch (error) {
      console.error("getProducersReport: ", error, report);
    }
    return producerReport;
  };
  FirefoxMeasurements2.prototype.getConsumerStatsFromParsedConsumerStats = function(report, stats, consumerId) {
    var _this = this;
    var consumerReport;
    try {
      var _a3 = this.consumerPeerIdMap.get(consumerId), peerId = _a3.peerId, producerId = _a3.producerId;
      var videoStats = stats === null || stats === void 0 ? void 0 : stats.inboundVideoRtpId.map(function(id) {
        var consumer = _this.consumerMap.get(consumerId);
        var track = consumer.track.getSettings();
        var val = report.inboundVideoRtp.get(id);
        if (!val.frameHeight) {
          val.frameHeight = track.height;
          val.frameWidth = track.width;
          val.framesPerSecond = track.frameRate;
        }
        return val;
      });
      consumerReport = {
        consumerId,
        peerId,
        producerId,
        videoStats,
        audioStats: stats === null || stats === void 0 ? void 0 : stats.inboundAudioRtpId.map(function(id) {
          return report.inboundAudioRtp.get(id);
        })
      };
    } catch (error) {
      console.error("getConsumerStatsFromParsedConsumerStats: ", error, report);
    }
    return consumerReport;
  };
  FirefoxMeasurements2.prototype.getConsumerStatsFromReport = function(report) {
    var _this = this;
    var consumerReport = [];
    try {
      report.consumerStreamMap.forEach(function(value, key) {
        consumerReport.push(_this.getConsumerStatsFromParsedConsumerStats(report, value, key));
      });
    } catch (error) {
      console.error("getConsumerStatsFromReport: ", error, report);
    }
    return consumerReport;
  };
  return FirefoxMeasurements2;
}(Measurements);
var __extends$1 = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var SafariMeasurements = function(_super) {
  __extends$1(SafariMeasurements2, _super);
  function SafariMeasurements2() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  return SafariMeasurements2;
}(FirefoxMeasurements);
var __values$1 = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i >= o.length)
          o = void 0;
        return { value: o && o[i++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function handleError(ctx, errorType, handler, error) {
  if (typeof handler === "function" && error instanceof errorType) {
    handler.call(null, error, ctx);
  } else {
    throw error;
  }
}
function generateDescriptor(descriptor, errorType, handler) {
  var originalMethod = descriptor.value;
  descriptor.value = function() {
    var _this = this;
    var args = [];
    for (var _i2 = 0; _i2 < arguments.length; _i2++) {
      args[_i2] = arguments[_i2];
    }
    try {
      var result = originalMethod.apply(this, args);
      if (result && result instanceof Promise) {
        return result.catch(function(error) {
          handleError(_this, errorType, handler, error);
        });
      }
      return result;
    } catch (error) {
      handleError(this, errorType, handler, error);
    }
    return null;
  };
  return descriptor;
}
var CatchFunction = function(errorType, handler) {
  return function(target, propertyKey, descriptor) {
    var originalMethod = descriptor.value;
    descriptor.value = function() {
      var _this = this;
      var args = [];
      for (var _i2 = 0; _i2 < arguments.length; _i2++) {
        args[_i2] = arguments[_i2];
      }
      try {
        var result = originalMethod.apply(this, args);
        if (result && result instanceof Promise) {
          return result.catch(function(error) {
            handleError(_this, errorType, handler, error);
          });
        }
        return result;
      } catch (error) {
        handleError(this, errorType, handler, error);
      }
      return null;
    };
    return descriptor;
  };
};
var CatchClass = function(errorType, handler) {
  return function(target, propertyKey, descriptor) {
    var e_1, _a3;
    if (descriptor) {
      return generateDescriptor(descriptor, errorType, handler);
    }
    try {
      for (var _b2 = __values$1(Reflect.ownKeys(target.prototype).filter(function(prop) {
        return prop !== "constructor";
      })), _c2 = _b2.next(); !_c2.done; _c2 = _b2.next()) {
        var propertyName = _c2.value;
        var desc = Object.getOwnPropertyDescriptor(target.prototype, propertyName);
        var isMethod = desc.value instanceof Function;
        if (!isMethod)
          continue;
        Object.defineProperty(target.prototype, propertyName, generateDescriptor(desc, errorType, handler));
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (_c2 && !_c2.done && (_a3 = _b2.return))
          _a3.call(_b2);
      } finally {
        if (e_1)
          throw e_1.error;
      }
    }
    return void 0;
  };
};
var __assign = globalThis && globalThis.__assign || function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __decorate = globalThis && globalThis.__decorate || function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
    r = Reflect.decorate(decorators, target, key, desc);
  else
    for (var i = decorators.length - 1; i >= 0; i--)
      if (d = decorators[i])
        r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter$2 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator$1 = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var __values = globalThis && globalThis.__values || function(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m)
    return m.call(o);
  if (o && typeof o.length === "number")
    return {
      next: function() {
        if (o && i >= o.length)
          o = void 0;
        return { value: o && o[i++], done: !o };
      }
    };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = globalThis && globalThis.__read || function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m)
    return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
      ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"]))
        m.call(i);
    } finally {
      if (e)
        throw e.error;
    }
  }
  return ar;
};
var __spreadArray = globalThis && globalThis.__spreadArray || function(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
    to[j] = from[i];
  return to;
};
var mainLogger = console;
var CallStats = function() {
  function CallStats2(backendUrl, engineName, env) {
    var _this = this;
    if (engineName === void 0) {
      engineName = "Blink";
    }
    if (env === void 0) {
      env = ClientEnvType.PRODUCTION;
    }
    this.producers = new Map();
    this.consumers = new Map();
    this.consumerSharedMediaStatesMap = new Map();
    this.currentUserMediaStates = {};
    this.env = env;
    if (env === ClientEnvType.DEV)
      this.logger = console;
    else {
      this.logger = {
        log: function(e) {
        },
        error: function(e) {
        },
        debug: function(e) {
        },
        trace: function(e) {
        }
      };
    }
    var connection = new SQSConnector(env);
    this.eventHandler = new EventHandler(connection);
    this.logger.log("engineName: ", engineName);
    switch (engineName) {
      case "Blink":
        this.measurements = new ChromeMeasurements();
        break;
      case "Gecko":
        this.measurements = new FirefoxMeasurements();
        break;
      case "WebKit":
        this.measurements = new SafariMeasurements();
        break;
      default:
        throw Error("Unknown engineName! " + engineName);
    }
    this.measurements.callStatsInstance = this;
    this.registerProducer = this.registerProducer.bind(this);
    this.registerConsumer = this.registerConsumer.bind(this);
    this.measurements.getIPDetails().then(function(e) {
      if (e) {
        var obj = __assign({}, e);
        if (e.loc) {
          obj.loc = parseIpLocation(e.loc);
        }
        _this.eventHandler.emit("initialized", obj);
      }
    });
  }
  CallStats2.prototype.authenticate = function(authPayload) {
    this.eventHandler.connection.authenticate(authPayload);
  };
  CallStats2.prototype.registerIceServers = function(servers) {
    this.iceServers = servers;
  };
  CallStats2.prototype.registerConsumer = function(consumer) {
    if (!this.consumerSharedMediaStatesMap.has(consumer.id)) {
      this.consumerSharedMediaStatesMap.set(consumer.id, {});
    }
    this.consumers.set(consumer.id, consumer);
    this.measurements.registerConsumer(consumer);
    this.logger.log("Registered Consumer", consumer.id, consumer);
    consumer.observer.on("close", this.deRegisterConsumer.bind(this, consumer));
  };
  CallStats2.prototype.registerProducer = function(producer) {
    this.producers.set(producer.id, producer);
    this.measurements.registerProducer(producer);
    this.logger.log("Registered Producer", producer.id, producer);
    producer.observer.on("close", this.deRegisterProducer.bind(this, producer));
  };
  CallStats2.prototype.sendConsumerSharedMediaStateEvent = function(consumerId, statusObj) {
    if (!this.consumerSharedMediaStatesMap.has(consumerId)) {
      this.consumerSharedMediaStatesMap.set(consumerId, {});
    }
    var currentStatusObj = this.consumerSharedMediaStatesMap.get(consumerId);
    this.consumerSharedMediaStatesMap.set(consumerId, Object.assign(currentStatusObj, statusObj));
  };
  CallStats2.prototype.registerProducingTransport = function(transport) {
    var _this = this;
    var _a3;
    this.producingTransport = transport;
    transport.observer.on("close", this.disconnectProducingTransport.bind(this, transport));
    transport.observer.on("disconnect", this.disconnectProducingTransport.bind(this, transport));
    var existingProducers = Array.from(((_a3 = transport._producers) === null || _a3 === void 0 ? void 0 : _a3.values()) || []);
    existingProducers.forEach(function(producer) {
      _this.registerProducer(producer);
    });
    transport.observer.on("newproducer", this.registerProducer);
  };
  CallStats2.prototype.registerConsumingTransport = function(transport) {
    var _this = this;
    var _a3;
    this.consumingTransport = transport;
    transport.observer.on("close", this.disconnectConsumingTransport.bind(this, transport));
    transport.observer.on("disconnect", this.disconnectConsumingTransport.bind(this, transport));
    var existingConsumers = Array.from(((_a3 = transport._consumers) === null || _a3 === void 0 ? void 0 : _a3.values()) || []);
    existingConsumers.forEach(function(consumer) {
      _this.registerConsumer(consumer);
    });
    transport.observer.on("newconsumer", this.registerConsumer);
  };
  CallStats2.prototype.deRegisterConsumer = function(consumer) {
    this.consumers.delete(consumer.id);
  };
  CallStats2.prototype.deRegisterProducer = function(producer) {
    this.producers.delete(producer.id);
  };
  CallStats2.prototype.disconnectConsumingTransport = function() {
    this.consumingTransport = void 0;
  };
  CallStats2.prototype.disconnectProducingTransport = function() {
    this.producingTransport = void 0;
  };
  CallStats2.prototype.callEvent = function(entry) {
    this.eventHandler.callEvent(entry);
  };
  CallStats2.prototype.sendPreCallTestBeginEvent = function() {
    var _this = this;
    this.connectionInfoPromise = this.measurements.getNetworkInfo(this.iceServers);
    this.eventHandler.callEvent({
      event: Event.PRECALL_TEST_BEGIN,
      timestamp: new Date()
    });
    if (this.connectionInfoPromise) {
      this.connectionInfoPromise.then(function(e) {
        _this.eventHandler.callEvent({
          event: Event.PRECALL_TEST_COMPLETE,
          metaData: {
            connectionInfo: e
          },
          timestamp: new Date()
        });
      });
    }
  };
  CallStats2.prototype.sendScreenShareToggleEvent = function(on, ssrc) {
    this.currentUserMediaStates.screen = on;
    this.eventHandler.callEvent({
      event: on ? Event.SCREENSHARE_STARTED : Event.SCREENSHARE_STOPPED,
      metaData: {
        ssrc
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendScreenShareRequestedEvent = function() {
    this.eventHandler.callEvent({
      event: Event.SCREENSHARE_START_REQUESTED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendActiveSpeakerEvent = function(peerId) {
    this.eventHandler.callEvent({
      event: Event.DOMINANT_SPEAKER,
      metaData: {
        peerId
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.devices = function(deviceType, deviceList) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.AUDIO_DEVICES_UPDATES || deviceType === MediaDeviceType.VIDEO && Event.VIDEO_DEVICES_UPDATES || deviceType === MediaDeviceType.SPEAKER && Event.SPEAKER_DEVICES_UPDATES,
      metaData: {
        deviceList
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.selectedDevice = function(deviceType, device) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.SELECTED_MICROHPONE_UPDATE || deviceType === MediaDeviceType.VIDEO && Event.SELECTED_CAMERA_UPDATE || deviceType === MediaDeviceType.SPEAKER && Event.SELECTED_SPEAKER_UPDATE,
      metaData: {
        device
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.mediaPermission = function(deviceType, permission) {
    this.eventHandler.callEvent({
      event: Event.MEDIA_PERMISSION,
      metaData: {
        deviceType,
        permission
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.mediaPlaybackFailed = function(deviceType) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.AUDIO_PLAY_FAILED || deviceType === MediaDeviceType.VIDEO && Event.VIDEO_PLAY_FAILED,
      metaData: {
        deviceType
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.mediaTrackMuted = function(deviceType) {
    this.eventHandler.callEvent({
      event: deviceType === MediaDeviceType.AUDIO && Event.AUDIO_TRACK_MUTED || deviceType === MediaDeviceType.VIDEO && Event.VIDEO_TRACK_MUTED,
      metaData: {
        deviceType
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.tabChanged = function(backToCurrentTab) {
    this.eventHandler.callEvent({
      event: Event.TAB_CHANGE,
      backToCurrentTab,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.browserBackgrounded = function() {
    this.eventHandler.callEvent({
      event: Event.BROWSER_BACKGROUNDED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.browserForegrounded = function() {
    this.eventHandler.callEvent({
      event: Event.BROWSER_FOREGROUNDED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.legacySwitch = function(on) {
    this.eventHandler.callEvent({
      event: Event.LEGACY_SWITCH,
      metadata: { on },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.getPreCallTestResults = function() {
    return __awaiter$2(this, void 0, void 0, function() {
      return __generator$1(this, function(_a3) {
        return [2, this.connectionInfoPromise];
      });
    });
  };
  CallStats2.prototype.sendCallJoinBeginEvent = function(peerMetaData) {
    peerMetaData = __assign(__assign({}, peerMetaData), { meetingEnv: this.env });
    peerMetaData.deviceInfo = __assign(__assign({}, peerMetaData.deviceInfo), { userAgent: navigator.userAgent, cpus: navigator.hardwareConcurrency, memory: navigator.deviceMemory });
    this.eventHandler.callEvent({
      event: Event.CALL_JOIN_BEGIN,
      metaData: {
        peerMetaData
      },
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendNetworkQualityTestBeginEvent = function(regionalInformations) {
    var _this = this;
    this.eventHandler.callEvent({
      event: Event.NET_QUALITY_TEST_BEGIN,
      timestamp: new Date()
    });
    var promise = new Promise(function(resolve, reject) {
      return __awaiter$2(_this, void 0, void 0, function() {
        var regionData, regionalInformations_1, regionalInformations_1_1, e, results, e_1, e_2_1, e_3;
        var e_2, _a3;
        return __generator$1(this, function(_b2) {
          switch (_b2.label) {
            case 0:
              regionData = [];
              _b2.label = 1;
            case 1:
              _b2.trys.push([1, 13, , 14]);
              _b2.label = 2;
            case 2:
              _b2.trys.push([2, 10, 11, 12]);
              regionalInformations_1 = __values(regionalInformations), regionalInformations_1_1 = regionalInformations_1.next();
              _b2.label = 3;
            case 3:
              if (!!regionalInformations_1_1.done)
                return [3, 9];
              e = regionalInformations_1_1.value;
              _b2.label = 4;
            case 4:
              _b2.trys.push([4, 7, , 8]);
              if (!(e.iceServers && e.iceServers.length > 0))
                return [3, 6];
              return [4, this.measurements.getNetworkQuality(e.iceServers)];
            case 5:
              results = _b2.sent();
              regionData.push(__assign(__assign({}, e), { networkResults: results }));
              _b2.label = 6;
            case 6:
              return [3, 8];
            case 7:
              e_1 = _b2.sent();
              console.warn("Error handling ", e_1);
              return [3, 8];
            case 8:
              regionalInformations_1_1 = regionalInformations_1.next();
              return [3, 3];
            case 9:
              return [3, 12];
            case 10:
              e_2_1 = _b2.sent();
              e_2 = { error: e_2_1 };
              return [3, 12];
            case 11:
              try {
                if (regionalInformations_1_1 && !regionalInformations_1_1.done && (_a3 = regionalInformations_1.return))
                  _a3.call(regionalInformations_1);
              } finally {
                if (e_2)
                  throw e_2.error;
              }
              return [7];
            case 12:
              resolve({
                regionData
              });
              return [3, 14];
            case 13:
              e_3 = _b2.sent();
              console.warn("Error in callstats, ", e_3);
              reject(e_3);
              return [3, 14];
            case 14:
              return [2];
          }
        });
      });
    });
    promise.then(function(e) {
      _this.eventHandler.callEvent({
        event: Event.NET_QUALITY_TEST_END,
        timestamp: new Date(),
        metaData: e
      });
    });
  };
  CallStats2.prototype.sendWebSocketConnectedEvent = function() {
    this.eventHandler.callEvent({
      event: Event.WEBSOCKET_CONNECTED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendTransportConnectedEvent = function() {
    this.eventHandler.callEvent({
      event: Event.TRANSPORT_CONNECTED,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendAudioToggleEvent = function(on) {
    this.currentUserMediaStates.audio = on;
    var event;
    if (!on) {
      event = Event.AUDIO_OFF;
    } else {
      event = Event.AUDIO_ON;
    }
    this.eventHandler.callEvent({
      event,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendVideoToggleEvent = function(on) {
    this.currentUserMediaStates.video = on;
    var event;
    if (!on) {
      event = Event.VIDEO_OFF;
    } else {
      event = Event.VIDEO_ON;
    }
    this.eventHandler.callEvent({
      event,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendParticipantRoleToggleEvent = function(role) {
    this.eventHandler.callEvent({
      event: Event.PARTICIPANT_ROLE,
      timestamp: new Date(),
      metaData: role
    });
  };
  CallStats2.prototype.startPingStats = function(interval) {
    if (interval === void 0) {
      interval = 7e3;
    }
    this.pingStatsTimeout = setInterval(this.sendPingStatsEvent.bind(this), interval);
  };
  CallStats2.prototype.stopPingStats = function() {
    clearInterval(this.pingStatsTimeout);
  };
  CallStats2.prototype.sendPingStatsEvent = function() {
    var _a3, _b2;
    return __awaiter$2(this, void 0, void 0, function() {
      var proReport, conReport, report, report, metaData;
      return __generator$1(this, function(_c2) {
        switch (_c2.label) {
          case 0:
            if (!this.producingTransport)
              return [3, 5];
            return [4, this.measurements.getProcessedStats(this.producingTransport, false, true)];
          case 1:
            proReport = _c2.sent();
            if (!(!proReport || !(proReport === null || proReport === void 0 ? void 0 : proReport.producerReport)))
              return [3, 5];
            this.logger.log("Stale producer? Regenerating Stream Maps!");
            return [4, this.measurements.getProducersReport(__spreadArray([], __read(this.producers.values())))];
          case 2:
            report = _c2.sent();
            if (!(proReport && report))
              return [3, 3];
            proReport.producerReport = report;
            return [3, 5];
          case 3:
            return [4, this.measurements.getProcessedStats(this.producingTransport, false, true)];
          case 4:
            proReport = _c2.sent();
            if (!proReport || !(proReport === null || proReport === void 0 ? void 0 : proReport.producerReport)) {
              this.logger.log("Stream maps invalid despite regenerating!");
            }
            _c2.label = 5;
          case 5:
            if (!this.consumingTransport)
              return [3, 10];
            return [4, this.measurements.getProcessedStats(this.consumingTransport, true, false)];
          case 6:
            conReport = _c2.sent();
            if (!(!conReport || !conReport.consumerReport))
              return [3, 10];
            this.logger.log("Stale consumer? Regenerating Stream Maps!");
            return [4, this.measurements.getConsumersReport(__spreadArray([], __read(this.consumers.values())))];
          case 7:
            report = _c2.sent();
            if (!(conReport && report))
              return [3, 8];
            conReport.consumerReport = report;
            return [3, 10];
          case 8:
            return [4, this.measurements.getProcessedStats(this.consumingTransport, true, false)];
          case 9:
            conReport = _c2.sent();
            if (!conReport || !conReport.consumerReport) {
              this.logger.log("Stream maps invalid despite regenerating!");
            }
            _c2.label = 10;
          case 10:
            metaData = {
              producingTransportStats: proReport ? proReport === null || proReport === void 0 ? void 0 : proReport.transportReport : void 0,
              consumingTransportStats: conReport ? conReport === null || conReport === void 0 ? void 0 : conReport.transportReport : void 0,
              producerStats: proReport ? (_a3 = proReport === null || proReport === void 0 ? void 0 : proReport.producerReport) === null || _a3 === void 0 ? void 0 : _a3.concat(conReport === null || conReport === void 0 ? void 0 : conReport.producerReport) : void 0,
              consumerStats: conReport ? (_b2 = conReport === null || conReport === void 0 ? void 0 : conReport.consumerReport) === null || _b2 === void 0 ? void 0 : _b2.concat(proReport === null || proReport === void 0 ? void 0 : proReport.consumerReport) : void 0
            };
            this.eventHandler.callEvent({
              event: Event.PING_STAT,
              metaData,
              timestamp: new Date()
            });
            return [2];
        }
      });
    });
  };
  CallStats2.prototype.sendDisconnectEvent = function() {
    this.eventHandler.callEvent({
      event: Event.DISCONNECT,
      timestamp: new Date()
    });
  };
  CallStats2.prototype.sendReconnectEvent = function() {
    this.eventHandler.callEvent({
      event: Event.RECONNECT_ATTEMPT,
      timestamp: new Date()
    });
  };
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "authenticate", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerIceServers", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerConsumer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerProducer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendConsumerSharedMediaStateEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerProducingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "registerConsumingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "deRegisterConsumer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "deRegisterProducer", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "disconnectConsumingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "disconnectProducingTransport", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendPreCallTestBeginEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendScreenShareToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendScreenShareRequestedEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendActiveSpeakerEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "devices", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "selectedDevice", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "mediaPermission", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "mediaPlaybackFailed", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "mediaTrackMuted", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "tabChanged", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "browserBackgrounded", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "browserForegrounded", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "legacySwitch", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "getPreCallTestResults", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendCallJoinBeginEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendNetworkQualityTestBeginEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendWebSocketConnectedEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendTransportConnectedEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendAudioToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendVideoToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendParticipantRoleToggleEvent", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "startPingStats", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "stopPingStats", null);
  __decorate([
    CatchFunction(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2.prototype, "sendPingStatsEvent", null);
  CallStats2 = __decorate([
    CatchClass(TypeError, function(err, ctx) {
      return mainLogger.error(ctx, err);
    })
  ], CallStats2);
  return CallStats2;
}();
var __extends = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (Object.prototype.hasOwnProperty.call(b2, p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter$1 = globalThis && globalThis.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = globalThis && globalThis.__generator || function(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
};
var InhouseCallStats = function(_super) {
  __extends(InhouseCallStats2, _super);
  function InhouseCallStats2() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.initialized = false;
    _this.stalled = false;
    return _this;
  }
  InhouseCallStats2.prototype.initialize = function(_a3) {
    var _b2, _c2;
    var peerId = _a3.peerId, engineName = _a3.engineName, _d2 = _a3.env, env = _d2 === void 0 ? ClientEnvType.PRODUCTION : _d2, iceServers = _a3.iceServers, _e2 = _a3.apiBase, apiBase = _e2 === void 0 ? "https://api.cluster.dyte.in" : _e2;
    return __awaiter$1(this, void 0, void 0, function() {
      var _this = this;
      return __generator(this, function(_f2) {
        try {
          this.peerId = peerId;
          this.backend = new CallStats(apiBase, engineName, env);
          this.backend.eventHandler.on("initialized", function(e) {
            _this.ipInformation = e;
            _this.initialized = true;
            _this.emit("initialized", e);
          });
          (_b2 = this.backend) === null || _b2 === void 0 ? void 0 : _b2.authenticate({ peerId });
          this.iceServers = iceServers;
          (_c2 = this.backend) === null || _c2 === void 0 ? void 0 : _c2.registerIceServers(this.iceServers);
          this.startPreCallTest();
        } catch (error) {
          console.error("CallStatsIntegration: ", error);
          this.stallCallStats();
        }
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.setRoomName = function(roomName) {
    this.roomURL = roomName;
  };
  InhouseCallStats2.prototype.configureSendTransport = function(sendTransport) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.registerProducingTransport(sendTransport);
  };
  InhouseCallStats2.prototype.configureRecvTransport = function(recvTransport) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.registerConsumingTransport(recvTransport);
  };
  InhouseCallStats2.prototype.candidateRegionalNetworkQualityTest = function(regionalIceServersInfo) {
    var _a3;
    return __awaiter$1(this, void 0, void 0, function() {
      return __generator(this, function(_b2) {
        try {
          (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendNetworkQualityTestBeginEvent(regionalIceServersInfo);
        } catch (ex) {
          console.log("sendNetworkQualityTestBeginEvent Failed: ", ex);
        }
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.roomJoined = function(peerData) {
    var _a3, _b2;
    return __awaiter$1(this, void 0, void 0, function() {
      return __generator(this, function(_c2) {
        (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendCallJoinBeginEvent(peerData);
        if (this.backend)
          ;
        (_b2 = this.backend) === null || _b2 === void 0 ? void 0 : _b2.startPingStats();
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.audioOff = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendAudioToggleEvent(false);
  };
  InhouseCallStats2.prototype.audioOn = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendAudioToggleEvent(true);
  };
  InhouseCallStats2.prototype.videoOff = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendVideoToggleEvent(false);
  };
  InhouseCallStats2.prototype.videoOn = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendVideoToggleEvent(true);
  };
  InhouseCallStats2.prototype.callEnded = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendDisconnectEvent();
  };
  InhouseCallStats2.prototype.screenShareStart = function(ssrc) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendScreenShareToggleEvent(true, ssrc);
  };
  InhouseCallStats2.prototype.consumerSharedMediaState = function(consumerId, statusObj) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendConsumerSharedMediaStateEvent(consumerId, statusObj);
  };
  InhouseCallStats2.prototype.screenShareStop = function(ssrc) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendScreenShareToggleEvent(false, ssrc);
  };
  InhouseCallStats2.prototype.screenShareRequested = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendScreenShareRequestedEvent();
  };
  InhouseCallStats2.prototype.activeSpeaker = function(peerId) {
    var _a3;
    if (peerId !== this.peerId) {
      return;
    }
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendActiveSpeakerEvent(peerId);
  };
  InhouseCallStats2.prototype.devices = function(deviceType, deviceList) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.devices(deviceType, deviceList);
  };
  InhouseCallStats2.prototype.selectedDevice = function(deviceType, device) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.selectedDevice(deviceType, device);
  };
  InhouseCallStats2.prototype.mediaPermission = function(deviceType, permission) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.mediaPermission(deviceType, permission);
  };
  InhouseCallStats2.prototype.mediaPlaybackFailed = function(deviceType) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.mediaPlaybackFailed(deviceType);
  };
  InhouseCallStats2.prototype.mediaTrackMuted = function(deviceType) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.mediaTrackMuted(deviceType);
  };
  InhouseCallStats2.prototype.tabChanged = function(backToCurrentTab) {
    var _a3;
    if (backToCurrentTab === void 0) {
      backToCurrentTab = false;
    }
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.tabChanged(backToCurrentTab);
  };
  InhouseCallStats2.prototype.browserBackgrounded = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.browserBackgrounded();
  };
  InhouseCallStats2.prototype.browserForegrounded = function() {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.browserForegrounded();
  };
  InhouseCallStats2.prototype.legacySwitch = function(on) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.legacySwitch(on);
  };
  InhouseCallStats2.prototype.startPreCallTest = function() {
    var _a3;
    return __awaiter$1(this, void 0, void 0, function() {
      return __generator(this, function(_b2) {
        (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.sendPreCallTestBeginEvent();
        return [2];
      });
    });
  };
  InhouseCallStats2.prototype.onPreCallTestResults = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.once("precall_end", fx);
    return fx;
  };
  InhouseCallStats2.prototype.onReceivingConsumerAudioStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("consumer_audio_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingConsumerVideoStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("consumer_video_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingProducerAudioStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("producer_audio_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingProducerVideoStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("producer_video_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingProducingTransportStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("producing_transport_status", fx);
  };
  InhouseCallStats2.prototype.onReceivingConsumingTransportStatus = function(fx) {
    var _a3;
    (_a3 = this.backend) === null || _a3 === void 0 ? void 0 : _a3.eventHandler.on("consuming_transport_status", fx);
  };
  InhouseCallStats2.prototype.onSafeInitialization = function(cb) {
    if (this.initialized) {
      cb(this.ipInformation, false);
    } else if (!this.stalled) {
      var eventEmitterCB = function(ipInfo) {
        var isAsyncInitialization = true;
        cb(ipInfo, isAsyncInitialization);
      };
      this.once("initialized", eventEmitterCB);
      return eventEmitterCB;
    }
    return function() {
    };
  };
  InhouseCallStats2.prototype.removeInitializationListener = function(fx) {
    this.removeListener("initialized", fx);
  };
  InhouseCallStats2.prototype.stallCallStats = function() {
    this.stalled = true;
    this.removeAllListeners("initialized");
  };
  return InhouseCallStats2;
}(EventEmitter$3);
var callStats = new InhouseCallStats();
callStats.setMaxListeners(30);
log.setLevel("SILENT");
var dist = {};
var defaultPreset = {};
var types = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.WaitingRoomConversionToV1Type = exports.DyteViewTypes = exports.WaitingRoomTypes = void 0;
  (function(WaitingRoomTypes) {
    WaitingRoomTypes["skip"] = "SKIP";
    WaitingRoomTypes["onAccept"] = "ON_ACCEPT";
    WaitingRoomTypes["skipOnPrivilegedUserEntry"] = "SKIP_ON_PRIVILEGED_USER_ENTRY";
    WaitingRoomTypes["skipOnAccept"] = "SKIP_ON_ACCEPT";
  })(exports.WaitingRoomTypes || (exports.WaitingRoomTypes = {}));
  (function(DyteViewTypes) {
    DyteViewTypes["groupCall"] = "GROUP_CALL";
    DyteViewTypes["webinar"] = "WEBINAR";
    DyteViewTypes["audioRoom"] = "AUDIO_ROOM";
  })(exports.DyteViewTypes || (exports.DyteViewTypes = {}));
  (function(WaitingRoomConversionToV1Type) {
    WaitingRoomConversionToV1Type["SKIP"] = "skip";
    WaitingRoomConversionToV1Type["SKIP_ON_PRIVILEGED_USER_ENTRY"] = "skipOnPrivilegedUserEntry";
    WaitingRoomConversionToV1Type["ON_ACCEPT"] = "skipOnAccept";
    WaitingRoomConversionToV1Type["SKIP_ON_ACCEPT"] = "";
  })(exports.WaitingRoomConversionToV1Type || (exports.WaitingRoomConversionToV1Type = {}));
})(types);
Object.defineProperty(defaultPreset, "__esModule", { value: true });
defaultPreset.theme = defaultPreset.permissions = void 0;
const types_1$1 = types;
defaultPreset.permissions = {
  view_type: types_1$1.DyteViewTypes.groupCall,
  accept_waiting_requests: false,
  accept_present_requests: false,
  request_produce: false,
  can_allow_participant_audio: false,
  can_allow_participant_screensharing: false,
  can_allow_participant_video: false,
  can_spotlight: false,
  request_kick_participant: false,
  kick_participant: false,
  pin_participant: false,
  can_edit_display_name: false,
  can_record: false,
  can_present: true,
  waiting_room_type: types_1$1.WaitingRoomTypes.skipOnAccept,
  plugins: {
    can_close: true,
    can_start: true
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view: true
  },
  produce: {
    video: {
      allow: true,
      quality: "vga",
      frame_rate: 24
    },
    audio: true,
    screenshare: {
      allow: true,
      quality: "hd",
      frame_rate: 5
    }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  connected_meetings: {
    can_alter_connected_meetings: false,
    can_switch_connected_meetings: false,
    can_switch_to_parent_meeting: false
  },
  reactions: false,
  hidden_participant: false,
  is_recorder: false,
  show_participant_list: true,
  can_change_participant_role: false,
  can_change_theme: false,
  max_screenshare_count: 1
};
defaultPreset.theme = {
  setup_screen: {
    is_enabled: true
  },
  alone_here: {
    is_enabled: true
  },
  waiting_room: {
    is_enabled: false,
    enable_preview: true
  },
  control_bar: {
    is_enabled: true,
    elements: {
      plugins: true,
      screenshare: true,
      invite: true,
      participants: true,
      chat: true,
      reactions: false,
      polls: true,
      fullscreen: true,
      layout: true
    }
  },
  header: {
    is_enabled: true,
    elements: {
      timer: true,
      title: true,
      participant_count: true,
      change_layout: true
    }
  },
  pip_mode: true,
  auto_tune: true,
  grid: {
    multi: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    single: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    defaultView: "multi"
  },
  controls: {
    pip_toggle: false
  }
};
var presetConversion = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.convertPresetToV2 = exports.convertThemeToV2 = exports.convertPresetToV1 = void 0;
  const types_12 = types;
  const convertPresetToV1 = (exisitngPreset, preset) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _j, _k, _l, _m;
    const convertedPreset = Object.assign({}, exisitngPreset);
    if (preset.permissions) {
      const modifiedPermissions = Object.assign({}, convertedPreset.role);
      if (preset.permissions.accept_waiting_requests !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { acceptWaitingRequests: preset.permissions.accept_waiting_requests });
      }
      if (preset.permissions.can_allow_participant_audio !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { disableParticipantAudio: preset.permissions.can_allow_participant_audio });
      }
      if (preset.permissions.can_allow_participant_screensharing !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { disableParticipantScreensharing: preset.permissions.can_allow_participant_screensharing });
      }
      if (preset.permissions.can_allow_participant_video !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { disableParticipantVideo: preset.permissions.can_allow_participant_video });
      }
      if (preset.permissions.kick_participant !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { kickParticipants: preset.permissions.kick_participant });
      }
      if (preset.permissions.pin_participant !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { pinParticipant: preset.permissions.pin_participant });
      }
      if (preset.permissions.can_record !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { allowRecording: preset.permissions.can_record });
      }
      if (preset.permissions.can_edit_display_name !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { editDisplayName: preset.permissions.can_edit_display_name });
      }
      const { waiting_room_type } = preset.permissions;
      if (waiting_room_type) {
        modifiedPermissions.waitingRoom = types_12.WaitingRoomConversionToV1Type[waiting_room_type];
      }
      if (preset.permissions.plugins) {
        modifiedPermissions.plugins = {
          close: preset.permissions.plugins.can_close,
          start: preset.permissions.plugins.can_start
        };
      }
      if (preset.permissions.produce) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { video: preset.permissions.produce.video.allow, audio: preset.permissions.produce.audio, screenshare: preset.permissions.produce.screenshare.allow });
      }
      if (preset.permissions.polls) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { polls: preset.permissions.polls.can_create });
      }
      if (preset.permissions.chat) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { chat: {
          text: preset.permissions.chat.public.text,
          files: preset.permissions.chat.public.files
        } });
      }
      if (preset.permissions.reactions !== void 0) {
        modifiedPermissions.produce = Object.assign(Object.assign({}, modifiedPermissions.produce), { reactions: preset.permissions.reactions });
      }
      if (preset.permissions.hidden_participant !== void 0) {
        modifiedPermissions.flags = Object.assign(Object.assign({}, modifiedPermissions.flags), { hiddenParticipant: preset.permissions.hidden_participant });
      }
      if (preset.permissions.is_recorder !== void 0) {
        modifiedPermissions.flags = Object.assign(Object.assign({}, modifiedPermissions.flags), { recorder: preset.permissions.is_recorder });
      }
      if (preset.permissions.view_type === types_12.DyteViewTypes.webinar) {
        modifiedPermissions.webinar = Object.assign(Object.assign({}, modifiedPermissions.webinar), { viewOnly: preset.permissions.request_produce });
        convertedPreset.roomViewType = "webinar";
      }
      if (preset.permissions.accept_present_requests !== void 0) {
        modifiedPermissions.permissions = Object.assign(Object.assign({}, modifiedPermissions.permissions), { acceptWaitingRequests: preset.permissions.accept_present_requests });
        modifiedPermissions.webinar = Object.assign(Object.assign({}, modifiedPermissions.webinar), { viewOnly: !preset.permissions.accept_present_requests });
        convertedPreset.roomViewType = "webinar";
      }
      convertedPreset["role"] = modifiedPermissions;
    }
    if (preset.theme) {
      const modifiedUiConfig = Object.assign({}, convertedPreset.uiConfig);
      if (preset.theme.alone_here) {
        modifiedUiConfig["aloneHereElement"] = !!preset.theme.alone_here;
      }
      if (preset.theme.waiting_room) {
        modifiedUiConfig["waitingRoom"] = {
          showSelf: preset.theme.waiting_room.enable_preview,
          roomElement: preset.theme.waiting_room.element
        };
      }
      if (preset.theme.control_bar) {
        modifiedUiConfig["controlBar"] = preset.theme.control_bar.is_enabled;
        modifiedUiConfig["controlBarElements"] = {
          share: (_a3 = preset.theme.control_bar.elements) === null || _a3 === void 0 ? void 0 : _a3.invite,
          screenShare: (_b2 = preset.theme.control_bar.elements) === null || _b2 === void 0 ? void 0 : _b2.screenshare,
          plugins: (_c2 = preset.theme.control_bar.elements) === null || _c2 === void 0 ? void 0 : _c2.plugins,
          participants: (_d2 = preset.theme.control_bar.elements) === null || _d2 === void 0 ? void 0 : _d2.participants,
          chat: (_e2 = preset.theme.control_bar.elements) === null || _e2 === void 0 ? void 0 : _e2.chat,
          polls: (_f2 = preset.theme.control_bar.elements) === null || _f2 === void 0 ? void 0 : _f2.polls,
          fullscreen: (_g2 = preset.theme.control_bar.elements) === null || _g2 === void 0 ? void 0 : _g2.fullscreen
        };
      }
      if (preset.theme.header) {
        modifiedUiConfig["header"] = preset.theme.header.is_enabled;
        modifiedUiConfig["headerElements"] = {
          clock: (_h2 = preset.theme.header.elements) === null || _h2 === void 0 ? void 0 : _h2.timer,
          title: (_j = preset.theme.header.elements) === null || _j === void 0 ? void 0 : _j.title,
          logo: !!((_k = preset.theme.header.elements) === null || _k === void 0 ? void 0 : _k.logo),
          participantCount: (_l = preset.theme.header.elements) === null || _l === void 0 ? void 0 : _l.participant_count
        };
        modifiedUiConfig["logo"] = (_m = preset.theme.header.elements) === null || _m === void 0 ? void 0 : _m.logo;
      }
      if (preset.theme.auto_tune) {
        modifiedUiConfig.grid = Object.assign({}, preset.theme.grid);
      }
      if (preset.theme.grid) {
        modifiedUiConfig.grid = Object.assign({}, preset.theme.grid);
      }
      if (preset.theme.colors) {
        modifiedUiConfig["colors"] = {
          primary: preset.theme.colors.primary,
          secondary: preset.theme.colors.secondary,
          textPrimary: preset.theme.colors.text,
          videoBackground: preset.theme.colors.background
        };
      }
      if (preset.theme.dimensions) {
        modifiedUiConfig["dimensions"] = {
          width: preset.theme.dimensions.width,
          height: preset.theme.dimensions.height
        };
      }
      convertedPreset["uiConfig"] = modifiedUiConfig;
    }
    return convertedPreset;
  };
  exports.convertPresetToV1 = convertPresetToV1;
  const convertThemeToV2 = (parentTheme, oldTheme) => {
    var _a3;
    const newTheme = Object.assign({}, parentTheme);
    const controlBarBody = Object.assign(Object.assign({}, newTheme.control_bar), { is_enabled: oldTheme.controlBar !== void 0 ? oldTheme.controlBar : newTheme.control_bar.is_enabled });
    const headerBody = Object.assign(Object.assign({}, newTheme.header), { is_enabled: oldTheme.header !== void 0 ? oldTheme.header : newTheme.header.is_enabled });
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements) {
      const elements = Object.assign({}, controlBarBody.elements);
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.chat) !== void 0) {
        elements.chat = oldTheme.controlBarElements.chat;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.fullscreen) !== void 0) {
        elements.fullscreen = oldTheme.controlBarElements.fullscreen;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.participants) !== void 0) {
        elements.participants = oldTheme.controlBarElements.participants;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.plugins) !== void 0) {
        elements.plugins = oldTheme.controlBarElements.plugins;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.polls) !== void 0) {
        elements.polls = oldTheme.controlBarElements.polls;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.screenShare) !== void 0) {
        elements.screenshare = oldTheme.controlBarElements.screenShare;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.controlBarElements.share) !== void 0) {
        elements.invite = oldTheme.controlBarElements.share;
      }
      elements.reactions = false;
      elements.layout = false;
      controlBarBody.elements = elements;
    }
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements) {
      const elements = Object.assign({}, headerBody.elements);
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements.clock) !== void 0) {
        elements.timer = oldTheme.headerElements.clock;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements.participantCount) !== void 0) {
        elements.participant_count = oldTheme.headerElements.participantCount;
      }
      if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.headerElements.title) !== void 0) {
        elements.title = oldTheme.headerElements.title;
      }
      elements.change_layout = false;
      headerBody.elements = elements;
    }
    if ((oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.logo) !== void 0 && oldTheme.logo !== "") {
      headerBody.elements.logo = oldTheme.logo;
    }
    newTheme.header = headerBody;
    newTheme.control_bar = controlBarBody;
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors) {
      const colorBody = Object.assign({}, newTheme.colors);
      if (oldTheme.colors.primary) {
        colorBody.primary = oldTheme.colors.primary;
      }
      if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors.secondary) {
        colorBody.secondary = oldTheme.colors.secondary;
      }
      if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors.textPrimary) {
        colorBody.text = oldTheme.colors.textPrimary;
        colorBody.textPrimary = oldTheme.colors.textPrimary;
      }
      if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.colors.videoBackground) {
        colorBody.background = oldTheme.colors.videoBackground;
        colorBody.videoBackground = oldTheme.colors.videoBackground;
      }
      newTheme.colors = colorBody;
    }
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.dimensions) {
      newTheme.dimensions = oldTheme.dimensions;
    }
    if (oldTheme === null || oldTheme === void 0 ? void 0 : oldTheme.waitingRoom) {
      newTheme.waiting_room = {
        is_enabled: true,
        enable_preview: ((_a3 = oldTheme.waitingRoom) === null || _a3 === void 0 ? void 0 : _a3.showSelf) !== void 0 ? oldTheme.waitingRoom.showSelf : true,
        element: oldTheme.waitingRoom.roomElement
      };
    }
    if (oldTheme.aloneHereElement !== void 0) {
      newTheme.alone_here = {
        is_enabled: oldTheme.aloneHereElement
      };
    }
    newTheme.pip_mode = true;
    return newTheme;
  };
  exports.convertThemeToV2 = convertThemeToV2;
  const convertPresetToV2 = (exisitngPreset, preset) => {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const convertedPreset = Object.assign({}, exisitngPreset);
    if (preset.role) {
      const permissionBody = Object.assign({}, convertedPreset.permissions);
      if (((_a3 = preset.role.permissions) === null || _a3 === void 0 ? void 0 : _a3.acceptWaitingRequests) !== void 0) {
        permissionBody.accept_waiting_requests = preset.role.permissions.acceptWaitingRequests;
      }
      if (((_b2 = preset.role.permissions) === null || _b2 === void 0 ? void 0 : _b2.allowRecording) !== void 0) {
        permissionBody.can_record = preset.role.permissions.allowRecording;
      }
      if (((_c2 = preset.role.permissions) === null || _c2 === void 0 ? void 0 : _c2.editDisplayName) !== void 0) {
        permissionBody.can_edit_display_name = preset.role.permissions.editDisplayName;
      }
      if (((_d2 = preset.role.permissions) === null || _d2 === void 0 ? void 0 : _d2.disableParticipantAudio) !== void 0) {
        permissionBody.can_allow_participant_audio = preset.role.permissions.disableParticipantAudio;
      }
      if (((_e2 = preset.role.permissions) === null || _e2 === void 0 ? void 0 : _e2.disableParticipantScreensharing) !== void 0) {
        permissionBody.can_allow_participant_screensharing = preset.role.permissions.disableParticipantScreensharing;
      }
      if (((_f2 = preset.role.permissions) === null || _f2 === void 0 ? void 0 : _f2.disableParticipantVideo) !== void 0) {
        permissionBody.can_allow_participant_video = preset.role.permissions.disableParticipantVideo;
      }
      if (((_g2 = preset.role.permissions) === null || _g2 === void 0 ? void 0 : _g2.kickParticipants) !== void 0) {
        permissionBody.kick_participant = preset.role.permissions.kickParticipants;
      }
      if (((_h2 = preset.role.permissions) === null || _h2 === void 0 ? void 0 : _h2.pinParticipant) !== void 0) {
        permissionBody.pin_participant = preset.role.permissions.pinParticipant;
      }
      if ((_j = preset.role) === null || _j === void 0 ? void 0 : _j.plugins) {
        permissionBody.plugins = {
          can_start: preset.role.plugins.start,
          can_close: preset.role.plugins.close,
          can_edit_acl: preset.role.plugins.canEditAcl,
          config: {}
        };
        if ((_l = (_k = preset.role) === null || _k === void 0 ? void 0 : _k.pluginConfig) === null || _l === void 0 ? void 0 : _l.hostOnlyControl) {
          preset.role.pluginConfig.hostOnlyControl.forEach((pluginId) => {
            permissionBody.plugins.config[pluginId] = {
              defaultAccess: "whitelist"
            };
          });
        }
        if ((_o = (_m = preset.role) === null || _m === void 0 ? void 0 : _m.pluginConfig) === null || _o === void 0 ? void 0 : _o.handlesViewOnly) {
          preset.role.pluginConfig.hostOnlyControl.forEach((pluginId) => {
            if (permissionBody.plugins.config[pluginId] === void 0) {
              permissionBody.plugins.config[pluginId] = {
                defaultAccess: "blacklist"
              };
            }
            permissionBody.plugins.config[pluginId].handlesViewOnly = true;
          });
        }
      }
      if ((_p = preset.role) === null || _p === void 0 ? void 0 : _p.produce) {
        permissionBody.produce = {
          video: Object.assign(Object.assign({}, permissionBody.produce.video), { allow: ((_q = preset.role.produce) === null || _q === void 0 ? void 0 : _q.video) !== void 0 ? preset.role.produce.video : true }),
          audio: preset.role.produce.audio !== void 0 ? preset.role.produce.audio : true,
          screenshare: Object.assign(Object.assign({}, permissionBody.produce.screenshare), { allow: ((_r = preset.role.produce) === null || _r === void 0 ? void 0 : _r.screenshare) !== void 0 ? preset.role.produce.screenshare : true })
        };
        permissionBody.polls = Object.assign(Object.assign({}, permissionBody.polls), { can_create: preset.role.produce.polls !== void 0 ? preset.role.produce.polls : true });
        if ((_s = preset.role.produce) === null || _s === void 0 ? void 0 : _s.chat) {
          permissionBody.chat = Object.assign(Object.assign({}, permissionBody.chat), { public: Object.assign(Object.assign({}, preset.role.produce.chat), { can_send: true }) });
        }
      }
      if (preset.role.flags) {
        permissionBody.hidden_participant = preset.role.flags.hiddenParticipant;
        permissionBody.is_recorder = preset.role.flags.recorder;
      }
      permissionBody.show_participant_list = true;
      permissionBody.can_change_participant_role = false;
      permissionBody.view_type = preset.roomViewType ? types_12.DyteViewTypes[preset.roomViewType] : types_12.DyteViewTypes.groupCall;
      permissionBody.reactions = false;
      permissionBody.request_produce = !!(types_12.DyteViewTypes[preset.roomViewType] === types_12.DyteViewTypes.webinar && ((_u = (_t = preset.role) === null || _t === void 0 ? void 0 : _t.webinar) === null || _u === void 0 ? void 0 : _u.viewOnly));
      permissionBody.request_kick_participant = false;
      permissionBody.waiting_room_type = preset.role.waitingRoom ? types_12.WaitingRoomTypes[preset.role.waitingRoom] : types_12.WaitingRoomTypes.skip;
      permissionBody.accept_present_requests = !!(types_12.DyteViewTypes[preset.roomViewType] === types_12.DyteViewTypes.webinar && !((_w = (_v = preset.role) === null || _v === void 0 ? void 0 : _v.webinar) === null || _w === void 0 ? void 0 : _w.viewOnly) && ((_x = preset.role.permissions) === null || _x === void 0 ? void 0 : _x.acceptWaitingRequests));
      convertedPreset.permissions = permissionBody;
    }
    if (preset.uiConfig) {
      convertedPreset.theme = (0, exports.convertThemeToV2)(convertedPreset.theme, preset.uiConfig);
    }
    return convertedPreset;
  };
  exports.convertPresetToV2 = convertPresetToV2;
})(presetConversion);
var defaultV2preset = {};
Object.defineProperty(defaultV2preset, "__esModule", { value: true });
defaultV2preset.defaultV2Preset = void 0;
const types_1 = types;
const defaultRolePermissions = {
  view_type: types_1.DyteViewTypes.groupCall,
  accept_waiting_requests: false,
  accept_present_requests: false,
  request_produce: false,
  can_allow_participant_audio: false,
  can_allow_participant_screensharing: false,
  can_allow_participant_video: false,
  can_spotlight: false,
  request_kick_participant: false,
  kick_participant: false,
  pin_participant: false,
  can_edit_display_name: false,
  can_record: false,
  waiting_room_type: types_1.WaitingRoomTypes.skipOnAccept,
  plugins: {
    can_close: true,
    can_start: true,
    can_edit_acl: false,
    config: {}
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view: true
  },
  produce: {
    video: {
      allow: true,
      quality: "vga",
      frame_rate: 24
    },
    audio: true,
    screenshare: {
      allow: true,
      quality: "hd",
      frame_rate: 5
    }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  connected_meetings: {
    can_alter_connected_meetings: false,
    can_switch_connected_meetings: false,
    can_switch_to_parent_meeting: false
  },
  reactions: false,
  hidden_participant: false,
  is_recorder: false,
  show_participant_list: true,
  can_change_participant_role: false,
  can_change_theme: false,
  can_present: false,
  max_screenshare_count: 1
};
const defaultTheme = {
  setup_screen: {
    is_enabled: false
  },
  alone_here: {
    is_enabled: false
  },
  waiting_room: {
    is_enabled: false,
    enable_preview: true
  },
  control_bar: {
    is_enabled: true,
    elements: {
      plugins: true,
      screenshare: true,
      invite: false,
      participants: true,
      chat: true,
      reactions: false,
      polls: true,
      fullscreen: true,
      layout: true
    }
  },
  header: {
    is_enabled: true,
    elements: {
      timer: true,
      title: true,
      participant_count: true,
      change_layout: true
    }
  },
  pip_mode: true,
  auto_tune: true,
  grid: {
    multi: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    single: {
      maxVideoCount: 6,
      videoFit: "cover"
    },
    defaultView: "MULTI"
  },
  controls: {
    pip_toggle: false
  }
};
defaultV2preset.defaultV2Preset = {
  permissions: defaultRolePermissions,
  theme: defaultTheme,
  version: "0.5.0"
};
var flagsmith = {};
var __awaiter = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
var _a;
Object.defineProperty(flagsmith, "__esModule", { value: true });
flagsmith.createNewFlagsmithInstance = flagsmith.globalFlagsmith = void 0;
const axios_1 = __importDefault(axios);
let defaultEnvironmentKey = "hXgU8Wc8pwuGNq9ms5q9Hh";
if (typeof process != "undefined") {
  if ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.FLAGSMITH_ENVIRONMENT_KEY) {
    defaultEnvironmentKey = {}.FLAGSMITH_ENVIRONMENT_KEY;
  }
}
function normalizeFlags(respFlags = []) {
  const formattedFlags = {};
  respFlags.forEach((respFlag) => {
    formattedFlags[respFlag.feature.name] = {
      enabled: respFlag.enabled,
      value: respFlag.feature_state_value
    };
  });
  return formattedFlags;
}
class Flagsmith {
  constructor(environmentKey = defaultEnvironmentKey) {
    this.flags = {};
    this.environmentKey = null;
    this.environmentKey = environmentKey;
    this.identify = this.identify.bind(this);
    this.getValue = this.getValue.bind(this);
    this.hasFeature = this.hasFeature.bind(this);
    this.getAllFlags = this.getAllFlags.bind(this);
  }
  identify(uniqueIdentifier, traitsObj = {}, forceEvaluate = false, timeout = 5e3) {
    return __awaiter(this, void 0, void 0, function* () {
      const traits = JSON.parse(JSON.stringify(traitsObj));
      const formattedTraits = Object.entries(traits).map((tuple) => ({
        trait_key: tuple[0],
        trait_value: tuple[1]
      }));
      try {
        const randomChars = "_" + (Math.random() + 1).toString(36).substring(2);
        const flagsmithResponse = yield axios_1.default.post("https://edge.api.flagsmith.com/api/v1/identities/", {
          identifier: uniqueIdentifier + (forceEvaluate ? randomChars : ""),
          traits: formattedTraits
        }, {
          headers: {
            "Content-Type": "application/json",
            "X-Environment-Key": this.environmentKey
          },
          timeout
        });
        this.flags = normalizeFlags(flagsmithResponse.data.flags || []);
      } catch (ex) {
      }
      return this.flags;
    });
  }
  getValue(featureFlagName) {
    return this.flags && this.flags[featureFlagName] && this.flags[featureFlagName].value;
  }
  hasFeature(featureFlagName) {
    return this.flags && this.flags[featureFlagName] && this.flags[featureFlagName].enabled;
  }
  getAllFlags() {
    return this.flags;
  }
}
const globalFlagsmith = new Flagsmith();
flagsmith.globalFlagsmith = globalFlagsmith;
function createNewFlagsmithInstance(environmentKey) {
  return new Flagsmith(environmentKey);
}
flagsmith.createNewFlagsmithInstance = createNewFlagsmithInstance;
(function(exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m[k];
      } };
    }
    Object.defineProperty(o, k2, desc);
  } : function(o, m, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o[k2] = m[k];
  });
  var __setModuleDefault = commonjsGlobal && commonjsGlobal.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
  } : function(o, v) {
    o["default"] = v;
  });
  var __importStar = commonjsGlobal && commonjsGlobal.__importStar || function(mod) {
    if (mod && mod.__esModule)
      return mod;
    var result = {};
    if (mod != null) {
      for (var k in mod)
        if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
  };
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m, exports2) {
    for (var p in m)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
        __createBinding(exports2, m, p);
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.defaultPreset = void 0;
  const defaultPreset$1 = __importStar(defaultPreset);
  exports.defaultPreset = defaultPreset$1;
  __exportStar(presetConversion, exports);
  __exportStar(types, exports);
  __exportStar(defaultV2preset, exports);
  __exportStar(flagsmith, exports);
})(dist);
const CHROME = "chrome";
const OPERA = "opera";
const FIREFOX = "firefox";
const INTERNET_EXPLORER = "iexplorer";
const SAFARI = "safari";
const NWJS = "nwjs";
const ELECTRON = "electron";
const REACT_NATIVE = "react-native";
const UNKNOWN = "unknown";
const bowserNameToJitsiName = {
  Chrome: CHROME,
  Chromium: CHROME,
  Opera: OPERA,
  Firefox: FIREFOX,
  "Internet Explorer": INTERNET_EXPLORER,
  Safari: SAFARI
};
function _detectChromiumBased() {
  const { userAgent } = navigator;
  const browserInfo = {
    name: UNKNOWN,
    version: void 0
  };
  if (userAgent.match(/Chrome/) && !userAgent.match(/Edge/)) {
    if (userAgent.match(/Edg(A?)/)) {
      const version = userAgent.match(/Chrome\/([\d.]+)/)[1];
      if (Number.parseInt(version, 10) > 72) {
        browserInfo.name = CHROME;
        browserInfo.version = version;
      }
    } else {
      browserInfo.name = CHROME;
      browserInfo.version = userAgent.match(/Chrome\/([\d.]+)/)[1];
    }
  }
  return browserInfo;
}
function _detectElectron() {
  const { userAgent } = navigator;
  if (userAgent.match(/Electron/)) {
    const version = userAgent.match(/Electron\/([\d.]+)/)[1];
    return {
      name: ELECTRON,
      version
    };
  }
  return null;
}
function _detectNWJS() {
  const { userAgent } = navigator;
  if (userAgent.match(/JitsiMeetNW/)) {
    const version = userAgent.match(/JitsiMeetNW\/([\d.]+)/)[1];
    return {
      name: NWJS,
      version
    };
  }
}
function _detectReactNative() {
  const match = navigator.userAgent.match(/\b(react[ \t_-]*native)(?:\/(\S+))?/i);
  let version;
  if (match || navigator.product === "ReactNative") {
    if (match && match.length > 2) {
      version = match[2];
    }
    version || (version = "unknown");
    return {
      name: REACT_NATIVE,
      version
    };
  }
}
function _detect(bowser) {
  let browserInfo;
  const detectors = [
    _detectReactNative,
    _detectElectron,
    _detectNWJS
  ];
  for (let i = 0; i < detectors.length; i += 1) {
    browserInfo = detectors[i]();
    if (browserInfo) {
      return browserInfo;
    }
  }
  const name = bowser.getBrowserName();
  if (name in bowserNameToJitsiName) {
    return {
      name: bowserNameToJitsiName[name],
      version: bowser.getBrowserVersion()
    };
  }
  browserInfo = _detectChromiumBased();
  if (browserInfo) {
    return browserInfo;
  }
  return {
    name: UNKNOWN,
    version: void 0
  };
}
class BrowserDetection {
  constructor() {
    __publicField(this, "_bowser");
    __publicField(this, "_name");
    __publicField(this, "_version");
    __publicField(this, "getDeviceInfo", () => ({
      isMobile: this.isMobile(),
      browserName: this._bowser.getBrowserName(),
      osName: this._bowser.getOSName(),
      browserVersion: this._bowser.getBrowserVersion(),
      osVersionName: this._bowser.getOSVersion(),
      engineName: this._bowser.getEngineName()
    }));
  }
  init(browserInfo) {
    let name;
    let version;
    this._bowser = Bowser.getParser(navigator.userAgent);
    if (typeof browserInfo === "undefined") {
      const detectedBrowserInfo = _detect(this._bowser);
      name = detectedBrowserInfo.name;
      version = detectedBrowserInfo.version;
    } else if (browserInfo.name in bowserNameToJitsiName) {
      name = bowserNameToJitsiName[browserInfo.name];
      version = browserInfo.version;
    } else {
      name = UNKNOWN;
      version = void 0;
    }
    this._name = name;
    this._version = version;
  }
  getName() {
    return this._name;
  }
  isChrome() {
    return this._name === CHROME;
  }
  isOpera() {
    return this._name === OPERA;
  }
  isFirefox() {
    return this._name === FIREFOX;
  }
  isIExplorer() {
    return this._name === INTERNET_EXPLORER;
  }
  isSafari() {
    return this._name === SAFARI;
  }
  isNWJS() {
    return this._name === NWJS;
  }
  isElectron() {
    return this._name === ELECTRON;
  }
  isReactNative() {
    return this._name === REACT_NATIVE;
  }
  getVersion() {
    return this._version;
  }
  isMobile() {
    return this._bowser.getPlatformType() === "mobile";
  }
  _checkCondition(checkTree) {
    if (this._version) {
      return this._bowser.satisfies(checkTree);
    }
  }
  isVersionGreaterThan(version) {
    return this._checkCondition({ [this._name]: `>${version}` });
  }
  isVersionLessThan(version) {
    return this._checkCondition({ [this._name]: `<${version}` });
  }
  isVersionEqualTo(version) {
    return this._checkCondition({ [this._name]: `~${version}` });
  }
}
const MIN_REQUIRED_CHROME_VERSION = 72;
class BrowserCapabilities extends BrowserDetection {
  doesVideoMuteByStreamRemove() {
    return this.isChromiumBased() || this.isWebKitBased();
  }
  supportsP2P() {
    return !this.usesUnifiedPlan();
  }
  isChromiumBased() {
    return this.isChrome() || this.isElectron() || this.isNWJS() || this.isOpera();
  }
  isWebKitBased() {
    return this._bowser.isEngine("webkit") && typeof navigator.mediaDevices !== "undefined" && typeof navigator.mediaDevices.getUserMedia !== "undefined" && typeof window.RTCRtpTransceiver !== "undefined" && Object.keys(RTCRtpTransceiver.prototype).indexOf("currentDirection") > -1;
  }
  isSupported() {
    return this.isChromiumBased() && this._getChromiumBasedVersion() >= MIN_REQUIRED_CHROME_VERSION || this.isFirefox() || this.isReactNative() || this.isWebKitBased();
  }
  isUserInteractionRequiredForUnmute() {
    return this.isFirefox() && this.isVersionLessThan("68");
  }
  supportsVideoMuteOnConnInterrupted() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  supportsBandwidthStatistics() {
    return !this.isFirefox() && !this.isWebKitBased();
  }
  supportsCodecPreferences() {
    return this.usesUnifiedPlan() && typeof window.RTCRtpTransceiver !== "undefined" && Object.keys(window.RTCRtpTransceiver.prototype).indexOf("setCodecPreferences") > -1 && Object.keys(RTCRtpSender.prototype).indexOf("getCapabilities") > -1 && !this.isWebKitBased();
  }
  supportsDeviceChangeEvent() {
    return navigator.mediaDevices && typeof navigator.mediaDevices.ondevicechange !== "undefined" && typeof navigator.mediaDevices.addEventListener !== "undefined";
  }
  supportsLocalCandidateRttStatistics() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  supportsPerformanceObserver() {
    return typeof window.PerformanceObserver !== "undefined" && PerformanceObserver.supportedEntryTypes.indexOf("longtask") > -1;
  }
  supportsReceiverStats() {
    return typeof window.RTCRtpReceiver !== "undefined" && Object.keys(RTCRtpReceiver.prototype).indexOf("getSynchronizationSources") > -1;
  }
  supportsRTTStatistics() {
    return !this.isFirefox();
  }
  usesPlanB() {
    return !this.usesUnifiedPlan();
  }
  usesSdpMungingForSimulcast() {
    return this.isChromiumBased() || this.isReactNative() || this.isWebKitBased();
  }
  usesUnifiedPlan() {
    if (this.isFirefox() || this.isWebKitBased()) {
      return true;
    }
    return false;
  }
  usesNewGumFlow() {
    if (this.isChromiumBased() || this.isFirefox() || this.isWebKitBased()) {
      return true;
    }
    return false;
  }
  usesAdapter() {
    return this.usesNewGumFlow();
  }
  usesRidsForSimulcast() {
    return false;
  }
  supportsGetDisplayMedia() {
    return typeof navigator.getDisplayMedia !== "undefined" || typeof navigator.mediaDevices !== "undefined" && typeof navigator.mediaDevices.getDisplayMedia !== "undefined";
  }
  supportsInsertableStreams() {
    if (!(typeof window.RTCRtpSender !== "undefined" && (window.RTCRtpSender.prototype.createEncodedStreams || window.RTCRtpSender.prototype.createEncodedVideoStreams))) {
      return false;
    }
    const stream = new ReadableStream();
    try {
      window.postMessage(stream, "*", [stream]);
      return true;
    } catch {
      return false;
    }
  }
  supportsAudioRed() {
    return Boolean(window.RTCRtpSender && window.RTCRtpSender.getCapabilities && window.RTCRtpSender.getCapabilities("audio").codecs.some((codec) => codec.mimeType === "audio/red") && window.RTCRtpReceiver && window.RTCRtpReceiver.getCapabilities && window.RTCRtpReceiver.getCapabilities("audio").codecs.some((codec) => codec.mimeType === "audio/red"));
  }
  supportsSdpSemantics() {
    return this.isChromiumBased();
  }
  _getChromiumBasedVersion() {
    if (this.isChromiumBased()) {
      if (this.isNWJS()) {
        return Number.parseInt(process.versions.chromium, 10);
      }
      const ua = navigator.userAgent;
      if (ua.match(/Chrome/)) {
        const version = Number.parseInt(ua.match(/Chrome\/([\d.]+)/)[1], 10);
        return version;
      }
    }
    return -1;
  }
}
const browserSpecs = new BrowserCapabilities();
var FlagsmithIdentifierPrefix;
(function(FlagsmithIdentifierPrefix2) {
  FlagsmithIdentifierPrefix2["PARTICIPANT"] = "PARTICIPANT";
  FlagsmithIdentifierPrefix2["PEER"] = "PEER";
  FlagsmithIdentifierPrefix2["CLIENT"] = "CLIENT";
})(FlagsmithIdentifierPrefix || (FlagsmithIdentifierPrefix = {}));
var FlagsmithFeatureFlags;
(function(FlagsmithFeatureFlags2) {
  FlagsmithFeatureFlags2["H264_SCREENSHARE"] = "h264_screenshare";
  FlagsmithFeatureFlags2["QUICK_ZOOM"] = "quick_zoom";
  FlagsmithFeatureFlags2["INTERNAL_CALL_STATS"] = "internal_call_stats";
  FlagsmithFeatureFlags2["CFWS"] = "cfws";
  FlagsmithFeatureFlags2["LOGROCKET"] = "logrocket";
  FlagsmithFeatureFlags2["SIMULCAST"] = "simulcast";
  FlagsmithFeatureFlags2["CHAT_SOCKET_SERVER"] = "chat_socket_server";
  FlagsmithFeatureFlags2["PLUGIN_SOCKET_SERVER"] = "plugin_socket_server";
  FlagsmithFeatureFlags2["DEV_MODE_PLUGINS"] = "dev_mode_plugins";
  FlagsmithFeatureFlags2["NR_OTEL_WEB"] = "nr_otel_web";
  FlagsmithFeatureFlags2["CONNECTED_MEETINGS"] = "connected_meetings";
  FlagsmithFeatureFlags2["FEAT_SPOTLIGHT"] = "feat_spotlight";
  FlagsmithFeatureFlags2["ICE_RESTART_ON_FAILED_STATE"] = "ice_restart_on_failed_state";
  FlagsmithFeatureFlags2["ENABLE_ICE_STATE_LOGGING"] = "enable_ice_state_logging";
  FlagsmithFeatureFlags2["REMOVE_TOGGLE_AUDIO"] = "remove_toggle_audio";
  FlagsmithFeatureFlags2["REMOVE_OPERATIONAL_MIC"] = "web_core_remove_operational_mic";
  FlagsmithFeatureFlags2["SUPPRESS_PEER_MUTE_UNMUTE_EMITS"] = "web_core_suppress_peer_mute_unmute_emits";
})(FlagsmithFeatureFlags || (FlagsmithFeatureFlags = {}));
function _flattenObjForOpenTelemetry(obj, parentKey, res = {}) {
  Object.getOwnPropertyNames(obj).forEach((key) => {
    if ([null, void 0, NaN].includes(obj[key])) {
      return;
    }
    const propName = parentKey ? `${parentKey}.${key}` : key;
    if (typeof obj[key] === "object") {
      _flattenObjForOpenTelemetry(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  });
  return res;
}
const _DyteTelemetry = class {
  static init(peerId) {
    const exporter = new OTLPTraceExporter({
      url: "https://otel.dyte.io/v1/traces",
      headers: {
        "api-key": ""
      }
    });
    const provider = new WebTracerProvider({
      resource: new Resource({
        "service.name": "web-core"
      })
    });
    _DyteTelemetry.tracer = provider.getTracer(peerId);
    _DyteTelemetry.meetingMetadata.peerId = peerId;
    provider.addSpanProcessor(new BatchSpanProcessor(exporter));
    provider.register({
      contextManager: new ZoneContextManager()
    });
    _DyteTelemetry.rootSpan = _DyteTelemetry.tracer.startSpan(`peer_${peerId}`, {}, ROOT_CONTEXT);
    _DyteTelemetry.rootSpan.end();
    _DyteTelemetry.logsProcessorTimer = setInterval(_DyteTelemetry.processCachedLogs, _DyteTelemetry.logsProcessingInterval);
  }
  static trace(spanName) {
    return (_target, _propertyKey, descriptor) => {
      const originalMethod = descriptor.value;
      descriptor.value = function opentelemetryValueDescriptorFunc(...args) {
        const immmediateParentSpan = _DyteTelemetry.getCurrentSpan();
        const ctx = opentelemetry.trace.setSpan(ROOT_CONTEXT, immmediateParentSpan);
        if (!dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.NR_OTEL_WEB)) {
          _DyteTelemetry.addEventInCurrentSpan("info", spanName);
        }
        return _DyteTelemetry.tracer.startActiveSpan(spanName, {}, ctx, (span) => {
          span.setAttributes({
            [SemanticAttributes.CODE_FUNCTION]: spanName
          });
          const result = originalMethod.apply(this, args);
          Promise.resolve(result).then(() => {
            span.end();
          }).catch(() => {
            span.end();
          });
          return result;
        });
      };
      return descriptor;
    };
  }
  static getCurrentSpan() {
    let immmediateParentSpan = opentelemetry.trace.getSpan(opentelemetry.context.active());
    immmediateParentSpan != null ? immmediateParentSpan : immmediateParentSpan = _DyteTelemetry.rootSpan;
    return immmediateParentSpan;
  }
  static getCurrentSpanName() {
    var _a3;
    return (_a3 = this.getCurrentSpan()) == null ? void 0 : _a3.name;
  }
  static addEventInCurrentSpan(eventSeverity = "info", eventName, metadata = {}, noCache) {
    var _a3;
    try {
      const flattendMetadata = _flattenObjForOpenTelemetry(metadata, "metadata");
      const currentSpan = _DyteTelemetry.getCurrentSpan();
      const logToProcess = __spreadProps(__spreadValues({
        message: eventName,
        logSeverity: eventSeverity
      }, flattendMetadata), {
        "trace.id": _DyteTelemetry.meetingMetadata.peerId,
        "span.id": (_a3 = currentSpan == null ? void 0 : currentSpan.spanContext()) == null ? void 0 : _a3.spanId,
        loggedAt: new Date().getTime()
      });
      if (noCache) {
        _DyteTelemetry.sendOtelLogsToNewRelic([logToProcess]);
      } else {
        _DyteTelemetry.logsCache.push(logToProcess);
      }
    } catch (ex) {
      log.error("opentelemetry::addEventInCurrentSpan_failed", ex);
    }
  }
  static sendOtelLogsToNewRelic(logs) {
    axios.post(_DyteTelemetry.logsEndpoint, {
      meetingMetadata: _flattenObjForOpenTelemetry(_DyteTelemetry.meetingMetadata, "meetingMetadata"),
      serviceName: "web-core",
      logs
    }).catch((err) => {
      log.error("opentelemetry::sendOtelLogToNewRelic_failed", err);
    });
  }
  static processCachedLogs() {
    const logs = _DyteTelemetry.logsCache.splice(0, 25);
    if (logs == null ? void 0 : logs.length) {
      _DyteTelemetry.sendOtelLogsToNewRelic(logs);
    }
  }
};
let DyteTelemetry = _DyteTelemetry;
__publicField(DyteTelemetry, "tracer");
__publicField(DyteTelemetry, "rootSpan");
__publicField(DyteTelemetry, "logsCache", []);
__publicField(DyteTelemetry, "logsProcessorTimer");
__publicField(DyteTelemetry, "logsEndpoint", "https://api-silos.dyte.io/otel/logs");
__publicField(DyteTelemetry, "logsProcessingInterval", 7e3);
__publicField(DyteTelemetry, "logExclusionList", [
  "message",
  "websocket/message",
  "roomMessage",
  "websocket/room-message",
  "chatMessage",
  "websocket/new-chat-message",
  "websocket/no-active-speaker",
  "websocket/selected-peers",
  "websocket/active-speaker"
]);
__publicField(DyteTelemetry, "meetingMetadata", {});
var SocketEvents;
(function(SocketEvents2) {
  SocketEvents2["SOCKET_CONNECTED"] = "SOCKET_CONNECTED";
  SocketEvents2["SOCKET_DISCONNECTED"] = "SOCKET_DISCONNECTED";
  SocketEvents2["SOCKET_CONNECTION_ERROR"] = "SOCKET_CONNECTION_ERROR";
  SocketEvents2["SOCKET_MESSAGE"] = "SOCKET_MESSAGE";
})(SocketEvents || (SocketEvents = {}));
var SocketState;
(function(SocketState2) {
  SocketState2[SocketState2["NOT_STARTED"] = 0] = "NOT_STARTED";
  SocketState2[SocketState2["CONNECTED"] = 1] = "CONNECTED";
  SocketState2[SocketState2["DISCONNECTED"] = 2] = "DISCONNECTED";
  SocketState2[SocketState2["ERRORED"] = 3] = "ERRORED";
})(SocketState || (SocketState = {}));
var SessionEvents;
(function(SessionEvents2) {
  SessionEvents2["NEW_PRODUCER"] = "NEW_PRODUCER";
  SessionEvents2["ROOM_NODE_CONNECTED"] = "ROOM_NODE_CONNECTED";
  SessionEvents2["ROOM_NODE_DISCONNECTED"] = "ROOM_NODE_DISCONNECTED";
  SessionEvents2["ROOM_JOINED"] = "ROOM_JOINED";
  SessionEvents2["SELF_ROOM_JOINED"] = "SELF_ROOM_JOINED";
  SessionEvents2["LOW_PRODUCER_SCORE"] = "LOW_PRODUCER_SCORE";
  SessionEvents2["LOW_CONSUMER_SCORE"] = "LOW_CONSUMER_SCORE";
  SessionEvents2["MEDIA_PERMISSION_ERROR"] = "MEDIA_PERMISSION_ERROR";
  SessionEvents2["WAITLISTED"] = "WAIT_LISTED";
  SessionEvents2["WAITLIST_ACCEPTED"] = "websocket/waitlist-accepted";
  SessionEvents2["WAITLIST_REJECTED"] = "websocket/waitlist-rejected";
  SessionEvents2["WAITLIST_PEER_ADDED"] = "websocket/waitlist-peer-added";
  SessionEvents2["WAITLIST_PEER_REMOVED"] = "websocket/waitlist-peer-closed";
  SessionEvents2["MESSAGE"] = "websocket/message";
  SessionEvents2["ROOM_MESSAGE"] = "websocket/room-message";
  SessionEvents2["DISABLE_AUDIO"] = "websocket/disable-audio";
  SessionEvents2["DISABLE_VIDEO"] = "websocket/disable-video";
  SessionEvents2["PEER_JOINED"] = "websocket/peer-joined";
  SessionEvents2["PEER_CLOSED"] = "websocket/peer-closed";
  SessionEvents2["PEER_MUTED"] = "websocket/peer-muted";
  SessionEvents2["PEER_UNMUTED"] = "websocket/peer-unmuted";
  SessionEvents2["PEER_PINNED"] = "websocket/pin-peer";
  SessionEvents2["PEER_UNPINNED"] = "websocker/unpin-peer";
  SessionEvents2["MUTE_ALL"] = "websocket/mute-all";
  SessionEvents2["MUTE_ALL_VIDEO"] = "websocket/mute-all-video";
  SessionEvents2["CONSUMER_CLOSED"] = "websocket/consumer-closed";
  SessionEvents2["CONSUMER_PAUSED"] = "websocket/consumer-paused";
  SessionEvents2["CONSUMER_RESUMED"] = "websocket/consumer-resumed";
  SessionEvents2["PRODUCER_CLOSED"] = "websocket/producer-closed";
  SessionEvents2["NEW_CONSUMER"] = "websocket/new-consumer";
  SessionEvents2["CONNECTED_MEETING_STATE"] = "websocket/connectedMeetingState";
  SessionEvents2["MOVE_TO_CONNECTED_MEETING"] = "websocket/transferMeeting";
  SessionEvents2["GET_CHAT_MESSAGES"] = "websocket/get-chat-messages";
  SessionEvents2["NEW_CHAT_MESSAGE"] = "websocket/new-chat-message";
  SessionEvents2["PIN_CHAT_MESSAGE"] = "websocket/pin-chat-message";
  SessionEvents2["UNPIN_CHAT_MESSAGE"] = "websocket/unpin-chat-message";
  SessionEvents2["GET_POLLS"] = "websocket/get-polls";
  SessionEvents2["UPDATE_POLL"] = "websocket/update-poll";
  SessionEvents2["SELECTED_PEERS"] = "websocket/selected-peers";
  SessionEvents2["GET_PAGE"] = "websocket/get-page";
  SessionEvents2["ACTIVE_SPEAKER"] = "websocket/active-speaker";
  SessionEvents2["NO_ACTIVE_SPEAKER"] = "websocket/no-active-speaker";
  SessionEvents2["PRODUCER_SCORE"] = "websocket/producer-score";
  SessionEvents2["CONSUMER_SCORE"] = "websocket/consumer-score";
  SessionEvents2["ENABLE_PLUGIN"] = "websocket/enable-plugin";
  SessionEvents2["DISABLE_PLUGIN"] = "websocket/disable-plugin";
  SessionEvents2["PLUGIN_EVENT"] = "websocket/plugin-event";
  SessionEvents2["PLUGIN_DATA"] = "websocket/plugin-data";
  SessionEvents2["PLUGIN_INTERNAL_DATA"] = "websocket/plugin-internal-data";
  SessionEvents2["KICKED"] = "websocket/kicked";
  SessionEvents2["RECORDING_STARTED"] = "websocket/recording-started";
  SessionEvents2["RECORDING_STOPPED"] = "websocket/recording-stopped";
  SessionEvents2["ASSERT_SPOTLIGHTER"] = "websocket/assert-spotlighter";
  SessionEvents2["PEER_REQUESTED_TO_JOIN_STAGE"] = "websocket/request-to-join-stage-peer-added";
  SessionEvents2["PEER_REJECTED_TO_JOIN_STAGE"] = "websocket/peer-rejected-to-join-stage";
  SessionEvents2["PEER_ADDED_TO_STAGE"] = "websocket/peer-added-to-stage";
  SessionEvents2["PEER_REMOVED_FROM_STAGE"] = "websocket/peer-removed-from-stage";
  SessionEvents2["PEER_STARTED_PRESENTING"] = "websocket/peer-started-presenting";
  SessionEvents2["PEER_STOPPED_PRESENTING"] = "websocket/peer-stopped-presenting";
  SessionEvents2["REQUEST_TO_JOIN_STAGE_ACCEPTED"] = "websocket/request-to-join-stage-accepted";
  SessionEvents2["REQUEST_TO_JOIN_STAGE_REJECTED"] = "websocket/request-to-join-stage-rejected";
  SessionEvents2["STARTED_PRESENTING"] = "websocket/started-presenting";
  SessionEvents2["STOPPED_PRESENTING"] = "websocket/stopped-presenting";
  SessionEvents2["REMOVED_FROM_STAGE"] = "websocket/removed-from-stage";
})(SessionEvents || (SessionEvents = {}));
class SessionStoreHandler extends events$1.exports.EventEmitter {
  constructor() {
    super();
    __privateAdd(this, _eventPromises, void 0);
    __privateAdd(this, _asyncListeners, void 0);
    __publicField(this, "asyncPromiseTimeout");
    __privateSet(this, _eventPromises, new Map());
    __privateSet(this, _asyncListeners, new Map());
    this.asyncPromiseTimeout = 8e3;
  }
  async emitAsync(event, ...args) {
    __privateGet(this, _eventPromises).set(event, []);
    const promises = __privateGet(this, _asyncListeners).get(event).map(() => new Promise((resolve) => {
      __privateGet(this, _eventPromises).get(event).push(resolve);
    }));
    super.emit(event, ...args);
    await Promise.race([
      Promise.all(promises),
      new Promise((_, reject) => setTimeout(() => reject(new Error("emitAsync failed to resolve.")), this.asyncPromiseTimeout))
    ]);
    __privateGet(this, _eventPromises).delete(event);
  }
  onAsync(event, cb) {
    const eventPromises = __privateGet(this, _eventPromises);
    const listener = async (...args) => {
      var _a3;
      try {
        await cb(...args);
      } catch (e) {
        log.error(`[onAsync] ${e}`);
      }
      const resolve = (_a3 = eventPromises.get(event)) == null ? void 0 : _a3.shift();
      resolve == null ? void 0 : resolve();
    };
    if (!__privateGet(this, _asyncListeners).get(event)) {
      __privateGet(this, _asyncListeners).set(event, []);
    }
    __privateGet(this, _asyncListeners).get(event).push(listener);
    return super.on(event, listener);
  }
}
_eventPromises = new WeakMap();
_asyncListeners = new WeakMap();
const SessionStore = new SessionStoreHandler();
var __defProp$l = Object.defineProperty;
var __getOwnPropDesc$l = Object.getOwnPropertyDescriptor;
var __decorateClass$l = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$l(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$l(target, key, result);
  return result;
};
const SIMPLE_SERVER_MESSAGE_EVENT = "event://server-simple-message";
const CLIENT_SIDE_EVENT = "event://send-message";
class SocketClient extends EventEmitter$3 {
  constructor(options) {
    super();
    __publicField(this, "socket");
    __publicField(this, "socketState");
    __publicField(this, "callbackHandler", null);
    this.socketState = SocketState.NOT_STARTED;
    if (options.callbackHandler) {
      this.callbackHandler = options.callbackHandler;
    }
  }
  connect(url) {
    if (this.socket) {
      this.socket.removeAllListeners();
      this.socket.disconnect();
    }
    this.socket = io(url, { closeOnBeforeunload: false });
    this.setupSocket();
  }
  disconnect() {
    this.socket.disconnect();
  }
  reconnect() {
    this.socket.connect();
  }
  setupSocket() {
    this.socket.on("disconnect", (reason) => {
      this.socketState = SocketState.DISCONNECTED;
      DyteTelemetry.addEventInCurrentSpan("warn", "SocketClient::socket_disconnected", { reason });
      this.emit(SocketEvents.SOCKET_DISCONNECTED, { reason });
    });
    this.socket.on("connect_error", (err) => {
      this.socketState = SocketState.ERRORED;
      log.error(`socket connection errored due to : ${err}`);
      DyteTelemetry.addEventInCurrentSpan("error", "SocketClient::socket_connection_errored", { message: err.message });
      this.emit(SocketEvents.SOCKET_CONNECTION_ERROR, { err });
    });
    this.socket.on("connect", () => {
      this.socketState = SocketState.CONNECTED;
      DyteTelemetry.addEventInCurrentSpan("info", "SocketClient::socket_connected");
      this.emit(SocketEvents.SOCKET_CONNECTED);
    });
    this.socket.on(SIMPLE_SERVER_MESSAGE_EVENT, async (message, callback) => {
      const parsedMessage = JSON.parse(message);
      if (!DyteTelemetry.logExclusionList.includes(parsedMessage == null ? void 0 : parsedMessage.type)) {
        DyteTelemetry.addEventInCurrentSpan("info", "SocketClient::SIMPLE_SERVER_MESSAGE_EVENT", { message: parsedMessage });
      }
      if (callback) {
        let response = "OK";
        if (this.callbackHandler) {
          response = await this.callbackHandler(parsedMessage);
        }
        callback(response);
      } else
        this.emit(SocketEvents.SOCKET_MESSAGE, parsedMessage);
      if (Object.values(SessionEvents).find((e) => e === parsedMessage.type)) {
        SessionStore.emit(parsedMessage.type, parsedMessage.payload);
      }
    });
  }
  async sendMessage(message) {
    if (!DyteTelemetry.logExclusionList.includes(message == null ? void 0 : message.type)) {
      DyteTelemetry.addEventInCurrentSpan("info", "SocketClient::sendMessage", { message });
    }
    return new Promise((resolve) => {
      this.socket.emit(CLIENT_SIDE_EVENT, JSON.stringify(message), (response) => {
        if (!response) {
          resolve(void 0);
          return;
        }
        const parsedMessage = JSON.parse(response);
        resolve(parsedMessage);
      });
    });
  }
}
__decorateClass$l([
  DyteTelemetry.trace("SocketClient.connect")
], SocketClient.prototype, "connect", 1);
__decorateClass$l([
  DyteTelemetry.trace("SocketClient.disconnect")
], SocketClient.prototype, "disconnect", 1);
__decorateClass$l([
  DyteTelemetry.trace("SocketClient.reconnect")
], SocketClient.prototype, "reconnect", 1);
__decorateClass$l([
  DyteTelemetry.trace("SocketClient.setupSocket")
], SocketClient.prototype, "setupSocket", 1);
const VIDEO_CONSTRAINTS = {
  qvga: { width: { ideal: 320 }, height: { ideal: 240 } },
  vga: { width: { ideal: 640 }, height: { ideal: 480 } },
  hd: { width: { ideal: 1280 }, height: { ideal: 720 } },
  hd_cropped: { width: { ideal: 900 }, height: { ideal: 720 } }
};
const PC_PROPRIETARY_CONSTRAINTS = {};
const WEBCAM_SIMULCAST_ENCODINGS_VGA = [
  { rid: "r0", scalabilityMode: "S1T2" },
  { rid: "r1", scalabilityMode: "S1T2" }
];
const WEBCAM_KSVC_ENCODINGS = [
  { scalabilityMode: "L3T3_KEY" }
];
var PRODUCERS_TYPE;
(function(PRODUCERS_TYPE2) {
  PRODUCERS_TYPE2["WEBCAM"] = "webcam";
  PRODUCERS_TYPE2["MIC"] = "mic";
  PRODUCERS_TYPE2["SCREENSHARE_VIDEO"] = "screenshare_video";
  PRODUCERS_TYPE2["SCREENSHARE_AUDIO"] = "screenshare_audio";
})(PRODUCERS_TYPE || (PRODUCERS_TYPE = {}));
class API {
  constructor(options) {
    __publicField(this, "axios");
    __publicField(this, "requests");
    __publicField(this, "roomName");
    __publicField(this, "roomUUID");
    __publicField(this, "peerId");
    __publicField(this, "authToken");
    __publicField(this, "organizationId");
    const {
      timeout = 1e4,
      baseURL = "https://api.cluster.dyte.in",
      authToken
    } = options || {};
    this.requests = axios.create({
      baseURL,
      responseType: "json",
      timeout
    });
    this.axios = axios;
    this.setAuthToken(authToken, { bearer: true });
    this.requests.interceptors.response.use((response) => {
      if (response.config.url !== DyteTelemetry.logsEndpoint) {
        DyteTelemetry.addEventInCurrentSpan("debug", "xhr::axios", {
          data: response.data,
          status: response.status,
          statusText: response.statusText,
          headers: response.config.headers,
          baseURL: response.config.baseURL,
          url: response.config.url
        });
      }
      return response;
    }, (error) => {
      var _a3, _b2, _c2, _d2;
      if (error && error.config && ((_a3 = error.config) == null ? void 0 : _a3.url) !== DyteTelemetry.logsEndpoint) {
        DyteTelemetry.addEventInCurrentSpan("error", "xhr::axios", {
          message: error == null ? void 0 : error.message,
          headers: (_b2 = error == null ? void 0 : error.config) == null ? void 0 : _b2.headers,
          status: error == null ? void 0 : error.status,
          statusText: error == null ? void 0 : error.statusText,
          stack: error == null ? void 0 : error.stack,
          baseUrl: (_c2 = error == null ? void 0 : error.config) == null ? void 0 : _c2.baseURL,
          url: (_d2 = error == null ? void 0 : error.config) == null ? void 0 : _d2.url
        });
      }
    });
  }
  setAuthToken(token, options) {
    const { bearer } = options || {};
    this.authToken = token;
    this.requests.defaults.headers.common.Authorization = bearer ? `Bearer ${token}` : token;
  }
  setHeader(key, value) {
    this.requests.defaults.headers.common[key] = value;
  }
  setRoomName(name) {
    this.roomName = name;
  }
  setRoomUUID(id) {
    this.roomUUID = id;
  }
  setPeerId(id) {
    this.peerId = id;
  }
  setOrganizationId(id) {
    this.organizationId = id;
  }
}
function stringToCamelCase(snakeCaseString) {
  return snakeCaseString.replace(/([-_]\w)/g, (g) => g[1].toUpperCase());
}
function objectToCamelCase(snakeCaseObject) {
  if (!snakeCaseObject || typeof snakeCaseObject !== "object") {
    return snakeCaseObject;
  }
  if (Array.isArray(snakeCaseObject)) {
    return snakeCaseObject.map((i) => objectToCamelCase(i));
  }
  const n = {};
  Object.keys(snakeCaseObject).forEach((k) => {
    n[stringToCamelCase(k)] = objectToCamelCase(snakeCaseObject[k]);
  });
  return n;
}
function postMessageSanitizer(value, acc = {}) {
  if (value === void 0 || value === null)
    return {};
  Object.getOwnPropertyNames(value).forEach((property) => {
    if (typeof value[property] === "function")
      return;
    if (typeof value[property] === "object") {
      postMessageSanitizer(value[property], acc[property] = {});
      return;
    }
    acc[property] = value[property];
  });
  return acc;
}
const config = {
  roomName: void 0,
  authToken: void 0,
  peerId: void 0,
  apiBase: void 0,
  defaults: void 0,
  modules: void 0
};
function setConfig(options) {
  config.roomName = options.roomName;
  config.authToken = options.authToken;
  config.peerId = options.peerId;
  config.apiBase = options.apiBase;
  config.defaults = options.defaults;
  config.modules = options.modules;
}
const WEB_CORE_VERSION = "0.38.1";
class DyteError extends Error {
  constructor(message) {
    super(message);
    __publicField(this, "code");
    this.name = "DyteError";
  }
}
const constants = {
  isV2AuthToken: false,
  meetingId: null
};
function setIsV2AuthToken(authToken, roomName) {
  if (roomName) {
    constants.isV2AuthToken = false;
    return;
  }
  try {
    const { meetingId } = JSON.parse(atob(authToken.split(".")[1]));
    if (!meetingId)
      throw Error(`Received V1 auth token ${authToken}`);
    constants.isV2AuthToken = true;
    constants.meetingId = meetingId;
  } catch (ex) {
    DyteTelemetry.addEventInCurrentSpan("error", "constants::setIsV2AuthToken", {
      reason: "Unable to decode auth token",
      authToken,
      exception: ex
    }, true);
    throw new DyteError("Invalid auth token");
  }
}
class APIClient extends API {
  constructor(options) {
    super(options);
    this.setHeader("x-dyte-web-core-version", WEB_CORE_VERSION);
  }
  async getRoomNodeData(roomName) {
    const { roomNodeLink, title } = constants.isV2AuthToken ? await this.getRoomNodeLinkAndTitleV2() : await this.getRoomNodeLinkAndTitleV1(roomName);
    return {
      roomNodeUrl: roomNodeLink,
      meetingTitle: title
    };
  }
  async getRoomNodeLinkAndTitleV1(roomName) {
    const query = `
        query Session($roomName: String!, $password: String) {
            session(roomName: $roomName, password: $password) {
              title,
              roomNodeLink,
              roomName,
              password
            }
          }
        `;
    const ipInformation = await ipDetails.getIPDetails();
    const { roomNodeLink, title } = (await this.requests.post("/graphql", {
      query,
      variables: { roomName, ipInformation }
    })).data.data.session;
    return { roomNodeLink, title };
  }
  async getRoomNodeLinkAndTitleV2() {
    const { roomNodeLink, title } = objectToCamelCase((await this.requests.post("v2/internals/rooms")).data.data);
    return { roomNodeLink, title };
  }
  async getICEServers() {
    const { success, iceServers } = (await this.requests.get("/iceservers")).data;
    if (success) {
      return iceServers;
    }
    return void 0;
  }
  async getUserDetails() {
    return constants.isV2AuthToken ? this.getUserDetailsV2() : this.getUserDetailsV1();
  }
  async getUserDetailsV1() {
    const { user } = (await this.requests.get("/auth/basicUserDetails")).data;
    return user;
  }
  async getUserDetailsV2() {
    const userDetailsResponseV2 = (await this.requests.get("v2/internals/participant-details")).data.data;
    return objectToCamelCase(userDetailsResponseV2);
  }
  async getUserPreset(roomName) {
    const { preset } = (await this.requests.post("/v1/userpreset", {
      roomName,
      authToken: this.authToken,
      clientType: "CLIENT_APP",
      version: "0.5.0"
    })).data.data;
    return objectToCamelCase(preset);
  }
  async getPlugins() {
    const { plugins } = (await this.requests.get("/v2/plugins/user")).data.data;
    return plugins;
  }
  async getPluginDetails(pluginId) {
    const { plugin } = (await this.requests.get(`/v2/plugins/view/${pluginId}`)).data.data;
    return plugin;
  }
  async getPluginConfig(pluginBaseUrl) {
    const config2 = (await this.axios.get(`${pluginBaseUrl}/dyte-config.json`)).data;
    return config2;
  }
  async authorizePlugin(pluginId) {
    const { token } = (await this.requests.post(`/v2/plugins/authorize/${pluginId}`, {
      roomName: this.roomName,
      peerId: this.peerId
    })).data.data;
    return token;
  }
  async getPresignedUrls(filename) {
    const { getLocation, putLocation } = (await this.requests.post("/v1/meetings/genPreSignedUploadUrl", {
      roomUUID: this.roomUUID,
      filename
    })).data.data;
    return {
      getLocation,
      putLocation
    };
  }
  async uploadFile(file, url) {
    await this.axios.put(url, file, {
      headers: {
        "Content-Type": file.type
      }
    });
  }
  async startRecording() {
    const response = await this.requests.post(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/recording`);
    if (response.status !== 201) {
      throw new Error("Recording failed to start");
    }
    return response.data.data.recording.id;
  }
  async stopRecording(recordingId) {
    const response = await this.requests.put(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/recordings/${recordingId}`, { recordingAction: "stop" });
    if (response.status !== 201) {
      throw new Error("Recording failed to stop");
    }
    return response;
  }
  async getActiveRecording() {
    if (!this.organizationId)
      return {};
    const response = await this.requests.get(`/v1/organizations/${this.organizationId}/rooms/${this.roomName}/active-recording?limit=50`);
    return response.data.data.recording;
  }
}
let api;
function setupAPIClient(options) {
  api = new APIClient(options);
  return api;
}
function getAPIClient() {
  return api;
}
var __defProp$k = Object.defineProperty;
var __getOwnPropDesc$k = Object.getOwnPropertyDescriptor;
var __decorateClass$k = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$k(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$k(target, key, result);
  return result;
};
class SFUHandler extends EventEmitter$3 {
  constructor(socketClient) {
    super();
    __publicField(this, "device");
    __publicField(this, "sendTransport");
    __publicField(this, "recvTransport");
    __publicField(this, "sendTransportIceStateDisconnectTime");
    __publicField(this, "recvTransportIceStateDisconnectTime");
    __publicField(this, "consumers");
    __publicField(this, "producers");
    __publicField(this, "socketClient");
    this.producers = new Map();
    this.consumers = new Map();
    this.device = new Device();
    this.socketClient = socketClient;
  }
  async setupTransports() {
    const APIClient2 = getAPIClient();
    const iceServers = await APIClient2.getICEServers();
    await this.loadRouter();
    await Promise.all([
      this.createRecvTransport(iceServers),
      this.createSendTransport(iceServers)
    ]);
  }
  async loadRouter() {
    if (this.recvTransport || this.sendTransport) {
      await this.stopAllTransports();
    }
    const routerMessage = await this.socketClient.sendMessage({
      type: "getRouterRtpCapabilities"
    });
    const routerRtpCapabilities = routerMessage == null ? void 0 : routerMessage.payload;
    if (this.device.loaded) {
      this.device = new Device();
    }
    if (routerRtpCapabilities) {
      routerRtpCapabilities.headerExtensions = routerRtpCapabilities.headerExtensions.filter((ext) => ext.uri !== "urn:3gpp:video-orientation");
    }
    return this.device.load({ routerRtpCapabilities });
  }
  getRTPCapabilities() {
    return this.device.rtpCapabilities;
  }
  async createRecvTransport(iceServers) {
    if (!this.socketClient) {
      return;
    }
    const payload = {
      forceTcp: false,
      producing: false,
      consuming: true
    };
    const transportOptions = (await this.socketClient.sendMessage({
      type: "createWebRtcTransport",
      payload
    })).payload;
    DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::initializing_transport");
    this.recvTransport = this.device.createRecvTransport(__spreadProps(__spreadValues({}, transportOptions), {
      iceServers,
      proprietaryConstraints: PC_PROPRIETARY_CONSTRAINTS
    }));
    DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::initialized_transport");
    callStats.onSafeInitialization(() => {
      callStats.configureRecvTransport(this.recvTransport);
    });
    this.recvTransport.on("connect", async ({ dtlsParameters }, callback, err) => {
      var _a3;
      const message = await this.socketClient.sendMessage({
        type: "connectWebRtcTransport",
        payload: {
          transportId: this.recvTransport.id,
          dtlsParameters
        }
      });
      if (!((_a3 = message.payload) == null ? void 0 : _a3.error)) {
        callback();
        DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::transport_status", {
          status: "connected"
        });
      } else {
        DyteTelemetry.addEventInCurrentSpan("error", "recvTransport::transport_status", {
          status: "failed"
        });
        err();
      }
    });
    if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.ENABLE_ICE_STATE_LOGGING)) {
      DyteTelemetry.addEventInCurrentSpan("info", "enabling_ice_state_logging_for_recv_transport");
      this.recvTransport.on("connectionstatechange", async (state) => {
        var _a3;
        DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::connection_state_change", {
          state
        });
        switch (state) {
          case "failed":
            DyteTelemetry.addEventInCurrentSpan("warn", "recvTransport::ice_state_failed");
            if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.ICE_RESTART_ON_FAILED_STATE)) {
              try {
                await this.restartIce(this.recvTransport);
              } catch (error) {
                DyteTelemetry.addEventInCurrentSpan("error", "recvTransport::ice_restart_failed", {
                  error
                });
              }
            }
            break;
          case "disconnected":
            DyteTelemetry.addEventInCurrentSpan("warn", "recvTransport::ice_state_disconnected");
            if (this.recvTransportIceStateDisconnectTime) {
              DyteTelemetry.addEventInCurrentSpan("warn", "recvTransport::ice_state_disconnected_again", {
                lastDisconnectedTime: this.recvTransportIceStateDisconnectTime.toLocaleTimeString(),
                durationPassed: new Date().getTime() - this.recvTransportIceStateDisconnectTime.getTime()
              });
            }
            this.recvTransportIceStateDisconnectTime = new Date();
            break;
          case "connected":
            DyteTelemetry.addEventInCurrentSpan("info", "recvTransport::ice_state_connected", {
              lastDisconnectionTime: (_a3 = this.recvTransportIceStateDisconnectTime) == null ? void 0 : _a3.toLocaleTimeString(),
              durationPassed: this.recvTransportIceStateDisconnectTime ? new Date().getTime() - this.recvTransportIceStateDisconnectTime.getTime() : null
            });
            this.recvTransportIceStateDisconnectTime = void 0;
            break;
        }
      });
    }
    this.recvTransport.observer.on("close", () => {
      this.recvTransport = void 0;
      DyteTelemetry.addEventInCurrentSpan("warn", "recvTransport_closed");
    });
  }
  async createSendTransport(iceServers) {
    const payload = {
      forceTcp: false,
      producing: true,
      consuming: false
    };
    const transportOptions = (await this.socketClient.sendMessage({
      type: "createWebRtcTransport",
      payload
    })).payload;
    DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::initializing_transport");
    this.sendTransport = this.device.createSendTransport(__spreadProps(__spreadValues({}, transportOptions), {
      iceServers,
      proprietaryConstraints: PC_PROPRIETARY_CONSTRAINTS
    }));
    DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::initialized_transport");
    callStats.onSafeInitialization(() => {
      callStats.configureSendTransport(this.sendTransport);
    });
    this.sendTransport.on("connect", async ({ dtlsParameters }, callback, err) => {
      var _a3, _b2;
      const message = await this.socketClient.sendMessage({
        type: "connectWebRtcTransport",
        payload: {
          transportId: (_a3 = this.sendTransport) == null ? void 0 : _a3.id,
          dtlsParameters
        }
      });
      if (!((_b2 = message.payload) == null ? void 0 : _b2.error)) {
        DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::transport_status", {
          status: "connected"
        });
        callback();
      } else {
        DyteTelemetry.addEventInCurrentSpan("error", "sendTransport::transport_status", {
          status: "failed"
        });
        err();
      }
    });
    this.sendTransport.on("produce", async ({
      kind,
      rtpParameters,
      appData
    }, callback, err) => {
      var _a3, _b2, _c2, _d2;
      const message = await this.socketClient.sendMessage({
        type: "produce",
        payload: {
          transportId: (_a3 = this.sendTransport) == null ? void 0 : _a3.id,
          kind,
          rtpParameters,
          appData
        }
      });
      if (!((_b2 = message.payload) == null ? void 0 : _b2.error)) {
        DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::producer_status", {
          kind,
          appData,
          status: "producing"
        });
        callback({ id: (_c2 = message.payload) == null ? void 0 : _c2.id });
      } else {
        DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::producer_status", {
          kind,
          appData,
          status: "failed"
        });
        err((_d2 = message.payload) == null ? void 0 : _d2.error);
      }
    });
    if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.ENABLE_ICE_STATE_LOGGING)) {
      DyteTelemetry.addEventInCurrentSpan("info", "enabling_ice_state_logging_for_send_transport");
      this.sendTransport.on("connectionstatechange", async (state) => {
        var _a3;
        DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::connection_state_change", {
          state
        });
        switch (state) {
          case "failed":
            DyteTelemetry.addEventInCurrentSpan("warn", "sendTransport::ice_state_failed");
            if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.ICE_RESTART_ON_FAILED_STATE)) {
              try {
                await this.restartIce(this.sendTransport);
              } catch (error) {
                DyteTelemetry.addEventInCurrentSpan("error", "sendTransport::ice_restart_failed", {
                  error
                });
              }
            }
            break;
          case "disconnected":
            DyteTelemetry.addEventInCurrentSpan("warn", "sendTransport::ice_state_disconnected");
            if (this.sendTransportIceStateDisconnectTime) {
              DyteTelemetry.addEventInCurrentSpan("warn", "sendTransport::ice_state_disconnected_again", {
                lastDisconnectedTime: this.sendTransportIceStateDisconnectTime.toLocaleTimeString(),
                durationPassed: new Date().getTime() - this.sendTransportIceStateDisconnectTime.getTime()
              });
            }
            this.sendTransportIceStateDisconnectTime = new Date();
            break;
          case "connected":
            DyteTelemetry.addEventInCurrentSpan("info", "sendTransport::ice_state_connected", {
              lastDisconnectionTime: (_a3 = this.sendTransportIceStateDisconnectTime) == null ? void 0 : _a3.toLocaleTimeString(),
              durationPassed: this.sendTransportIceStateDisconnectTime ? new Date().getTime() - this.sendTransportIceStateDisconnectTime.getTime() : null
            });
            this.sendTransportIceStateDisconnectTime = void 0;
            break;
        }
      });
    }
    this.sendTransport.observer.on("close", () => {
      this.sendTransport = void 0;
      DyteTelemetry.addEventInCurrentSpan("warn", "sendTransport_closed");
    });
  }
  async restartIce(transport) {
    const iceParameters = (await this.socketClient.sendMessage({
      type: "restartIce",
      payload: {
        transportId: transport.id
      }
    })).payload;
    return transport.restartIce(iceParameters);
  }
  async createConsumer(request) {
    if (this.recvTransport === void 0 || this.recvTransport.closed) {
      return;
    }
    const {
      peerId,
      producerId,
      id,
      kind,
      rtpParameters,
      appData,
      remotelyPaused
    } = request;
    DyteTelemetry.addEventInCurrentSpan("info", "createConsumer::initializing_consumer", {
      peerId,
      kind,
      appData,
      remotelyPaused
    });
    const consumer = await this.recvTransport.consume({
      id,
      producerId,
      kind,
      rtpParameters,
      appData: __spreadProps(__spreadValues({}, appData), { peerId })
    });
    DyteTelemetry.addEventInCurrentSpan("info", "createConsumer::initialized_consumer", {
      peerId,
      kind,
      appData,
      remotelyPaused
    });
    const extendedConsumer = consumer;
    extendedConsumer.peerId = peerId;
    extendedConsumer.remotelyPaused = remotelyPaused;
    extendedConsumer.score = 10;
    this.consumers.set(consumer.id, extendedConsumer);
  }
  async closeConsumer(request) {
    const { id } = request;
    const consumer = this.consumers.get(id);
    if (!consumer)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "SFUHandler::close_consumer", {
      peerId: consumer.peerId,
      kind: consumer.kind,
      appData: consumer.appData
    });
    consumer.close();
    this.consumers.delete(id);
  }
  async cleanupConsumers() {
    var _a3;
    (_a3 = this.consumers) == null ? void 0 : _a3.forEach((consumer) => {
      SessionStore.emit(SessionEvents.CONSUMER_CLOSED, { id: consumer.id });
      this.closeConsumer({ id: consumer.id });
    });
  }
  async pauseConsumer(request) {
    const { id } = request;
    const consumer = this.consumers.get(id);
    if (!consumer)
      return;
    consumer.pause();
  }
  async resumeConsumer(request) {
    const { id } = request;
    const consumer = this.consumers.get(id);
    if (!consumer)
      return;
    consumer.resume();
  }
  async createProducer(producerType, producerOptions, onDisconnect) {
    if (this.sendTransport === void 0 || this.sendTransport.closed) {
      return;
    }
    DyteTelemetry.addEventInCurrentSpan("info", "createProducer::initializing_producer", {
      producerType
    });
    const producer = await this.sendTransport.produce(producerOptions);
    DyteTelemetry.addEventInCurrentSpan("info", "createProducer::initialized_producer", {
      producerType
    });
    producer.on("transportclose", () => {
      DyteTelemetry.addEventInCurrentSpan("info", "producer::transportclose", {
        producerType
      });
      this.producers.delete(producerType);
    });
    producer.on("trackended", () => {
      DyteTelemetry.addEventInCurrentSpan("info", "producer::trackended", {
        producerType
      });
      if (![PRODUCERS_TYPE.MIC, PRODUCERS_TYPE.WEBCAM].includes(producerType)) {
        onDisconnect();
      }
    });
    const extendedProducer = producer;
    extendedProducer.score = 10;
    this.producers.set(producerType, extendedProducer);
  }
  async removeProducer(producerType, stopTrack = true) {
    const producer = this.producers.get(producerType);
    if (!producer || producer.closed) {
      return;
    }
    DyteTelemetry.addEventInCurrentSpan("info", "SFUHandler::remove_producer", {
      producerType,
      stopTrack
    });
    if (stopTrack) {
      producer.track.stop();
    }
    producer.close();
    await this.socketClient.sendMessage({ type: "closeProducer", payload: { producerId: producer.id } });
    this.producers.delete(producerType);
  }
  stopAllProducers() {
    Array.from(this.producers.keys()).forEach((producerType) => {
      this.removeProducer(producerType);
    });
  }
  async stopAllTransports() {
    if (this.sendTransport) {
      try {
        this.sendTransport.close();
      } catch (err) {
        log.error(err);
      }
      this.sendTransport = void 0;
    }
    if (this.recvTransport) {
      try {
        this.recvTransport.close();
      } catch (err) {
        DyteTelemetry.addEventInCurrentSpan("error", "SFUHandler::stopAllTransports::error", {
          message: err.message
        });
        log.error(err);
      }
      this.recvTransport = void 0;
    }
  }
}
__decorateClass$k([
  DyteTelemetry.trace("setupTransports")
], SFUHandler.prototype, "setupTransports", 1);
__decorateClass$k([
  DyteTelemetry.trace("loadRouter")
], SFUHandler.prototype, "loadRouter", 1);
__decorateClass$k([
  DyteTelemetry.trace("createRecvTransport")
], SFUHandler.prototype, "createRecvTransport", 1);
__decorateClass$k([
  DyteTelemetry.trace("createSendTransport")
], SFUHandler.prototype, "createSendTransport", 1);
__decorateClass$k([
  DyteTelemetry.trace("restartIce")
], SFUHandler.prototype, "restartIce", 1);
__decorateClass$k([
  DyteTelemetry.trace("createConsumer")
], SFUHandler.prototype, "createConsumer", 1);
__decorateClass$k([
  DyteTelemetry.trace("closeConsumer")
], SFUHandler.prototype, "closeConsumer", 1);
__decorateClass$k([
  DyteTelemetry.trace("cleanupConsumers")
], SFUHandler.prototype, "cleanupConsumers", 1);
__decorateClass$k([
  DyteTelemetry.trace("pauseConsumer")
], SFUHandler.prototype, "pauseConsumer", 1);
__decorateClass$k([
  DyteTelemetry.trace("resumeConsumer")
], SFUHandler.prototype, "resumeConsumer", 1);
__decorateClass$k([
  DyteTelemetry.trace("createProducer")
], SFUHandler.prototype, "createProducer", 1);
__decorateClass$k([
  DyteTelemetry.trace("removeProducer")
], SFUHandler.prototype, "removeProducer", 1);
__decorateClass$k([
  DyteTelemetry.trace("stopAllProducers")
], SFUHandler.prototype, "stopAllProducers", 1);
__decorateClass$k([
  DyteTelemetry.trace("stopAllTransports")
], SFUHandler.prototype, "stopAllTransports", 1);
class DyteEventEmitter extends events$1.exports.EventEmitter {
  emit(event, ...args) {
    super.emit("*", event, ...args);
    return super.emit(event, ...args);
  }
  on(event, callback) {
    return super.on(event, callback);
  }
  addListener(event, callback) {
    return super.addListener(event, callback);
  }
  off(event, callback) {
    return super.off(event, callback);
  }
  once(event, callback) {
    return super.once(event, callback);
  }
  prependListener(event, callback) {
    return super.prependListener(event, callback);
  }
  prependOnceListener(event, callback) {
    return super.prependOnceListener(event, callback);
  }
  removeListener(event, callback) {
    return super.removeListener(event, callback);
  }
  removeAllListeners(event) {
    return super.removeAllListeners(event);
  }
  listeners(event) {
    return super.listeners(event);
  }
  listenerCount(event) {
    return super.listenerCount(event);
  }
}
var RemoteRequestType;
(function(RemoteRequestType2) {
  RemoteRequestType2["REQUEST"] = "REQUEST";
  RemoteRequestType2["ACCEPT"] = "ACCEPT";
  RemoteRequestType2["REJECT"] = "REJECT";
  RemoteRequestType2["END"] = "END";
  RemoteRequestType2["EVENT"] = "EVENT";
})(RemoteRequestType || (RemoteRequestType = {}));
var RemoteRequestState;
(function(RemoteRequestState2) {
  RemoteRequestState2["PENDING"] = "PENDING";
  RemoteRequestState2["ACCEPTED"] = "ACCEPTED";
  RemoteRequestState2["REJECTED"] = "REJECTED";
  RemoteRequestState2["ENDED"] = "ENDED";
})(RemoteRequestState || (RemoteRequestState = {}));
var RemoteEventType;
(function(RemoteEventType2) {
  RemoteEventType2["KEYBOARD"] = "KEYBOARD";
  RemoteEventType2["MOUSE"] = "MOUSE";
})(RemoteEventType || (RemoteEventType = {}));
var RemoteMouseEventTypes;
(function(RemoteMouseEventTypes2) {
  RemoteMouseEventTypes2["LEFT_CLICK"] = "click";
  RemoteMouseEventTypes2["RIGHT_CLICK"] = "contextmenu";
  RemoteMouseEventTypes2["MOVE"] = "mousemove";
})(RemoteMouseEventTypes || (RemoteMouseEventTypes = {}));
var RemoteUpdateType;
(function(RemoteUpdateType2) {
  RemoteUpdateType2["REQUEST_RECEIVED"] = "REQUEST_RECEIVED";
  RemoteUpdateType2["REQUEST_SENT"] = "REQUEST_SENT";
  RemoteUpdateType2["INCOMING_REQUEST_ACCEPTED"] = "INCOMING_REQUEST_ACCEPTED";
  RemoteUpdateType2["OUTGOING_REQUEST_ACCEPTED"] = "OUTGOING_REQUEST_ACCEPTED";
  RemoteUpdateType2["INCOMING_REQUEST_ENDED"] = "INCOMING_REQUEST_ENDED";
  RemoteUpdateType2["OUTGOING_REQUEST_ENDED"] = "OUTGOING_REQUEST_ENDED";
})(RemoteUpdateType || (RemoteUpdateType = {}));
class DyteRemoteRequest extends DyteEventEmitter {
  constructor(request) {
    super();
    __publicField(this, "id");
    __publicField(this, "remotePeerId");
    __publicField(this, "hostPeerId");
    __publicField(this, "state");
    const {
      remotePeerId,
      requestId,
      hostPeerId,
      state
    } = request;
    this.id = requestId;
    this.remotePeerId = remotePeerId;
    this.hostPeerId = hostPeerId;
    this.state = state;
  }
}
var WebinarAcceptRequestType;
(function(WebinarAcceptRequestType2) {
  WebinarAcceptRequestType2["REQUESTED_BY_PARTICIPANT"] = "REQUESTED_BY_PARTICIPANT";
  WebinarAcceptRequestType2["REQUESTED_BY_MODERATOR"] = "REQUESTED_BY_MODERATOR";
})(WebinarAcceptRequestType || (WebinarAcceptRequestType = {}));
var RequestToJoinType;
(function(RequestToJoinType2) {
  RequestToJoinType2["PRESENT"] = "REQUEST_TO_PRESENT";
})(RequestToJoinType || (RequestToJoinType = {}));
var __defProp$j = Object.defineProperty;
var __getOwnPropDesc$j = Object.getOwnPropertyDescriptor;
var __decorateClass$j = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$j(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$j(target, key, result);
  return result;
};
const _RoomNodeClient = (_a2 = class {
  constructor(options) {
    __privateAdd(this, _socketClient, void 0);
    __privateAdd(this, _localMediaHandler, void 0);
    __publicField(this, "isV2AuthToken");
    __privateAdd(this, _sfuHandler, void 0);
    __publicField(this, "maxPreferredStreams");
    __publicField(this, "legacyMode");
    __publicField(this, "roomNodeUrl");
    __publicField(this, "meetingTitle");
    __publicField(this, "roomName");
    __publicField(this, "roomUUID");
    __publicField(this, "peerId");
    __publicField(this, "authToken");
    __publicField(this, "roomJoined");
    __publicField(this, "peerDisplayName");
    __publicField(this, "isDisconnected");
    const {
      roomName,
      roomNodeUrl,
      peerId,
      authToken,
      legacyMode,
      socketClient,
      localMediaHandler,
      meetingTitle
    } = options;
    this.roomName = roomName;
    this.roomNodeUrl = roomNodeUrl;
    this.peerId = peerId;
    this.authToken = authToken;
    this.legacyMode = legacyMode;
    __privateSet(this, _socketClient, socketClient);
    this.roomJoined = false;
    this.meetingTitle = meetingTitle;
    __privateSet(this, _localMediaHandler, localMediaHandler);
    this.isV2AuthToken = constants.isV2AuthToken;
    __privateSet(this, _sfuHandler, new SFUHandler(socketClient));
    callStats.legacySwitch(legacyMode);
  }
  static async init(options, localMediaHandler) {
    const {
      legacyMode = true,
      roomName,
      peerId,
      authToken,
      meetingTitle
    } = options;
    let roomNodeClient;
    const roomNodeUrl = `${options.roomNodeUrl}?roomURL=${roomName}&peerId=${peerId}&authToken=${authToken}&version=0.5.0`;
    const socketClient = new SocketClient({
      callbackHandler: async (message) => {
        await roomNodeClient.handleSocketCallbacks(message);
      }
    });
    socketClient.on(SocketEvents.SOCKET_MESSAGE, async (message, callBack) => {
      await roomNodeClient.handleSockets(message, callBack);
    });
    socketClient.connect(roomNodeUrl);
    roomNodeClient = new _RoomNodeClient({
      legacyMode,
      authToken,
      peerId,
      roomName,
      roomNodeUrl,
      localMediaHandler,
      socketClient,
      meetingTitle
    });
    socketClient.on(SocketEvents.SOCKET_DISCONNECTED, (event) => {
      var _a3;
      roomNodeClient.isDisconnected = true;
      (_a3 = __privateGet(roomNodeClient, _sfuHandler)) == null ? void 0 : _a3.cleanupConsumers();
      SessionStore.emit(SessionEvents.ROOM_NODE_DISCONNECTED, event);
      roomNodeClient.roomJoined = false;
      DyteTelemetry.addEventInCurrentSpan("info", "ROOM_NODE_DISCONNECTED");
    });
    socketClient.on(SocketEvents.SOCKET_CONNECTED, async (event) => {
      SessionStore.emit(SessionEvents.ROOM_NODE_CONNECTED, event);
      if (roomNodeClient.isDisconnected) {
        await roomNodeClient.resetRoomNodeClient();
      }
      roomNodeClient.isDisconnected = false;
      DyteTelemetry.addEventInCurrentSpan("info", "ROOM_NODE_CONNECTED");
    });
    return roomNodeClient;
  }
  reconnect() {
    __privateGet(this, _socketClient).reconnect();
  }
  async setupTransports() {
    await __privateGet(this, _sfuHandler).setupTransports();
  }
  async resetRoomNodeClient() {
    __privateGet(this, _sfuHandler).cleanupConsumers();
    await __privateGet(this, _sfuHandler).setupTransports();
    await this.joinRoom(this.peerDisplayName, !__privateGet(this, _localMediaHandler).audioEnabled, this.roomUUID, this.meetingTitle, {
      audio: __privateGet(this, _localMediaHandler).audioEnabled,
      video: __privateGet(this, _localMediaHandler).videoEnabled,
      screen: __privateGet(this, _localMediaHandler).screenShareEnabled
    });
    if (__privateGet(this, _localMediaHandler).videoEnabled) {
      await this.shareWebcam(__privateGet(this, _localMediaHandler).videoTrack);
    }
    if (__privateGet(this, _localMediaHandler).audioEnabled) {
      await this.shareMic(__privateGet(this, _localMediaHandler).audioTrack);
    }
    if (__privateGet(this, _localMediaHandler).screenShareEnabled) {
      await this.shareScreen({
        video: __privateGet(this, _localMediaHandler).screenShareTracks.video,
        audio: __privateGet(this, _localMediaHandler).screenShareTracks.audio
      });
    }
  }
  async handleSocketCallbacks(message) {
    switch (message.type) {
      case SessionEvents.NEW_CONSUMER:
        return __privateGet(this, _sfuHandler).createConsumer(message.payload);
      default:
        return null;
    }
  }
  async handleSockets(message, callBack) {
    if (!message) {
      return;
    }
    if (!DyteTelemetry.logExclusionList.includes(message.type)) {
      DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::handleSockets", {
        type: message.type,
        payload: message.payload
      });
    }
    switch (message.type) {
      case SessionEvents.CONSUMER_CLOSED:
        __privateGet(this, _sfuHandler).closeConsumer(message.payload);
        break;
      case SessionEvents.CONSUMER_PAUSED:
        __privateGet(this, _sfuHandler).pauseConsumer(message.payload);
        break;
      case SessionEvents.CONSUMER_RESUMED:
        __privateGet(this, _sfuHandler).resumeConsumer(message.payload);
        break;
      case SessionEvents.CONSUMER_SCORE:
        this.handleConsumerScore(message.payload);
        break;
      case SessionEvents.PRODUCER_SCORE:
        this.handleProducerScore(message.payload);
        break;
      case SessionEvents.PRODUCER_CLOSED:
        this.handleProducerClosed(message.payload);
        break;
    }
    if (typeof callBack === "function") {
      callBack();
    }
  }
  async joinRoom(displayName, audioMuted, roomUUID, roomTitle, currentUserSharedMediaStates = {}) {
    var _a3, _b2, _c2;
    this.peerDisplayName = displayName;
    this.roomUUID = roomUUID;
    const response = await __privateGet(this, _socketClient).sendMessage({
      type: "joinRoom",
      payload: {
        device: browserSpecs.getDeviceInfo(),
        displayName,
        rtpCapabilities: __privateGet(this, _sfuHandler).getRTPCapabilities(),
        isLegacy: this.legacyMode,
        audioMuted
      }
    });
    if ((_a3 = response.payload) == null ? void 0 : _a3.waitlisted) {
      SessionStore.emit(SessionEvents.WAITLISTED);
      return { roomJoined: false };
    }
    (_c2 = (_b2 = response.payload) == null ? void 0 : _b2.waitlistedPeers) == null ? void 0 : _c2.forEach((data) => {
      SessionStore.emit(SessionEvents.WAITLIST_PEER_ADDED, data);
    });
    this.legacyMode = response.payload.legacyMode || this.legacyMode;
    if (roomTitle && roomTitle !== "") {
      await this.changeRoomDisplayTitle(roomTitle);
    }
    this.maxPreferredStreams = response.payload.maxPreferredStreams;
    this.roomJoined = true;
    const APIClient2 = getAPIClient();
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::joinRoom::pre_emitasync_room_joined");
    try {
      await SessionStore.emitAsync(SessionEvents.ROOM_JOINED, response.payload);
    } catch (error) {
      DyteTelemetry.addEventInCurrentSpan("error", "RoomNodeClient::joinRoom::emitAsync", { error });
    }
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::joinRoom::post_emitasync_room_joined");
    SessionStore.emit(SessionEvents.SELF_ROOM_JOINED);
    if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.INTERNAL_CALL_STATS) && navigator.product !== "ReactNative") {
      setTimeout(async () => {
        const user = await APIClient2.getUserDetails();
        const peerData = {
          userId: constants.isV2AuthToken ? user.participant.id : user.id,
          peerId: this.peerId,
          displayName,
          roomUUID: this.roomUUID,
          roomViewType: "groupCall",
          roomName: this.roomName,
          deviceInfo: __spreadProps(__spreadValues({}, browserSpecs.getDeviceInfo()), {
            userAgent: navigator.userAgent,
            memory: navigator.deviceMemory,
            cpus: navigator.hardwareConcurrency
          }),
          metaData: {},
          permissions: {}
        };
        callStats.roomJoined(peerData);
        if (currentUserSharedMediaStates == null ? void 0 : currentUserSharedMediaStates.audio) {
          callStats.audioOn();
        } else {
          callStats.audioOff();
        }
        if (currentUserSharedMediaStates == null ? void 0 : currentUserSharedMediaStates.video) {
          callStats.videoOn();
        } else {
          callStats.videoOff();
        }
      });
    }
    return { roomJoined: true };
  }
  async leaveRoom() {
    __privateGet(this, _sfuHandler).stopAllProducers();
    await __privateGet(this, _sfuHandler).stopAllTransports();
    __privateGet(this, _socketClient).disconnect();
    callStats.callEnded();
    clearInterval(DyteTelemetry.logsProcessorTimer);
    DyteTelemetry.processCachedLogs();
  }
  handleProducerClosed({ id }) {
    __privateGet(this, _sfuHandler).producers.forEach((producer, type) => {
      if (producer.id === id) {
        __privateGet(this, _sfuHandler).removeProducer(type);
      }
    });
  }
  getConsumers() {
    return __privateGet(this, _sfuHandler).consumers;
  }
  handleConsumerScore({ id, score }) {
    var _a3, _b2;
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::received_consumer_score", { id, score });
    const consumer = __privateGet(this, _sfuHandler).consumers.get(id);
    if (!consumer)
      return;
    consumer.score = (_b2 = score == null ? void 0 : score.score) != null ? _b2 : (_a3 = consumer.score) != null ? _a3 : 10;
    if (consumer.score < 5) {
      SessionStore.emit(SessionEvents.LOW_CONSUMER_SCORE, {
        id: consumer.id,
        kind: consumer.kind,
        peerId: consumer.peerId,
        score: consumer.score
      });
    }
  }
  handleProducerScore({ id, score }) {
    var _a3;
    DyteTelemetry.addEventInCurrentSpan("info", "RoomNodeClient::received_producer_score", { id, score });
    const producer = [...__privateGet(this, _sfuHandler).producers.values()].find((p) => p.id === id);
    if (!producer) {
      DyteTelemetry.addEventInCurrentSpan("error", "RoomNodeClient::producer_not_found", { id });
      return;
    }
    if (!producer)
      return;
    producer.score = (_a3 = score == null ? void 0 : score.score) != null ? _a3 : 10;
    if (producer.score && producer.score < 5) {
      SessionStore.emit(SessionEvents.LOW_PRODUCER_SCORE, {
        id: producer.id,
        score: producer.score
      });
    }
  }
  async shareWebcam(videoTrack) {
    if (videoTrack === void 0) {
      return;
    }
    if (__privateGet(this, _sfuHandler).producers.has(PRODUCERS_TYPE.WEBCAM)) {
      const webcamProducer = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.WEBCAM);
      if (!webcamProducer.closed) {
        await webcamProducer.replaceTrack({ track: videoTrack });
        await this.resumeWebcam();
        return;
      }
      await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.WEBCAM, false);
    }
    let simulcast = WEBCAM_SIMULCAST_ENCODINGS_VGA;
    const vp9Codec = __privateGet(this, _sfuHandler).getRTPCapabilities().codecs.find((c) => c.mimeType.toLowerCase() === "video/vp9") || void 0;
    const vp8Codec = __privateGet(this, _sfuHandler).getRTPCapabilities().codecs.find((c) => c.mimeType.toLowerCase() === "video/vp8") || void 0;
    if (vp9Codec && !this.legacyMode) {
      simulcast = WEBCAM_KSVC_ENCODINGS;
    }
    const getCodec = () => this.legacyMode ? vp8Codec : vp9Codec;
    const producerOptions = {
      track: videoTrack,
      encodings: simulcast,
      codecOptions: {
        videoGoogleStartBitrate: 1e3
      },
      codec: getCodec(),
      appData: {
        screenShare: false
      },
      stopTracks: false
    };
    const onDisconnect = () => {
      this.disableWebcam();
    };
    await __privateGet(this, _sfuHandler).createProducer(PRODUCERS_TYPE.WEBCAM, producerOptions, onDisconnect);
  }
  async shareScreen(tracks) {
    var _a3, _b2;
    const { video: videoTrack, audio: audioTrack } = tracks;
    if (videoTrack === void 0) {
      return;
    }
    const h264Codec = __privateGet(this, _sfuHandler).device.rtpCapabilities.codecs.find((c) => c.mimeType.toLowerCase() === "video/h264") || void 0;
    const producerOptions = {
      track: videoTrack,
      codecOptions: {
        videoGoogleStartBitrate: 1e3
      },
      appData: {
        screenShare: true,
        supportsRemoteControl: browserSpecs.isElectron()
      },
      stopTracks: false
    };
    if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.H264_SCREENSHARE)) {
      producerOptions.codec = h264Codec;
    }
    let onDisconnect = () => {
      this.disableScreenShare();
    };
    callStats.screenShareRequested();
    await __privateGet(this, _sfuHandler).createProducer(PRODUCERS_TYPE.SCREENSHARE_VIDEO, producerOptions, onDisconnect);
    if (audioTrack) {
      const audioProducerOptions = {
        track: audioTrack,
        codecOptions: {
          opusDtx: false,
          opusStereo: false,
          opusFec: true
        },
        appData: {
          screenShare: true,
          supportsRemoteControl: browserSpecs.isElectron()
        },
        stopTracks: false
      };
      onDisconnect = () => {
      };
      await __privateGet(this, _sfuHandler).createProducer(PRODUCERS_TYPE.SCREENSHARE_AUDIO, audioProducerOptions, onDisconnect);
    }
    callStats.screenShareStart((_b2 = (_a3 = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.SCREENSHARE_VIDEO)) == null ? void 0 : _a3.rtpParameters.encodings[0]) == null ? void 0 : _b2.ssrc);
  }
  async shareMic(audioTrack) {
    if (audioTrack === void 0) {
      return;
    }
    if (__privateGet(this, _sfuHandler).producers.has(PRODUCERS_TYPE.MIC)) {
      const micProducer = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.MIC);
      if (!micProducer.closed) {
        await micProducer.replaceTrack({ track: audioTrack });
        await this.resumeMic();
        return;
      }
      await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.MIC, false);
    }
    const producerOptions = {
      track: audioTrack,
      codecOptions: {
        opusDtx: false,
        opusStereo: false,
        opusFec: true,
        opusMaxAverageBitrate: 16e3
      },
      stopTracks: false
    };
    const onDisconnect = () => {
      this.disableMic();
    };
    await __privateGet(this, _sfuHandler).createProducer(PRODUCERS_TYPE.MIC, producerOptions, onDisconnect);
  }
  pauseMic() {
    const micProducer = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.MIC);
    if (!micProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "pauseMic::could_not_find_mic_producer");
      return;
    }
    micProducer.pause();
    __privateGet(this, _socketClient).sendMessage({
      type: "pauseProducer",
      payload: { producerId: micProducer.id }
    });
  }
  async pauseWebcam() {
    const webcamProducer = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.WEBCAM);
    if (!webcamProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "pauseWebcam::could_not_find_webcam_producer");
      return;
    }
    webcamProducer.pause();
    await __privateGet(this, _socketClient).sendMessage({
      type: "pauseProducer",
      payload: { producerId: webcamProducer.id }
    });
  }
  async resumeMic() {
    const micProducer = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.MIC);
    if (!micProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "resumeMic::could_not_find_mic_producer");
      return;
    }
    micProducer.resume();
    await __privateGet(this, _socketClient).sendMessage({
      type: "resumeProducer",
      payload: { producerId: micProducer.id }
    });
  }
  async resumeWebcam() {
    const webcamProducer = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.WEBCAM);
    if (!webcamProducer) {
      DyteTelemetry.addEventInCurrentSpan("error", "resumeWebcam::could_not_find_webcam_producer");
      return;
    }
    webcamProducer.resume();
    await __privateGet(this, _socketClient).sendMessage({
      type: "resumeProducer",
      payload: { producerId: webcamProducer.id }
    });
  }
  async disableWebcam() {
    await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.WEBCAM);
  }
  async disableMic() {
    await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.MIC);
  }
  async disableScreenShare() {
    var _a3, _b2;
    DyteTelemetry.addEventInCurrentSpan("info", "screen_sharing_stopped");
    callStats.screenShareStop((_b2 = (_a3 = __privateGet(this, _sfuHandler).producers.get(PRODUCERS_TYPE.SCREENSHARE_VIDEO)) == null ? void 0 : _a3.rtpParameters.encodings[0]) == null ? void 0 : _b2.ssrc);
    await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.SCREENSHARE_VIDEO);
    await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.SCREENSHARE_AUDIO);
  }
  async resetVideoProducers(videoTrack, screenShareTrack) {
    if (videoTrack) {
      await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.WEBCAM, false);
      this.shareWebcam(videoTrack);
    }
    if (screenShareTrack) {
      await __privateGet(this, _sfuHandler).removeProducer(PRODUCERS_TYPE.SCREENSHARE_VIDEO, false);
      this.shareScreen({ video: screenShareTrack });
    }
  }
  async getRoomState() {
    return __privateGet(this, _socketClient).sendMessage({ type: "getRoomState" });
  }
  async changeRoomDisplayTitle(displayTitle) {
    await __privateGet(this, _socketClient).sendMessage({
      type: "changeDisplayTitle",
      payload: {
        displayTitle
      }
    });
  }
  async sendMessage(message) {
    return __privateGet(this, _socketClient).sendMessage(message);
  }
  async broadcastMessage(type, messagePayload) {
    const payload = {
      payload: messagePayload,
      type
    };
    return __privateGet(this, _socketClient).sendMessage({ type: "roomMessage", payload });
  }
  async sendChatMessage(message) {
    await __privateGet(this, _socketClient).sendMessage({ type: "chatMessage", payload: message });
  }
  async getChatMessages() {
    return __privateGet(this, _socketClient).sendMessage({ type: "getChatMessages" });
  }
  async pinChatMessage(payload) {
    return __privateGet(this, _socketClient).sendMessage({ type: "pinChatMessage", payload });
  }
  async unpinChatMessage(payload) {
    return __privateGet(this, _socketClient).sendMessage({ type: "unpinChatMessage", payload });
  }
  async getPolls() {
    return __privateGet(this, _socketClient).sendMessage({ type: "getPolls" });
  }
  async newPoll(poll) {
    await __privateGet(this, _socketClient).sendMessage({ type: "newPoll", payload: poll });
  }
  async votePoll(poll) {
    await __privateGet(this, _socketClient).sendMessage({ type: "votePoll", payload: poll });
  }
  async acceptWaitingRequest(peerId) {
    await __privateGet(this, _socketClient).sendMessage({ type: "acceptWaitingRequest", payload: { id: peerId } });
  }
  async rejectWaitingRequest(peerId) {
    await __privateGet(this, _socketClient).sendMessage({ type: "rejectWaitingRequest", payload: { id: peerId } });
  }
  async muteAll(allowUnMute) {
    await __privateGet(this, _socketClient).sendMessage({ type: "muteAllNew", payload: { allowUnMute } });
  }
  async muteAllVideo() {
    await __privateGet(this, _socketClient).sendMessage({ type: "muteAllVideo" });
  }
  async pinPeer(peerId) {
    return __privateGet(this, _socketClient).sendMessage({ type: "pinPeer", payload: { id: peerId } });
  }
  async unpinPeer(peerId) {
    return __privateGet(this, _socketClient).sendMessage({ type: "unpinPeer", payload: { id: peerId } });
  }
  async disableAudio(peerId) {
    await __privateGet(this, _socketClient).sendMessage({ type: "disableAudioPeerNew", payload: { id: peerId } });
  }
  async disableVideo(peerId) {
    await __privateGet(this, _socketClient).sendMessage({ type: "disableVideoPeer", payload: { id: peerId } });
  }
  async kickAll() {
    await __privateGet(this, _socketClient).sendMessage({ type: "kickAll" });
  }
  async kick(peerId) {
    await __privateGet(this, _socketClient).sendMessage({ type: "kick", payload: { id: peerId } });
  }
  async getPage(pageNum) {
    return __privateGet(this, _socketClient).sendMessage({ type: "getPage", payload: { pageNum } });
  }
  async muteSelf() {
    this.pauseMic();
    await __privateGet(this, _socketClient).sendMessage({ type: "muteSelf" });
  }
  async unmuteSelf() {
    await this.resumeMic();
    await __privateGet(this, _socketClient).sendMessage({ type: "unmuteSelf" });
  }
  async addRoomPlugin(plugin) {
    return __privateGet(this, _socketClient).sendMessage({
      type: "addPlugin",
      payload: plugin
    });
  }
  async removeRoomPlugin(plugin) {
    return __privateGet(this, _socketClient).sendMessage({
      type: "removePlugin",
      payload: plugin
    });
  }
  async remoteControlMessage(payload) {
    return __privateGet(this, _socketClient).sendMessage({
      type: "message",
      payload
    });
  }
  async requestRemoteControl(request) {
    return this.remoteControlMessage({
      peerId: request.hostPeerId,
      remoteRequestId: request.id,
      hostPeerId: request.hostPeerId,
      remotePeerId: request.remotePeerId,
      remoteRequestType: RemoteRequestType.REQUEST
    });
  }
  async acceptRemoteControl(request) {
    return this.remoteControlMessage({
      peerId: request.remotePeerId,
      remoteRequestId: request.id,
      hostPeerId: request.hostPeerId,
      remotePeerId: request.remotePeerId,
      remoteRequestType: RemoteRequestType.ACCEPT
    });
  }
  async terminateRemoteControl(peerId, request) {
    return this.remoteControlMessage({
      peerId,
      remoteRequestId: request.id,
      hostPeerId: request.hostPeerId,
      remotePeerId: request.remotePeerId,
      remoteRequestType: RemoteRequestType.END
    });
  }
  async sendEventRemoteControl(peerId, remoteRequestId, remoteEvent) {
    return this.remoteControlMessage({
      peerId,
      remoteRequestId,
      remoteEvent,
      hostPeerId: this.peerId,
      remotePeerId: peerId,
      remoteRequestType: RemoteRequestType.EVENT
    });
  }
  async assertSpotlight(messageType, spotlightAssertMessage) {
    return __privateGet(this, _socketClient).sendMessage({
      type: messageType,
      payload: spotlightAssertMessage
    });
  }
  async assertSpotlightToRoom(spotlightAssertMessage) {
    return this.assertSpotlight("roomMessage", spotlightAssertMessage);
  }
  async assertSpotlightToPeer(spotlightAssertMessage) {
    return this.assertSpotlight("message", spotlightAssertMessage);
  }
  async requestToJoinStage(requestToJoinType) {
    await this.sendMessage({ type: "requestToJoinStage", payload: requestToJoinType });
  }
  async acceptAllRequestToJoinStage(peers) {
    await this.sendMessage({
      type: "acceptAllRequestToJoinStage",
      payload: peers.map((peer) => __spreadProps(__spreadValues({}, peer), {
        type: WebinarAcceptRequestType.REQUESTED_BY_MODERATOR
      }))
    });
  }
  async removePeerFromStage(peerId, type) {
    await this.sendMessage({ type: "removePeerFromStage", payload: { id: peerId, type } });
  }
  async startPresenting() {
    await this.sendMessage({ type: "startPresenting" });
  }
  async stopPresenting() {
    __privateGet(this, _sfuHandler).stopAllProducers();
    await this.sendMessage({ type: "stopPresenting" });
  }
  async rejectRequestToJoinStage(peerId) {
    await this.sendMessage({ type: "rejectRequestToJoinStage", payload: { id: peerId } });
  }
}, _socketClient = new WeakMap(), _localMediaHandler = new WeakMap(), _sfuHandler = new WeakMap(), _a2);
let RoomNodeClient = _RoomNodeClient;
__decorateClass$j([
  DyteTelemetry.trace("RoomNodeClient.reconnect")
], RoomNodeClient.prototype, "reconnect", 1);
__decorateClass$j([
  DyteTelemetry.trace("resetRoomNodeClientOnSocketReconnect")
], RoomNodeClient.prototype, "resetRoomNodeClient", 1);
__decorateClass$j([
  DyteTelemetry.trace("joinRoom.RoomNodeClient")
], RoomNodeClient.prototype, "joinRoom", 1);
__decorateClass$j([
  DyteTelemetry.trace("RoomNodeClient.leaveRoom")
], RoomNodeClient.prototype, "leaveRoom", 1);
__decorateClass$j([
  DyteTelemetry.trace("shareWebcam")
], RoomNodeClient.prototype, "shareWebcam", 1);
__decorateClass$j([
  DyteTelemetry.trace("shareScreen")
], RoomNodeClient.prototype, "shareScreen", 1);
__decorateClass$j([
  DyteTelemetry.trace("shareMic")
], RoomNodeClient.prototype, "shareMic", 1);
__decorateClass$j([
  DyteTelemetry.trace("pauseMic")
], RoomNodeClient.prototype, "pauseMic", 1);
__decorateClass$j([
  DyteTelemetry.trace("pauseWebcam")
], RoomNodeClient.prototype, "pauseWebcam", 1);
__decorateClass$j([
  DyteTelemetry.trace("resumeMic")
], RoomNodeClient.prototype, "resumeMic", 1);
__decorateClass$j([
  DyteTelemetry.trace("resumeWebcam")
], RoomNodeClient.prototype, "resumeWebcam", 1);
__decorateClass$j([
  DyteTelemetry.trace("disableWebcam")
], RoomNodeClient.prototype, "disableWebcam", 1);
__decorateClass$j([
  DyteTelemetry.trace("disableMic")
], RoomNodeClient.prototype, "disableMic", 1);
__decorateClass$j([
  DyteTelemetry.trace("disableScreenShare")
], RoomNodeClient.prototype, "disableScreenShare", 1);
__decorateClass$j([
  DyteTelemetry.trace("resetVideoProducers")
], RoomNodeClient.prototype, "resetVideoProducers", 1);
var WaitingRoomType;
(function(WaitingRoomType2) {
  WaitingRoomType2["skip"] = "SKIP";
  WaitingRoomType2["onPrivilegedUserEntry"] = "ON_PRIVILEGED_USER_ENTRY";
  WaitingRoomType2["skipOnAccept"] = "SKIP_ON_ACCEPT";
})(WaitingRoomType || (WaitingRoomType = {}));
var CanProduceType;
(function(CanProduceType2) {
  CanProduceType2["allowed"] = "ALLOWED";
  CanProduceType2["notAllowed"] = "NOT_ALLOWED";
  CanProduceType2["canRequest"] = "CAN_REQUEST";
})(CanProduceType || (CanProduceType = {}));
const DEFAULT_PERMISSIONS_SNAKE_CASED$1 = {
  name: "Default Permission",
  accept_waiting_requests: false,
  disable_participant_audio: false,
  disable_participant_screensharing: false,
  disable_participant_video: false,
  kick_participant: true,
  pin_participant: true,
  can_record: false,
  waiting_room_type: WaitingRoomType.skip,
  plugins: {
    can_close: true,
    can_start: true
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view_results: true
  },
  media: {
    video: { can_produce: CanProduceType.allowed, can_accept_production_request: false },
    audio: { can_produce: CanProduceType.allowed, can_accept_production_request: false },
    screenshare: { can_produce: CanProduceType.allowed, can_accept_production_request: false }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  connected_meetings: {
    can_alter_connected_meetings: false,
    can_switch_to_parent_meeting: false,
    can_switch_connected_meetings: false
  },
  hidden_participant: false,
  show_participant_list: true,
  can_change_participant_role: true,
  can_spotlight: false
};
const DEFAULT_PERMISSIONS_CAMEL_CASED$1 = objectToCamelCase(DEFAULT_PERMISSIONS_SNAKE_CASED$1);
const _DytePermissionsPreset = class {
  constructor(userPresetResponse) {
    __privateAdd(this, _permissions, void 0);
    if (!userPresetResponse) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePermissionsPreset::load_preset_permissions_failed");
      throw new DyteError("Could not load preset permissions.");
    }
    __privateSet(this, _permissions, userPresetResponse);
    DyteTelemetry.addEventInCurrentSpan("debug", "Preset permissions:", __privateGet(this, _permissions));
  }
  static fromResponse(response) {
    return new _DytePermissionsPreset(response);
  }
  static default() {
    return new _DytePermissionsPreset(DEFAULT_PERMISSIONS_CAMEL_CASED$1);
  }
  get acceptWaitingRequests() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.acceptWaitingRequests) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.acceptWaitingRequests;
  }
  get requestProduceVideo() {
    var _a3, _b2, _c2, _d2;
    return ((_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.video) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.video.canProduce) === CanProduceType.canRequest;
  }
  get requestProduceAudio() {
    var _a3, _b2, _c2, _d2;
    return ((_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.audio) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.audio.canProduce) === CanProduceType.canRequest;
  }
  get requestProduceScreenshare() {
    var _a3, _b2, _c2, _d2;
    return ((_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.screenshare) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.screenshare.canProduce) === CanProduceType.canRequest;
  }
  get canAllowParticipantAudio() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.audio) == null ? void 0 : _c2.canAcceptProductionRequest) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.audio.canAcceptProductionRequest;
  }
  get canAllowParticipantScreensharing() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.screenshare) == null ? void 0 : _c2.canAcceptProductionRequest) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.screenshare.canAcceptProductionRequest;
  }
  get canAllowParticipantVideo() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.video) == null ? void 0 : _c2.canAcceptProductionRequest) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.video.canAcceptProductionRequest;
  }
  get kickParticipant() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.kickParticipant) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.kickParticipant;
  }
  get pinParticipant() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.pinParticipant) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.pinParticipant;
  }
  get canRecord() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.canRecord) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.canRecord;
  }
  get waitingRoomType() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.waitingRoomType) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.waitingRoomType;
  }
  get plugins() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.plugins) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.plugins;
  }
  get polls() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.polls) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.polls;
  }
  get produceVideo() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.video) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.video.canProduce;
  }
  get produceScreenshare() {
    var _a3, _b2, _c2, _d2;
    return (_d2 = (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.media) == null ? void 0 : _b2.screenshare) == null ? void 0 : _c2.canProduce) != null ? _d2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.screenshare.canProduce;
  }
  get produceAudio() {
    var _a3;
    return (_a3 = __privateGet(this, _permissions).media.audio.canProduce) != null ? _a3 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.media.audio.canProduce;
  }
  get chatPublic() {
    var _a3, _b2, _c2;
    return (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.chat) == null ? void 0 : _b2.public) != null ? _c2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.chat.public;
  }
  get chatPrivate() {
    var _a3, _b2, _c2;
    return (_c2 = (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.chat) == null ? void 0 : _b2.private) != null ? _c2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.chat.private;
  }
  get connectedMeetings() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.connectedMeetings) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1 == null ? void 0 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.connectedMeetings;
  }
  get hiddenParticipant() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.hiddenParticipant) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.hiddenParticipant;
  }
  get showParticipantList() {
    var _a3;
    return (_a3 = __privateGet(this, _permissions).showParticipantList) != null ? _a3 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.showParticipantList;
  }
  get canChangeParticipantRole() {
    var _a3, _b2;
    return (_b2 = (_a3 = __privateGet(this, _permissions)) == null ? void 0 : _a3.canChangeParticipantRole) != null ? _b2 : DEFAULT_PERMISSIONS_CAMEL_CASED$1.canChangeParticipantRole;
  }
  get canSpotlight() {
    return __privateGet(this, _permissions).canSpotlight;
  }
};
let DytePermissionsPreset = _DytePermissionsPreset;
_permissions = new WeakMap();
var ViewType;
(function(ViewType2) {
  ViewType2["groupCall"] = "GROUPCALL";
  ViewType2["webinar"] = "WEBINAR";
  ViewType2["audioRoom"] = "AUDIO_ROOM";
})(ViewType || (ViewType = {}));
var MediaThemeQuality;
(function(MediaThemeQuality2) {
  MediaThemeQuality2[MediaThemeQuality2["hd"] = 0] = "hd";
  MediaThemeQuality2[MediaThemeQuality2["vga"] = 1] = "vga";
  MediaThemeQuality2[MediaThemeQuality2["qvga"] = 2] = "qvga";
})(MediaThemeQuality || (MediaThemeQuality = {}));
const DEFAULT_THEME_SNAKE_CASED$1 = {
  waiting_room: { is_enabled: false, enable_preview: true },
  view_type: ViewType.groupCall,
  max_video_streams: { mobile: 4, desktop: 12 },
  max_screen_share_count: 2,
  media: {
    video: {
      quality: 0,
      frame_rate: 123
    },
    screenshare: {
      quality: 0,
      frame_rate: 5
    }
  }
};
const DEFAULT_THEME_CAMEL_CASED$1 = objectToCamelCase(DEFAULT_THEME_SNAKE_CASED$1);
const _DyteThemePreset = class {
  constructor(presetTheme) {
    __privateAdd(this, _theme, void 0);
    if (!presetTheme) {
      throw new DyteError("Could not load preset theme.");
    }
    __privateSet(this, _theme, presetTheme);
    DyteTelemetry.addEventInCurrentSpan("debug", "preset_theme", {
      theme: __privateGet(this, _theme)
    });
  }
  static fromResponse(theme) {
    return new _DyteThemePreset(theme);
  }
  static default() {
    return new _DyteThemePreset(DEFAULT_THEME_CAMEL_CASED$1);
  }
  get waitingRoom() {
    return __privateGet(this, _theme).waitingRoom;
  }
  get viewType() {
    return __privateGet(this, _theme).viewType;
  }
  get maxVideoStreams() {
    return __privateGet(this, _theme).maxVideoStreams;
  }
  get maxScreenShareCount() {
    return __privateGet(this, _theme).maxScreenShareCount;
  }
};
let DyteThemePreset = _DyteThemePreset;
_theme = new WeakMap();
var __defProp$i = Object.defineProperty;
var __getOwnPropDesc$i = Object.getOwnPropertyDescriptor;
var __decorateClass$i = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$i(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$i(target, key, result);
  return result;
};
var WebinarStageStatus;
(function(WebinarStageStatus2) {
  WebinarStageStatus2["OFF_STAGE"] = "OFF_STAGE";
  WebinarStageStatus2["REQUESTED_TO_JOIN_STAGE"] = "REQUESTED_TO_JOIN_STAGE";
  WebinarStageStatus2["ACCEPTED_TO_JOIN_STAGE"] = "ACCEPTED_TO_JOIN_STAGE";
  WebinarStageStatus2["ON_STAGE"] = "ON_STAGE";
})(WebinarStageStatus || (WebinarStageStatus = {}));
const _DyteSelf = (_b = class extends DyteEventEmitter {
  constructor(roomNodeClient, localMediaHandler, details, permissions, theme) {
    super();
    __publicField(this, "id");
    __publicField(this, "name");
    __publicField(this, "picture");
    __publicField(this, "clientSpecificId");
    __publicField(this, "waitlistStatus");
    __privateAdd(this, _roomNodeClient, void 0);
    __privateAdd(this, _localMediaHandler2, void 0);
    __privateAdd(this, _meetingViewType, void 0);
    __privateAdd(this, _theme2, void 0);
    __privateAdd(this, _permissions2, void 0);
    __privateAdd(this, _isPinned, void 0);
    __publicField(this, "role");
    __publicField(this, "userId");
    __publicField(this, "organizationId");
    __publicField(this, "supportsRemoteControl", false);
    __publicField(this, "device");
    __publicField(this, "webinarStageStatus", WebinarStageStatus.OFF_STAGE);
    __privateSet(this, _roomNodeClient, roomNodeClient);
    __privateSet(this, _localMediaHandler2, localMediaHandler);
    this.id = roomNodeClient.peerId;
    this.userId = details.id;
    this.name = details.name;
    this.picture = details.picture;
    this.clientSpecificId = details.clientSpecificId;
    this.waitlistStatus = "none";
    __privateSet(this, _permissions2, permissions);
    __privateSet(this, _theme2, theme);
    __privateSet(this, _isPinned, false);
    this.organizationId = details.organizationId;
    this.supportsRemoteControl = browserSpecs.isElectron();
    this.device = browserSpecs.getDeviceInfo();
    __privateSet(this, _meetingViewType, constants.isV2AuthToken ? ViewType.groupCall : permissions.viewType);
    this.setupEvents();
  }
  static async init(roomNodeClient, details, permissions, theme, defaults, localMediaHandler) {
    var _a3, _b2;
    await localMediaHandler.setupStreams({
      video: (_a3 = defaults.video) != null ? _a3 : true,
      audio: (_b2 = defaults.audio) != null ? _b2 : true
    });
    return new _DyteSelf(roomNodeClient, localMediaHandler, details, permissions, theme);
  }
  setupEvents() {
    __privateGet(this, _localMediaHandler2).on("AUDIO_TRACK_CHANGE", async () => {
      var _a3;
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::AUDIO_TRACK_CHANGE", {
        audioEnabled: this.audioEnabled,
        trackId: (_a3 = this.audioTrack) == null ? void 0 : _a3.id
      });
      if (__privateGet(this, _roomNodeClient).roomJoined) {
        await __privateGet(this, _roomNodeClient).shareMic(this.audioTrack);
      }
      this.emit("audioUpdate", {
        audioEnabled: this.audioEnabled,
        audioTrack: this.audioTrack
      });
    });
    __privateGet(this, _localMediaHandler2).on("VIDEO_TRACK_CHANGE", async () => {
      var _a3;
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::VIDEO_TRACK_CHANGE", {
        videoEnabled: this.videoEnabled,
        trackId: (_a3 = this.videoTrack) == null ? void 0 : _a3.id
      });
      if (this.videoEnabled && __privateGet(this, _roomNodeClient).roomJoined) {
        await __privateGet(this, _roomNodeClient).shareWebcam(this.videoTrack);
      }
      this.emit("videoUpdate", {
        videoEnabled: this.videoEnabled,
        videoTrack: this.videoTrack
      });
    });
    __privateGet(this, _localMediaHandler2).on("SCREENSHARE_TRACK_CHANGE", async () => {
      if (!__privateGet(this, _roomNodeClient).roomJoined)
        return;
      if (this.screenShareEnabled) {
        await __privateGet(this, _roomNodeClient).shareScreen(this.screenShareTracks);
      }
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::SCREENSHARE_TRACK_CHANGE", {
        screenShareEnabled: this.screenShareEnabled
      });
      this.emit("screenShareUpdate", {
        screenShareEnabled: this.screenShareEnabled,
        screenShareTracks: this.screenShareTracks
      });
    });
    __privateGet(this, _localMediaHandler2).on("SCREENSHARE_ENDED", async () => {
      await this.disableScreenShare();
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSelf::setupEvents::SCREENSHARE_ENDED", {
        screenShareEnabled: this.screenShareEnabled
      });
    });
    __privateGet(this, _localMediaHandler2).on("AUDIO_TRACK_SILENT", () => {
      this.emit("audioTrackSilent");
    });
  }
  get audioTrack() {
    return __privateGet(this, _localMediaHandler2).audioTrack;
  }
  get rawAudioTrack() {
    return __privateGet(this, _localMediaHandler2).rawAudioTrack;
  }
  async addAudioMiddleware(audioMiddleware) {
    return __privateGet(this, _localMediaHandler2).mediaMiddlewareUtils.addAudioMiddleware(audioMiddleware);
  }
  async removeAudioMiddleware(audioMiddleware) {
    return __privateGet(this, _localMediaHandler2).mediaMiddlewareUtils.removeAudioMiddleware(audioMiddleware);
  }
  get videoTrack() {
    return __privateGet(this, _localMediaHandler2).videoTrack;
  }
  get rawVideoTrack() {
    return __privateGet(this, _localMediaHandler2).rawVideoTrack;
  }
  async addVideoMiddleware(videoMiddleware) {
    return __privateGet(this, _localMediaHandler2).mediaMiddlewareUtils.addVideoMiddleware(videoMiddleware);
  }
  async removeVideoMiddleware(videoMiddleware) {
    return __privateGet(this, _localMediaHandler2).mediaMiddlewareUtils.removeVideoMiddleware(videoMiddleware);
  }
  get screenShareTracks() {
    return __privateGet(this, _localMediaHandler2).screenShareTracks;
  }
  get audioEnabled() {
    return __privateGet(this, _localMediaHandler2).audioEnabled;
  }
  get videoEnabled() {
    return __privateGet(this, _localMediaHandler2).videoEnabled;
  }
  get screenShareEnabled() {
    return __privateGet(this, _localMediaHandler2).screenShareEnabled;
  }
  get mediaPermissions() {
    return __privateGet(this, _localMediaHandler2).permissions;
  }
  get permissions() {
    return __privateGet(this, _permissions2);
  }
  get suggestedTheme() {
    return __privateGet(this, _theme2);
  }
  get roomJoined() {
    return __privateGet(this, _roomNodeClient).roomJoined;
  }
  setName(name) {
    if (!name) {
      throw new DyteError("Name cannot be empty.");
    }
    this.name = name;
  }
  setupTracks(options = {}) {
    var _a3, _b2;
    return __privateGet(this, _localMediaHandler2).setupStreams({
      video: (_a3 = options.video) != null ? _a3 : true,
      audio: (_b2 = options.audio) != null ? _b2 : true
    });
  }
  async enableAudio() {
    if (!this.permissions.produceAudio) {
      return;
    }
    if (this.audioEnabled) {
      return;
    }
    const wasAudioTrackDefined = !!this.audioTrack;
    if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.REMOVE_TOGGLE_AUDIO)) {
      await __privateGet(this, _localMediaHandler2).enableAudio();
    } else {
      await __privateGet(this, _localMediaHandler2).toggleAudio();
    }
    if (this.roomJoined) {
      if (!wasAudioTrackDefined && !!this.audioTrack) {
        await __privateGet(this, _roomNodeClient).shareMic(this.audioTrack);
      }
      if (!this.audioEnabled) {
        return;
      }
      __privateGet(this, _roomNodeClient).unmuteSelf();
    }
    this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
    callStats.audioOn();
  }
  async enableVideo() {
    if (constants.isV2AuthToken ? __privateGet(this, _permissions2).produceVideo !== CanProduceType.allowed : !__privateGet(this, _permissions2).produceVideo.allow) {
      return;
    }
    if (this.videoEnabled) {
      return;
    }
    await __privateGet(this, _localMediaHandler2).toggleVideo();
    if (this.roomJoined) {
      await __privateGet(this, _roomNodeClient).shareWebcam(this.videoTrack);
    }
    this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
    callStats.videoOn();
  }
  async enableScreenShare() {
    if (!__privateGet(this, _roomNodeClient).roomJoined) {
      return;
    }
    if (constants.isV2AuthToken ? __privateGet(this, _permissions2).produceScreenshare : !__privateGet(this, _permissions2).produceScreenshare.allow) {
      return;
    }
    if (this.screenShareEnabled) {
      return;
    }
    await __privateGet(this, _localMediaHandler2).toggleScreenShare();
    if (this.screenShareTracks.audio || this.screenShareTracks.video) {
      await __privateGet(this, _roomNodeClient).shareScreen(this.screenShareTracks);
    }
    this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    });
  }
  async disableAudio() {
    if (!this.audioEnabled) {
      return;
    }
    if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.REMOVE_TOGGLE_AUDIO)) {
      __privateGet(this, _localMediaHandler2).disableAudio();
    } else {
      await __privateGet(this, _localMediaHandler2).toggleAudio();
    }
    if (this.roomJoined) {
      __privateGet(this, _roomNodeClient).muteSelf();
    }
    this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
    callStats.audioOff();
    callStats.mediaTrackMuted("AUDIO");
  }
  async disableVideo() {
    if (!this.videoEnabled) {
      return;
    }
    await __privateGet(this, _localMediaHandler2).toggleVideo();
    if (this.roomJoined) {
      await __privateGet(this, _roomNodeClient).pauseWebcam();
    }
    this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
    callStats.videoOff();
    callStats.mediaTrackMuted("VIDEO");
  }
  async disableScreenShare() {
    if (!__privateGet(this, _roomNodeClient).roomJoined) {
      return;
    }
    if (!this.screenShareEnabled) {
      return;
    }
    await __privateGet(this, _localMediaHandler2).toggleScreenShare();
    await __privateGet(this, _roomNodeClient).disableScreenShare();
    this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    });
  }
  getCurrentDevices() {
    return __privateGet(this, _localMediaHandler2).currentDevices;
  }
  getAudioDevices() {
    return __privateGet(this, _localMediaHandler2).getAudioDevices();
  }
  getVideoDevices() {
    return __privateGet(this, _localMediaHandler2).getVideoDevices();
  }
  getSpeakerDevices() {
    return __privateGet(this, _localMediaHandler2).getSpeakerDevices();
  }
  getDeviceById(deviceId, kind) {
    let k;
    if (kind === "audio") {
      k = "audioinput";
    } else if (kind === "video") {
      k = "videoinput";
    } else if (kind === "speaker") {
      k = "audiooutput";
    }
    return __privateGet(this, _localMediaHandler2).getDeviceById(deviceId, k);
  }
  getAllDevices() {
    return __privateGet(this, _localMediaHandler2).getAllDevices();
  }
  setIsPinned(isPinned, emitEvent = true) {
    __privateSet(this, _isPinned, isPinned);
    const event = isPinned ? "pinned" : "unpinned";
    if (emitEvent)
      this.emit(event, this);
  }
  get isPinned() {
    return __privateGet(this, _isPinned);
  }
  async pin() {
    return __privateGet(this, _roomNodeClient).pinPeer(this.id);
  }
  async unpin() {
    return __privateGet(this, _roomNodeClient).pinPeer(null);
  }
  async setDevice(device) {
    const changedDevices = {
      added: [device],
      removed: []
    };
    await __privateGet(this, _localMediaHandler2).onDeviceChange(changedDevices);
    this.emit("deviceUpdate", {
      device
    });
  }
  cleanUpTracks() {
    var _a3, _b2, _c2, _d2;
    (_a3 = this.audioTrack) == null ? void 0 : _a3.stop();
    (_b2 = this.rawAudioTrack) == null ? void 0 : _b2.stop();
    (_c2 = this.videoTrack) == null ? void 0 : _c2.stop();
    (_d2 = this.rawVideoTrack) == null ? void 0 : _d2.stop();
  }
  async requestToJoinStage() {
    if (!(__privateGet(this, _meetingViewType) === ViewType.webinar))
      throw new DyteError("Not allowed to go on stage on non webinar meeting");
    if (constants.isV2AuthToken)
      throw new DyteError("V2 Meetings not supported for webinars");
    if (!this.permissions.requestProduce) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteSelf::requestGoToStage::permission_denied");
      throw new DyteError("User does not have permission to go on stage");
    }
    this.webinarStageStatus = WebinarStageStatus.REQUESTED_TO_JOIN_STAGE;
    await __privateGet(this, _roomNodeClient).requestToJoinStage(RequestToJoinType.PRESENT);
  }
  async leaveStage() {
    if (!(__privateGet(this, _meetingViewType) === ViewType.webinar))
      throw new DyteError("Not allowed to leave stage on non webinar meeting");
    if (constants.isV2AuthToken)
      throw new DyteError("V2 Meetings not supported for webinars");
    await this.disableScreenShare();
    await this.disableVideo();
    await this.disableAudio();
    __privateGet(this, _localMediaHandler2).mediaMiddlewareUtils.terminateMiddlewareWebWorker();
    await __privateGet(this, _roomNodeClient).stopPresenting();
  }
  async joinStage() {
    if (constants.isV2AuthToken)
      throw new DyteError("V2 Meetings not supported for webinars");
    if (!this.permissions.canPresent && this.webinarStageStatus !== WebinarStageStatus.ACCEPTED_TO_JOIN_STAGE) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteSelf::joinStage::permission_denied");
      throw new DyteError("User does not have permission to join stage");
    }
    await __privateGet(this, _roomNodeClient).startPresenting();
  }
  setWebinarStageStatus(webinarStageStatus) {
    this.webinarStageStatus = webinarStageStatus;
  }
  async disablePreview() {
    return this;
  }
}, _roomNodeClient = new WeakMap(), _localMediaHandler2 = new WeakMap(), _meetingViewType = new WeakMap(), _theme2 = new WeakMap(), _permissions2 = new WeakMap(), _isPinned = new WeakMap(), _b);
let DyteSelf = _DyteSelf;
__decorateClass$i([
  DyteTelemetry.trace("DyteSelf.setupEvents")
], DyteSelf.prototype, "setupEvents", 1);
__decorateClass$i([
  DyteTelemetry.trace("setupTracks")
], DyteSelf.prototype, "setupTracks", 1);
__decorateClass$i([
  DyteTelemetry.trace("enableAudio")
], DyteSelf.prototype, "enableAudio", 1);
__decorateClass$i([
  DyteTelemetry.trace("enableVideo")
], DyteSelf.prototype, "enableVideo", 1);
__decorateClass$i([
  DyteTelemetry.trace("enableScreenShare")
], DyteSelf.prototype, "enableScreenShare", 1);
__decorateClass$i([
  DyteTelemetry.trace("disableAudio")
], DyteSelf.prototype, "disableAudio", 1);
__decorateClass$i([
  DyteTelemetry.trace("disableVideo")
], DyteSelf.prototype, "disableVideo", 1);
__decorateClass$i([
  DyteTelemetry.trace("disableScreenShare")
], DyteSelf.prototype, "disableScreenShare", 1);
__decorateClass$i([
  DyteTelemetry.trace("setDevice")
], DyteSelf.prototype, "setDevice", 1);
__decorateClass$i([
  DyteTelemetry.trace("requestToJoinStage")
], DyteSelf.prototype, "requestToJoinStage", 1);
__decorateClass$i([
  DyteTelemetry.trace("leaveStage")
], DyteSelf.prototype, "leaveStage", 1);
__decorateClass$i([
  DyteTelemetry.trace("joinStage")
], DyteSelf.prototype, "joinStage", 1);
__decorateClass$i([
  DyteTelemetry.trace("DyteSelf.deprecated.disablePreview")
], DyteSelf.prototype, "disablePreview", 1);
const DEFAULT_THEME_SNAKE_CASED = {
  setup_screen: { is_enabled: false },
  alone_here: { is_enabled: false },
  waiting_room: { is_enabled: false, enable_preview: true },
  control_bar: {
    is_enabled: true,
    elements: {
      plugins: true,
      screenshare: true,
      invite: false,
      participants: true,
      chat: true,
      reactions: false,
      polls: true,
      fullscreen: true,
      layout: true
    }
  },
  header: {
    is_enabled: true,
    elements: {
      logo: "https://app.dyte.in/dyte_logo.svg",
      timer: true,
      title: true,
      participant_count: true,
      change_layout: true
    }
  },
  pip_mode: true,
  auto_tune: true,
  grid: {
    multi: { max_video_count: 9, video_fit: "cover" },
    single: { max_video_count: 6, video_fit: "cover" },
    default_view: "MULTI"
  },
  colors: {
    primary: "#2160FD",
    secondary: "#1A1A1A",
    text: "#EEEEEE",
    background: "#1A1A1A",
    text_primary: "#EEEEEE",
    video_background: "#1A1A1A"
  },
  controls: { pip_toggle: false },
  plugins: []
};
const DEFAULT_THEME_CAMEL_CASED = objectToCamelCase(DEFAULT_THEME_SNAKE_CASED);
const _DyteThemePresetV1 = class {
  constructor(presetThemeV1) {
    __privateAdd(this, _theme3, void 0);
    if (!presetThemeV1) {
      throw new DyteError("Could not load preset theme.");
    }
    __privateSet(this, _theme3, presetThemeV1);
    DyteTelemetry.addEventInCurrentSpan("debug", "preset_theme", {
      theme: __privateGet(this, _theme3)
    });
  }
  static fromResponse(theme) {
    return new _DyteThemePresetV1(theme);
  }
  static default() {
    return new _DyteThemePresetV1(DEFAULT_THEME_CAMEL_CASED);
  }
  get setupScreen() {
    return __privateGet(this, _theme3).setupScreen;
  }
  get aloneHere() {
    return __privateGet(this, _theme3).aloneHere;
  }
  get waitingRoom() {
    return __privateGet(this, _theme3).waitingRoom;
  }
  get controlBar() {
    return __privateGet(this, _theme3).controlBar;
  }
  get header() {
    return __privateGet(this, _theme3).header;
  }
  get pipMode() {
    return __privateGet(this, _theme3).pipMode;
  }
  get autoTune() {
    return __privateGet(this, _theme3).autoTune;
  }
  get grid() {
    return __privateGet(this, _theme3).grid;
  }
  get colors() {
    return __privateGet(this, _theme3).colors;
  }
  get controls() {
    return __privateGet(this, _theme3).controls;
  }
  get plugins() {
    return __privateGet(this, _theme3).plugins;
  }
};
let DyteThemePresetV1 = _DyteThemePresetV1;
_theme3 = new WeakMap();
const DEFAULT_PERMISSIONS_SNAKE_CASED = {
  view_type: ViewType.groupCall,
  accept_waiting_requests: false,
  request_produce: false,
  can_allow_participant_audio: true,
  can_allow_participant_screensharing: false,
  can_allow_participant_video: true,
  request_kick_participant: false,
  kick_participant: true,
  pin_participant: true,
  can_record: false,
  waiting_room_type: "SKIP",
  plugins: {
    can_close: true,
    can_start: true,
    can_edit_acl: false,
    config: {}
  },
  polls: {
    can_create: true,
    can_vote: true,
    can_view: true
  },
  produce: {
    video: { allow: true, quality: "vga", frame_rate: 24 },
    audio: true,
    screenshare: { allow: true, quality: "hd", frame_rate: 5 }
  },
  chat: {
    public: {
      can_send: true,
      text: true,
      files: true
    },
    private: {
      can_send: false,
      can_receive: false,
      text: false,
      files: false
    }
  },
  reactions: false,
  hidden_participant: false,
  show_participant_list: true,
  can_change_participant_role: true,
  can_change_theme: false,
  can_present: false,
  accept_present_requests: false,
  can_edit_display_name: false,
  max_screenshare_count: 1,
  is_recorder: false,
  can_spotlight: false
};
const DEFAULT_PERMISSIONS_CAMEL_CASED = objectToCamelCase(DEFAULT_PERMISSIONS_SNAKE_CASED);
const _DytePermissionsPresetV1 = class {
  constructor(userPresetResponse) {
    __privateAdd(this, _permissions3, void 0);
    if (!userPresetResponse) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePermissionsPresetV1::load_preset_permissions_failed");
      throw new DyteError("Could not load preset permissions.");
    }
    __privateSet(this, _permissions3, userPresetResponse);
  }
  static fromResponse(response) {
    return new _DytePermissionsPresetV1(response);
  }
  static default() {
    return new _DytePermissionsPresetV1(DEFAULT_PERMISSIONS_CAMEL_CASED);
  }
  get viewType() {
    return __privateGet(this, _permissions3).viewType;
  }
  get acceptWaitingRequests() {
    return __privateGet(this, _permissions3).acceptWaitingRequests;
  }
  get requestProduce() {
    return __privateGet(this, _permissions3).requestProduce;
  }
  get canAllowParticipantAudio() {
    return __privateGet(this, _permissions3).canAllowParticipantAudio;
  }
  get canAllowParticipantScreensharing() {
    return __privateGet(this, _permissions3).canAllowParticipantScreensharing;
  }
  get canAllowParticipantVideo() {
    return __privateGet(this, _permissions3).canAllowParticipantVideo;
  }
  get requestKickParticipant() {
    return __privateGet(this, _permissions3).requestKickParticipant;
  }
  get kickParticipant() {
    return __privateGet(this, _permissions3).kickParticipant;
  }
  get pinParticipant() {
    return __privateGet(this, _permissions3).pinParticipant;
  }
  get canRecord() {
    return __privateGet(this, _permissions3).canRecord;
  }
  get waitingRoomType() {
    return __privateGet(this, _permissions3).waitingRoomType;
  }
  get plugins() {
    return __privateGet(this, _permissions3).plugins;
  }
  get polls() {
    return __privateGet(this, _permissions3).polls;
  }
  get produceVideo() {
    return __spreadProps(__spreadValues({}, __privateGet(this, _permissions3).produce.video), {
      allow: __privateGet(this, _permissions3).produce.video.allow ? CanProduceType.allowed : CanProduceType.notAllowed
    });
  }
  get produceScreenshare() {
    return __spreadProps(__spreadValues({}, __privateGet(this, _permissions3).produce.screenshare), {
      allow: __privateGet(this, _permissions3).produce.screenshare.allow ? CanProduceType.allowed : CanProduceType.notAllowed
    });
  }
  get produceAudio() {
    return __privateGet(this, _permissions3).produce.audio ? CanProduceType.allowed : CanProduceType.notAllowed;
  }
  get chatPublic() {
    return __privateGet(this, _permissions3).chat.public;
  }
  get chatPrivate() {
    return __privateGet(this, _permissions3).chat.private;
  }
  get reactions() {
    return __privateGet(this, _permissions3).reactions;
  }
  get hiddenParticipant() {
    return __privateGet(this, _permissions3).hiddenParticipant;
  }
  get showParticipantList() {
    return __privateGet(this, _permissions3).showParticipantList;
  }
  get canChangeParticipantRole() {
    return __privateGet(this, _permissions3).canChangeParticipantRole;
  }
  get canChangeTheme() {
    return __privateGet(this, _permissions3).canChangeTheme;
  }
  get canPresent() {
    return __privateGet(this, _permissions3).canPresent;
  }
  get acceptPresentRequests() {
    return __privateGet(this, _permissions3).acceptPresentRequests;
  }
  get canEditDisplayName() {
    return __privateGet(this, _permissions3).canEditDisplayName;
  }
  get maxScreenShareCount() {
    return __privateGet(this, _permissions3).maxScreenshareCount;
  }
  get isRecorder() {
    return __privateGet(this, _permissions3).isRecorder;
  }
  get canSpotlight() {
    return __privateGet(this, _permissions3).canSpotlight;
  }
};
let DytePermissionsPresetV1 = _DytePermissionsPresetV1;
_permissions3 = new WeakMap();
var Target;
(function(Target2) {
  Target2[Target2["PUBLISHER"] = 0] = "PUBLISHER";
  Target2[Target2["SUBSCRIBER"] = 1] = "SUBSCRIBER";
})(Target || (Target = {}));
class Pair$Type extends MessageType$2 {
  constructor() {
    super("media.Pair", [
      { no: 1, name: "key", kind: "scalar", T: 9 },
      { no: 2, name: "value", kind: "scalar", T: 9 }
    ]);
  }
}
new Pair$Type();
class Codec$Type extends MessageType$2 {
  constructor() {
    super("media.Codec", []);
  }
}
new Codec$Type();
class Fingerprint$Type extends MessageType$2 {
  constructor() {
    super("media.Fingerprint", [
      { no: 1, name: "algorithm", kind: "scalar", T: 9 },
      { no: 2, name: "value", kind: "scalar", T: 9 }
    ]);
  }
}
new Fingerprint$Type();
class SessionDescription$Type extends MessageType$2 {
  constructor() {
    super("media.SessionDescription", [
      { no: 1, name: "target", kind: "enum", T: () => ["media.Target", Target] },
      { no: 2, name: "type", kind: "scalar", T: 9 },
      { no: 3, name: "sdp", kind: "scalar", T: 9 }
    ]);
  }
}
const SessionDescription = new SessionDescription$Type();
class CreateTransportRequest$Type extends MessageType$2 {
  constructor() {
    super("media.CreateTransportRequest", [
      { no: 1, name: "consuming", kind: "scalar", T: 8 },
      { no: 2, name: "force_tcp", kind: "scalar", opt: true, T: 8 },
      { no: 3, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new CreateTransportRequest$Type();
class CreateTransportResponse$Type extends MessageType$2 {
  constructor() {
    super("media.CreateTransportResponse", [
      { no: 1, name: "transport_id", kind: "scalar", T: 9 },
      { no: 2, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
const CreateTransportResponse = new CreateTransportResponse$Type();
class RenegotiateRequest$Type extends MessageType$2 {
  constructor() {
    super("media.RenegotiateRequest", [
      { no: 1, name: "transport_id", kind: "scalar", T: 9 },
      { no: 2, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new RenegotiateRequest$Type();
class RenegotiateResponse$Type extends MessageType$2 {
  constructor() {
    super("media.RenegotiateResponse", [
      { no: 1, name: "transport_id", kind: "scalar", T: 9 },
      { no: 2, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new RenegotiateResponse$Type();
class NestedScore$Type extends MessageType$2 {
  constructor() {
    super("media.NestedScore", [
      { no: 1, name: "encoding_idx", kind: "scalar", T: 5 },
      { no: 2, name: "rid", kind: "scalar", T: 9 },
      { no: 3, name: "score", kind: "scalar", T: 5 },
      { no: 4, name: "ssrc", kind: "scalar", T: 3, L: 0 }
    ]);
  }
}
const NestedScore = new NestedScore$Type();
var ProducerKind;
(function(ProducerKind2) {
  ProducerKind2[ProducerKind2["AUDIO"] = 0] = "AUDIO";
  ProducerKind2[ProducerKind2["VIDEO"] = 1] = "VIDEO";
})(ProducerKind || (ProducerKind = {}));
class PeerPreJoinRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerPreJoinRequest", []);
  }
}
new PeerPreJoinRequest$Type();
class PeerJoinRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerJoinRequest", [
      { no: 1, name: "display_name", kind: "scalar", opt: true, T: 9 },
      { no: 2, name: "prejoined", kind: "scalar", T: 8 }
    ]);
  }
}
new PeerJoinRequest$Type();
class PeerLeaveRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerLeaveRequest", [
      { no: 1, name: "close_room", kind: "scalar", T: 8 }
    ]);
  }
}
new PeerLeaveRequest$Type();
class ConsumeMultiplePeerRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumeMultiplePeerRequest", [
      { no: 1, name: "producing_peer_ids", kind: "scalar", repeat: 2, T: 9 },
      { no: 2, name: "description", kind: "message", T: () => SessionDescription },
      { no: 3, name: "paused", kind: "scalar", opt: true, T: 8 }
    ]);
  }
}
new ConsumeMultiplePeerRequest$Type();
class ConsumePeerRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumePeerRequest", [
      { no: 1, name: "producing_peer_id", kind: "scalar", T: 9 },
      { no: 2, name: "description", kind: "message", T: () => SessionDescription },
      { no: 3, name: "paused", kind: "scalar", opt: true, T: 8 },
      { no: 4, name: "producer_id", kind: "scalar", opt: true, T: 9 }
    ]);
  }
}
new ConsumePeerRequest$Type();
class ProducerCreateRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerCreateRequest", [
      { no: 1, name: "kind", kind: "scalar", T: 9 },
      { no: 2, name: "paused", kind: "scalar", T: 8 },
      { no: 3, name: "screen_share", kind: "scalar", T: 8 },
      { no: 4, name: "description", kind: "message", T: () => SessionDescription },
      { no: 5, name: "msid", kind: "scalar", T: 9 }
    ]);
  }
}
new ProducerCreateRequest$Type();
class SelectedPeersRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.SelectedPeersRequest", []);
  }
}
new SelectedPeersRequest$Type();
class GlobalPeerPinningRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.GlobalPeerPinningRequest", [
      { no: 1, name: "participant_id", kind: "scalar", T: 9 }
    ]);
  }
}
new GlobalPeerPinningRequest$Type();
class ProducerToggleRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerToggleRequest", [
      { no: 1, name: "producer_id", kind: "scalar", T: 9 },
      { no: 2, name: "pause", kind: "scalar", T: 8 }
    ]);
  }
}
new ProducerToggleRequest$Type();
class ConsumerToggleRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumerToggleRequest", [
      { no: 1, name: "consumer_id", kind: "scalar", T: 9 },
      { no: 2, name: "pause", kind: "scalar", T: 8 }
    ]);
  }
}
new ConsumerToggleRequest$Type();
class ProducerCloseRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerCloseRequest", [
      { no: 1, name: "producer_id", kind: "scalar", T: 9 },
      { no: 2, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new ProducerCloseRequest$Type();
class ConsumerCloseRequest$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumerCloseRequest", [
      { no: 1, name: "consumer_id", kind: "scalar", T: 9 },
      { no: 2, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new ConsumerCloseRequest$Type();
class GetRoomStateResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.GetRoomStateResponse", [
      { no: 1, name: "display_title", kind: "scalar", T: 9 },
      { no: 2, name: "locked_mode", kind: "scalar", T: 8 },
      { no: 3, name: "room_uuid", kind: "scalar", T: 9 },
      { no: 4, name: "room_name", kind: "scalar", T: 9 },
      { no: 5, name: "current_peer_id", kind: "scalar", T: 9 }
    ]);
  }
}
const GetRoomStateResponse = new GetRoomStateResponse$Type();
class ProducerState$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerState", [
      { no: 1, name: "producer_id", kind: "scalar", T: 9 },
      { no: 2, name: "kind", kind: "enum", T: () => ["media.edge.ProducerKind", ProducerKind] },
      { no: 3, name: "pause", kind: "scalar", T: 8 },
      { no: 4, name: "screen_share", kind: "scalar", T: 8 }
    ]);
  }
}
const ProducerState = new ProducerState$Type();
class RoomParticipants$Type extends MessageType$2 {
  constructor() {
    super("media.edge.RoomParticipants", [
      { no: 1, name: "peer_id", kind: "scalar", T: 9 },
      { no: 2, name: "producer_states", kind: "message", repeat: 1, T: () => ProducerState },
      { no: 3, name: "display_name", kind: "scalar", T: 9 }
    ]);
  }
}
const RoomParticipants = new RoomParticipants$Type();
class PeerPreJoinResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerPreJoinResponse", []);
  }
}
new PeerPreJoinResponse$Type();
class PeerJoinResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerJoinResponse", [
      { no: 2, name: "max_preferred_streams", kind: "scalar", T: 5 },
      { no: 4, name: "room_state", kind: "message", T: () => GetRoomStateResponse },
      { no: 5, name: "participants", kind: "message", repeat: 1, T: () => RoomParticipants }
    ]);
  }
}
new PeerJoinResponse$Type();
class PeerLeaveResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerLeaveResponse", [
      { no: 1, name: "closed", kind: "scalar", T: 8 }
    ]);
  }
}
new PeerLeaveResponse$Type();
class ConsumerState$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumerState", [
      { no: 1, name: "consumer_id", kind: "scalar", T: 9 },
      { no: 2, name: "producer_state", kind: "message", T: () => ProducerState }
    ]);
  }
}
const ConsumerState = new ConsumerState$Type();
class ProducerIdToConsumerMap$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerIdToConsumerMap", [
      { no: 1, name: "map", kind: "map", K: 9, V: { kind: "message", T: () => ConsumerState } }
    ]);
  }
}
const ProducerIdToConsumerMap = new ProducerIdToConsumerMap$Type();
class ConsumeMultiplePeerResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumeMultiplePeerResponse", [
      { no: 1, name: "status", kind: "scalar", T: 8 },
      { no: 2, name: "peer_to_consumer_ids_map", kind: "map", K: 9, V: { kind: "message", T: () => ProducerIdToConsumerMap } },
      { no: 3, name: "transport_details", kind: "message", T: () => CreateTransportResponse },
      { no: 4, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new ConsumeMultiplePeerResponse$Type();
class ConsumePeerResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumePeerResponse", [
      { no: 1, name: "status", kind: "scalar", T: 8 },
      { no: 2, name: "consumer_ids_map", kind: "message", T: () => ProducerIdToConsumerMap },
      { no: 3, name: "transport_details", kind: "message", T: () => CreateTransportResponse },
      { no: 4, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new ConsumePeerResponse$Type();
class ProducerCreateResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerCreateResponse", [
      { no: 1, name: "status", kind: "scalar", T: 8 },
      { no: 2, name: "producer_id", kind: "scalar", T: 9 },
      { no: 3, name: "transport_details", kind: "message", T: () => CreateTransportResponse },
      { no: 4, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new ProducerCreateResponse$Type();
class ProducerScoreResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerScoreResponse", [
      { no: 1, name: "responseid", kind: "scalar", T: 9 },
      { no: 2, name: "score", kind: "message", T: () => NestedScore }
    ]);
  }
}
new ProducerScoreResponse$Type();
class ActiveSpeakerResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ActiveSpeakerResponse", [
      { no: 1, name: "responsepeer_id", kind: "scalar", T: 9 },
      { no: 2, name: "volume", kind: "scalar", T: 5 }
    ]);
  }
}
new ActiveSpeakerResponse$Type();
class NoActiveSpeakerResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.NoActiveSpeakerResponse", []);
  }
}
new NoActiveSpeakerResponse$Type();
class SelectedPeersResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.SelectedPeersResponse", [
      { no: 1, name: "audio_peers", kind: "scalar", repeat: 2, T: 9 },
      { no: 2, name: "compulsory_peers", kind: "scalar", repeat: 2, T: 9 }
    ]);
  }
}
new SelectedPeersResponse$Type();
class SelectedPeersDiffEntry$Type extends MessageType$2 {
  constructor() {
    super("media.edge.SelectedPeersDiffEntry", [
      { no: 1, name: "peer_id", kind: "scalar", T: 9 },
      { no: 2, name: "priority", kind: "scalar", T: 5 }
    ]);
  }
}
const SelectedPeersDiffEntry = new SelectedPeersDiffEntry$Type();
class SelectedPeersDiffResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.SelectedPeersDiffResponse", [
      { no: 1, name: "entries", kind: "message", repeat: 1, T: () => SelectedPeersDiffEntry }
    ]);
  }
}
new SelectedPeersDiffResponse$Type();
class ProducerToggleResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerToggleResponse", []);
  }
}
new ProducerToggleResponse$Type();
class ConsumerToggleResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumerToggleResponse", []);
  }
}
new ConsumerToggleResponse$Type();
class ProducerClosingResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ProducerClosingResponse", [
      { no: 1, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new ProducerClosingResponse$Type();
class ConsumerClosingResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.ConsumerClosingResponse", [
      { no: 1, name: "description", kind: "message", T: () => SessionDescription }
    ]);
  }
}
new ConsumerClosingResponse$Type();
class PeerJoinBroadcastResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerJoinBroadcastResponse", [
      { no: 1, name: "participant", kind: "message", T: () => RoomParticipants }
    ]);
  }
}
new PeerJoinBroadcastResponse$Type();
class PeerProducerCreateBroadcastResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerProducerCreateBroadcastResponse", [
      { no: 1, name: "participant_id", kind: "scalar", T: 9 },
      { no: 2, name: "producer_state", kind: "message", T: () => ProducerState }
    ]);
  }
}
new PeerProducerCreateBroadcastResponse$Type();
class PeerProducerToggleBroadcastResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerProducerToggleBroadcastResponse", [
      { no: 1, name: "participant_id", kind: "scalar", T: 9 },
      { no: 2, name: "producer_state", kind: "message", T: () => ProducerState }
    ]);
  }
}
new PeerProducerToggleBroadcastResponse$Type();
class PeerProducerCloseBroadcastResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerProducerCloseBroadcastResponse", [
      { no: 1, name: "participant_id", kind: "scalar", T: 9 },
      { no: 2, name: "producer_state", kind: "message", T: () => ProducerState }
    ]);
  }
}
new PeerProducerCloseBroadcastResponse$Type();
class PeerLeaveBroadcastResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.PeerLeaveBroadcastResponse", [
      { no: 1, name: "participant_id", kind: "scalar", T: 9 }
    ]);
  }
}
new PeerLeaveBroadcastResponse$Type();
class GlobalPeerPinningBroadcastResponse$Type extends MessageType$2 {
  constructor() {
    super("media.edge.GlobalPeerPinningBroadcastResponse", [
      { no: 1, name: "participant_id", kind: "scalar", T: 9 }
    ]);
  }
}
new GlobalPeerPinningBroadcastResponse$Type();
class BaseSocketHubMessage$Type extends MessageType$2 {
  constructor() {
    super("socket.api.BaseSocketHubMessage", [
      { no: 1, name: "event", kind: "scalar", T: 5 },
      { no: 2, name: "id", kind: "scalar", T: 9 },
      { no: 3, name: "peer_id", kind: "scalar", T: 9 },
      { no: 4, name: "room_id", kind: "scalar", T: 9 },
      { no: 5, name: "payload", kind: "scalar", T: 12 }
    ]);
  }
}
new BaseSocketHubMessage$Type();
class ErrorMessage$Type extends MessageType$2 {
  constructor() {
    super("socket.api.ErrorMessage", [
      { no: 1, name: "code", kind: "scalar", opt: true, T: 5 },
      { no: 2, name: "message", kind: "scalar", T: 9 }
    ]);
  }
}
new ErrorMessage$Type();
class PeerPreset$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset", [
      { no: 1, name: "success", kind: "scalar", T: 8 },
      { no: 2, name: "message", kind: "scalar", T: 9 },
      { no: 3, name: "data", kind: "message", T: () => PeerPreset_Data }
    ]);
  }
}
const PeerPreset = new PeerPreset$Type();
class PeerPreset_Plugins$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Plugins", [
      { no: 1, name: "can_close", kind: "scalar", T: 8 },
      { no: 2, name: "can_start", kind: "scalar", T: 8 }
    ]);
  }
}
const PeerPreset_Plugins = new PeerPreset_Plugins$Type();
class PeerPreset_Polls$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Polls", [
      { no: 1, name: "can_create", kind: "scalar", T: 8 },
      { no: 2, name: "can_vote", kind: "scalar", T: 8 },
      { no: 3, name: "can_view", kind: "scalar", T: 8 }
    ]);
  }
}
const PeerPreset_Polls = new PeerPreset_Polls$Type();
class PeerPreset_Video$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Video", [
      { no: 1, name: "allow", kind: "scalar", T: 8 },
      { no: 2, name: "quality", kind: "scalar", T: 9 },
      { no: 3, name: "frame_rate", kind: "scalar", T: 13 }
    ]);
  }
}
const PeerPreset_Video = new PeerPreset_Video$Type();
class PeerPreset_Screenshare$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Screenshare", [
      { no: 1, name: "allow", kind: "scalar", T: 8 },
      { no: 2, name: "quality", kind: "scalar", T: 9 },
      { no: 3, name: "frame_rate", kind: "scalar", T: 13 }
    ]);
  }
}
const PeerPreset_Screenshare = new PeerPreset_Screenshare$Type();
class PeerPreset_Produce$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Produce", [
      { no: 1, name: "video", kind: "message", T: () => PeerPreset_Video },
      { no: 2, name: "audio", kind: "scalar", T: 8 },
      { no: 3, name: "screenshare", kind: "message", T: () => PeerPreset_Screenshare }
    ]);
  }
}
const PeerPreset_Produce = new PeerPreset_Produce$Type();
class PeerPreset_Public$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Public", [
      { no: 1, name: "can_send", kind: "scalar", T: 8 },
      { no: 2, name: "text", kind: "scalar", T: 8 },
      { no: 3, name: "files", kind: "scalar", T: 8 }
    ]);
  }
}
const PeerPreset_Public = new PeerPreset_Public$Type();
class PeerPreset_Private$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Private", [
      { no: 1, name: "can_send", kind: "scalar", T: 8 },
      { no: 2, name: "can_receive", kind: "scalar", T: 8 },
      { no: 3, name: "text", kind: "scalar", T: 8 },
      { no: 4, name: "files", kind: "scalar", T: 8 }
    ]);
  }
}
const PeerPreset_Private = new PeerPreset_Private$Type();
class PeerPreset_Chat$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Chat", [
      { no: 1, name: "public", kind: "message", T: () => PeerPreset_Public },
      { no: 2, name: "private", kind: "message", T: () => PeerPreset_Private }
    ]);
  }
}
const PeerPreset_Chat = new PeerPreset_Chat$Type();
class PeerPreset_Permissions$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Permissions", [
      { no: 1, name: "view_type", kind: "scalar", T: 9 },
      { no: 2, name: "accept_waiting_requests", kind: "scalar", T: 8 },
      { no: 3, name: "request_produce", kind: "scalar", T: 8 },
      { no: 4, name: "can_allow_participant_audio", kind: "scalar", T: 8 },
      { no: 5, name: "can_allow_participant_screensharing", kind: "scalar", T: 8 },
      { no: 6, name: "can_allow_participant_video", kind: "scalar", T: 8 },
      { no: 7, name: "request_kick_participant", kind: "scalar", T: 8 },
      { no: 8, name: "kick_participant", kind: "scalar", T: 8 },
      { no: 9, name: "pin_participant", kind: "scalar", T: 8 },
      { no: 10, name: "can_record", kind: "scalar", T: 8 },
      { no: 11, name: "waiting_room_type", kind: "scalar", T: 9 },
      { no: 12, name: "plugins", kind: "message", T: () => PeerPreset_Plugins },
      { no: 13, name: "polls", kind: "message", T: () => PeerPreset_Polls },
      { no: 14, name: "produce", kind: "message", T: () => PeerPreset_Produce },
      { no: 15, name: "chat", kind: "message", T: () => PeerPreset_Chat },
      { no: 16, name: "reactions", kind: "scalar", T: 8 },
      { no: 17, name: "hidden_participant", kind: "scalar", T: 8 },
      { no: 18, name: "show_participant_list", kind: "scalar", T: 8 },
      { no: 19, name: "can_change_participant_role", kind: "scalar", T: 8 },
      { no: 20, name: "can_change_theme", kind: "scalar", T: 8 },
      { no: 21, name: "can_present", kind: "scalar", T: 8 }
    ]);
  }
}
const PeerPreset_Permissions = new PeerPreset_Permissions$Type();
class PeerPreset_Preset$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Preset", [
      { no: 1, name: "permissions", kind: "message", T: () => PeerPreset_Permissions },
      { no: 3, name: "version", kind: "scalar", T: 9 },
      { no: 4, name: "preset_name", kind: "scalar", T: 9 }
    ]);
  }
}
const PeerPreset_Preset = new PeerPreset_Preset$Type();
class PeerPreset_Data$Type extends MessageType$2 {
  constructor() {
    super("socket.PeerPreset.Data", [
      { no: 1, name: "preset", kind: "message", T: () => PeerPreset_Preset }
    ]);
  }
}
const PeerPreset_Data = new PeerPreset_Data$Type();
class Timestamp$Type extends MessageType$2 {
  constructor() {
    super("google.protobuf.Timestamp", [
      { no: 1, name: "seconds", kind: "scalar", T: 3, L: 0 },
      { no: 2, name: "nanos", kind: "scalar", T: 5 }
    ]);
  }
  now() {
    const msg = this.create();
    const ms = Date.now();
    msg.seconds = PbLong$1.from(Math.floor(ms / 1e3)).toBigInt();
    msg.nanos = ms % 1e3 * 1e6;
    return msg;
  }
  toDate(message) {
    return new Date(PbLong$1.from(message.seconds).toNumber() * 1e3 + Math.ceil(message.nanos / 1e6));
  }
  fromDate(date) {
    const msg = this.create();
    const ms = date.getTime();
    msg.seconds = PbLong$1.from(Math.floor(ms / 1e3)).toBigInt();
    msg.nanos = ms % 1e3 * 1e6;
    return msg;
  }
  internalJsonWrite(message, options) {
    let ms = PbLong$1.from(message.seconds).toNumber() * 1e3;
    if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z"))
      throw new Error("Unable to encode Timestamp to JSON. Must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive.");
    if (message.nanos < 0)
      throw new Error("Unable to encode invalid Timestamp to JSON. Nanos must not be negative.");
    let z = "Z";
    if (message.nanos > 0) {
      let nanosStr = (message.nanos + 1e9).toString().substring(1);
      if (nanosStr.substring(3) === "000000")
        z = "." + nanosStr.substring(0, 3) + "Z";
      else if (nanosStr.substring(6) === "000")
        z = "." + nanosStr.substring(0, 6) + "Z";
      else
        z = "." + nanosStr + "Z";
    }
    return new Date(ms).toISOString().replace(".000Z", z);
  }
  internalJsonRead(json, options, target) {
    if (typeof json !== "string")
      throw new Error("Unable to parse Timestamp from JSON " + typeofJsonValue$1(json) + ".");
    let matches = json.match(/^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2}):([0-9]{2})(?:Z|\.([0-9]{3,9})Z|([+-][0-9][0-9]:[0-9][0-9]))$/);
    if (!matches)
      throw new Error("Unable to parse Timestamp from JSON. Invalid format.");
    let ms = Date.parse(matches[1] + "-" + matches[2] + "-" + matches[3] + "T" + matches[4] + ":" + matches[5] + ":" + matches[6] + (matches[8] ? matches[8] : "Z"));
    if (Number.isNaN(ms))
      throw new Error("Unable to parse Timestamp from JSON. Invalid value.");
    if (ms < Date.parse("0001-01-01T00:00:00Z") || ms > Date.parse("9999-12-31T23:59:59Z"))
      throw new globalThis.Error("Unable to parse Timestamp from JSON. Must be from 0001-01-01T00:00:00Z to 9999-12-31T23:59:59Z inclusive.");
    if (!target)
      target = this.create();
    target.seconds = PbLong$1.from(ms / 1e3).toBigInt();
    target.nanos = 0;
    if (matches[7])
      target.nanos = parseInt("1" + matches[7] + "0".repeat(9 - matches[7].length)) - 1e9;
    return target;
  }
}
const Timestamp = new Timestamp$Type();
class ChatMessage$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.ChatMessage", [
      { no: 1, name: "chat_id", kind: "scalar", T: 9 },
      { no: 2, name: "peer_id", kind: "scalar", T: 9 },
      { no: 3, name: "user_id", kind: "scalar", T: 9 },
      { no: 4, name: "display_name", kind: "scalar", T: 9 },
      { no: 5, name: "pinned", kind: "scalar", T: 8 },
      { no: 6, name: "is_edited", kind: "scalar", T: 8 },
      { no: 7, name: "payload_type", kind: "scalar", T: 5 },
      { no: 8, name: "payload", kind: "scalar", T: 9 },
      { no: 9, name: "created_at", kind: "message", T: () => Timestamp }
    ]);
  }
}
const ChatMessage = new ChatMessage$Type();
class GetChatMessagesResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.GetChatMessagesResponse", [
      { no: 1, name: "messages", kind: "message", repeat: 1, T: () => ChatMessage }
    ]);
  }
}
const GetChatMessagesResponse = new GetChatMessagesResponse$Type();
class SendChatMessageToRoomRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.SendChatMessageToRoomRequest", [
      { no: 1, name: "payload_type", kind: "scalar", T: 5 },
      { no: 2, name: "payload", kind: "scalar", T: 9 }
    ]);
  }
}
const SendChatMessageToRoomRequest = new SendChatMessageToRoomRequest$Type();
class SendChatMessageToRoomResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.SendChatMessageToRoomResponse", [
      { no: 1, name: "message", kind: "message", T: () => ChatMessage }
    ]);
  }
}
const SendChatMessageToRoomResponse = new SendChatMessageToRoomResponse$Type();
class SendChatMessageToPeersRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.SendChatMessageToPeersRequest", [
      { no: 1, name: "peer_ids", kind: "scalar", repeat: 2, T: 9 },
      { no: 2, name: "payload_type", kind: "scalar", T: 5 },
      { no: 3, name: "payload", kind: "scalar", T: 9 }
    ]);
  }
}
const SendChatMessageToPeersRequest = new SendChatMessageToPeersRequest$Type();
class SendChatMessageToPeersResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.SendChatMessageToPeersResponse", [
      { no: 1, name: "message", kind: "message", T: () => ChatMessage }
    ]);
  }
}
const SendChatMessageToPeersResponse = new SendChatMessageToPeersResponse$Type();
class EditChatMessageRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.EditChatMessageRequest", [
      { no: 1, name: "chat_id", kind: "scalar", T: 9 },
      { no: 2, name: "payload_type", kind: "scalar", opt: true, T: 5 },
      { no: 3, name: "payload", kind: "scalar", opt: true, T: 9 },
      { no: 4, name: "pinned", kind: "scalar", opt: true, T: 8 }
    ]);
  }
}
const EditChatMessageRequest = new EditChatMessageRequest$Type();
class EditChatMessageResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.EditChatMessageResponse", [
      { no: 1, name: "message", kind: "message", T: () => ChatMessage }
    ]);
  }
}
const EditChatMessageResponse = new EditChatMessageResponse$Type();
class DeleteChatMessageRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.DeleteChatMessageRequest", [
      { no: 1, name: "chat_id", kind: "scalar", T: 9 }
    ]);
  }
}
const DeleteChatMessageRequest = new DeleteChatMessageRequest$Type();
class DeleteChatMessageResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.chat.DeleteChatMessageResponse", [
      { no: 1, name: "chat_id", kind: "scalar", T: 9 }
    ]);
  }
}
const DeleteChatMessageResponse = new DeleteChatMessageResponse$Type();
class Peer$Type extends MessageType$2 {
  constructor() {
    super("socket.room.Peer", [
      { no: 1, name: "peer_id", kind: "scalar", T: 9 },
      { no: 2, name: "user_id", kind: "scalar", T: 9 },
      { no: 3, name: "display_name", kind: "scalar", T: 9 }
    ]);
  }
}
const Peer = new Peer$Type();
class PeerInfoResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.room.PeerInfoResponse", [
      { no: 1, name: "peer", kind: "message", T: () => Peer }
    ]);
  }
}
new PeerInfoResponse$Type();
class RoomPeersInfoResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.room.RoomPeersInfoResponse", [
      { no: 1, name: "peers", kind: "message", repeat: 1, T: () => Peer }
    ]);
  }
}
new RoomPeersInfoResponse$Type();
class Room$Type extends MessageType$2 {
  constructor() {
    super("socket.room.Room", [
      { no: 1, name: "room_id", kind: "scalar", T: 9 },
      { no: 2, name: "title", kind: "scalar", T: 9 }
    ]);
  }
}
const Room = new Room$Type();
class RoomInfoResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.room.RoomInfoResponse", [
      { no: 1, name: "room", kind: "message", T: () => Room }
    ]);
  }
}
new RoomInfoResponse$Type();
class GetPeerInfoRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.room.GetPeerInfoRequest", [
      { no: 1, name: "peer_id", kind: "scalar", T: 9 }
    ]);
  }
}
new GetPeerInfoRequest$Type();
class UpdatePeerInfoRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.room.UpdatePeerInfoRequest", [
      { no: 1, name: "peer_id", kind: "scalar", T: 9 },
      { no: 2, name: "display_name", kind: "scalar", opt: true, T: 9 }
    ]);
  }
}
new UpdatePeerInfoRequest$Type();
class JoinRoomRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.room.JoinRoomRequest", [
      { no: 1, name: "peer", kind: "message", T: () => Peer },
      { no: 2, name: "preset", kind: "message", T: () => PeerPreset },
      { no: 3, name: "room_uuid", kind: "scalar", T: 9 }
    ]);
  }
}
const JoinRoomRequest = new JoinRoomRequest$Type();
class LeaveRoomRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.room.LeaveRoomRequest", [
      { no: 1, name: "peer", kind: "message", T: () => Peer }
    ]);
  }
}
const LeaveRoomRequest = new LeaveRoomRequest$Type();
class UpdateRoomInfoRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.room.UpdateRoomInfoRequest", [
      { no: 1, name: "room", kind: "message", T: () => Room }
    ]);
  }
}
new UpdateRoomInfoRequest$Type();
class AddPluginRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.AddPluginRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "staggered", kind: "scalar", T: 8 }
    ]);
  }
}
const AddPluginRequest = new AddPluginRequest$Type();
class RemovePluginRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.RemovePluginRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "staggered", kind: "scalar", T: 8 }
    ]);
  }
}
const RemovePluginRequest = new RemovePluginRequest$Type();
class EnablePluginForRoomRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.EnablePluginForRoomRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 }
    ]);
  }
}
const EnablePluginForRoomRequest = new EnablePluginForRoomRequest$Type();
class DisablePluginForRoomRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.DisablePluginForRoomRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 }
    ]);
  }
}
const DisablePluginForRoomRequest = new DisablePluginForRoomRequest$Type();
class EnablePluginForPeersRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.EnablePluginForPeersRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "peer_ids", kind: "scalar", repeat: 2, T: 9 }
    ]);
  }
}
const EnablePluginForPeersRequest = new EnablePluginForPeersRequest$Type();
class DisablePluginForPeersRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.DisablePluginForPeersRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "peer_ids", kind: "scalar", repeat: 2, T: 9 }
    ]);
  }
}
const DisablePluginForPeersRequest = new DisablePluginForPeersRequest$Type();
class PluginEventToRoomRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginEventToRoomRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "plugin_data", kind: "scalar", T: 12 }
    ]);
  }
}
const PluginEventToRoomRequest = new PluginEventToRoomRequest$Type();
class PluginEventToPeersRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginEventToPeersRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "peer_ids", kind: "scalar", repeat: 2, T: 9 },
      { no: 3, name: "plugin_data", kind: "scalar", T: 12 }
    ]);
  }
}
const PluginEventToPeersRequest = new PluginEventToPeersRequest$Type();
class StoreKeys$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.StoreKeys", [
      { no: 1, name: "store_key", kind: "scalar", T: 9 },
      { no: 2, name: "payload", kind: "scalar", opt: true, T: 12 }
    ]);
  }
}
const StoreKeys = new StoreKeys$Type();
class PluginStoreInsertKeysRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginStoreInsertKeysRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "store_name", kind: "scalar", T: 9 },
      { no: 3, name: "insert_keys", kind: "message", repeat: 1, T: () => StoreKeys }
    ]);
  }
}
const PluginStoreInsertKeysRequest = new PluginStoreInsertKeysRequest$Type();
class PluginStoreGetKeysRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginStoreGetKeysRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "store_name", kind: "scalar", T: 9 },
      { no: 3, name: "get_keys", kind: "message", repeat: 1, T: () => StoreKeys }
    ]);
  }
}
const PluginStoreGetKeysRequest = new PluginStoreGetKeysRequest$Type();
class PluginStoreDeleteKeysRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginStoreDeleteKeysRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "store_name", kind: "scalar", T: 9 },
      { no: 3, name: "delete_keys", kind: "message", repeat: 1, T: () => StoreKeys }
    ]);
  }
}
const PluginStoreDeleteKeysRequest = new PluginStoreDeleteKeysRequest$Type();
class PluginStoreDeleteRequest$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginStoreDeleteRequest", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "store_name", kind: "scalar", T: 9 }
    ]);
  }
}
const PluginStoreDeleteRequest = new PluginStoreDeleteRequest$Type();
class EnablePluginResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.EnablePluginResponse", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "enabled_by", kind: "scalar", T: 9 }
    ]);
  }
}
const EnablePluginResponse = new EnablePluginResponse$Type();
class EnablePluginsResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.EnablePluginsResponse", [
      { no: 1, name: "plugins", kind: "message", repeat: 1, T: () => EnablePluginResponse }
    ]);
  }
}
const EnablePluginsResponse = new EnablePluginsResponse$Type();
class DisablePluginResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.DisablePluginResponse", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "disabled_by", kind: "scalar", T: 9 }
    ]);
  }
}
const DisablePluginResponse = new DisablePluginResponse$Type();
class PluginStoreItem$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginStoreItem", [
      { no: 1, name: "timestamp", kind: "scalar", T: 9 },
      { no: 2, name: "peer_id", kind: "scalar", T: 9 },
      { no: 3, name: "store_key", kind: "scalar", T: 9 },
      { no: 4, name: "payload", kind: "scalar", T: 12 }
    ]);
  }
}
const PluginStoreItem = new PluginStoreItem$Type();
class PluginStoreResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginStoreResponse", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "store_name", kind: "scalar", T: 9 },
      { no: 3, name: "store_items", kind: "message", repeat: 1, T: () => PluginStoreItem }
    ]);
  }
}
const PluginStoreResponse = new PluginStoreResponse$Type();
class PluginEventResponse$Type extends MessageType$2 {
  constructor() {
    super("socket.plugin.PluginEventResponse", [
      { no: 1, name: "plugin_id", kind: "scalar", T: 9 },
      { no: 2, name: "plugin_data", kind: "scalar", T: 12 }
    ]);
  }
}
const PluginEventResponse = new PluginEventResponse$Type();
const roomMessageBase = 0;
const chatMessageBase = 1;
const pluginMessageBase = 2;
const roomEventSlugs = {
  getPeerInfo: 0,
  updatePeerInfo: 1,
  getRoomPeersInfo: 2,
  joinRoom: 3,
  leaveRoom: 4,
  getRoomInfo: 5,
  updateRoomInfo: 6,
  closeRoom: 7
};
const chatEventSlugs = {
  getMessages: 0,
  sendMessageToRoom: 1,
  sendMessageToPeers: 2,
  editMessage: 3,
  deleteMessage: 4
};
const pluginEventSlugs = {
  getPlugins: 0,
  addPlugin: 1,
  enablePluginForRoom: 2,
  disablePluginForPeers: 3,
  enablePluginForPeers: 4,
  disablePluginForRoom: 5,
  removePlugin: 6,
  customPluginEventToRoom: 7,
  customPluginEventToPeers: 8,
  storeInsertKeys: 9,
  storeGetKeys: 10,
  storeDeleteKeys: 11,
  storeDelete: 12
};
function generateEvents(base, slugs) {
  return Object.keys(slugs).reduce((acc, key) => {
    acc[key] = (base << 16) + slugs[key];
    return acc;
  }, {});
}
const roomEvents = generateEvents(roomMessageBase, roomEventSlugs);
const chatEvents = generateEvents(chatMessageBase, chatEventSlugs);
const pluginEvents = generateEvents(pluginMessageBase, pluginEventSlugs);
class RoomSocketHandler {
  constructor(socketService) {
    __publicField(this, "socket");
    this.socket = socketService;
    this.setupEvents();
  }
  setupEvents() {
    this.socket.onStateEvent("disconnected", ({ reason, code: code2 }) => {
      log.info(`Disconnected from room: [${code2}] ${reason}`);
    });
  }
  set onReconnect(fn) {
    this.socket.onStateEvent("reconnected", fn);
  }
  joinRoom(displayName, peerId, userId, roomUUID) {
    const req = {
      peer: { displayName, peerId, userId },
      roomUuid: roomUUID
    };
    this.socket.sendMessage(roomEvents.joinRoom, JoinRoomRequest.toBinary(req));
  }
  leaveRoom() {
    this.socket.sendMessage(roomEvents.leaveRoom, LeaveRoomRequest.toBinary({}));
  }
}
function hash(str) {
  let h = 0;
  let i;
  let chr;
  if (!str)
    return h;
  for (i = 0; i < str.length; i += 1) {
    chr = str.charCodeAt(i);
    h = (h << 5) - h + chr;
    h |= 0;
  }
  return Math.abs(h) % 100 + 1;
}
var __defProp$h = Object.defineProperty;
var __getOwnPropDesc$h = Object.getOwnPropertyDescriptor;
var __decorateClass$h = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$h(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$h(target, key, result);
  return result;
};
const _SelfController = (_c = class {
  constructor(socketService, roomNodeClient, localMediaHandler, self2) {
    __publicField(this, "self");
    __publicField(this, "authToken");
    __publicField(this, "peerId");
    __privateAdd(this, _socketService, void 0);
    __privateAdd(this, _roomNodeClient2, void 0);
    __privateAdd(this, _localMediaHandler3, void 0);
    __privateSet(this, _socketService, socketService);
    __privateSet(this, _roomNodeClient2, roomNodeClient);
    __privateSet(this, _localMediaHandler3, localMediaHandler);
    this.authToken = roomNodeClient.authToken;
    this.peerId = roomNodeClient.peerId;
    this.self = self2;
    this.setupEvents();
  }
  static async init(socketService, roomNodeClient, options, localMediaHandler) {
    var _a3, _b2;
    const { defaults, modules } = options;
    const APIClient2 = getAPIClient();
    const userResponse = await APIClient2.getUserDetails();
    const { isV2AuthToken } = constants;
    let permissions = isV2AuthToken ? DytePermissionsPreset.default() : DytePermissionsPresetV1.default();
    let theme = isV2AuthToken ? DyteThemePreset.default() : DyteThemePresetV1.default();
    const modulePermissions = (_a3 = modules.permissions) != null ? _a3 : true;
    const moduleTheme = (_b2 = modules.theme) != null ? _b2 : true;
    if (modulePermissions || moduleTheme) {
      const userPreset = isV2AuthToken ? void 0 : await APIClient2.getUserPreset(roomNodeClient.roomName);
      if (modulePermissions) {
        permissions = isV2AuthToken ? DytePermissionsPreset.fromResponse(userResponse.preset.permissions) : DytePermissionsPresetV1.fromResponse(userPreset.permissions);
      }
      if (moduleTheme) {
        theme = isV2AuthToken ? DyteThemePreset.fromResponse(userResponse.preset.config) : DyteThemePresetV1.fromResponse(userPreset.theme);
      }
    }
    const self2 = await DyteSelf.init(roomNodeClient, constants.isV2AuthToken ? userResponse.participant : userResponse, permissions, theme, defaults, localMediaHandler);
    const organizationId = isV2AuthToken ? userResponse.participant.organizationId : userResponse.organizationId;
    DyteTelemetry.meetingMetadata.organizationId = organizationId;
    const { roomName } = roomNodeClient != null ? roomNodeClient : {};
    const meetingHash = hash(roomName);
    await dist.globalFlagsmith.identify(`${FlagsmithIdentifierPrefix.PEER}_${roomNodeClient.peerId}`, JSON.parse(JSON.stringify(__spreadValues({
      entity: FlagsmithIdentifierPrefix.PEER,
      clientId: organizationId,
      isAnonUser: !organizationId,
      sdkVersion: WEB_CORE_VERSION,
      meetingHash,
      roomName
    }, browserSpecs.getDeviceInfo()))));
    DyteTelemetry.addEventInCurrentSpan("info", "flagsmith::allFlags", { flags: dist.globalFlagsmith.getAllFlags() }, true);
    if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.INTERNAL_CALL_STATS) && navigator.product !== "ReactNative") {
      setTimeout(async () => {
        callStats.initialize({
          peerId: roomNodeClient.peerId,
          engineName: browserSpecs.getDeviceInfo().engineName,
          env: "production",
          iceServers: await APIClient2.getICEServers(),
          apiBase: config.apiBase
        });
      });
    }
    return new _SelfController(socketService, roomNodeClient, localMediaHandler, self2);
  }
  async shareMediaTracks() {
    return Promise.all([
      this.self.videoTrack && __privateGet(this, _roomNodeClient2).shareWebcam(this.self.videoTrack),
      this.self.audioTrack && __privateGet(this, _roomNodeClient2).shareMic(this.self.audioTrack)
    ]);
  }
  setupEvents() {
    SessionStore.on(SessionEvents.DISABLE_AUDIO, async () => {
      if (this.self.audioEnabled) {
        await this.self.disableAudio();
        callStats.audioOff();
      }
    });
    SessionStore.on(SessionEvents.DISABLE_VIDEO, async () => {
      if (this.self.videoEnabled) {
        await this.self.disableVideo();
        callStats.videoOff();
      }
    });
    SessionStore.on(SessionEvents.MUTE_ALL, async () => {
      if (this.self.audioEnabled) {
        await this.self.disableAudio();
        callStats.audioOff();
      }
    });
    SessionStore.on(SessionEvents.MUTE_ALL_VIDEO, async () => {
      if (this.self.videoEnabled) {
        await this.self.disableVideo();
        callStats.videoOff();
      }
    });
    SessionStore.on(SessionEvents.WAITLISTED, () => {
      this.self.waitlistStatus = "waiting";
      this.self.emit("waitlisted");
    });
    SessionStore.on(SessionEvents.WAITLIST_ACCEPTED, async () => {
      this.self.waitlistStatus = "accepted";
      this.joinRoom();
    });
    SessionStore.on(SessionEvents.WAITLIST_REJECTED, async () => {
      this.self.waitlistStatus = "rejected";
      this.leaveRoom("rejected");
    });
    SessionStore.on(SessionEvents.KICKED, async (payload) => {
      let state = "kicked";
      if ((payload == null ? void 0 : payload.kickType) === "kickAll")
        state = "ended";
      this.leaveRoom(state);
    });
    SessionStore.on(SessionEvents.SELF_ROOM_JOINED, () => {
      if (!constants.isV2AuthToken && this.self.permissions.viewType === "WEBINAR" && this.self.permissions.canPresent) {
        this.self.joinStage();
      }
      this.self.emit("roomJoined");
    });
    SessionStore.on(SessionEvents.MEDIA_PERMISSION_ERROR, async (payload) => {
      this.self.emit("mediaPermissionError", payload);
    });
    SessionStore.on(SessionEvents.REQUEST_TO_JOIN_STAGE_ACCEPTED, () => {
      this.self.setWebinarStageStatus(WebinarStageStatus.ACCEPTED_TO_JOIN_STAGE);
      this.self.emit("joinStageRequestAccepted");
    });
    SessionStore.on(SessionEvents.REQUEST_TO_JOIN_STAGE_REJECTED, () => {
      this.self.setWebinarStageStatus(WebinarStageStatus.OFF_STAGE);
      this.self.emit("joinStageRequestRejected");
    });
    SessionStore.on(SessionEvents.REMOVED_FROM_STAGE, async () => {
      this.self.setWebinarStageStatus(WebinarStageStatus.OFF_STAGE);
      await this.self.disableScreenShare();
      await this.self.disableVideo();
      await this.self.disableAudio();
      __privateGet(this, _localMediaHandler3).mediaMiddlewareUtils.terminateMiddlewareWebWorker();
      this.self.emit("removedFromStage");
    });
    SessionStore.on(SessionEvents.STARTED_PRESENTING, () => {
      this.self.setWebinarStageStatus(WebinarStageStatus.ON_STAGE);
      this.self.emit("stageJoined");
    });
    SessionStore.on(SessionEvents.STOPPED_PRESENTING, () => {
      this.self.setWebinarStageStatus(WebinarStageStatus.OFF_STAGE);
      this.self.emit("stageLeft");
    });
  }
  async joinRoom() {
    var _a3, _b2;
    if (__privateGet(this, _roomNodeClient2).isDisconnected) {
      __privateGet(this, _roomNodeClient2).reconnect();
      return;
    }
    const roomState = await __privateGet(this, _roomNodeClient2).getRoomState();
    const APIClient2 = getAPIClient();
    const { roomUUID } = (_b2 = (_a3 = roomState == null ? void 0 : roomState.payload) == null ? void 0 : _a3.roomState) != null ? _b2 : {};
    APIClient2.setRoomUUID(roomUUID);
    if (!constants.isV2AuthToken) {
      const roomSocketHandler = new RoomSocketHandler(__privateGet(this, _socketService));
      roomSocketHandler.joinRoom(this.self.name, this.self.id, this.self.userId, roomUUID);
      roomSocketHandler.onReconnect = () => {
        roomSocketHandler.joinRoom(this.self.name, this.self.id, this.self.userId, roomUUID);
      };
    }
    const { roomJoined } = await __privateGet(this, _roomNodeClient2).joinRoom(this.self.name, !this.self.audioEnabled, roomUUID, void 0, {
      audio: this.self.audioEnabled,
      video: this.self.videoEnabled,
      screen: this.self.screenShareEnabled
    });
    if (roomJoined) {
      await this.shareMediaTracks();
    }
  }
  async leaveRoom(state = "left") {
    var _a3;
    await this.self.disableAudio();
    await this.self.disableVideo();
    await this.self.disableScreenShare();
    this.self.cleanUpTracks();
    (_a3 = __privateGet(this, _socketService)) == null ? void 0 : _a3.disconnect();
    __privateGet(this, _localMediaHandler3).mediaMiddlewareUtils.terminateMiddlewareWebWorker();
    await __privateGet(this, _roomNodeClient2).leaveRoom();
    __privateGet(this, _roomNodeClient2).roomJoined = false;
    this.self.emit("roomLeft", { state });
  }
}, _socketService = new WeakMap(), _roomNodeClient2 = new WeakMap(), _localMediaHandler3 = new WeakMap(), _c);
let SelfController = _SelfController;
__decorateClass$h([
  DyteTelemetry.trace("SelfController.setupEvents")
], SelfController.prototype, "setupEvents", 1);
__decorateClass$h([
  DyteTelemetry.trace("SelfController.joinRoom")
], SelfController.prototype, "joinRoom", 1);
__decorateClass$h([
  DyteTelemetry.trace("SelfController.leaveRoom")
], SelfController.prototype, "leaveRoom", 1);
var __defProp$g = Object.defineProperty;
var __getOwnPropDesc$g = Object.getOwnPropertyDescriptor;
var __decorateClass$g = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$g(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$g(target, key, result);
  return result;
};
class DyteParticipant extends DyteEventEmitter {
  constructor(participant, self2, roomNodeClient) {
    super();
    __publicField(this, "id");
    __publicField(this, "userId");
    __publicField(this, "name");
    __publicField(this, "picture");
    __publicField(this, "isHost");
    __publicField(this, "clientSpecificId");
    __publicField(this, "flags");
    __publicField(this, "device");
    __publicField(this, "videoTrack");
    __publicField(this, "audioTrack");
    __publicField(this, "screenShareTracks");
    __publicField(this, "videoEnabled");
    __publicField(this, "audioEnabled");
    __publicField(this, "screenShareEnabled");
    __privateAdd(this, _isPinned2, void 0);
    __publicField(this, "supportsRemoteControl", false);
    __publicField(this, "webinarStageStatus", WebinarStageStatus.OFF_STAGE);
    __privateAdd(this, _roomNodeClient3, void 0);
    __privateAdd(this, _self, void 0);
    const {
      id,
      userId,
      displayName: name,
      device,
      picture,
      isHost,
      flags,
      clientSpecificId,
      audioMuted,
      audioTrack,
      videoEnabled = false,
      videoTrack
    } = participant;
    this.id = id;
    this.userId = userId;
    this.name = name;
    this.device = device;
    this.picture = picture;
    this.isHost = isHost;
    this.flags = flags;
    this.clientSpecificId = clientSpecificId;
    this.audioEnabled = !audioMuted;
    this.audioTrack = audioTrack;
    this.videoEnabled = videoEnabled;
    this.videoTrack = videoTrack;
    this.screenShareTracks = {
      audio: void 0,
      video: void 0
    };
    __privateSet(this, _isPinned2, false);
    __privateSet(this, _self, self2);
    __privateSet(this, _roomNodeClient3, roomNodeClient);
  }
  setVideoEnabled(videoEnabled, emitEvent = true) {
    var _a3;
    this.videoEnabled = videoEnabled;
    if (!emitEvent)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::setVideoEnabled::videoUpdate", {
      audioEnabled: this.videoEnabled,
      trackId: (_a3 = this.videoTrack) == null ? void 0 : _a3.id
    });
    this.emit("videoUpdate", {
      videoEnabled: this.videoEnabled,
      videoTrack: this.videoTrack
    });
  }
  setAudioEnabled(audioEnabled, emitEvent = true) {
    var _a3;
    this.audioEnabled = audioEnabled;
    if (!emitEvent)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::setAudioEnabled::audioUpdate", {
      audioEnabled: this.audioEnabled,
      trackId: (_a3 = this.audioTrack) == null ? void 0 : _a3.id
    });
    this.emit("audioUpdate", {
      audioEnabled: this.audioEnabled,
      audioTrack: this.audioTrack
    });
  }
  setScreenShareEnabled(screenShareEnabled, emitEvent = true) {
    this.screenShareEnabled = screenShareEnabled;
    if (!emitEvent)
      return;
    this.emit("screenShareUpdate", {
      screenShareEnabled: this.screenShareEnabled,
      screenShareTracks: this.screenShareTracks
    });
  }
  async pin() {
    return __privateGet(this, _roomNodeClient3).pinPeer(this.id);
  }
  async unpin() {
    return __privateGet(this, _roomNodeClient3).pinPeer(null);
  }
  setIsPinned(isPinned, emitEvent = true) {
    __privateSet(this, _isPinned2, isPinned);
    const event = isPinned ? "pinned" : "unpinned";
    if (emitEvent)
      this.emit(event, this);
  }
  async disableAudio() {
    const peerId = this.id;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::disable_audio", { peerId });
    if (__privateGet(this, _self).permissions.canAllowParticipantAudio) {
      return __privateGet(this, _roomNodeClient3).disableAudio(peerId);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipant::unauthorized_disable_audio", { peerId });
    throw new DyteError("Unauthorized: User does not have permission to disable participant audio.");
  }
  async kick() {
    const peerId = this.id;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::kick", { peerId });
    if (__privateGet(this, _self).permissions.kickParticipant) {
      return __privateGet(this, _roomNodeClient3).kick(peerId);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipant::unauthorized_kick", { peerId });
    throw new DyteError("Unauthorized: User does not have permission to kick participants.");
  }
  async disableVideo() {
    const peerId = this.id;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipant::disable_video", { peerId });
    if (__privateGet(this, _self).permissions.canAllowParticipantVideo) {
      return __privateGet(this, _roomNodeClient3).disableVideo(peerId);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipant::unauthorized_disable_video", { peerId });
    throw new DyteError("Unauthorized: User does not have permission to disable participant video.");
  }
  async acceptJoinStageRequest() {
    __privateGet(this, _roomNodeClient3).acceptAllRequestToJoinStage([{
      id: this.id,
      requestToJoinType: RequestToJoinType.PRESENT
    }]);
  }
  async rejectRequestToJoinStage() {
    __privateGet(this, _roomNodeClient3).rejectRequestToJoinStage(this.id);
  }
  async removeFromStage() {
    __privateGet(this, _roomNodeClient3).removePeerFromStage(this.id, WebinarAcceptRequestType.REQUESTED_BY_MODERATOR);
  }
  setWebinarStageStatus(webinarStageStatus) {
    this.webinarStageStatus = webinarStageStatus;
    let eventName;
    if (webinarStageStatus === WebinarStageStatus.OFF_STAGE) {
      eventName = "peerStoppedPresenting";
    }
    if (webinarStageStatus === WebinarStageStatus.ON_STAGE) {
      eventName = "peerStartedPresenting";
    }
    if (webinarStageStatus === WebinarStageStatus.ACCEPTED_TO_JOIN_STAGE) {
      eventName = "peerAcceptedToJoinStage";
    }
    if (webinarStageStatus === WebinarStageStatus.REQUESTED_TO_JOIN_STAGE) {
      eventName = "peerRequestToJoinStage";
    }
    if (eventName) {
      this.emit(eventName, this);
    }
  }
  get isPinned() {
    return __privateGet(this, _isPinned2);
  }
}
_isPinned2 = new WeakMap();
_roomNodeClient3 = new WeakMap();
_self = new WeakMap();
__decorateClass$g([
  DyteTelemetry.trace("DyteParticipant.disableAudio")
], DyteParticipant.prototype, "disableAudio", 1);
__decorateClass$g([
  DyteTelemetry.trace("DyteParticipant.kick")
], DyteParticipant.prototype, "kick", 1);
__decorateClass$g([
  DyteTelemetry.trace("DyteParticipant.disableVideo")
], DyteParticipant.prototype, "disableVideo", 1);
__decorateClass$g([
  DyteTelemetry.trace("DyteParticipant.acceptJoinStageRequest")
], DyteParticipant.prototype, "acceptJoinStageRequest", 1);
__decorateClass$g([
  DyteTelemetry.trace("DyteParticipant.rejectRequestToJoinStage")
], DyteParticipant.prototype, "rejectRequestToJoinStage", 1);
__decorateClass$g([
  DyteTelemetry.trace("DyteParticipant.removeFromStage")
], DyteParticipant.prototype, "removeFromStage", 1);
__decorateClass$g([
  DyteTelemetry.trace("DyteParticipant.setWebinarStageStatus")
], DyteParticipant.prototype, "setWebinarStageStatus", 1);
class DyteMap extends Map {
  constructor(options) {
    const {
      onAddEvent = "added",
      onDeleteEvent = "deleted",
      onClearEvent = "cleared"
    } = options != null ? options : {};
    super();
    __privateAdd(this, _eventEmitter2, void 0);
    __privateAdd(this, _listeners2, void 0);
    __publicField(this, "onAddEvent");
    __publicField(this, "onDeleteEvent");
    __publicField(this, "onClearEvent");
    __privateSet(this, _eventEmitter2, new DyteEventEmitter());
    this.onAddEvent = onAddEvent;
    this.onDeleteEvent = onDeleteEvent;
    this.onClearEvent = onClearEvent;
    __privateSet(this, _listeners2, new Map());
  }
  emit(event, ...args) {
    return __privateGet(this, _eventEmitter2).emit(event, ...args);
  }
  on(event, callback) {
    return __privateGet(this, _eventEmitter2).on(event, callback);
  }
  addListener(event, callback) {
    return __privateGet(this, _eventEmitter2).addListener(event, callback);
  }
  off(event, callback) {
    return __privateGet(this, _eventEmitter2).off(event, callback);
  }
  once(event, callback) {
    return __privateGet(this, _eventEmitter2).once(event, callback);
  }
  prependListener(event, callback) {
    return __privateGet(this, _eventEmitter2).prependListener(event, callback);
  }
  prependOnceListener(event, callback) {
    return __privateGet(this, _eventEmitter2).prependOnceListener(event, callback);
  }
  removeListener(event, callback) {
    return __privateGet(this, _eventEmitter2).removeListener(event, callback);
  }
  removeAllListeners(event) {
    return __privateGet(this, _eventEmitter2).removeAllListeners(event);
  }
  listeners(event) {
    return __privateGet(this, _eventEmitter2).listeners(event);
  }
  listenerCount(event) {
    return __privateGet(this, _eventEmitter2).listenerCount(event);
  }
  getMaxListeners() {
    return __privateGet(this, _eventEmitter2).getMaxListeners();
  }
  setMaxListeners(n) {
    return __privateGet(this, _eventEmitter2).setMaxListeners(n);
  }
  eventNames() {
    return __privateGet(this, _eventEmitter2).eventNames();
  }
  add(obj, emitEvent = true) {
    return this.set(obj.id, obj, emitEvent);
  }
  set(objId, obj, emitEvent = true) {
    const setVal = super.set(objId, obj);
    const listener = (event, ...args) => {
      this.emit(event, obj, ...args);
    };
    __privateGet(this, _listeners2).set(objId, listener);
    obj.on("*", listener);
    if (emitEvent) {
      __privateGet(this, _eventEmitter2).emit(this.onAddEvent, obj);
    }
    return setVal;
  }
  delete(objId, emitEvent = true, removeListeners = false) {
    const obj = this.get(objId);
    if (!obj) {
      return false;
    }
    obj.removeListener("*", __privateGet(this, _listeners2).get(objId));
    const deleteVal = super.delete(objId);
    if (removeListeners) {
      obj.removeAllListeners();
    }
    if (emitEvent) {
      __privateGet(this, _eventEmitter2).emit(this.onDeleteEvent, obj);
    }
    return deleteVal;
  }
  clear(emitEvent = true, removeListeners = false) {
    this.forEach((obj) => {
      obj.removeListener("*", __privateGet(this, _listeners2).get(obj.id));
      if (removeListeners) {
        obj.removeAllListeners();
      }
    });
    const clearVal = super.clear();
    if (emitEvent) {
      __privateGet(this, _eventEmitter2).emit(this.onClearEvent);
    }
    return clearVal;
  }
  toArray() {
    return Array.from(this.values());
  }
}
_eventEmitter2 = new WeakMap();
_listeners2 = new WeakMap();
class DyteParticipantMap extends DyteMap {
  constructor(options) {
    const {
      onAddEvent = "participantJoined",
      onDeleteEvent = "participantLeft",
      onClearEvent = "participantsCleared"
    } = options != null ? options : {};
    super({
      onAddEvent,
      onDeleteEvent,
      onClearEvent
    });
  }
  add(participant, emitEvent = true) {
    return super.add(participant, emitEvent);
  }
  clear(emitEvent = true, removeListeners = false) {
    return super.clear(emitEvent, removeListeners);
  }
  delete(participantId, emitEvent = true, removeListeners = false) {
    return super.delete(participantId, emitEvent, removeListeners);
  }
}
var __defProp$f = Object.defineProperty;
var __getOwnPropDesc$f = Object.getOwnPropertyDescriptor;
var __decorateClass$f = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$f(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$f(target, key, result);
  return result;
};
class DyteParticipants extends DyteEventEmitter {
  constructor(roomNodeClient, self2) {
    super();
    __publicField(this, "waitlisted");
    __publicField(this, "joined");
    __publicField(this, "active");
    __publicField(this, "pinned");
    __privateAdd(this, _roomNodeClient4, void 0);
    __privateAdd(this, _self2, void 0);
    __publicField(this, "viewMode");
    __publicField(this, "currentPage");
    __publicField(this, "lastActiveSpeaker");
    __privateSet(this, _roomNodeClient4, roomNodeClient);
    __privateSet(this, _self2, self2);
    this.waitlisted = new DyteParticipantMap();
    this.joined = new DyteParticipantMap();
    this.active = new DyteParticipantMap();
    this.pinned = new DyteParticipantMap();
    this.viewMode = "ACTIVE_GRID";
    this.currentPage = 0;
  }
  get count() {
    return this.joined.size;
  }
  get maxActiveParticipantsCount() {
    return __privateGet(this, _roomNodeClient4).maxPreferredStreams;
  }
  get pageCount() {
    return this.viewMode === "PAGINATED" ? Math.ceil(this.joined.size / __privateGet(this, _roomNodeClient4).maxPreferredStreams) : 0;
  }
  async acceptWaitingRoomRequest(id) {
    return __privateGet(this, _roomNodeClient4).acceptWaitingRequest(id);
  }
  async rejectWaitingRoomRequest(id) {
    await __privateGet(this, _roomNodeClient4).rejectWaitingRequest(id);
    this.waitlisted.delete(id);
  }
  async setViewMode(viewMode) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::set_view_mode", {
      viewMode
    });
    if (!["ACTIVE_GRID", "PAGINATED"].includes(viewMode)) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::setViewMode::invalid_view_mode", {
        viewMode
      });
      throw new DyteError(`Invalid view mode: ${viewMode}. Try ACTIVE_GRID or PAGINATED.`);
    }
    if (this.viewMode === viewMode) {
      DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::setViewMode::view_mode_same_as_previous", {
        viewMode
      });
      return;
    }
    this.viewMode = viewMode;
    if (viewMode === "PAGINATED") {
      this.currentPage = 1;
      SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet(this, _roomNodeClient4).getPage(this.currentPage)).payload);
    } else if (viewMode === "ACTIVE_GRID") {
      this.currentPage = 0;
      __privateGet(this, _roomNodeClient4).getPage(this.currentPage);
    }
    this.emit("viewModeChanged", {
      viewMode,
      currentPage: this.currentPage,
      pageCount: this.pageCount
    });
  }
  async setPage(page) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::set_page", {
      page,
      maxPageCount: this.pageCount
    });
    if (this.viewMode !== "PAGINATED") {
      return;
    }
    if (!Number.isInteger(page)) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::invalid_page_number", {
        page,
        maxPageCount: this.pageCount
      });
      throw new DyteError(`Invalid page: ${page}. Page must be an integer.`);
    }
    if (page < 1 || page > this.pageCount) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::invalid_page_number", {
        page,
        maxPageCount: this.pageCount
      });
      throw new DyteError(`Invalid page: ${page}. Page must be greater than 0 and less than or equal to ${this.pageCount}.`);
    }
    this.currentPage = page;
    SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet(this, _roomNodeClient4).getPage(page)).payload);
    this.emit("pageChanged", {
      viewMode: this.viewMode,
      currentPage: this.currentPage,
      pageCount: this.pageCount
    });
  }
  async disableAllAudio(allowUnMute) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::disable_all_audio", {
      allowUnMute
    });
    if (__privateGet(this, _self2).permissions.canAllowParticipantAudio) {
      return __privateGet(this, _roomNodeClient4).muteAll(allowUnMute);
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::unauthorized_disable_all_audio", {
      allowUnMute
    });
    throw new DyteError("Unauthorized: User does not have permission to disable peer audio.");
  }
  async disableAllVideo() {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::disable_all_video");
    if (__privateGet(this, _self2).permissions.canAllowParticipantVideo) {
      return __privateGet(this, _roomNodeClient4).muteAllVideo();
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::unauthorized_disable_all_video");
    throw new DyteError("Unauthorized: User does not have permission to disable peer video.");
  }
  async disableAudio(participantId) {
    this.joined.get(participantId).disableAudio();
  }
  async disableVideo(participantId) {
    this.joined.get(participantId).disableVideo();
  }
  async kick(participantId) {
    this.joined.get(participantId).kick();
  }
  async kickAll() {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::kick_all");
    if (__privateGet(this, _self2).permissions.kickParticipant) {
      return __privateGet(this, _roomNodeClient4).kickAll();
    }
    DyteTelemetry.addEventInCurrentSpan("error", "DyteParticipants::unauthorized_kick_all");
    throw new DyteError("Unauthorized: User does not have permission to kick peers.");
  }
  async broadcastMessage(type, payload) {
    DyteTelemetry.addEventInCurrentSpan("info", "DyteParticipants::broadcastMessage");
    if (!(type == null ? void 0 : type.trim())) {
      throw new DyteError("`type` must be a non-empty string.");
    }
    __privateGet(this, _roomNodeClient4).broadcastMessage(type, payload);
  }
  async acceptAllRequestToJoinStageRequests(acceptJoinStageRequests) {
    __privateGet(this, _roomNodeClient4).acceptAllRequestToJoinStage(acceptJoinStageRequests);
  }
}
_roomNodeClient4 = new WeakMap();
_self2 = new WeakMap();
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.setViewMode")
], DyteParticipants.prototype, "setViewMode", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.setPage")
], DyteParticipants.prototype, "setPage", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.disableAllAudio")
], DyteParticipants.prototype, "disableAllAudio", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.disableAllVideo")
], DyteParticipants.prototype, "disableAllVideo", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.disablePeerAudio")
], DyteParticipants.prototype, "disableAudio", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.disablePeerVideo")
], DyteParticipants.prototype, "disableVideo", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.kickPeer")
], DyteParticipants.prototype, "kick", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.kickAll")
], DyteParticipants.prototype, "kickAll", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.broadcastMessage")
], DyteParticipants.prototype, "broadcastMessage", 1);
__decorateClass$f([
  DyteTelemetry.trace("DyteParticipants.acceptAllRequestToJoinStageRequests")
], DyteParticipants.prototype, "acceptAllRequestToJoinStageRequests", 1);
var __defProp$e = Object.defineProperty;
var __getOwnPropDesc$e = Object.getOwnPropertyDescriptor;
var __decorateClass$e = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$e(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$e(target, key, result);
  return result;
};
class ParticipantController {
  constructor(roomNodeClient, self2) {
    __publicField(this, "participants");
    __privateAdd(this, _roomNodeClient5, void 0);
    __privateAdd(this, _self3, void 0);
    __privateAdd(this, _consumerPeerMap, void 0);
    __privateSet(this, _roomNodeClient5, roomNodeClient);
    this.participants = new DyteParticipants(roomNodeClient, self2);
    __privateSet(this, _consumerPeerMap, new Map());
    __privateSet(this, _self3, self2);
    this.setupEvents();
  }
  updatePageParticipants(peerIds) {
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::updatePageParticipants", {
      peerIds: JSON.stringify(peerIds)
    });
    const activePeers = new Map(this.participants.active);
    this.participants.active.forEach((_, participantId) => {
      this.participants.active.delete(participantId, !peerIds.includes(participantId));
    });
    peerIds.forEach((peerId) => {
      if (!this.participants.joined.get(peerId)) {
        DyteTelemetry.addEventInCurrentSpan("warn", "updatePageParticipants::participant_not_in_joined_list", {
          peerId
        });
        return;
      }
      this.participants.active.add(this.participants.joined.get(peerId), !activePeers.get(peerId));
    });
  }
  updatePinnedParticipants() {
    this.participants.pinned.forEach((p) => {
      p.setIsPinned(false);
      this.participants.pinned.delete(p.id);
    });
  }
  updateActiveParticipants(peerIds) {
    if (!__privateGet(this, _roomNodeClient5).roomJoined) {
      DyteTelemetry.addEventInCurrentSpan("info", "Skipped::ParticipantController::updateActiveParticipants", {
        peerIds: JSON.stringify(peerIds),
        roomJoined: __privateGet(this, _roomNodeClient5).roomJoined
      });
      return;
    }
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::updateActiveParticipants", {
      peerIds: JSON.stringify(peerIds)
    });
    const activePeerIds = Array.from(this.participants.active.keys());
    const activePeers = new Map(this.participants.active);
    const peerIdMap = {};
    peerIds.forEach((peerId) => {
      peerIdMap[peerId] = true;
    });
    const replaceableIndices = [];
    activePeerIds.forEach((activePeerId, index) => {
      if (!peerIdMap[activePeerId] || !this.participants.joined.get(activePeerId)) {
        replaceableIndices.push(index);
      }
    });
    peerIds.forEach((peerId) => {
      if (!activePeers.get(peerId)) {
        if (activePeerIds.length < peerIds.length) {
          activePeerIds.push(peerId);
        } else {
          activePeerIds[replaceableIndices.shift()] = peerId;
        }
      }
    });
    activePeerIds.forEach((peerId, index) => {
      if (!peerIdMap[peerId]) {
        activePeerIds.splice(index, 1);
      }
    });
    Array.from(this.participants.active.keys()).forEach((peerId) => {
      this.participants.active.delete(peerId, !peerIdMap[peerId]);
    });
    activePeerIds.forEach((peerId) => {
      if (!this.participants.joined.get(peerId)) {
        DyteTelemetry.addEventInCurrentSpan("warn", "updateActiveParticipants::participant_not_in_joined_list", { peerId });
        return;
      }
      this.participants.active.add(this.participants.joined.get(peerId), !activePeers.get(peerId));
    });
    this.updateWebinarStatusForJoinedParticipants(peerIds);
    DyteTelemetry.addEventInCurrentSpan("info", "updateActiveParticipants::refreshed_participants");
    this.participants.active.emit("participantsUpdate");
  }
  setupEvents() {
    SessionStore.on(SessionEvents.PEER_JOINED, async (p) => {
      var _a3, _b2;
      const participant = new DyteParticipant(p, __privateGet(this, _self3), __privateGet(this, _roomNodeClient5));
      DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::peer_joined", { info: JSON.stringify(p, null, 4) });
      if (__privateGet(this, _self3).id !== participant.id && !((_a3 = p.flags) == null ? void 0 : _a3.recorder) && !((_b2 = participant.flags) == null ? void 0 : _b2.hidden_participant)) {
        this.participants.joined.add(participant);
        this.participants.waitlisted.delete(participant.id);
        if (this.participants.currentPage === this.participants.pageCount) {
          SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet(this, _roomNodeClient5).getPage(this.participants.currentPage)).payload);
        }
      }
    });
    SessionStore.on(SessionEvents.WAITLIST_PEER_ADDED, ({ id, name }) => {
      this.participants.waitlisted.add(new DyteParticipant({
        id,
        displayName: name,
        audioMuted: true,
        videoEnabled: false,
        audioTrack: void 0,
        videoTrack: void 0,
        userId: void 0,
        flags: {},
        isHost: false
      }, __privateGet(this, _self3), __privateGet(this, _roomNodeClient5)));
    });
    SessionStore.on(SessionEvents.WAITLIST_PEER_REMOVED, ({ id }) => {
      this.participants.waitlisted.delete(id);
    });
    SessionStore.on(SessionEvents.ROOM_JOINED, (payload) => {
      DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::room_joined", { info: JSON.stringify(payload, null, 4) });
      payload.peers.forEach((participant) => {
        var _a3, _b2;
        if (((_a3 = participant.flags) == null ? void 0 : _a3.recorder) || ((_b2 = participant.flags) == null ? void 0 : _b2.hidden_participant))
          return;
        const p = new DyteParticipant(participant, __privateGet(this, _self3), __privateGet(this, _roomNodeClient5));
        if (p.id === payload.pinnedPeerId) {
          p.setIsPinned(true, false);
          this.participants.pinned.add(p);
        }
        this.participants.joined.add(p);
      });
      if (payload.requestToJoinPeersList) {
        payload.requestToJoinPeersList.forEach(({ id }) => {
          var _a3;
          (_a3 = this.participants.joined.get(id)) == null ? void 0 : _a3.setWebinarStageStatus(WebinarStageStatus.REQUESTED_TO_JOIN_STAGE);
        });
      }
      __privateGet(this, _roomNodeClient5).getPage(this.participants.currentPage);
    });
    SessionStore.on(SessionEvents.PEER_CLOSED, async ({ id }) => {
      var _a3, _b2;
      this.participants.joined.delete(id, true, true);
      this.participants.pinned.delete(id, true, true);
      const { currentPage } = this.participants;
      let maxPreferredStreams = 9;
      if (constants.isV2AuthToken) {
        const maxVideoStreamsV2 = __privateGet(this, _self3).suggestedTheme.maxVideoStreams;
        maxPreferredStreams = browserSpecs.isMobile() ? maxVideoStreamsV2.mobile : maxVideoStreamsV2.desktop;
      } else {
        maxPreferredStreams = (_b2 = (_a3 = __privateGet(this, _self3).suggestedTheme.grid) == null ? void 0 : _a3.multi) == null ? void 0 : _b2.maxVideoCount;
      }
      const peersNeededToSustainCurrentPage = maxPreferredStreams * (currentPage - 1);
      const isActive = this.participants.active.get(id);
      if (peersNeededToSustainCurrentPage === 0) {
        this.participants.setViewMode("ACTIVE_GRID");
      } else if (this.participants.joined.size <= peersNeededToSustainCurrentPage) {
        if (currentPage === 2) {
          this.participants.setViewMode("ACTIVE_GRID");
        } else {
          this.participants.setPage(currentPage - 1);
        }
      } else if (isActive) {
        SessionStore.emit(SessionEvents.GET_PAGE, (await __privateGet(this, _roomNodeClient5).getPage(currentPage)).payload);
      }
    });
    SessionStore.on(SessionEvents.ROOM_NODE_DISCONNECTED, () => {
      Array.from(this.participants.joined.keys()).forEach((participantId) => {
        this.participants.joined.delete(participantId);
      });
      Array.from(this.participants.active.keys()).forEach((participantId) => {
        this.participants.active.delete(participantId);
      });
      Array.from(this.participants.pinned.keys()).forEach((participantId) => {
        this.participants.pinned.delete(participantId);
      });
      this.participants.currentPage = 0;
      this.participants.viewMode = "ACTIVE_GRID";
      this.participants.emit("viewModeChanged", {
        viewMode: "ACTIVE_GRID",
        currentPage: this.participants.currentPage,
        pageCount: this.participants.pageCount
      });
    });
    SessionStore.on(SessionEvents.PEER_MUTED, ({ peerId }) => {
      const participant = this.participants.joined.get(peerId);
      const emitEvent = !(dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.SUPPRESS_PEER_MUTE_UNMUTE_EMITS) === true);
      if (participant)
        participant.setAudioEnabled(false, emitEvent);
    });
    SessionStore.on(SessionEvents.PEER_UNMUTED, ({ peerId }) => {
      const participant = this.participants.joined.get(peerId);
      const emitEvent = !(dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.SUPPRESS_PEER_MUTE_UNMUTE_EMITS) === true);
      if (participant)
        participant.setAudioEnabled(true, emitEvent);
    });
    SessionStore.on(SessionEvents.CONSUMER_PAUSED, ({ id: consumerId }) => {
      this.processConsumerPaused(consumerId);
    });
    SessionStore.on(SessionEvents.CONSUMER_RESUMED, ({ id: consumerId }) => {
      this.processConsumerResumed(consumerId);
    });
    SessionStore.on(SessionEvents.NEW_CONSUMER, ({ id: consumerId }) => {
      this.processNewConsumer(consumerId);
    });
    SessionStore.on(SessionEvents.CONSUMER_CLOSED, ({ id: consumerId }) => {
      this.processConsumerClosed(consumerId);
    });
    SessionStore.on(SessionEvents.GET_PAGE, ({ peerIds }) => {
      if (this.participants.viewMode !== "PAGINATED") {
        return;
      }
      this.updatePageParticipants(peerIds);
    });
    SessionStore.on(SessionEvents.SELECTED_PEERS, ({ peerIds }) => {
      if (this.participants.viewMode !== "ACTIVE_GRID") {
        return;
      }
      this.updateActiveParticipants(peerIds);
    });
    SessionStore.on(SessionEvents.ACTIVE_SPEAKER, ({ peerId, volume }) => {
      this.participants.lastActiveSpeaker = peerId;
      this.participants.emit("activeSpeaker", { peerId, volume });
    });
    SessionStore.on(SessionEvents.ROOM_MESSAGE, async ({ payload, type }) => {
      this.participants.emit("broadcastedMessage", { type, payload });
    });
    SessionStore.on(SessionEvents.LOW_CONSUMER_SCORE, ({ peerId, score, kind }) => {
      const participant = this.participants.joined.get(peerId);
      participant.emit("poorConnection", { score, kind });
      this.participants.emit("poorConnection", { participantId: peerId, score, kind });
    });
    SessionStore.on(SessionEvents.PEER_PINNED, ({ peerId }) => {
      if (!peerId) {
        if (__privateGet(this, _self3).isPinned)
          __privateGet(this, _self3).setIsPinned(false);
        if (this.participants.pinned.size !== 0) {
          this.updatePinnedParticipants();
        }
        return;
      }
      if (peerId === __privateGet(this, _self3).id) {
        if (this.participants.pinned.size !== 0) {
          this.updatePinnedParticipants();
        }
        __privateGet(this, _self3).setIsPinned(true);
        return;
      }
      const peer = this.participants.joined.get(peerId);
      if (__privateGet(this, _self3).isPinned)
        __privateGet(this, _self3).setIsPinned(false);
      this.updatePinnedParticipants();
      peer.setIsPinned(true);
      this.participants.pinned.add(peer);
    });
    SessionStore.on(SessionEvents.PEER_REQUESTED_TO_JOIN_STAGE, ({ id }) => {
      const participant = this.participants.joined.get(id);
      participant == null ? void 0 : participant.setWebinarStageStatus(WebinarStageStatus.REQUESTED_TO_JOIN_STAGE);
    });
    SessionStore.on(SessionEvents.PEER_REJECTED_TO_JOIN_STAGE, ({ id }) => {
      const participant = this.participants.joined.get(id);
      participant == null ? void 0 : participant.setWebinarStageStatus(WebinarStageStatus.OFF_STAGE);
    });
    SessionStore.on(SessionEvents.PEER_ADDED_TO_STAGE, ({ id }) => {
      const participant = this.participants.joined.get(id);
      participant == null ? void 0 : participant.setWebinarStageStatus(WebinarStageStatus.ACCEPTED_TO_JOIN_STAGE);
    });
    SessionStore.on(SessionEvents.PEER_REMOVED_FROM_STAGE, ({ id }) => {
      const participant = this.participants.joined.get(id);
      participant == null ? void 0 : participant.setWebinarStageStatus(WebinarStageStatus.OFF_STAGE);
    });
    SessionStore.on(SessionEvents.PEER_STARTED_PRESENTING, ({ id }) => {
      const participant = this.participants.joined.get(id);
      participant == null ? void 0 : participant.setWebinarStageStatus(WebinarStageStatus.ON_STAGE);
    });
    SessionStore.on(SessionEvents.PEER_STOPPED_PRESENTING, ({ id }) => {
      const participant = this.participants.joined.get(id);
      participant == null ? void 0 : participant.setWebinarStageStatus(WebinarStageStatus.OFF_STAGE);
    });
  }
  processMedia(consumerId) {
    var _a3;
    const consumers = __privateGet(this, _roomNodeClient5).getConsumers();
    const {
      peerId,
      kind,
      appData: untypedAppData,
      remotelyPaused,
      track
    } = (_a3 = consumers.get(consumerId)) != null ? _a3 : {};
    if (peerId)
      log.warn("Peer ID is undefined.");
    const appData = untypedAppData;
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processMedia", {
      consumerId,
      peerId,
      kind,
      appData,
      remotelyPaused
    });
    __privateGet(this, _consumerPeerMap).set(consumerId, {
      type: kind,
      peerId,
      appData
    });
    return {
      peerId,
      kind,
      appData,
      remotelyPaused,
      track
    };
  }
  processConsumerClosed(consumerId) {
    const { peerId, type, appData } = __privateGet(this, _consumerPeerMap).get(consumerId) || {};
    const participant = this.participants.joined.get(peerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerClosed", {
      consumerId,
      peerId,
      type,
      appData
    });
    __privateGet(this, _consumerPeerMap).delete(consumerId);
    if (!participant)
      return;
    if (appData && appData.screenShare) {
      participant.setScreenShareEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { screen: false });
      participant.screenShareTracks = {
        audio: void 0,
        video: void 0
      };
      return;
    }
    if (type === "audio") {
      participant.setAudioEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { audio: false });
      participant.audioTrack = void 0;
    } else if (type === "video") {
      participant.setVideoEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { video: false });
      participant.videoTrack = void 0;
    }
  }
  processConsumerResumed(consumerId) {
    const {
      peerId,
      kind,
      appData,
      track
    } = this.processMedia(consumerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerResumed", {
      consumerId,
      peerId,
      kind,
      appData
    });
    const participant = this.participants.joined.get(peerId);
    if (!participant)
      return;
    if (appData.screenShare) {
      if (kind === "video") {
        participant.screenShareTracks.video = track;
      } else if (kind === "audio") {
        participant.screenShareTracks.audio = track;
      }
      participant.setScreenShareEnabled(true);
      callStats.consumerSharedMediaState(consumerId, { screen: true });
      return;
    }
    if (kind === "video") {
      participant.videoTrack = track;
      participant.setVideoEnabled(true);
      callStats.consumerSharedMediaState(consumerId, { video: true });
    } else if (kind === "audio") {
      participant.audioTrack = track;
      participant.setAudioEnabled(participant.audioEnabled);
      callStats.consumerSharedMediaState(consumerId, { audio: participant.audioEnabled });
    }
  }
  processConsumerPaused(consumerId) {
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerPaused", {
      consumerId
    });
    const {
      peerId,
      kind,
      track,
      appData
    } = this.processMedia(consumerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processConsumerPaused", {
      consumerId,
      peerId,
      kind,
      appData
    });
    const participant = this.participants.joined.get(peerId);
    if (!participant)
      return;
    if (kind === "video") {
      participant.videoTrack = track;
      participant.setVideoEnabled(false);
      callStats.consumerSharedMediaState(consumerId, { video: false });
    } else if (kind === "audio") {
      participant.audioTrack = track;
      participant.setAudioEnabled(participant.audioEnabled);
      callStats.consumerSharedMediaState(consumerId, { audio: participant.audioEnabled });
    }
  }
  processNewConsumer(consumerId) {
    const {
      peerId,
      kind,
      remotelyPaused,
      track,
      appData
    } = this.processMedia(consumerId);
    DyteTelemetry.addEventInCurrentSpan("info", "ParticipantController::processNewConsumer", {
      consumerId,
      peerId,
      kind,
      remotelyPaused,
      appData
    });
    const participant = this.participants.joined.get(peerId);
    if (!participant)
      return;
    if (appData.screenShare) {
      if (kind === "video") {
        participant.screenShareTracks.video = track;
      } else if (kind === "audio") {
        participant.screenShareTracks.audio = track;
      }
      if (!remotelyPaused) {
        participant.setScreenShareEnabled(true);
      }
      if (appData.supportsRemoteControl) {
        participant.supportsRemoteControl = true;
      }
      return;
    }
    if (kind === "video") {
      participant.videoTrack = track;
      if (!remotelyPaused) {
        participant.setVideoEnabled(true);
      }
      callStats.consumerSharedMediaState(consumerId, { video: !remotelyPaused });
    }
  }
  updateWebinarStatusForJoinedParticipants(peerIds) {
    peerIds.forEach((peerId) => {
      const peer = this.participants.joined.get(peerId);
      if (peer)
        peer.webinarStageStatus = WebinarStageStatus.ON_STAGE;
    });
  }
}
_roomNodeClient5 = new WeakMap();
_self3 = new WeakMap();
_consumerPeerMap = new WeakMap();
__decorateClass$e([
  DyteTelemetry.trace("updatePageParticipants")
], ParticipantController.prototype, "updatePageParticipants", 1);
__decorateClass$e([
  DyteTelemetry.trace("updateActiveParticipants")
], ParticipantController.prototype, "updateActiveParticipants", 1);
__decorateClass$e([
  DyteTelemetry.trace("ParticipantController.setupEvents")
], ParticipantController.prototype, "setupEvents", 1);
__decorateClass$e([
  DyteTelemetry.trace("processMedia")
], ParticipantController.prototype, "processMedia", 1);
__decorateClass$e([
  DyteTelemetry.trace("processConsumerClosed")
], ParticipantController.prototype, "processConsumerClosed", 1);
__decorateClass$e([
  DyteTelemetry.trace("processConsumerResumed")
], ParticipantController.prototype, "processConsumerResumed", 1);
__decorateClass$e([
  DyteTelemetry.trace("processConsumerPaused")
], ParticipantController.prototype, "processConsumerPaused", 1);
__decorateClass$e([
  DyteTelemetry.trace("processNewConsumer")
], ParticipantController.prototype, "processNewConsumer", 1);
__decorateClass$e([
  DyteTelemetry.trace("updateWebinarStatusForJoinedParticipants")
], ParticipantController.prototype, "updateWebinarStatusForJoinedParticipants", 1);
class DyteMeta extends DyteEventEmitter {
  constructor(roomNodeClient, self2, viewType) {
    super();
    __privateAdd(this, _roomNodeClient6, void 0);
    __privateAdd(this, _self4, void 0);
    __publicField(this, "viewType");
    __publicField(this, "meetingStartedTimestamp");
    __privateSet(this, _roomNodeClient6, roomNodeClient);
    __privateSet(this, _self4, self2);
    this.viewType = viewType;
  }
  get joined() {
    return __privateGet(this, _roomNodeClient6).roomJoined;
  }
  get roomName() {
    return __privateGet(this, _roomNodeClient6).roomName;
  }
  get meetingTitle() {
    return __privateGet(this, _roomNodeClient6).meetingTitle;
  }
}
_roomNodeClient6 = new WeakMap();
_self4 = new WeakMap();
var __defProp$d = Object.defineProperty;
var __getOwnPropDesc$d = Object.getOwnPropertyDescriptor;
var __decorateClass$d = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$d(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$d(target, key, result);
  return result;
};
class MetaController {
  constructor(roomNodeClient, self2) {
    __publicField(this, "meta");
    this.meta = new DyteMeta(roomNodeClient, self2, constants.isV2AuthToken ? "GROUPCALL" : self2.permissions.viewType);
    this.setupEvents();
  }
  get roomName() {
    return this.meta.roomName;
  }
  setupEvents() {
    SessionStore.on(SessionEvents.ROOM_JOINED, (response) => {
      this.meta.meetingStartedTimestamp = new Date(response.startedAt);
    });
    SessionStore.on(SessionEvents.ROOM_NODE_CONNECTED, () => {
      this.meta.emit("connected");
    });
    SessionStore.on(SessionEvents.ROOM_NODE_DISCONNECTED, () => {
      this.meta.emit("disconnected");
    });
    SessionStore.on(SessionEvents.LOW_PRODUCER_SCORE, () => {
      this.meta.emit("poorConnection");
    });
  }
}
__decorateClass$d([
  DyteTelemetry.trace("MetaController.setupEvents")
], MetaController.prototype, "setupEvents", 1);
const localPluginEvents = {
  getPeer: 14,
  getPeers: 15,
  chatMessage: 16,
  getRoomName: 17,
  getDisplayTitle: 18,
  getPluginInitiator: 19,
  customPluginEventToParent: 20,
  peerJoined: 22,
  peerLeft: 23,
  sendData: 24
};
class DytePlugin extends DyteEventEmitter {
  constructor({
    baseURL,
    createdAt,
    description,
    id,
    name,
    organizationId,
    picture,
    private: isPrivate,
    published,
    staggered,
    tags,
    type,
    updatedAt
  }, pluginSocketHandler, roomNodeClient, socketServerName, self2, participants, chat) {
    super();
    __privateAdd(this, _pluginSocketHandler, void 0);
    __privateAdd(this, _roomNodeClient7, void 0);
    __privateAdd(this, _socketServerName, void 0);
    __publicField(this, "baseURL");
    __publicField(this, "createdAt");
    __publicField(this, "description");
    __publicField(this, "id");
    __publicField(this, "name");
    __privateAdd(this, _self5, void 0);
    __privateAdd(this, _participants, void 0);
    __privateAdd(this, _chat, void 0);
    __publicField(this, "organizationId");
    __publicField(this, "picture");
    __publicField(this, "private");
    __publicField(this, "published");
    __publicField(this, "staggered");
    __publicField(this, "tags");
    __publicField(this, "type");
    __publicField(this, "updatedAt");
    __publicField(this, "config");
    __privateAdd(this, _authToken, void 0);
    __publicField(this, "active");
    __publicField(this, "iframes");
    __publicField(this, "enabledBy");
    this.baseURL = baseURL;
    this.createdAt = new Date(createdAt);
    this.description = description;
    this.id = id;
    this.name = name;
    __privateSet(this, _self5, self2);
    this.organizationId = organizationId;
    this.picture = picture;
    this.private = isPrivate;
    this.published = published;
    this.staggered = staggered;
    this.tags = tags;
    this.type = type;
    this.updatedAt = new Date(updatedAt);
    this.active = false;
    this.iframes = new Map();
    __privateSet(this, _pluginSocketHandler, pluginSocketHandler);
    __privateSet(this, _roomNodeClient7, roomNodeClient);
    __privateSet(this, _socketServerName, socketServerName);
    __privateSet(this, _participants, participants);
    __privateSet(this, _chat, chat);
    this.enabledBy = "";
  }
  sendIframeEvent(message) {
    if (!this.iframes.size) {
      return;
    }
    [...this.iframes.keys()].forEach((viewId) => {
      const { iframe } = this.iframes.get(viewId);
      if (!iframe)
        return;
      log.info(`Sending message to plugin ${this.id}`, message, iframe);
      iframe.contentWindow.postMessage(message, "*");
    });
  }
  async handleIframeMessage(iframeMessage) {
    var _a3, _b2;
    let response;
    if (__privateGet(this, _socketServerName) === "socket-service") {
      const message2 = iframeMessage;
      const { payload, uuid, type } = message2;
      switch (type) {
        case pluginEvents.customPluginEventToRoom: {
          __privateGet(this, _pluginSocketHandler).customPluginEventToRoom(this.id, payload, uuid);
          break;
        }
        case pluginEvents.customPluginEventToPeers: {
          __privateGet(this, _pluginSocketHandler).customPluginEventToPeers(this.id, payload, payload.peerIds, uuid);
          break;
        }
        case pluginEvents.enablePluginForRoom: {
          __privateGet(this, _pluginSocketHandler).enablePluginForRoom(this.id, uuid);
          break;
        }
        case pluginEvents.enablePluginForPeers: {
          __privateGet(this, _pluginSocketHandler).enablePluginForPeers(this.id, payload.peerIds, uuid);
          break;
        }
        case pluginEvents.disablePluginForRoom: {
          __privateGet(this, _pluginSocketHandler).disablePluginForRoom(this.id, uuid);
          break;
        }
        case pluginEvents.disablePluginForPeers: {
          __privateGet(this, _pluginSocketHandler).disablePluginForPeers(this.id, payload.peerIds, uuid);
          break;
        }
        case pluginEvents.storeInsertKeys: {
          __privateGet(this, _pluginSocketHandler).storeInsertKeys(this.id, payload.store, payload.insertKeys, uuid);
          break;
        }
        case pluginEvents.storeGetKeys: {
          __privateGet(this, _pluginSocketHandler).storeGetKeys(this.id, payload.store, payload.getKeys, uuid);
          break;
        }
        case pluginEvents.storeDeleteKeys: {
          __privateGet(this, _pluginSocketHandler).storeDeleteKeys(this.id, payload.store, payload.deleteKeys, uuid);
          break;
        }
        case pluginEvents.storeDelete: {
          __privateGet(this, _pluginSocketHandler).storeDelete(this.id, payload.store, uuid);
          break;
        }
        case localPluginEvents.chatMessage: {
          const {
            messagePayload,
            peerIds
          } = payload;
          if (!__privateGet(this, _chat)) {
            this.sendIframeEvent({
              type: localPluginEvents.chatMessage,
              uuid: message2.uuid,
              payload: { error: "Chat is disabled for this room." }
            });
            return;
          }
          try {
            await __privateGet(this, _chat).sendMessage(messagePayload, peerIds);
            this.sendIframeEvent({
              type: localPluginEvents.chatMessage,
              uuid: message2.uuid,
              payload: { success: true }
            });
          } catch (e) {
            this.sendIframeEvent({
              type: localPluginEvents.chatMessage,
              uuid: message2.uuid,
              payload: {
                error: e
              }
            });
          }
          break;
        }
        case localPluginEvents.getPeer: {
          let peer;
          const { peerId } = payload;
          if (peerId) {
            peer = __privateGet(this, _participants).joined.get(payload.peerId);
            if (__privateGet(this, _self5).id === peerId)
              peer = __privateGet(this, _self5);
          } else
            peer = __privateGet(this, _self5);
          this.sendIframeEvent({
            type: localPluginEvents.getPeer,
            payload: { peer: peer && postMessageSanitizer(peer) },
            uuid: message2.uuid
          });
          break;
        }
        case localPluginEvents.getPeers: {
          const peers = __privateGet(this, _participants).joined.toArray().map((p) => postMessageSanitizer(p));
          this.sendIframeEvent({
            type: localPluginEvents.getPeers,
            payload: { peers },
            uuid: message2.uuid
          });
          break;
        }
        case localPluginEvents.getPluginInitiator: {
          this.sendIframeEvent({
            type: localPluginEvents.getPluginInitiator,
            payload: { enabledBy: this.enabledBy },
            uuid: message2.uuid
          });
          break;
        }
        case localPluginEvents.getDisplayTitle: {
          this.sendIframeEvent({
            type: localPluginEvents.getDisplayTitle,
            payload: { displayTitle: __privateGet(this, _roomNodeClient7).meetingTitle },
            uuid: message2.uuid
          });
          break;
        }
        case localPluginEvents.getRoomName: {
          this.sendIframeEvent({
            type: localPluginEvents.getRoomName,
            payload: { roomName: __privateGet(this, _roomNodeClient7).roomName },
            uuid: message2.uuid
          });
          break;
        }
        case localPluginEvents.customPluginEventToParent: {
          this.emit(message2.payload.eventName, message2.payload.data);
          break;
        }
      }
      return;
    }
    const getEnabledByPeerId = (enabledBy, peers) => {
      if (__privateGet(this, _self5).userId === enabledBy)
        return __privateGet(this, _self5).id;
      let enabledById;
      peers.forEach((p) => {
        if (p.userId === enabledBy)
          enabledById = p.id;
      });
      return enabledById;
    };
    const message = iframeMessage;
    switch (message.type) {
      case "pluginEvent":
      case "storePluginData":
      case "getPluginData":
      case "enablePluginForAll":
      case "enablePluginForUser":
      case "disablePluginForUser":
      case "chatMessage": {
        response = await __privateGet(this, _roomNodeClient7).sendMessage(message);
        this.sendIframeEvent(response);
        break;
      }
      case "getJoinedPeers": {
        response = await __privateGet(this, _roomNodeClient7).getRoomState();
        this.sendIframeEvent({
          type: "websocket/get-joined-peers",
          payload: __spreadProps(__spreadValues({}, message.payload), {
            peers: response.payload.roomState.peers
          })
        });
        break;
      }
      case "getPeerInfo": {
        response = await __privateGet(this, _roomNodeClient7).sendMessage({
          type: message.type,
          payload: __spreadProps(__spreadValues({}, message.payload), {
            peerId: (_b2 = (_a3 = message.payload) == null ? void 0 : _a3.peerId) != null ? _b2 : __privateGet(this, _self5).id
          })
        });
        this.sendIframeEvent(response);
        break;
      }
      case "getRoomState": {
        response = await __privateGet(this, _roomNodeClient7).getRoomState();
        const { plugins, peers } = response.payload.roomState;
        const { enabledBy } = plugins.find((x) => x.id === this.id);
        const enabledByPeerId = getEnabledByPeerId(enabledBy, peers);
        this.sendIframeEvent({
          type: "websocket/get-room-state",
          payload: __spreadProps(__spreadValues({}, message.payload), {
            roomName: response.payload.roomState.roomName,
            pluginInitiatorPeerId: enabledByPeerId,
            pluginInitiatorUserId: enabledBy,
            peers: response.payload.roomState.peers,
            displayTitle: response.payload.roomState.displayTitle,
            roomUUID: response.payload.roomState.roomUUID,
            currentPeer: __privateGet(this, _self5).id
          })
        });
        break;
      }
      case "getPluginInitiatorId": {
        response = await __privateGet(this, _roomNodeClient7).getRoomState();
        const { plugins, peers } = response.payload.roomState;
        const { enabledBy } = plugins.find((x) => x.id === this.id);
        const enabledByPeerId = getEnabledByPeerId(enabledBy, peers);
        this.sendIframeEvent({
          type: "websocket/get-plugin-initiator-peer-id",
          payload: __spreadProps(__spreadValues({}, message.payload), {
            pluginInitiatorPeerId: enabledByPeerId
          })
        });
        break;
      }
      case "getPluginInitiatorUserId": {
        response = await __privateGet(this, _roomNodeClient7).getRoomState();
        const { plugins } = response.payload.roomState;
        const { enabledBy } = plugins.find((x) => x.id === this.id);
        this.sendIframeEvent({
          type: "websocket/get-plugin-initiator-user-id",
          payload: __spreadProps(__spreadValues({}, message.payload), {
            pluginInitiatorUserId: enabledBy
          })
        });
        break;
      }
      case "pluginEventToParent": {
        this.emit(message.payload.eventName, message.payload.data);
        break;
      }
    }
  }
  sendData(data) {
    if (__privateGet(this, _socketServerName) === "socket-service") {
      this.sendIframeEvent({
        type: localPluginEvents.sendData,
        uuid: "",
        payload: data
      });
      return;
    }
    this.sendIframeEvent({
      type: SessionEvents.PLUGIN_INTERNAL_DATA,
      payload: {
        pluginId: this.id,
        data
      }
    });
  }
  removePluginView(viewId = "default") {
    var _a3;
    const { iframe, listener } = (_a3 = this.iframes.get(viewId)) != null ? _a3 : {};
    if (iframe || listener) {
      window.removeEventListener("message", listener);
      this.iframes.delete(viewId);
    }
  }
  addPluginView(iframe, viewId = "default") {
    if (!__privateGet(this, _authToken)) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePlugin::addPluginView::no_auth_token_set_for_plugin");
      throw new DyteError("No auth token set for plugin.");
    }
    if (!iframe) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePlugin::addPluginView::iframe_was_not_provided");
      throw new DyteError("Iframe was not provided.");
    }
    this.removePluginView(viewId);
    const iframeElement = iframe;
    const url = new URL(this.baseURL);
    const params = {
      auth: __privateGet(this, _authToken),
      parent: window.location.origin,
      backend: config.apiBase,
      pluginId: this.id
    };
    Object.keys(params).forEach((param) => {
      url.searchParams.set(param, params[param]);
    });
    iframeElement.src = url.href;
    iframeElement.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframeElement.title = viewId;
    const listener = async (message) => {
      if (message.source === iframe.contentWindow) {
        await this.handleIframeMessage(message.data);
      }
    };
    window.addEventListener("message", listener);
    this.iframes.set(viewId, { iframe: iframeElement, listener });
  }
  setActive(active) {
    var _a3, _b2;
    this.active = active;
    if (active) {
      this.emit("stateUpdate", {
        active: this.active,
        pluginId: this.id,
        bind: this.addPluginView.bind(this),
        views: (_a3 = this.config) == null ? void 0 : _a3.views
      });
      return;
    }
    this.active = false;
    this.emit("stateUpdate", {
      active: this.active,
      pluginId: this.id,
      views: (_b2 = this.config) == null ? void 0 : _b2.views
    });
  }
  async activateForSelf() {
    const APIClient2 = getAPIClient();
    const authToken = await APIClient2.authorizePlugin(this.id);
    __privateSet(this, _authToken, authToken);
    try {
      const pluginConfig = await APIClient2.getPluginConfig(this.baseURL);
      this.config = pluginConfig;
    } catch (err) {
      log.error(err);
    }
    this.setActive(true);
  }
  deactivateForSelf() {
    [...this.iframes.keys()].forEach((viewId) => {
      this.removePluginView(viewId);
    });
    this.iframes.clear();
    this.setActive(false);
    this.emit("closed");
  }
  async enable() {
    return this.activateForSelf();
  }
  disable() {
    return this.deactivateForSelf();
  }
  async activate() {
    var _a3, _b2;
    if (!((_b2 = (_a3 = __privateGet(this, _self5).permissions) == null ? void 0 : _a3.plugins) == null ? void 0 : _b2.canStart)) {
      return;
    }
    if (__privateGet(this, _socketServerName) === "socket-service") {
      __privateGet(this, _pluginSocketHandler).addPlugin(this.id, this.staggered);
      return;
    }
    await __privateGet(this, _roomNodeClient7).addRoomPlugin(this);
  }
  async deactivate() {
    var _a3, _b2;
    if (!((_b2 = (_a3 = __privateGet(this, _self5).permissions) == null ? void 0 : _a3.plugins) == null ? void 0 : _b2.canClose)) {
      return;
    }
    if (__privateGet(this, _socketServerName) === "socket-service") {
      __privateGet(this, _pluginSocketHandler).removePlugin(this.id);
      return;
    }
    await __privateGet(this, _roomNodeClient7).removeRoomPlugin(this);
  }
}
_pluginSocketHandler = new WeakMap();
_roomNodeClient7 = new WeakMap();
_socketServerName = new WeakMap();
_self5 = new WeakMap();
_participants = new WeakMap();
_chat = new WeakMap();
_authToken = new WeakMap();
class DytePluginMap extends DyteMap {
  constructor() {
    super({
      onAddEvent: "pluginAdded",
      onDeleteEvent: "pluginDeleted"
    });
  }
  add(plugin, emitEvent = true) {
    return super.add(plugin, emitEvent);
  }
  delete(pluginId, emitEvent = true, removeListeners = false) {
    return super.delete(pluginId, emitEvent, removeListeners);
  }
}
class DytePlugins {
  constructor() {
    __publicField(this, "all");
    __publicField(this, "active");
    this.all = new DytePluginMap();
    this.active = new DytePluginMap();
  }
}
var ChatMessageType;
(function(ChatMessageType2) {
  ChatMessageType2[ChatMessageType2["TEXT"] = 0] = "TEXT";
  ChatMessageType2[ChatMessageType2["IMAGE"] = 1] = "IMAGE";
  ChatMessageType2[ChatMessageType2["FILE"] = 2] = "FILE";
})(ChatMessageType || (ChatMessageType = {}));
class ChatSocketHandler {
  constructor(socketService) {
    __publicField(this, "socket");
    this.socket = socketService;
  }
  getChatMessages() {
    return this.socket.sendMessagePromise(chatEvents.getMessages);
  }
  sendMessageToRoom(message, messageType) {
    const req = {
      payloadType: messageType,
      payload: message
    };
    this.socket.sendMessage(chatEvents.sendMessageToRoom, SendChatMessageToRoomRequest.toBinary(req));
  }
  sendMessageToPeers(message, messageType, peerIds) {
    const req = {
      payloadType: messageType,
      peerIds,
      payload: message
    };
    this.socket.sendMessage(chatEvents.sendMessageToPeers, SendChatMessageToPeersRequest.toBinary(req));
  }
  sendMessage(message, messageType, peerIds) {
    if (peerIds && peerIds.length > 0) {
      this.sendMessageToPeers(message, messageType, peerIds);
      return;
    }
    this.sendMessageToRoom(message, messageType);
  }
  editMessage(chatId, message, messageType, pinned) {
    const req = {
      chatId,
      pinned,
      payloadType: messageType,
      payload: message
    };
    this.socket.sendMessage(chatEvents.editMessage, EditChatMessageRequest.toBinary(req));
  }
  deleteMessage(chatId) {
    this.socket.sendMessage(chatEvents.deleteMessage, DeleteChatMessageRequest.toBinary({ chatId }));
  }
}
var __defProp$c = Object.defineProperty;
var __getOwnPropDesc$c = Object.getOwnPropertyDescriptor;
var __decorateClass$c = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$c(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$c(target, key, result);
  return result;
};
var MessageType$1;
(function(MessageType2) {
  MessageType2["text"] = "text";
  MessageType2["image"] = "image";
  MessageType2["file"] = "file";
  MessageType2["poll"] = "poll";
})(MessageType$1 || (MessageType$1 = {}));
const messageTypes = ["text", "image", "file", "poll"];
class DyteChat extends DyteEventEmitter {
  constructor(chatSocketHandler, roomNodeClient, socketServerName, self2) {
    super();
    __publicField(this, "messages");
    __privateAdd(this, _self6, void 0);
    __privateAdd(this, _chatSocketHandler, void 0);
    __privateAdd(this, _roomNodeClient8, void 0);
    __privateAdd(this, _socketServerName2, void 0);
    __privateSet(this, _chatSocketHandler, chatSocketHandler);
    __privateSet(this, _roomNodeClient8, roomNodeClient);
    __privateSet(this, _socketServerName2, socketServerName);
    __privateSet(this, _self6, self2);
    this.messages = [];
  }
  async sendTextMessage(message, participantIds) {
    var _a3, _b2, _c2, _d2;
    if (!((_b2 = (_a3 = __privateGet(this, _self6).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet(this, _self6).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.text)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendTextMessage::permission_denied");
      return;
    }
    if (!message) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendTextMessage::message_can_not_be_empty");
      return;
    }
    if (__privateGet(this, _socketServerName2) === "socket-service") {
      const peerIds = participantIds;
      if (peerIds && peerIds.length > 0) {
        peerIds.push(__privateGet(this, _self6).id);
      }
      __privateGet(this, _chatSocketHandler).sendMessage(message, ChatMessageType.TEXT, peerIds);
      return;
    }
    const text = {
      userId: __privateGet(this, _self6).userId,
      displayName: __privateGet(this, _self6).name,
      message,
      type: messageTypes.indexOf(MessageType$1.text),
      time: +new Date()
    };
    await __privateGet(this, _roomNodeClient8).sendChatMessage(text);
  }
  async sendImageMessage(image, participantIds) {
    var _a3, _b2, _c2, _d2;
    if (!((_b2 = (_a3 = __privateGet(this, _self6).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet(this, _self6).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::permission_denied");
      return;
    }
    if (!image) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::required_argument_image_can_not_be_empty");
      return;
    }
    const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
    if (!acceptedImageTypes.includes(image.type)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::image_type_not_supported", {
        imageType: image.type
      });
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(image.name);
      await APIClient2.uploadFile(image, putLocation);
      if (__privateGet(this, _socketServerName2) === "socket-service") {
        const peerIds = participantIds;
        if (peerIds && peerIds.length > 0) {
          peerIds.push(__privateGet(this, _self6).id);
        }
        __privateGet(this, _chatSocketHandler).sendMessage(getLocation, ChatMessageType.IMAGE, peerIds);
        return;
      }
      const imageObj = {
        userId: __privateGet(this, _self6).userId,
        displayName: __privateGet(this, _self6).name,
        type: messageTypes.indexOf(MessageType$1.image),
        link: getLocation,
        time: +new Date()
      };
      await __privateGet(this, _roomNodeClient8).sendChatMessage(imageObj);
    } catch (err) {
      throw new DyteError("Error sending image message.");
    }
  }
  async sendFileMessage(file, participantIds) {
    var _a3, _b2, _c2, _d2;
    if (!((_b2 = (_a3 = __privateGet(this, _self6).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet(this, _self6).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::permission_denied");
      return;
    }
    if (!file) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::required_argument_file_can_not_be_empty");
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(file.name);
      await APIClient2.uploadFile(file, putLocation);
      if (__privateGet(this, _socketServerName2) === "socket-service") {
        const peerIds = participantIds;
        if (peerIds && peerIds.length > 0) {
          peerIds.push(__privateGet(this, _self6).id);
        }
        __privateGet(this, _chatSocketHandler).sendMessage(JSON.stringify({
          link: getLocation,
          name: file.name,
          size: file.size
        }), ChatMessageType.FILE, peerIds);
        return;
      }
      const fileObj = {
        userId: __privateGet(this, _self6).userId,
        displayName: __privateGet(this, _self6).name,
        type: messageTypes.indexOf(MessageType$1.file),
        link: getLocation,
        name: file.name,
        size: file.size,
        time: +new Date()
      };
      await __privateGet(this, _roomNodeClient8).sendChatMessage(fileObj);
    } catch (err) {
      throw new DyteError("Error sending file message.");
    }
  }
  async sendMessage(message, participantIds) {
    switch (message.type) {
      case MessageType$1.text:
        await this.sendTextMessage(message.message, participantIds);
        break;
      case MessageType$1.image:
        await this.sendImageMessage(message.image, participantIds);
        break;
      case MessageType$1.file:
        await this.sendFileMessage(message.file, participantIds);
        break;
      default:
        DyteTelemetry.addEventInCurrentSpan("error", "sendMessage::message_type_not_supported", {
          messageType: message.type
        });
        break;
    }
  }
  async editTextMessage(messageId, message) {
    var _a3, _b2, _c2, _d2;
    if (__privateGet(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    if (!((_b2 = (_a3 = __privateGet(this, _self6).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet(this, _self6).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.text)) {
      DyteTelemetry.addEventInCurrentSpan("error", "editTextMessage::permission_denied");
      return;
    }
    if (!message) {
      DyteTelemetry.addEventInCurrentSpan("error", "editTextMessage::message_can_not_be_empty");
      return;
    }
    __privateGet(this, _chatSocketHandler).editMessage(messageId, message, ChatMessageType.TEXT);
  }
  async editImageMessage(messageId, image) {
    var _a3, _b2, _c2, _d2;
    if (__privateGet(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    if (!((_b2 = (_a3 = __privateGet(this, _self6).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet(this, _self6).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "editImageMessage::permission_denied");
      return;
    }
    if (!image) {
      DyteTelemetry.addEventInCurrentSpan("error", "editImageMessage::required_argument_image_can_not_be_empty");
      return;
    }
    const acceptedImageTypes = ["image/gif", "image/jpeg", "image/png"];
    if (!acceptedImageTypes.includes(image.type)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendImageMessage::image_type_not_supported", {
        imageType: image.type
      });
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(image.name);
      await APIClient2.uploadFile(image, putLocation);
      __privateGet(this, _chatSocketHandler).editMessage(messageId, getLocation, ChatMessageType.IMAGE);
    } catch {
      throw new DyteError("Error editing image message.");
    }
  }
  async editFileMessage(messageId, file) {
    var _a3, _b2, _c2, _d2;
    if (__privateGet(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    if (!((_b2 = (_a3 = __privateGet(this, _self6).permissions) == null ? void 0 : _a3.chatPublic) == null ? void 0 : _b2.canSend) || !((_d2 = (_c2 = __privateGet(this, _self6).permissions) == null ? void 0 : _c2.chatPublic) == null ? void 0 : _d2.files)) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::permission_denied");
      return;
    }
    if (!file) {
      DyteTelemetry.addEventInCurrentSpan("error", "sendFileMessage::required_argument_file_can_not_be_empty");
      return;
    }
    try {
      const APIClient2 = getAPIClient();
      const { getLocation, putLocation } = await APIClient2.getPresignedUrls(file.name);
      await APIClient2.uploadFile(file, putLocation);
      __privateGet(this, _chatSocketHandler).editMessage(messageId, JSON.stringify({
        link: getLocation,
        name: file.name,
        size: file.size
      }), ChatMessageType.FILE);
    } catch {
      throw new DyteError("Error editing file message.");
    }
  }
  async editMessage(messageId, message) {
    if (__privateGet(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    switch (message.type) {
      case MessageType$1.text: {
        this.editTextMessage(messageId, message.message);
        break;
      }
      case MessageType$1.image: {
        this.editImageMessage(messageId, message.image);
        break;
      }
      case MessageType$1.file: {
        this.editFileMessage(messageId, message.file);
        break;
      }
      default: {
        DyteTelemetry.addEventInCurrentSpan("error", "editMessage::message_type_not_supported", {
          messageType: message.type
        });
        break;
      }
    }
  }
  async deleteMessage(messageId) {
    if (__privateGet(this, _socketServerName2) !== "socket-service") {
      log.warn("Coming soon!");
      return;
    }
    __privateGet(this, _chatSocketHandler).deleteMessage(messageId);
  }
  getMessagesByUser(userId) {
    return this.messages.filter((message) => message.userId === userId);
  }
  getMessagesByType(type) {
    return this.messages.filter((message) => message.type === type);
  }
  async pin(id) {
    if (__privateGet(this, _socketServerName2) === "socket-service") {
      return;
    }
    await __privateGet(this, _roomNodeClient8).pinChatMessage({ id });
  }
  async unpin(id) {
    if (__privateGet(this, _socketServerName2) === "socket-service") {
      return;
    }
    await __privateGet(this, _roomNodeClient8).unpinChatMessage({ id });
  }
  get pinned() {
    return this.messages.filter((message) => message.pinned);
  }
}
_self6 = new WeakMap();
_chatSocketHandler = new WeakMap();
_roomNodeClient8 = new WeakMap();
_socketServerName2 = new WeakMap();
__decorateClass$c([
  DyteTelemetry.trace("sendTextMessage")
], DyteChat.prototype, "sendTextMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("sendImageMessage")
], DyteChat.prototype, "sendImageMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("sendFileMessage")
], DyteChat.prototype, "sendFileMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("sendMessage")
], DyteChat.prototype, "sendMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("editTextMessage")
], DyteChat.prototype, "editTextMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("editImageMessage")
], DyteChat.prototype, "editImageMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("editFileMessage")
], DyteChat.prototype, "editFileMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("editMessage")
], DyteChat.prototype, "editMessage", 1);
__decorateClass$c([
  DyteTelemetry.trace("deleteMessage")
], DyteChat.prototype, "deleteMessage", 1);
var __defProp$b = Object.defineProperty;
var __getOwnPropDesc$b = Object.getOwnPropertyDescriptor;
var __decorateClass$b = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$b(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$b(target, key, result);
  return result;
};
const _ChatController = (_d = class {
  constructor(chatSocketHandler, roomNodeClient, socketServerName, self2) {
    __publicField(this, "chat");
    __publicField(this, "chatSocketHandler");
    __privateAdd(this, _roomNodeClient9, void 0);
    __privateAdd(this, _socketServerName3, void 0);
    this.chatSocketHandler = chatSocketHandler;
    __privateSet(this, _roomNodeClient9, roomNodeClient);
    __privateSet(this, _socketServerName3, socketServerName);
    this.chat = new DyteChat(chatSocketHandler, roomNodeClient, socketServerName, self2);
    this.setupEvents();
  }
  static async init(chatSocketHandler, roomNodeClient, self2) {
    const flagsmithChatSocketServer = !constants.isV2AuthToken && await dist.globalFlagsmith.getValue(FlagsmithFeatureFlags.CHAT_SOCKET_SERVER);
    DyteTelemetry.addEventInCurrentSpan("debug", `Received flagsmith chat_socket_server: ${flagsmithChatSocketServer}`);
    const socketServerName = flagsmithChatSocketServer === "socket-service" ? "socket-service" : "room-node";
    DyteTelemetry.addEventInCurrentSpan("info", "Using socket server", { socketServerName });
    return new _ChatController(chatSocketHandler, roomNodeClient, socketServerName, self2);
  }
  static formatMessage(message) {
    return __spreadProps(__spreadValues({}, message), {
      time: new Date(message.time),
      type: messageTypes[message.type]
    });
  }
  static formatSocketServiceMessage(sockMessage) {
    const chatMessage = {
      displayName: sockMessage.displayName,
      id: sockMessage.chatId,
      time: +Timestamp.toDate(sockMessage.createdAt),
      type: sockMessage.payloadType,
      isEdited: sockMessage.isEdited,
      userId: sockMessage.userId,
      message: "",
      link: "",
      name: "",
      size: 0
    };
    switch (chatMessage.type) {
      case ChatMessageType.TEXT: {
        chatMessage.message = sockMessage.payload;
        break;
      }
      case ChatMessageType.IMAGE: {
        chatMessage.link = sockMessage.payload;
        break;
      }
      case ChatMessageType.FILE: {
        const { link, name, size } = JSON.parse(sockMessage.payload);
        chatMessage.link = link;
        chatMessage.name = name;
        chatMessage.size = size;
        break;
      }
    }
    return _ChatController.formatMessage(chatMessage);
  }
  async getChatMessages() {
    if (__privateGet(this, _socketServerName3) === "socket-service") {
      const protoChatMessages = await this.chatSocketHandler.getChatMessages();
      if (!(protoChatMessages == null ? void 0 : protoChatMessages.payload))
        return;
      const chatMessages = GetChatMessagesResponse.fromBinary(protoChatMessages.payload).messages;
      this.chat.messages = chatMessages.map((m) => _ChatController.formatSocketServiceMessage(m));
      return;
    }
    const { messages } = (await __privateGet(this, _roomNodeClient9).getChatMessages()).payload;
    this.chat.messages = messages.map(_ChatController.formatMessage);
  }
  setupEvents() {
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async () => {
      await this.getChatMessages();
      DyteTelemetry.addEventInCurrentSpan("debug", "[ROOM_JOINED] resolved request to fetch chat messages.");
    });
    if (__privateGet(this, _socketServerName3) === "socket-service") {
      this.chatSocketHandler.socket.on(chatEvents.sendMessageToRoom, ({ payload }) => {
        const sockMessage = SendChatMessageToRoomResponse.fromBinary(payload).message;
        const message = _ChatController.formatSocketServiceMessage(sockMessage);
        this.chat.messages = [...this.chat.messages, message];
        log.info("Emitting chatUpdate event for new message");
        this.chat.emit("chatUpdate", {
          action: "add",
          message,
          messages: this.chat.messages
        });
      });
      this.chatSocketHandler.socket.on(chatEvents.sendMessageToPeers, ({ payload }) => {
        const sockMessage = SendChatMessageToPeersResponse.fromBinary(payload).message;
        const message = _ChatController.formatSocketServiceMessage(sockMessage);
        this.chat.messages = [...this.chat.messages, message];
        log.info("Emitting chatUpdate event for new message");
        this.chat.emit("chatUpdate", {
          action: "add",
          message,
          messages: this.chat.messages
        });
      });
      this.chatSocketHandler.socket.on(chatEvents.editMessage, ({ payload }) => {
        const sockMessage = EditChatMessageResponse.fromBinary(payload).message;
        const message = _ChatController.formatSocketServiceMessage(sockMessage);
        const index = this.chat.messages.findIndex((m) => m.id === message.id);
        if (index === -1)
          return;
        this.chat.messages[index] = message;
        this.chat.emit("chatUpdate", {
          action: "edit",
          message,
          messages: this.chat.messages
        });
      });
      this.chatSocketHandler.socket.on(chatEvents.deleteMessage, ({ payload }) => {
        const sockMessageId = DeleteChatMessageResponse.fromBinary(payload).chatId;
        const index = this.chat.messages.findIndex((m) => m.id === sockMessageId);
        if (index === -1)
          return;
        const [message] = this.chat.messages.splice(index, 1);
        this.chat.emit("chatUpdate", {
          action: "delete",
          message,
          messages: this.chat.messages
        });
      });
      return;
    }
    SessionStore.on(SessionEvents.NEW_CHAT_MESSAGE, (payload) => {
      if (messageTypes[payload == null ? void 0 : payload.type] === "poll")
        return;
      const message = _ChatController.formatMessage(payload);
      this.chat.messages = [...this.chat.messages, message];
      this.chat.emit("chatUpdate", {
        action: "add",
        message,
        messages: this.chat.messages
      });
    });
    SessionStore.on(SessionEvents.PIN_CHAT_MESSAGE, async (payload) => {
      const message = _ChatController.formatMessage(payload);
      const index = this.chat.messages.findIndex((msg) => msg.id === message.id);
      this.chat.messages[index] = message;
      this.chat.emit("pinMessage", {
        message,
        messages: this.chat.messages
      });
    });
    SessionStore.on(SessionEvents.UNPIN_CHAT_MESSAGE, async (payload) => {
      const message = _ChatController.formatMessage(payload);
      const index = this.chat.messages.findIndex((msg) => msg.id === message.id);
      this.chat.messages[index] = message;
      this.chat.emit("unpinMessage", {
        message,
        messages: this.chat.messages
      });
    });
  }
}, _roomNodeClient9 = new WeakMap(), _socketServerName3 = new WeakMap(), _d);
let ChatController = _ChatController;
__decorateClass$b([
  DyteTelemetry.trace("ChatController.setupEvents")
], ChatController.prototype, "setupEvents", 1);
var __defProp$a = Object.defineProperty;
var __getOwnPropDesc$a = Object.getOwnPropertyDescriptor;
var __decorateClass$a = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$a(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$a(target, key, result);
  return result;
};
const _PluginController = (_e = class {
  constructor(pluginSocketHandler, chatSocketHandler, roomNodeClient, socketServerName, plugins) {
    __publicField(this, "plugins");
    __privateAdd(this, _pluginSocketHandler2, void 0);
    __privateAdd(this, _roomNodeClient10, void 0);
    __privateAdd(this, _socketServerName4, void 0);
    __privateAdd(this, _chatSocketHandler2, void 0);
    __privateSet(this, _pluginSocketHandler2, pluginSocketHandler);
    __privateSet(this, _chatSocketHandler2, chatSocketHandler);
    __privateSet(this, _roomNodeClient10, roomNodeClient);
    __privateSet(this, _socketServerName4, socketServerName);
    this.plugins = plugins;
    this.setupEvents();
  }
  static async init(pluginSocketHandler, chatSocketHandler, chat, roomNodeClient, self2, participants) {
    const APIClient2 = getAPIClient();
    const receivedPlugins = await APIClient2.getPlugins();
    const flagsmithPluginSocketServer = constants.isV2AuthToken ? false : dist.globalFlagsmith.getValue(FlagsmithFeatureFlags.PLUGIN_SOCKET_SERVER);
    DyteTelemetry.addEventInCurrentSpan("debug", "Received flagsmith plugin_socket_server", { flagsmithPluginSocketServer });
    const socketServerName = flagsmithPluginSocketServer === "socket-service" ? "socket-service" : "room-node";
    log.info(`Using socket server: ${socketServerName}`);
    const plugins = new DytePlugins();
    const flagsmithDevModePlugins = JSON.parse(dist.globalFlagsmith.getValue(FlagsmithFeatureFlags.DEV_MODE_PLUGINS) || "[]");
    receivedPlugins.forEach((p) => {
      if (flagsmithDevModePlugins.includes(p.id))
        return;
      const plugin = new DytePlugin(p, pluginSocketHandler, roomNodeClient, socketServerName, self2, participants, chat);
      plugins.all.add(plugin);
    });
    return new _PluginController(pluginSocketHandler, chatSocketHandler, roomNodeClient, socketServerName, plugins);
  }
  async getRoomPlugins() {
    if (__privateGet(this, _socketServerName4) === "socket-service") {
      const { plugins } = await __privateGet(this, _pluginSocketHandler2).getActivePlugins();
      await Promise.all(plugins.map((plugin) => this.enablePlugin({
        id: plugin.pluginId,
        enabledBy: plugin.enabledBy
      })));
      return;
    }
    const { payload } = await __privateGet(this, _roomNodeClient10).getRoomState();
    await Promise.all(payload.roomState.plugins.map((plugin) => this.enablePlugin(plugin)));
  }
  async enablePlugin({ id, enabledBy }) {
    const plugin = this.plugins.all.get(id);
    if (!plugin) {
      return;
    }
    await plugin.activateForSelf();
    plugin.enabledBy = enabledBy;
  }
  async disablePlugin({ id }) {
    const plugin = this.plugins.all.get(id);
    if (!plugin) {
      return;
    }
    plugin.deactivateForSelf();
  }
  sendIframeEventOld(event, payload) {
    const { id } = payload;
    const plugin = this.plugins.all.get(id);
    if (!plugin)
      return;
    plugin.sendIframeEvent({ type: event, payload });
  }
  sendIframeEvent(event, pluginId, uuid, payload) {
    const plugin = this.plugins.all.get(pluginId);
    if (!pluginId)
      return;
    plugin.sendIframeEvent({ type: event, uuid, payload });
  }
  broadcastIframeEventOld(event, payload) {
    this.plugins.active.forEach((plugin) => {
      this.sendIframeEventOld(event, __spreadProps(__spreadValues({}, payload), { id: plugin.id }));
    });
  }
  broadcastIframeEvent(event, payload) {
    this.plugins.active.forEach((plugin) => {
      this.sendIframeEvent(event, plugin.id, "", payload);
    });
  }
  setupEvents() {
    this.plugins.all.on("stateUpdate", ({ active, id }) => {
      if (active) {
        this.plugins.active.add(this.plugins.all.get(id));
        return;
      }
      this.plugins.active.delete(id);
    });
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async () => {
      await this.getRoomPlugins();
      DyteTelemetry.addEventInCurrentSpan("debug", "[ROOM_JOINED] resolved request to fetch plugins.");
    });
    if (__privateGet(this, _socketServerName4) === "socket-service") {
      __privateGet(this, _pluginSocketHandler2).socket.on(pluginEvents.addPlugin, async ({ payload }) => {
        var _a3;
        const plugin = EnablePluginResponse.fromBinary(payload);
        const id = plugin.pluginId;
        if ((_a3 = this.plugins.all.get(id)) == null ? void 0 : _a3.active) {
          return;
        }
        await this.enablePlugin({ id, enabledBy: plugin.enabledBy });
      });
      __privateGet(this, _pluginSocketHandler2).socket.on(pluginEvents.removePlugin, async ({ payload }) => {
        var _a3;
        const id = DisablePluginResponse.fromBinary(payload).pluginId;
        if (!((_a3 = this.plugins.all.get(id)) == null ? void 0 : _a3.active)) {
          return;
        }
        await this.disablePlugin({ id });
      });
      [
        pluginEvents.enablePluginForPeers,
        pluginEvents.enablePluginForRoom
      ].forEach((event) => {
        __privateGet(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          const plugin = EnablePluginResponse.fromBinary(payload);
          this.sendIframeEvent(event, plugin.pluginId, id, {
            enabledBy: plugin.enabledBy
          });
        });
      });
      [
        pluginEvents.disablePluginForPeers,
        pluginEvents.disablePluginForRoom
      ].forEach((event) => {
        __privateGet(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          const plugin = DisablePluginResponse.fromBinary(payload);
          this.sendIframeEvent(event, plugin.pluginId, id, {
            disabledBy: plugin.disabledBy
          });
        });
      });
      [
        pluginEvents.customPluginEventToPeers,
        pluginEvents.customPluginEventToRoom
      ].forEach((event) => {
        __privateGet(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          const plugin = PluginEventResponse.fromBinary(payload);
          this.sendIframeEvent(event, plugin.pluginId, id, {
            data: JSON.parse(new TextDecoder().decode(plugin.pluginData))
          });
        });
      });
      [
        pluginEvents.storeInsertKeys,
        pluginEvents.storeGetKeys,
        pluginEvents.storeDeleteKeys
      ].forEach((event) => {
        __privateGet(this, _pluginSocketHandler2).socket.on(event, async ({ payload, id }) => {
          var _a3;
          const plugin = PluginStoreResponse.fromBinary(payload);
          const storeItems = (_a3 = plugin.storeItems) == null ? void 0 : _a3.map((storeItem) => ({
            timestamp: storeItem.timestamp,
            peerId: storeItem.peerId,
            payload: JSON.parse(storeItem.payload ? new TextDecoder().decode(storeItem.payload) : "{}"),
            key: storeItem.storeKey
          }));
          this.sendIframeEvent(event, plugin.pluginId, id, {
            storeName: plugin.storeName,
            storeItems
          });
        });
      });
      __privateGet(this, _pluginSocketHandler2).socket.on(pluginEvents.storeDelete, async ({ payload, id }) => {
        const plugin = PluginStoreResponse.fromBinary(payload);
        this.sendIframeEvent(pluginEvents.storeDelete, plugin.pluginId, id, {
          storeName: plugin.storeName
        });
      });
      __privateGet(this, _chatSocketHandler2).socket.on(chatEvents.sendMessageToPeers, ({ payload }) => {
        const sockMessage = SendChatMessageToPeersResponse.fromBinary(payload).message;
        const message = ChatController == null ? void 0 : ChatController.formatSocketServiceMessage(sockMessage);
        this.broadcastIframeEvent(localPluginEvents.chatMessage, { message });
      });
      __privateGet(this, _chatSocketHandler2).socket.on(chatEvents.sendMessageToRoom, ({ payload }) => {
        const sockMessage = SendChatMessageToRoomResponse.fromBinary(payload).message;
        const message = ChatController == null ? void 0 : ChatController.formatSocketServiceMessage(sockMessage);
        this.broadcastIframeEvent(localPluginEvents.chatMessage, { message });
      });
      SessionStore.on(SessionEvents.PEER_JOINED, (payload) => {
        this.broadcastIframeEvent(localPluginEvents.peerJoined, payload);
      });
      SessionStore.on(SessionEvents.PEER_CLOSED, (payload) => {
        this.broadcastIframeEvent(localPluginEvents.peerLeft, payload);
      });
      return;
    }
    SessionStore.on(SessionEvents.ENABLE_PLUGIN, async ({ id, enabledBy }) => {
      await this.enablePlugin({ id, enabledBy });
    });
    SessionStore.on(SessionEvents.DISABLE_PLUGIN, async ({ id }) => {
      await this.disablePlugin({ id });
    });
    [
      SessionEvents.PLUGIN_DATA,
      SessionEvents.PLUGIN_EVENT
    ].forEach((event) => {
      SessionStore.on(event, (payload) => {
        this.sendIframeEventOld(event, payload);
      });
    });
    [
      SessionEvents.PEER_JOINED,
      SessionEvents.PEER_CLOSED,
      SessionEvents.NEW_CHAT_MESSAGE
    ].forEach((event) => {
      SessionStore.on(event, (payload) => {
        this.broadcastIframeEventOld(event, payload);
      });
    });
  }
}, _pluginSocketHandler2 = new WeakMap(), _roomNodeClient10 = new WeakMap(), _socketServerName4 = new WeakMap(), _chatSocketHandler2 = new WeakMap(), _e);
let PluginController = _PluginController;
__decorateClass$a([
  DyteTelemetry.trace("PluginController.setupEvents")
], PluginController.prototype, "setupEvents", 1);
function setupMediaPolyfill() {
  if (browserSpecs.isElectron()) {
    if (window.dyteElectronGetDisplayMediaSource) {
      navigator.mediaDevices.getDisplayMedia = async (constraints) => {
        const source = await window.dyteElectronGetDisplayMediaSource({
          types: ["window", "screen"]
        });
        let video = false;
        if (constraints.video) {
          const videoConstrainst = constraints.video;
          video = {
            mandatory: {
              chromeMediaSource: "desktop",
              chromeMediaSourceId: source.id,
              maxWidth: videoConstrainst.width.max,
              maxHeight: videoConstrainst.height.max
            }
          };
        }
        const electronConstraints = {
          audio: false,
          video
        };
        const stream = await navigator.mediaDevices.getUserMedia(electronConstraints);
        return stream;
      };
    }
  }
}
class DytePolls extends DyteEventEmitter {
  constructor(roomNodeClient, self2) {
    super();
    __publicField(this, "items");
    __privateAdd(this, _roomNodeClient11, void 0);
    __privateAdd(this, _self7, void 0);
    __privateSet(this, _roomNodeClient11, roomNodeClient);
    __privateSet(this, _self7, self2);
    this.items = [];
  }
  async create(question, options, anonymous = false, hideVotes = false) {
    if (!__privateGet(this, _self7).permissions.polls.canCreate) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePolls::create::permission_denied");
      return;
    }
    if (!question || !options) {
      DyteTelemetry.addEventInCurrentSpan("error", "question_and_options_can_not_be_empty", {
        question,
        options
      });
      return;
    }
    if (options.length < 2) {
      DyteTelemetry.addEventInCurrentSpan("error", "there_must_be_at_least_two_options", { options });
      return;
    }
    const pollCreateMessage = {
      question,
      options,
      anonymous,
      hideVotes,
      createdBy: __privateGet(this, _self7).name,
      createdByUserId: __privateGet(this, _self7).userId
    };
    await __privateGet(this, _roomNodeClient11).newPoll(pollCreateMessage);
  }
  async vote(id, index) {
    if (!__privateGet(this, _self7).permissions.polls.canVote) {
      DyteTelemetry.addEventInCurrentSpan("error", "DytePolls::vote::permission_denied");
      return;
    }
    const pollVoteMessage = {
      pollId: id,
      index
    };
    await __privateGet(this, _roomNodeClient11).votePoll(pollVoteMessage);
  }
}
_roomNodeClient11 = new WeakMap();
_self7 = new WeakMap();
var __defProp$9 = Object.defineProperty;
var __getOwnPropDesc$9 = Object.getOwnPropertyDescriptor;
var __decorateClass$9 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$9(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$9(target, key, result);
  return result;
};
class PollController {
  constructor(roomNodeClient, self2) {
    __publicField(this, "polls");
    __privateAdd(this, _roomNodeClient12, void 0);
    __privateAdd(this, _self8, void 0);
    __privateSet(this, _roomNodeClient12, roomNodeClient);
    this.polls = new DytePolls(roomNodeClient, self2);
    __privateSet(this, _self8, self2);
    this.setupEvents();
  }
  canViewPolls() {
    return constants.isV2AuthToken ? __privateGet(this, _self8).permissions.polls.canViewResults || __privateGet(this, _self8).permissions.polls.canVote : __privateGet(this, _self8).permissions.polls.canView;
  }
  setupEvents() {
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async () => {
      if (!this.canViewPolls()) {
        return;
      }
      const { polls } = (await __privateGet(this, _roomNodeClient12).getPolls()).payload;
      this.polls.items = Object.values(polls);
      DyteTelemetry.addEventInCurrentSpan("debug", "[ROOM_JOINED] resolved request to fetch polls.");
    });
    SessionStore.on(SessionEvents.UPDATE_POLL, async ({ poll }) => {
      if (!this.canViewPolls()) {
        return;
      }
      const index = this.polls.items.findIndex((p) => p.id === poll.id);
      if (index > -1) {
        const oldPoll = JSON.stringify(this.polls.items[index]);
        this.polls.items[index] = poll;
        if (oldPoll !== JSON.stringify(poll)) {
          this.polls.emit("pollsUpdate", { polls: this.polls.items });
        }
        return;
      }
      this.polls.items = [...this.polls.items, poll];
      this.polls.emit("pollsUpdate", { polls: this.polls.items });
    });
  }
}
_roomNodeClient12 = new WeakMap();
_self8 = new WeakMap();
__decorateClass$9([
  DyteTelemetry.trace("PollController.setupEvents")
], PollController.prototype, "setupEvents", 1);
class DyteRemoteMap extends DyteMap {
  constructor() {
    super({
      onAddEvent: "remoteRequestAdd",
      onDeleteEvent: "remoteRequestRemove"
    });
  }
  add(request, emitEvent = true) {
    return super.add(request, emitEvent);
  }
  delete(requestId, emitEvent = true, removeListeners = false) {
    return super.delete(requestId, emitEvent, removeListeners);
  }
}
const _DyteRemote = class extends DyteEventEmitter {
  constructor(roomNodeClient, self2, participants) {
    super();
    __publicField(this, "incomingRequests");
    __publicField(this, "outgoingRequests");
    __publicField(this, "active");
    __privateAdd(this, _roomNodeClient13, void 0);
    __privateAdd(this, _self9, void 0);
    __privateAdd(this, _participants2, void 0);
    __privateSet(this, _roomNodeClient13, roomNodeClient);
    __privateSet(this, _participants2, participants);
    __privateSet(this, _self9, self2);
    this.incomingRequests = new DyteRemoteMap();
    this.outgoingRequests = new DyteRemoteMap();
    this.active = null;
    this.mouseEvent = this.mouseEvent.bind(this);
    this.keyboardEvent = this.keyboardEvent.bind(this);
  }
  async requestControl(peerId) {
    var _a3;
    const peer = __privateGet(this, _participants2).joined.get(peerId);
    if (!peer) {
      throw new DyteError("Invalid peer.");
    }
    const duplicateRequest = (_a3 = this.outgoingRequests) == null ? void 0 : _a3.toArray().find((request2) => request2.hostPeerId === peerId);
    if (duplicateRequest) {
      return duplicateRequest.id;
    }
    const requestId = v4();
    const request = new DyteRemoteRequest({
      requestId,
      hostPeerId: peerId,
      remotePeerId: __privateGet(this, _self9).id,
      state: RemoteRequestState.PENDING
    });
    this.outgoingRequests.add(request);
    await __privateGet(this, _roomNodeClient13).requestRemoteControl(request);
    this.emit("remoteUpdate", {
      payload: {
        request: {
          id: request.id,
          hostPeerId: request.hostPeerId,
          remotePeerId: request.remotePeerId
        }
      },
      type: RemoteUpdateType.REQUEST_SENT
    });
    return requestId;
  }
  async acceptControl(requestId) {
    var _a3;
    if (((_a3 = this.active) == null ? void 0 : _a3.id) === requestId) {
      return;
    }
    const request = this.incomingRequests.get(requestId);
    if (!request)
      throw new DyteError("No request found.");
    request.state = RemoteRequestState.ACCEPTED;
    this.endControl();
    this.active = request;
    __privateGet(this, _roomNodeClient13).acceptRemoteControl(request);
    this.emit("remoteUpdate", {
      payload: {
        request: {
          id: this.active.id,
          hostPeerId: this.active.hostPeerId,
          remotePeerId: this.active.remotePeerId
        }
      },
      type: RemoteUpdateType.INCOMING_REQUEST_ACCEPTED
    });
  }
  async endControl() {
    if (!this.active) {
      return;
    }
    const lastActiveControl = __spreadValues({}, this.active);
    __privateGet(this, _roomNodeClient13).terminateRemoteControl(this.active.hostPeerId === __privateGet(this, _self9).id ? this.active.remotePeerId : this.active.hostPeerId, this.active);
    this.active = null;
    this.emit("remoteUpdate", {
      payload: {
        request: {
          id: lastActiveControl.id,
          hostPeerId: lastActiveControl.hostPeerId,
          remotePeerId: lastActiveControl.remotePeerId
        }
      },
      type: lastActiveControl.hostPeerId === __privateGet(this, _self9).id ? RemoteUpdateType.INCOMING_REQUEST_ENDED : RemoteUpdateType.OUTGOING_REQUEST_ENDED
    });
  }
  async keyboardEvent(event) {
    if (!this.active) {
      return;
    }
    const keyboardEvent = _DyteRemote.getFormattedKeyboardEvent(event);
    if (keyboardEvent) {
      const data = {
        eventType: RemoteEventType.KEYBOARD,
        keyboardEvent
      };
      __privateGet(this, _roomNodeClient13).sendEventRemoteControl(this.active.hostPeerId, this.active.id, data);
    }
  }
  async mouseEvent(event, screenShareVideoElement) {
    if (!this.active) {
      return;
    }
    const mouseEvent = _DyteRemote.getFormattedRemoteMouseEvent(event, screenShareVideoElement);
    if (mouseEvent) {
      const data = {
        eventType: RemoteEventType.MOUSE,
        mouseEvent
      };
      __privateGet(this, _roomNodeClient13).sendEventRemoteControl(this.active.hostPeerId, this.active.id, data);
    }
  }
  static getFormattedRemoteMouseEvent(event, screenShareVideoElement) {
    const remoteRect = screenShareVideoElement.getBoundingClientRect();
    const formattedEvent = {
      type: event.type,
      position: {
        x: Math.floor(event.x - remoteRect.left),
        y: Math.floor(event.y - remoteRect.top)
      },
      boundingRect: {
        width: remoteRect.width,
        height: remoteRect.height
      }
    };
    return formattedEvent;
  }
  static getFormattedKeyboardEvent(event) {
    if (event.type === "keydown") {
      const formattedEvent = {
        type: event.type,
        key: event.key
      };
      return formattedEvent;
    }
    return null;
  }
};
let DyteRemote = _DyteRemote;
_roomNodeClient13 = new WeakMap();
_self9 = new WeakMap();
_participants2 = new WeakMap();
const _RemoteController = class {
  constructor(roomNodeClient, self2, participants) {
    __publicField(this, "remote");
    __publicField(this, "hostPeetId");
    __publicField(this, "remotePeetId");
    __publicField(this, "remoteRequestTokens");
    __publicField(this, "activeRemoteToken");
    __privateAdd(this, _roomNodeClient14, void 0);
    __privateAdd(this, _self10, void 0);
    __privateAdd(this, _participants3, void 0);
    __privateSet(this, _roomNodeClient14, roomNodeClient);
    __privateSet(this, _self10, self2);
    __privateSet(this, _participants3, participants);
    this.hostPeetId = self2.id;
    this.remote = new DyteRemote(roomNodeClient, self2, participants);
    this.setupEvents();
  }
  setupEvents() {
    SessionStore.on(SessionEvents.MESSAGE, (payload) => {
      var _a3;
      if (payload.remoteRequestType === RemoteRequestType.REQUEST) {
        this.remote.incomingRequests.add(new DyteRemoteRequest({
          requestId: payload.remoteRequestId,
          hostPeerId: payload.hostPeerId,
          remotePeerId: payload.remotePeerId,
          state: RemoteRequestState.PENDING
        }));
        this.remote.emit("remoteUpdate", {
          payload: {
            request: {
              id: payload.remoteRequestId,
              hostPeerId: payload.hostPeerId,
              remotePeerId: payload.remotePeerId
            }
          },
          type: RemoteUpdateType.REQUEST_RECEIVED
        });
      }
      if (payload.remoteRequestType === RemoteRequestType.ACCEPT) {
        const outgoingRequest = this.remote.outgoingRequests.get(payload.remoteRequestId);
        if (!outgoingRequest) {
          throw new DyteError("There is no pending remote control request to accept.");
        }
        this.remote.endControl();
        outgoingRequest.state = RemoteRequestState.ACCEPTED;
        this.remote.active = new DyteRemoteRequest({
          requestId: payload.remoteRequestId,
          hostPeerId: payload.hostPeerId,
          remotePeerId: payload.remotePeerId,
          state: RemoteRequestState.ACCEPTED
        });
        this.remote.emit("remoteUpdate", {
          payload: {
            request: {
              id: payload.remoteRequestId,
              hostPeerId: payload.hostPeerId,
              remotePeerId: payload.remotePeerId
            }
          },
          type: RemoteUpdateType.OUTGOING_REQUEST_ACCEPTED
        });
      }
      if (payload.remoteRequestType === RemoteRequestType.END) {
        if (((_a3 = this.remote.active) == null ? void 0 : _a3.id) === payload.remoteRequestId) {
          this.remote.active = null;
        }
        this.remote.emit("remoteUpdate", {
          payload: {
            request: {
              id: payload.remoteRequestId,
              hostPeerId: payload.hostPeerId,
              remotePeerId: payload.remotePeerId
            }
          },
          type: payload.hostPeerId === __privateGet(this, _self10).id ? RemoteUpdateType.INCOMING_REQUEST_ENDED : RemoteUpdateType.OUTGOING_REQUEST_ENDED
        });
      }
      if (payload.remoteRequestType === RemoteRequestType.EVENT && this.remote.active && this.remote.active.id === payload.remoteRequestId) {
        if (window.DyteRobot) {
          if (payload.remoteEvent.eventType === RemoteEventType.MOUSE) {
            _RemoteController.executeMouseEvent(payload.remoteEvent.mouseEvent);
          } else if (payload.remoteEvent.eventType === RemoteEventType.KEYBOARD) {
            _RemoteController.executeKeyboardEvent(payload.remoteEvent.keyboardEvent);
          }
        }
      }
    });
    SessionStore.on(SessionEvents.PEER_CLOSED, ({ id: closedPeerId }) => {
      var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2;
      if ([
        (_b2 = (_a3 = this.remote) == null ? void 0 : _a3.active) == null ? void 0 : _b2.hostPeerId,
        (_d2 = (_c2 = this.remote) == null ? void 0 : _c2.active) == null ? void 0 : _d2.remotePeerId
      ].includes(closedPeerId)) {
        this.remote.endControl();
      }
      (_f2 = (_e2 = this.remote) == null ? void 0 : _e2.incomingRequests) == null ? void 0 : _f2.toArray().forEach((req) => {
        if ([req.hostPeerId, req.remotePeerId].includes(closedPeerId)) {
          this.remote.incomingRequests.delete(req.id);
        }
      });
      (_h2 = (_g2 = this.remote) == null ? void 0 : _g2.outgoingRequests) == null ? void 0 : _h2.toArray().forEach((req) => {
        if ([req.hostPeerId, req.remotePeerId].includes(closedPeerId)) {
          this.remote.outgoingRequests.delete(req.id);
        }
      });
    });
  }
  static executeMouseEvent(mouseEvent) {
    const xOnThisScreen = window.screen.width * mouseEvent.position.x / mouseEvent.boundingRect.width;
    const yOnThisScreen = window.screen.height * mouseEvent.position.y / mouseEvent.boundingRect.height;
    const browserScreen = {
      width: window.screen.width,
      height: window.screen.height
    };
    switch (mouseEvent.type) {
      case RemoteMouseEventTypes.LEFT_CLICK:
        window.DyteRobot.mouse.leftClick(xOnThisScreen, yOnThisScreen, browserScreen);
        break;
      case RemoteMouseEventTypes.RIGHT_CLICK:
        window.DyteRobot.mouse.rightClick(xOnThisScreen, yOnThisScreen, browserScreen);
        break;
      case RemoteMouseEventTypes.MOVE:
        window.DyteRobot.mouse.moveTo(xOnThisScreen, yOnThisScreen, browserScreen);
        break;
    }
  }
  static executeKeyboardEvent(keyboardEvent) {
    switch (keyboardEvent.type) {
      case "keydown":
        window.DyteRobot.keyboard.press(keyboardEvent.key);
        break;
    }
  }
};
let RemoteController = _RemoteController;
_roomNodeClient14 = new WeakMap();
_self10 = new WeakMap();
_participants3 = new WeakMap();
class LocalMediaError extends Error {
  constructor(message, code2) {
    super(message);
    __publicField(this, "code");
    this.code = code2;
  }
}
class LocalMediaException extends Error {
  constructor(name, message, constraints) {
    super(message);
    __publicField(this, "constraints");
    __publicField(this, "name");
    this.name = name;
    this.constraints = constraints;
  }
}
var __defProp$8 = Object.defineProperty;
var __getOwnPropDesc$8 = Object.getOwnPropertyDescriptor;
var __decorateClass$8 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$8(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$8(target, key, result);
  return result;
};
const _LocalMediaUtils = (_f = class {
  constructor(availableDevices) {
    __privateAdd(this, _availableDevices, void 0);
    __privateSet(this, _availableDevices, availableDevices);
  }
  static async init() {
    let availableDevices = [];
    if (_LocalMediaUtils.isDeviceListAvailable()) {
      availableDevices = await _LocalMediaUtils.enumerateDevices();
      DyteTelemetry.addEventInCurrentSpan("info", "initial_full_device_list", {
        devices: JSON.stringify(availableDevices, null, 2)
      });
    }
    return new _LocalMediaUtils(availableDevices);
  }
  static isDeviceListAvailable() {
    return !!(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices);
  }
  static enumerateDevices() {
    try {
      return navigator.mediaDevices.enumerateDevices();
    } catch (error) {
      DyteTelemetry.addEventInCurrentSpan("error", "enumerate_devices_failed", {
        message: error.message
      });
      log.info("Failed to enumerate devices", error);
      return Promise.resolve([]);
    }
  }
  static getAudioConstraints(options) {
    const constraints = {};
    const {
      disableAP = false,
      disableAEC = false,
      disableNS = false,
      disableAGC = false,
      disableHPF = false
    } = options.audioOptions || {};
    if (browserSpecs.isFirefox() || browserSpecs.isWebKitBased()) {
      constraints.audio = {
        deviceId: options.audioDeviceId,
        autoGainControl: !disableAGC && !disableAP,
        echoCancellation: !disableAEC && !disableAP,
        noiseSuppression: !disableNS && !disableAP
      };
    } else {
      if (typeof constraints.audio === "boolean") {
        return constraints;
      }
      constraints.audio = {};
      constraints.audio.optional = [
        options.audioDeviceId ? { sourceId: options.audioDeviceId } : { sourceId: "default" },
        { echoCancellation: !disableAEC && !disableAP },
        { googEchoCancellation: !disableAEC && !disableAP },
        { googAutoGainControl: !disableAGC && !disableAP },
        { googNoiseSuppression: !disableNS && !disableAP },
        { googHighpassFilter: !disableHPF && !disableAP },
        { googNoiseSuppression2: !disableNS && !disableAP },
        { googEchoCancellation2: !disableAEC && !disableAP },
        { googAutoGainControl2: !disableAGC && !disableAP }
      ];
    }
    return constraints;
  }
  static getVideoConstraints(options) {
    const constraints = {};
    const {
      videoDeviceId,
      videoTrackConstraints,
      facingMode = "user",
      frameRate = { ideal: 24, max: 30 }
    } = options;
    constraints.video = videoTrackConstraints || VIDEO_CONSTRAINTS.vga;
    if (typeof constraints.video === "boolean") {
      return constraints;
    }
    if (videoDeviceId) {
      constraints.video.deviceId = { exact: videoDeviceId };
    }
    constraints.video.facingMode = facingMode;
    constraints.video.frameRate = frameRate;
    return constraints;
  }
  static async getUserMediaWithTimeout(constraints = {}, timeout = 0) {
    try {
      DyteTelemetry.addEventInCurrentSpan("info", "getUserMediaWithTimeout::requesting_user_media", {
        timeout,
        constraints
      });
      if (!timeout) {
        const mediaStream = await navigator.mediaDevices.getUserMedia(constraints);
        DyteTelemetry.addEventInCurrentSpan("info", "getUserMediaWithTimeout::received_user_media", {
          timeout,
          constraints
        });
        return mediaStream;
      }
      const mediaStreamResp = await Promise.race([
        navigator.mediaDevices.getUserMedia(constraints),
        new Promise((_resolve, reject) => {
          setTimeout(() => reject(new LocalMediaError("Get user media timed out", "ERR_GUM_TIMEOUT")), timeout);
        })
      ]);
      DyteTelemetry.addEventInCurrentSpan("info", "getUserMediaWithTimeout::received_user_media", {
        timeout,
        constraints
      });
      return mediaStreamResp;
    } catch (err) {
      DyteTelemetry.addEventInCurrentSpan("error", "getUserMediaWithTimeout::failed_to_access_local_media", {
        message: err.message,
        constraints
      });
      log.info("Failed to get access to local media.", err, constraints);
      throw new LocalMediaException(err.name, err.message, constraints);
    }
  }
  static async getAudioTrack(constraints) {
    const mediaStream = await _LocalMediaUtils.getUserMediaWithTimeout(constraints);
    return mediaStream.getAudioTracks()[0];
  }
  static async getVideoTrack(constraints) {
    const mediaStream = await _LocalMediaUtils.getUserMediaWithTimeout(constraints);
    return mediaStream.getVideoTracks()[0];
  }
  static async getScreenShareTracks(constraints) {
    const stream = await navigator.mediaDevices.getDisplayMedia(constraints);
    return { video: stream.getVideoTracks()[0], audio: stream.getAudioTracks()[0] };
  }
  static async getAudioAndVideoTrack(constraints) {
    const mediaStream = await _LocalMediaUtils.getUserMediaWithTimeout(constraints);
    return {
      audioTrack: mediaStream.getAudioTracks()[0],
      videoTrack: mediaStream.getVideoTracks()[0]
    };
  }
  onDeviceChange(callback) {
    if (browserSpecs.supportsDeviceChangeEvent()) {
      navigator.mediaDevices.addEventListener("devicechange", async (ev) => {
        const previouslyAvailableDevices = this.availableDevices;
        const previouslyAvailableDeviceIds = new Set(previouslyAvailableDevices.map((device) => device.deviceId));
        await this.repopulateAvailableDevices();
        const currentlyAvailableDevices = this.availableDevices;
        const currentlyAvailableDeviceIds = new Set(currentlyAvailableDevices.map((device) => device.deviceId));
        const changedDevices = {
          added: currentlyAvailableDevices.filter((device) => !previouslyAvailableDeviceIds.has(device.deviceId)),
          removed: previouslyAvailableDevices.filter((device) => !currentlyAvailableDeviceIds.has(device.deviceId))
        };
        this.repopulateAvailableDevices().then(() => callback(ev, changedDevices));
      });
    }
  }
  async repopulateAvailableDevices() {
    const devices = await _LocalMediaUtils.enumerateDevices();
    __privateSet(this, _availableDevices, devices);
    callStats.devices("AUDIO", this.getAudioDevices());
    callStats.devices("VIDEO", this.getVideoDevices());
    callStats.devices("SPEAKER", this.getSpeakerDevices());
    DyteTelemetry.addEventInCurrentSpan("info", "repopulated_full_device_list", {
      devices: JSON.stringify(devices, null, 2)
    });
  }
  get availableDevices() {
    return __privateGet(this, _availableDevices);
  }
  getAvailableDevicesByKind(kind) {
    return __privateGet(this, _availableDevices).filter((device) => device.kind === kind);
  }
  getDeviceById(deviceId, kind) {
    return __privateGet(this, _availableDevices).find((device) => device.deviceId === deviceId && device.kind === kind);
  }
  getAudioDevices() {
    return this.getAvailableDevicesByKind("audioinput");
  }
  getVideoDevices() {
    return this.getAvailableDevicesByKind("videoinput");
  }
  getSpeakerDevices() {
    return this.getAvailableDevicesByKind("audiooutput");
  }
}, _availableDevices = new WeakMap(), _f);
let LocalMediaUtils = _LocalMediaUtils;
__decorateClass$8([
  DyteTelemetry.trace("onDeviceChange")
], LocalMediaUtils.prototype, "onDeviceChange", 1);
__decorateClass$8([
  DyteTelemetry.trace("repopulateAvailableDevices")
], LocalMediaUtils.prototype, "repopulateAvailableDevices", 1);
__decorateClass$8([
  DyteTelemetry.trace("isDeviceListAvailable")
], LocalMediaUtils, "isDeviceListAvailable", 1);
__decorateClass$8([
  DyteTelemetry.trace("enumerateDevices")
], LocalMediaUtils, "enumerateDevices", 1);
__decorateClass$8([
  DyteTelemetry.trace("getUserMediaWithTimeout")
], LocalMediaUtils, "getUserMediaWithTimeout", 1);
__decorateClass$8([
  DyteTelemetry.trace("getAudioTrack")
], LocalMediaUtils, "getAudioTrack", 1);
__decorateClass$8([
  DyteTelemetry.trace("getVideoTrack")
], LocalMediaUtils, "getVideoTrack", 1);
__decorateClass$8([
  DyteTelemetry.trace("getScreenShareTracks")
], LocalMediaUtils, "getScreenShareTracks", 1);
__decorateClass$8([
  DyteTelemetry.trace("getAudioAndVideoTrack")
], LocalMediaUtils, "getAudioAndVideoTrack", 1);
var __defProp$7 = Object.defineProperty;
var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
var __decorateClass$7 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$7(target, key, result);
  return result;
};
class MediaMiddlewareUtils {
  constructor(localMediaHandler) {
    __privateAdd(this, _localMediaHandler4, void 0);
    __publicField(this, "audioMiddlewares", []);
    __publicField(this, "videoMiddlewares", []);
    __privateAdd(this, _middlewareWebWorker, void 0);
    __privateSet(this, _localMediaHandler4, localMediaHandler);
  }
  createMiddlewareWebWorker() {
    __privateSet(this, _middlewareWebWorker, new Worker(new URL("data:application/javascript;base64,bGV0IGludGVydmFsSWQ7Cm9ubWVzc2FnZSA9IChldmVudCkgPT4gewogICAgc3dpdGNoIChldmVudC5kYXRhPy5hY3Rpb24pIHsKICAgIGNhc2UgJ2NsZWFyLWludGVydmFsJzoKICAgICAgICBjbGVhckludGVydmFsKGludGVydmFsSWQpOwogICAgICAgIGJyZWFrOwogICAgY2FzZSAnc3RhcnQtd29ya2VyJzoKICAgICAgICBpbnRlcnZhbElkID0gdGhpcy5zZXRJbnRlcnZhbCgoKSA9PiBwb3N0TWVzc2FnZSh7IGFjdGlvbjogJ3Byb2Nlc3MtbmV4dC1mcmFtZScsIHRpbWVzdGFtcDogbmV3IERhdGUoKS5nZXRUaW1lKCkgfSksIDUwKTsKICAgICAgICBicmVhazsKICAgIGRlZmF1bHQ6CiAgICAgICAgYnJlYWs7CiAgICB9Cn07Cg==", self.location)));
  }
  terminateMiddlewareWebWorker() {
    var _a3, _b2;
    (_a3 = __privateGet(this, _middlewareWebWorker)) == null ? void 0 : _a3.postMessage({ action: "clear-interval" });
    (_b2 = __privateGet(this, _middlewareWebWorker)) == null ? void 0 : _b2.terminate();
  }
  async getTransformedVideoTrack(originalVideoTrack) {
    var _a3, _b2;
    if (!((_a3 = this.videoMiddlewares) == null ? void 0 : _a3.length)) {
      return originalVideoTrack;
    }
    const middlewares = await Promise.all((_b2 = this.videoMiddlewares) == null ? void 0 : _b2.map((videoMiddleware) => videoMiddleware()));
    const originalVideoStream = new MediaStream();
    originalVideoStream.addTrack(originalVideoTrack);
    const transformedVideoCanvasElement = document.createElement("canvas");
    const transformedVideoCanvasCtx = transformedVideoCanvasElement.getContext("2d");
    const rawVideoFeedElement = document.createElement("video");
    rawVideoFeedElement.srcObject = originalVideoStream;
    rawVideoFeedElement.autoplay = true;
    if (__privateGet(this, _middlewareWebWorker) === void 0) {
      this.createMiddlewareWebWorker();
    } else {
      this.terminateMiddlewareWebWorker();
      this.createMiddlewareWebWorker();
    }
    __privateGet(this, _middlewareWebWorker).onmessage = async (event) => {
      var _a4;
      switch ((_a4 = event.data) == null ? void 0 : _a4.action) {
        case "process-next-frame":
          if (!__privateGet(this, _localMediaHandler4).videoEnabled || originalVideoTrack.readyState === "ended") {
            __privateGet(this, _middlewareWebWorker).postMessage({ action: "clear-interval" });
            __privateGet(this, _middlewareWebWorker).terminate();
            rawVideoFeedElement.remove();
            transformedVideoCanvasElement.remove();
            return;
          }
          try {
            transformedVideoCanvasCtx.drawImage(rawVideoFeedElement, 0, 0);
            for (let middlewareIndex = 0; middlewareIndex < middlewares.length; middlewareIndex += 1) {
              await middlewares[middlewareIndex](transformedVideoCanvasElement, transformedVideoCanvasCtx);
            }
          } catch (ex) {
            DyteTelemetry.addEventInCurrentSpan("error", "getTransformedVideoTrack::middleware_execution_failed", {});
          }
          break;
      }
    };
    try {
      rawVideoFeedElement.play();
    } catch (ex) {
    }
    rawVideoFeedElement.addEventListener("play", () => {
      transformedVideoCanvasElement.width = rawVideoFeedElement.width || originalVideoTrack.getSettings().width;
      transformedVideoCanvasElement.height = rawVideoFeedElement.width || originalVideoTrack.getSettings().height;
      __privateGet(this, _middlewareWebWorker).postMessage({ action: "start-worker" });
    }, false);
    const canvasMediaStream = transformedVideoCanvasElement.captureStream();
    return canvasMediaStream.getVideoTracks()[0];
  }
  async addVideoMiddleware(videoMiddleware) {
    if (browserSpecs.isSafari()) {
      return { success: false, message: "Video middlewares are not yet supported in Safari." };
    }
    if (this.videoMiddlewares.includes(videoMiddleware)) {
      return { success: true, message: "This video middleware has been applied, already. Skipping." };
    }
    this.videoMiddlewares.push(videoMiddleware);
    if (__privateGet(this, _localMediaHandler4).videoEnabled) {
      __privateGet(this, _localMediaHandler4).setVideoTrack(await this.getTransformedVideoTrack(__privateGet(this, _localMediaHandler4).rawVideoTrack));
      __privateGet(this, _localMediaHandler4).emit("VIDEO_TRACK_CHANGE");
      return { success: true, message: "Successfully applied the video middleware." };
    }
    return { success: true, message: "Successfully added the video middleware. It will be applied automatically once webcam is turned on." };
  }
  async removeVideoMiddleware(videoMiddleware) {
    const index = this.videoMiddlewares.indexOf(videoMiddleware, 0);
    if (index > -1) {
      this.videoMiddlewares.splice(index, 1);
      if (__privateGet(this, _localMediaHandler4).videoEnabled) {
        __privateGet(this, _localMediaHandler4).setVideoTrack(await this.getTransformedVideoTrack(__privateGet(this, _localMediaHandler4).rawVideoTrack));
        __privateGet(this, _localMediaHandler4).emit("VIDEO_TRACK_CHANGE");
      }
      return { success: true, message: "Successfully removed the video middleware." };
    }
    return { success: true, message: "No such video middleware was found. Skipping." };
  }
  async getTransformedAudioTrack(originalAudioTrack) {
    var _a3, _b2;
    if (!((_a3 = this.audioMiddlewares) == null ? void 0 : _a3.length)) {
      return originalAudioTrack;
    }
    const audioContext = new AudioContext();
    const middlewares = await Promise.all((_b2 = this.audioMiddlewares) == null ? void 0 : _b2.map((audioMiddleware) => audioMiddleware(audioContext)));
    const mediaStreamSource = audioContext.createMediaStreamSource(new MediaStream([originalAudioTrack]));
    const transformedStreamHolder = audioContext.createMediaStreamDestination();
    try {
      let lastMediaStreamSource = mediaStreamSource;
      for (let middlewareIndex = 0; middlewareIndex < middlewares.length; middlewareIndex += 1) {
        lastMediaStreamSource.connect(middlewares[middlewareIndex]);
        lastMediaStreamSource = middlewares[middlewareIndex];
      }
      lastMediaStreamSource.connect(transformedStreamHolder);
    } catch (ex) {
      DyteTelemetry.addEventInCurrentSpan("error", "getTransformedAudioTrack::middleware_execution_failed", {});
      return originalAudioTrack;
    }
    return transformedStreamHolder.stream.getAudioTracks()[0];
  }
  async addAudioMiddleware(audioMiddleware) {
    if (browserSpecs.isSafari()) {
      return { success: false, message: "Audio middlewares are not yet supported in Safari." };
    }
    if (this.audioMiddlewares.includes(audioMiddleware)) {
      return { success: true, message: "This audio middleware has been applied, already. Skipping." };
    }
    this.audioMiddlewares.push(audioMiddleware);
    if (__privateGet(this, _localMediaHandler4).audioEnabled) {
      __privateGet(this, _localMediaHandler4).setAudioTrack(await this.getTransformedAudioTrack(__privateGet(this, _localMediaHandler4).rawAudioTrack));
      __privateGet(this, _localMediaHandler4).emit("AUDIO_TRACK_CHANGE");
      return { success: true, message: "Successfully applied the audio middleware." };
    }
    return { success: true, message: "Successfully added the audio middleware. It will be applied automatically once mic is turned on." };
  }
  async removeAudioMiddleware(audioMiddleware) {
    const index = this.audioMiddlewares.indexOf(audioMiddleware, 0);
    if (index > -1) {
      this.audioMiddlewares.splice(index, 1);
      if (__privateGet(this, _localMediaHandler4).audioEnabled) {
        __privateGet(this, _localMediaHandler4).setAudioTrack(await this.getTransformedAudioTrack(__privateGet(this, _localMediaHandler4).rawAudioTrack));
        __privateGet(this, _localMediaHandler4).emit("AUDIO_TRACK_CHANGE");
      }
      return { success: true, message: "Successfully removed the audio middleware." };
    }
    return { success: true, message: "No such audio middleware was found. Skipping." };
  }
}
_localMediaHandler4 = new WeakMap();
_middlewareWebWorker = new WeakMap();
__decorateClass$7([
  DyteTelemetry.trace("getTransformedVideoTrack")
], MediaMiddlewareUtils.prototype, "getTransformedVideoTrack", 1);
__decorateClass$7([
  DyteTelemetry.trace("addVideoMiddleware")
], MediaMiddlewareUtils.prototype, "addVideoMiddleware", 1);
__decorateClass$7([
  DyteTelemetry.trace("removeVideoMiddleware")
], MediaMiddlewareUtils.prototype, "removeVideoMiddleware", 1);
__decorateClass$7([
  DyteTelemetry.trace("getTransformedAudioTrack")
], MediaMiddlewareUtils.prototype, "getTransformedAudioTrack", 1);
__decorateClass$7([
  DyteTelemetry.trace("addAudioMiddleware")
], MediaMiddlewareUtils.prototype, "addAudioMiddleware", 1);
__decorateClass$7([
  DyteTelemetry.trace("removeAudioMiddleware")
], MediaMiddlewareUtils.prototype, "removeAudioMiddleware", 1);
const delay = (timeout = 0) => new Promise((resolve) => setTimeout(resolve, timeout));
const detectSilence = (audioContext, stream, timeout) => {
  const timer = typeof timeout === "number" ? timeout : 250;
  const source = audioContext.createMediaStreamSource(stream);
  const analyser = audioContext.createAnalyser();
  analyser.fftSize = 2048;
  source.connect(analyser);
  const samples = new Uint8Array(analyser.fftSize);
  let timeoutDidFire = false;
  setTimeout(() => {
    timeoutDidFire = true;
  }, timer);
  function checkSilentSamples() {
    if (timeoutDidFire) {
      return Promise.resolve(true);
    }
    analyser.getByteTimeDomainData(samples);
    return samples.some((sample) => sample !== 128 && sample !== 0) ? Promise.resolve(false) : delay().then(checkSilentSamples);
  }
  return checkSilentSamples().then((isSilent) => {
    source.disconnect();
    return isSilent;
  }, (error) => {
    source.disconnect();
    throw error;
  });
};
const NativeAudioContext = typeof AudioContext !== "undefined" ? AudioContext : null;
class AudioContextProvider {
  constructor(opts) {
    __publicField(this, "_AudioContext");
    __publicField(this, "audioContext");
    __publicField(this, "_audioContextRefContainers");
    const options = __spreadValues({ AudioContext: NativeAudioContext }, opts);
    Object.defineProperties(this, {
      _AudioContext: {
        value: options.AudioContext
      },
      audioContext: {
        value: null,
        writable: true
      },
      _audioContextRefContainers: {
        value: new Set()
      },
      AudioContextProvider: {
        enumerable: true,
        value: AudioContextProvider
      }
    });
  }
  getOrCreate(audioContextRefContainer) {
    if (!this._audioContextRefContainers.has(audioContextRefContainer)) {
      this._audioContextRefContainers.add(audioContextRefContainer);
      if (this._AudioContext && !this.audioContext) {
        try {
          this.audioContext = new this._AudioContext();
        } catch (error) {
        }
      }
    }
    return this.audioContext;
  }
  release(audioContextRefContainer) {
    if (this._audioContextRefContainers.has(audioContextRefContainer)) {
      this._audioContextRefContainers.delete(audioContextRefContainer);
      if (!this._audioContextRefContainers.size && this.audioContext) {
        this.audioContext.close();
        this.audioContext = null;
      }
    }
  }
}
var AudioContextProvider$1 = new AudioContextProvider();
const NUM_OF_ATTEMPTS = 3;
const ATTEMPT_DURATION_MS = 250;
function detectAudioElementSilence(el) {
  const audioContextRefContainer = {};
  const audioContext = AudioContextProvider$1.getOrCreate(audioContextRefContainer);
  let attemptsLeft = NUM_OF_ATTEMPTS;
  function performSilenceCheck() {
    attemptsLeft -= 1;
    return detectSilence(audioContext, el.srcObject, ATTEMPT_DURATION_MS).then((isSilent) => {
      if (!isSilent) {
        return false;
      }
      if (attemptsLeft > 0) {
        return performSilenceCheck();
      }
      return true;
    }).catch(() => true);
  }
  return performSilenceCheck().finally(() => {
    AudioContextProvider$1.release(audioContextRefContainer);
  });
}
async function checkIfAudioTrackIsSilent(audioTrack) {
  const el = new Audio();
  const stream = new MediaStream();
  stream.addTrack(audioTrack);
  el.srcObject = stream;
  let isSilent = false;
  try {
    const promise = el.play();
    if (promise)
      await promise;
    isSilent = await detectAudioElementSilence(el);
    if (isSilent) {
      DyteTelemetry.addEventInCurrentSpan("info", "checkIfAudioTrackIsSilent::silence_detected");
    }
  } catch (error) {
    DyteTelemetry.addEventInCurrentSpan("warn", "checkIfAudioTrackIsSilent::failed_to_detect_silence");
    log.warn("Failed to detect silence:", error);
  } finally {
    el.pause();
    el.remove();
  }
  return isSilent;
}
const _LocalMediaExecutionContext = class {
  constructor() {
    __publicField(this, "mediaPermissionEvent");
    this.mediaPermissionEvent = true;
  }
  static getInstance() {
    if (!_LocalMediaExecutionContext.instance) {
      _LocalMediaExecutionContext.instance = new _LocalMediaExecutionContext();
    }
    return _LocalMediaExecutionContext.instance;
  }
  get shouldEmitMediaPermissionEvent() {
    return this.mediaPermissionEvent;
  }
  setEmitMediaPermissionEvent(emit3) {
    this.mediaPermissionEvent = emit3;
  }
};
let LocalMediaExecutionContext = _LocalMediaExecutionContext;
__publicField(LocalMediaExecutionContext, "instance");
const instance = LocalMediaExecutionContext.getInstance();
var MediaPermission;
(function(MediaPermission2) {
  MediaPermission2[MediaPermission2["NOT_REQUESTED"] = 0] = "NOT_REQUESTED";
  MediaPermission2[MediaPermission2["ACCEPTED"] = 1] = "ACCEPTED";
  MediaPermission2[MediaPermission2["DENIED"] = 2] = "DENIED";
  MediaPermission2[MediaPermission2["SYSTEM_DENIED"] = 3] = "SYSTEM_DENIED";
  MediaPermission2[MediaPermission2["COULD_NOT_START"] = 4] = "COULD_NOT_START";
})(MediaPermission || (MediaPermission = {}));
var MediaErrorName;
(function(MediaErrorName2) {
  MediaErrorName2["NotAllowedError"] = "NotAllowedError";
  MediaErrorName2["NotReadableError"] = "NotReadableError";
  MediaErrorName2["NotFoundError"] = "NotFoundError";
  MediaErrorName2["AbortError"] = "AbortError";
})(MediaErrorName || (MediaErrorName = {}));
function resolveMediaPermissionError(errorName, errorMessage) {
  if (browserSpecs.isChromiumBased()) {
    if (errorName === MediaErrorName.NotAllowedError) {
      if (errorMessage.indexOf("by system") > 0) {
        return "SYSTEM_DENIED";
      }
      return "DENIED";
    }
    if (errorName === MediaErrorName.NotReadableError) {
      return "COULD_NOT_START";
    }
  } else if (browserSpecs.isSafari()) {
    if (errorName === MediaErrorName.NotAllowedError) {
      return "DENIED";
    }
  } else if (browserSpecs.isFirefox()) {
    if (errorName === MediaErrorName.NotFoundError || errorName === MediaErrorName.NotReadableError) {
      return "SYSTEM_DENIED";
    }
    if (errorName === MediaErrorName.NotAllowedError) {
      return "DENIED";
    }
    if (errorName === MediaErrorName.AbortError) {
      return "COULD_NOT_START";
    }
  }
  return "COULD_NOT_START";
}
var __defProp$6 = Object.defineProperty;
var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
var __decorateClass$6 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$6(target, key, result);
  return result;
};
var MediaEvents;
(function(MediaEvents2) {
  MediaEvents2[MediaEvents2["AUDIO_TRACK_CHANGE"] = 0] = "AUDIO_TRACK_CHANGE";
  MediaEvents2[MediaEvents2["VIDEO_TRACK_CHANGE"] = 1] = "VIDEO_TRACK_CHANGE";
  MediaEvents2[MediaEvents2["SCREENSHARE_TRACK_CHANGE"] = 2] = "SCREENSHARE_TRACK_CHANGE";
  MediaEvents2[MediaEvents2["SCREENSHARE_ENDED"] = 3] = "SCREENSHARE_ENDED";
  MediaEvents2[MediaEvents2["AUDIO_TRACK_SILENT"] = 4] = "AUDIO_TRACK_SILENT";
})(MediaEvents || (MediaEvents = {}));
const _LocalMediaHandler = (_g = class extends events$1.exports.EventEmitter {
  constructor(localMediaUtils) {
    super();
    __privateAdd(this, _localMediaUtils, void 0);
    __publicField(this, "mediaMiddlewareUtils");
    __publicField(this, "audioTrack");
    __publicField(this, "rawAudioTrack");
    __publicField(this, "videoTrack");
    __publicField(this, "rawVideoTrack");
    __publicField(this, "screenShareTracks");
    __publicField(this, "audioEnabled");
    __publicField(this, "videoEnabled");
    __publicField(this, "screenShareEnabled");
    __publicField(this, "currentDevices");
    __publicField(this, "permissions");
    __publicField(this, "audioUpdateInProgress");
    __publicField(this, "videoUpdateInProgress");
    __publicField(this, "screenShareUpdateInProgress");
    __privateSet(this, _localMediaUtils, localMediaUtils);
    this.audioEnabled = true;
    this.videoEnabled = true;
    this.audioUpdateInProgress = false;
    this.videoUpdateInProgress = false;
    this.screenShareUpdateInProgress = false;
    this.screenShareEnabled = false;
    this.permissions = {
      audio: "NOT_REQUESTED",
      video: "NOT_REQUESTED",
      screenshare: "NOT_REQUESTED"
    };
    this.screenShareTracks = {
      audio: void 0,
      video: void 0
    };
    this.currentDevices = {
      audio: void 0,
      video: void 0,
      speaker: void 0
    };
    __privateGet(this, _localMediaUtils).onDeviceChange((_, changedDevices) => this.onDeviceChange(changedDevices));
    if (browserSpecs.getName() !== "firefox") {
      this.onPermissionChange();
    }
    this.conditionallyRestartAudio = this.conditionallyRestartAudio.bind(this);
    this.conditionallyRestartVideo = this.conditionallyRestartVideo.bind(this);
    document.addEventListener("visibilitychange", this.onVisibilityChange.bind(this));
  }
  handlePermissionErrors(kind, err) {
    if (kind === "audio") {
      this.audioEnabled = false;
    } else if (kind === "video") {
      this.videoEnabled = false;
    }
    const permissionError = resolveMediaPermissionError(err.name, err.message);
    this.permissions[kind] = permissionError;
    SessionStore.emit(SessionEvents.MEDIA_PERMISSION_ERROR, {
      message: permissionError,
      constraints: err.constraints,
      kind
    });
  }
  onVisibilityChange() {
    if (document.visibilityState === "visible") {
      if (browserSpecs.isMobile()) {
        this.conditionallyRestartAudio();
      }
      this.conditionallyRestartVideo();
    }
    callStats.tabChanged(document.visibilityState === "visible");
    if (document.visibilityState !== "visible") {
      callStats.browserBackgrounded();
    } else {
      callStats.browserForegrounded();
    }
  }
  async conditionallyRestartAudio(ev) {
    var _a3, _b2;
    if (!((_a3 = this.currentDevices) == null ? void 0 : _a3.audio) || !this.audioEnabled) {
      return;
    }
    await Promise.race([
      new Promise((resolve) => {
        var _a4;
        return (_a4 = this.rawAudioTrack) == null ? void 0 : _a4.addEventListener("unmute", (e) => {
          resolve(e);
        });
      }),
      new Promise((resolve) => setTimeout(resolve, 50))
    ]);
    DyteTelemetry.addEventInCurrentSpan("info", "performingCheck::shouldReacquireAudioTrack", { type: ev == null ? void 0 : ev.type });
    const reacquireTrack = await this.shouldReacquireTrack("audio");
    DyteTelemetry.addEventInCurrentSpan("info", "performedCheck::shouldReacquireAudioTrack", { reacquireTrack });
    if (reacquireTrack) {
      DyteTelemetry.addEventInCurrentSpan("info", "reacquiring_audio_track");
      this.removeMediaStreamTrackListeners(this.rawAudioTrack);
      await this.setupAudioStream((_b2 = this.currentDevices.audio) == null ? void 0 : _b2.deviceId);
      this.addMediaStreamTrackListeners(this.rawAudioTrack);
      this.emit("AUDIO_TRACK_CHANGE");
    }
  }
  async conditionallyRestartVideo(ev) {
    var _a3;
    if (!((_a3 = this.currentDevices) == null ? void 0 : _a3.video) || !this.videoEnabled)
      return;
    DyteTelemetry.addEventInCurrentSpan("info", "performingCheck::shouldReacquireVideoTrack", { type: ev == null ? void 0 : ev.type });
    await Promise.race([
      new Promise((resolve) => {
        var _a4;
        return (_a4 = this.rawVideoTrack) == null ? void 0 : _a4.addEventListener("unmute", resolve);
      }),
      new Promise((resolve) => setTimeout(resolve, 50))
    ]);
    const reacquireTrack = await this.shouldReacquireTrack("video");
    DyteTelemetry.addEventInCurrentSpan("info", "performedCheck::shouldReacquireVideoTrack", { reacquireTrack });
    if (reacquireTrack) {
      DyteTelemetry.addEventInCurrentSpan("info", "reacquiring_video_track");
      this.removeMediaStreamTrackListeners(this.rawVideoTrack);
      await this.setupVideoStream(this.currentDevices.video.deviceId);
      this.addMediaStreamTrackListeners(this.rawVideoTrack);
      this.emit("VIDEO_TRACK_CHANGE");
    }
  }
  async shouldReacquireTrack(kind) {
    const workaroundWebKitBug1208516 = true;
    let mediaStreamTrack;
    let wasEnabled = false;
    if (kind === "audio") {
      mediaStreamTrack = this.rawAudioTrack;
      wasEnabled = this.audioEnabled;
    } else if (kind === "video") {
      mediaStreamTrack = this.rawVideoTrack;
      wasEnabled = this.videoEnabled;
    }
    if (!mediaStreamTrack)
      return false;
    const isStopped = mediaStreamTrack.readyState === "ended";
    const isInadvertentlyStopped = isStopped && wasEnabled && workaroundWebKitBug1208516;
    let isSilentAudio = false;
    if (kind === "audio") {
      isSilentAudio = await checkIfAudioTrackIsSilent(this.rawAudioTrack);
    }
    return document.visibilityState === "visible" && (mediaStreamTrack.muted || isInadvertentlyStopped || isSilentAudio);
  }
  onAudioUnmute(ev) {
    DyteTelemetry.addEventInCurrentSpan("info", "audio_track_unmuted", { eventType: ev.type });
  }
  onVideoUnmute(ev) {
    DyteTelemetry.addEventInCurrentSpan("info", "video_track_unmuted", { eventType: ev.type });
  }
  removeMediaStreamTrackListeners(mediaStreamTrack) {
    DyteTelemetry.addEventInCurrentSpan("info", "Removing listerners: ", { mediaStreamTrackKind: mediaStreamTrack.kind });
    if (!mediaStreamTrack) {
      return void 0;
    }
    const conditionallyRestart = mediaStreamTrack.kind === "audio" ? this.conditionallyRestartAudio : this.conditionallyRestartVideo;
    mediaStreamTrack.removeEventListener("ended", conditionallyRestart);
    mediaStreamTrack.removeEventListener("mute", conditionallyRestart);
    mediaStreamTrack.removeEventListener("unmute", mediaStreamTrack.kind === "audio" ? this.onAudioUnmute : this.onVideoUnmute);
    return mediaStreamTrack;
  }
  addMediaStreamTrackListeners(mediaStreamTrack) {
    if (!mediaStreamTrack) {
      return null;
    }
    DyteTelemetry.addEventInCurrentSpan("info", `adding_${mediaStreamTrack.kind}_stream_listerners`);
    const conditionallyRestart = mediaStreamTrack.kind === "audio" ? this.conditionallyRestartAudio : this.conditionallyRestartVideo;
    mediaStreamTrack.addEventListener("ended", conditionallyRestart);
    mediaStreamTrack.addEventListener("mute", conditionallyRestart);
    mediaStreamTrack.addEventListener("unmute", mediaStreamTrack.kind === "audio" ? this.onAudioUnmute : this.onVideoUnmute);
    return mediaStreamTrack;
  }
  async notifyIfTrackSilent() {
    if (this.audioEnabled && this.audioTrack && this.audioTrack.readyState !== "ended" && this.audioTrack.enabled) {
      if (await checkIfAudioTrackIsSilent(this.audioTrack) === true) {
        DyteTelemetry.addEventInCurrentSpan("info", "LocalMediaHandler:notifyIfTrackSilent:TrackSilent", {
          audioEnabled: this.audioEnabled,
          audioTrack: this.audioTrack
        });
        this.emit("AUDIO_TRACK_SILENT");
      }
    }
  }
  async setupAudioStream(deviceId, forceStopTrack = true) {
    var _a3, _b2, _c2;
    if (this.audioUpdateInProgress) {
      return;
    }
    try {
      this.audioUpdateInProgress = true;
      const audioDevices = __privateGet(this, _localMediaUtils).getAudioDevices();
      if (!audioDevices.length) {
        return;
      }
      let audioDeviceId = deviceId;
      if (!audioDeviceId) {
        if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.REMOVE_OPERATIONAL_MIC)) {
          this.notifyIfTrackSilent();
        } else {
          const operationalDevice = await this.getOperationalMicDeviceId();
          if (!operationalDevice.isOperational)
            return;
          audioDeviceId = operationalDevice.deviceId;
        }
      }
      if (((_a3 = this.currentDevices.audio) == null ? void 0 : _a3.deviceId) !== audioDeviceId) {
        this.currentDevices.audio = __privateGet(this, _localMediaUtils).getDeviceById(audioDeviceId, "audioinput");
      }
      const audioConstraints = LocalMediaUtils.getAudioConstraints({ audioDeviceId });
      if (forceStopTrack) {
        (_b2 = this.rawAudioTrack) == null ? void 0 : _b2.stop();
        (_c2 = this.audioTrack) == null ? void 0 : _c2.stop();
      }
      this.rawAudioTrack = await LocalMediaUtils.getAudioTrack(audioConstraints);
      this.rawAudioTrack.enabled = this.audioEnabled;
      this.setAudioTrack(await this.mediaMiddlewareUtils.getTransformedAudioTrack(this.rawAudioTrack));
      this.addMediaStreamTrackListeners(this.rawAudioTrack);
      if (this.rawAudioTrack && this.permissions.audio === "NOT_REQUESTED") {
        await __privateGet(this, _localMediaUtils).repopulateAvailableDevices();
      }
      this.permissions.audio = "ACCEPTED";
      callStats.mediaPermission("AUDIO", PermissionEnum.ACCEPTED);
      callStats.selectedDevice("AUDIO", this.currentDevices.audio);
    } catch (err) {
      this.handlePermissionErrors("audio", err);
    } finally {
      this.audioUpdateInProgress = false;
    }
  }
  async setupVideoStream(deviceId, forceStopTrack = true) {
    var _a3, _b2;
    if (this.videoUpdateInProgress) {
      return;
    }
    try {
      this.videoUpdateInProgress = true;
      const videoDevices = __privateGet(this, _localMediaUtils).getVideoDevices();
      if (!videoDevices.length) {
        return;
      }
      let videoDeviceId = deviceId;
      if (!videoDeviceId) {
        videoDeviceId = (await this.getOperationalWebcamDeviceId()).deviceId;
      }
      if (((_a3 = this.currentDevices.video) == null ? void 0 : _a3.deviceId) !== videoDeviceId) {
        this.currentDevices.video = __privateGet(this, _localMediaUtils).getDeviceById(videoDeviceId, "videoinput");
      }
      if (forceStopTrack) {
        (_b2 = this.videoTrack) == null ? void 0 : _b2.stop();
      }
      if (this.videoEnabled) {
        const videoConstraints = LocalMediaUtils.getVideoConstraints({ videoDeviceId });
        this.rawVideoTrack = await LocalMediaUtils.getVideoTrack(videoConstraints);
        this.setVideoTrack(await this.mediaMiddlewareUtils.getTransformedVideoTrack(this.rawVideoTrack));
        this.addMediaStreamTrackListeners(this.rawVideoTrack);
      }
      if (this.videoTrack && this.permissions.video === "NOT_REQUESTED") {
        await __privateGet(this, _localMediaUtils).repopulateAvailableDevices();
      }
      this.permissions.video = "ACCEPTED";
      callStats.mediaPermission("VIDEO", PermissionEnum.ACCEPTED);
      callStats.selectedDevice("VIDEO", this.currentDevices.video);
    } catch (err) {
      this.handlePermissionErrors("video", err);
    } finally {
      this.videoUpdateInProgress = false;
    }
  }
  async setupScreenShareStreams() {
    if (this.screenShareUpdateInProgress) {
      return;
    }
    const constraints = {
      audio: true,
      video: {
        width: { max: 1920 },
        height: { max: 1080 },
        frameRate: { max: 5 }
      }
    };
    try {
      this.screenShareUpdateInProgress = true;
      const screenShareTracks = await LocalMediaUtils.getScreenShareTracks(constraints);
      this.setScreenShareTracks(screenShareTracks);
    } catch (err) {
      this.handlePermissionErrors("screenshare", new LocalMediaException(err.name, err.message, constraints));
      throw new DyteError(err.message);
    } finally {
      this.screenShareUpdateInProgress = false;
    }
  }
  async setupSpeaker(deviceId) {
    var _a3;
    const speakerDevices = __privateGet(this, _localMediaUtils).getSpeakerDevices();
    if (!speakerDevices.length) {
      return;
    }
    const speakerDeviceId = deviceId != null ? deviceId : speakerDevices[0].deviceId;
    if (((_a3 = this.currentDevices.speaker) == null ? void 0 : _a3.deviceId) !== speakerDeviceId) {
      this.currentDevices.speaker = __privateGet(this, _localMediaUtils).getDeviceById(speakerDeviceId, "audiooutput");
      callStats.selectedDevice("SPEAKER", this.currentDevices.speaker);
    }
    document.querySelectorAll("audio").forEach(async (audioElem) => {
      if (typeof audioElem.sinkId !== "undefined" && this.currentDevices.speaker.deviceId && audioElem.sinkId !== this.currentDevices.speaker.deviceId) {
        try {
          await audioElem.setSinkId(this.currentDevices.speaker.deviceId);
        } catch {
        }
      }
    });
  }
  async getOperationalWebcamDeviceId() {
    const videoDevices = __privateGet(this, _localMediaUtils).getVideoDevices();
    if (!videoDevices.length) {
      return { isOperational: false, deviceId: null };
    }
    instance.setEmitMediaPermissionEvent(false);
    const exceptions = [];
    const operationalDeviceId = await videoDevices.reduce(async (promisedActive, device) => {
      const active = await promisedActive;
      if (active !== null)
        return active;
      const videoConstraints = LocalMediaUtils.getVideoConstraints({
        videoDeviceId: device.deviceId
      });
      try {
        const videoTrack = await LocalMediaUtils.getVideoTrack(videoConstraints);
        videoTrack.stop();
        return device.deviceId;
      } catch (err) {
        DyteTelemetry.addEventInCurrentSpan("error", "could_not_acquire_video_device", { device });
        exceptions.push({ exception: err, constraints: videoConstraints });
      }
      return active;
    }, Promise.resolve(null));
    instance.setEmitMediaPermissionEvent(true);
    if (!operationalDeviceId && exceptions.length > 0 && exceptions.length === videoDevices.length) {
      const { exception, constraints } = exceptions[0];
      throw new LocalMediaException(exception.name, exception.message, constraints);
    }
    return operationalDeviceId ? { isOperational: true, deviceId: operationalDeviceId } : { isOperational: false, deviceId: videoDevices[0].deviceId };
  }
  async getOperationalMicDeviceId() {
    const audioDevices = __privateGet(this, _localMediaUtils).getAudioDevices();
    if (!audioDevices.length) {
      return { isOperational: false, deviceId: null };
    }
    const exceptions = [];
    instance.setEmitMediaPermissionEvent(false);
    const operationalDevice = await audioDevices.reduce(async (promisedActive, device) => {
      const active = await promisedActive;
      if (active !== null)
        return active;
      const audioConstraints = LocalMediaUtils.getAudioConstraints({
        audioDeviceId: device.deviceId
      });
      try {
        const audioTrack = await LocalMediaUtils.getAudioTrack(audioConstraints);
        const isSilent = await checkIfAudioTrackIsSilent(audioTrack);
        audioTrack == null ? void 0 : audioTrack.stop();
        if (!isSilent) {
          return device;
        }
      } catch (err) {
        DyteTelemetry.addEventInCurrentSpan("error", "could_not_acquire_audio_device", { device });
        exceptions.push({ exception: err, constraints: audioConstraints });
      }
      return active;
    }, Promise.resolve(null));
    instance.setEmitMediaPermissionEvent(true);
    if (!operationalDevice && exceptions.length > 0 && exceptions.length === audioDevices.length) {
      const { exception, constraints } = exceptions[0];
      throw new LocalMediaException(exception.name, exception.message, constraints);
    }
    return operationalDevice ? { isOperational: true, deviceId: operationalDevice.deviceId } : { isOperational: false, deviceId: audioDevices[0].deviceId };
  }
  async setupStreams({ audio, video }) {
    var _a3;
    const constraints = {};
    if (!this.currentDevices) {
      this.currentDevices = {
        audio: void 0,
        video: void 0,
        speaker: void 0
      };
    }
    try {
      if (audio && !this.audioUpdateInProgress) {
        const audioDevices = __privateGet(this, _localMediaUtils).getAudioDevices();
        if (audioDevices.length !== 0) {
          const audioDeviceId = (await this.getOperationalMicDeviceId()).deviceId;
          this.currentDevices.audio = __privateGet(this, _localMediaUtils).getDeviceById(audioDeviceId, "audioinput");
          const audioConstraints = LocalMediaUtils.getAudioConstraints({ audioDeviceId });
          constraints.audio = audioConstraints.audio;
        }
      }
      if (video && !this.videoUpdateInProgress) {
        const videoDevices = __privateGet(this, _localMediaUtils).getVideoDevices();
        if (videoDevices.length !== 0) {
          const videoDeviceId = (await this.getOperationalWebcamDeviceId()).deviceId;
          this.currentDevices.video = __privateGet(this, _localMediaUtils).getDeviceById(videoDeviceId, "videoinput");
          const videoConstraints = LocalMediaUtils.getVideoConstraints({ videoDeviceId });
          constraints.video = videoConstraints.video;
        }
      }
      if (((_a3 = Object.keys(constraints)) == null ? void 0 : _a3.length) === 0) {
        this.audioEnabled = audio != null ? audio : this.audioEnabled;
        this.videoEnabled = video != null ? video : this.videoEnabled;
        this.audioUpdateInProgress = false;
        this.videoUpdateInProgress = false;
        return;
      }
      const {
        audioTrack,
        videoTrack
      } = await LocalMediaUtils.getAudioAndVideoTrack(constraints);
      if (audio && audioTrack) {
        this.audioTrack = audioTrack;
        this.rawAudioTrack = audioTrack;
        this.permissions.audio = "ACCEPTED";
      }
      if (video && videoTrack) {
        this.videoTrack = videoTrack;
        this.rawVideoTrack = videoTrack;
        this.permissions.video = "ACCEPTED";
      }
    } catch (err) {
      if (err.name === "NotAllowedError") {
        if (audio)
          await this.setupAudioStream();
        if (video)
          await this.setupVideoStream();
      }
    }
    this.audioEnabled = !!this.audioTrack;
    this.videoEnabled = !!this.videoTrack;
    this.screenShareEnabled = false;
    this.audioUpdateInProgress = false;
    this.videoUpdateInProgress = false;
    await this.setupSpeaker();
  }
  stopAudioTrack() {
    var _a3, _b2;
    if (this.audioUpdateInProgress) {
      return;
    }
    this.audioUpdateInProgress = true;
    (_a3 = this.audioTrack) == null ? void 0 : _a3.stop();
    (_b2 = this.rawAudioTrack) == null ? void 0 : _b2.stop();
    this.audioEnabled = false;
    this.audioUpdateInProgress = false;
  }
  stopVideoTrack() {
    var _a3, _b2;
    if (this.videoUpdateInProgress) {
      return;
    }
    this.videoUpdateInProgress = true;
    (_a3 = this.videoTrack) == null ? void 0 : _a3.stop();
    (_b2 = this.rawVideoTrack) == null ? void 0 : _b2.stop();
    this.videoEnabled = false;
    this.videoUpdateInProgress = false;
  }
  stopScreenShareTracks(tracks = {}) {
    var _a3, _b2, _c2, _d2;
    if (this.screenShareUpdateInProgress) {
      return;
    }
    this.screenShareUpdateInProgress = true;
    const { audio = true, video = true } = tracks;
    if (audio) {
      (_b2 = (_a3 = this.screenShareTracks) == null ? void 0 : _a3.audio) == null ? void 0 : _b2.stop();
    }
    if (video) {
      (_d2 = (_c2 = this.screenShareTracks) == null ? void 0 : _c2.video) == null ? void 0 : _d2.stop();
    }
    this.screenShareEnabled = false;
    this.screenShareUpdateInProgress = false;
  }
  removeAudioTrack() {
    this.stopAudioTrack();
    this.audioTrack = void 0;
    this.rawAudioTrack = void 0;
  }
  removeVideoTrack() {
    this.stopVideoTrack();
    this.videoTrack = void 0;
    this.rawVideoTrack = void 0;
  }
  removeScreenShareTracks(tracks) {
    var _a3;
    (_a3 = this.screenShareTracks.video) == null ? void 0 : _a3.removeEventListener("ended", this.onScreenShareEnded);
    this.stopScreenShareTracks(tracks);
    this.screenShareTracks = {
      audio: void 0,
      video: void 0
    };
  }
  removeAllTracks() {
    this.removeAudioTrack();
    this.removeVideoTrack();
    this.removeScreenShareTracks({
      audio: !!this.screenShareTracks.audio,
      video: !!this.screenShareTracks.video
    });
  }
  setAudioTrack(audioTrack) {
    if (audioTrack === this.audioTrack) {
      return;
    }
    if (audioTrack === void 0) {
      this.stopAudioTrack();
    }
    this.audioTrack = audioTrack;
    if (this.audioTrack) {
      this.audioTrack.enabled = this.audioEnabled;
    }
  }
  setVideoTrack(videoTrack) {
    if (videoTrack === this.videoTrack) {
      return;
    }
    if (videoTrack === void 0) {
      this.stopVideoTrack();
    }
    this.videoTrack = videoTrack;
  }
  setScreenShareTracks(tracks) {
    var _a3;
    const { audio, video } = tracks;
    if (!audio || !video) {
      this.stopScreenShareTracks({ audio: !!audio, video: !!video });
    }
    this.screenShareTracks = tracks;
    (_a3 = this.screenShareTracks.video) == null ? void 0 : _a3.addEventListener("ended", this.onScreenShareEnded.bind(this));
  }
  onScreenShareEnded() {
    this.emit("SCREENSHARE_ENDED");
  }
  disableAudio() {
    this.audioEnabled = false;
    if (this.audioTrack) {
      this.audioTrack.enabled = this.audioEnabled;
    }
    if (this.rawAudioTrack) {
      this.rawAudioTrack.enabled = this.audioEnabled;
    }
  }
  async enableAudio() {
    var _a3;
    if (this.permissions.audio === "DENIED") {
      this.audioEnabled = false;
      return;
    }
    try {
      if (!this.audioTrack || this.audioTrack.readyState === "ended") {
        await this.setupAudioStream((_a3 = this.currentDevices.audio) == null ? void 0 : _a3.deviceId);
      }
      if (!this.audioTrack || !this.rawAudioTrack) {
        this.audioEnabled = false;
        DyteTelemetry.addEventInCurrentSpan("error", "LocalMediaHandler::enableAudio:Setting up audio stream failed while enabling audio", {
          permissions: this.permissions,
          currentDevices: this.currentDevices
        });
        return;
      }
      this.audioEnabled = true;
    } catch (ex) {
      this.audioEnabled = false;
      this.audioTrack = void 0;
      this.rawAudioTrack = void 0;
      DyteTelemetry.addEventInCurrentSpan("error", "LocalMediaHandler::enableAudio", { message: ex.message, stack: ex.stack }, true);
    }
    if (this.audioTrack) {
      this.audioTrack.enabled = true;
    }
    if (this.rawAudioTrack) {
      this.rawAudioTrack.enabled = true;
    }
  }
  async toggleAudio() {
    var _a3;
    if (this.permissions.audio === "DENIED") {
      this.audioEnabled = false;
      return;
    }
    try {
      if (!this.audioTrack || this.audioTrack.readyState === "ended") {
        await this.setupAudioStream((_a3 = this.currentDevices.audio) == null ? void 0 : _a3.deviceId);
      }
      if (!this.audioTrack || !this.rawAudioTrack) {
        this.audioEnabled = false;
        return;
      }
      this.audioEnabled = !this.audioEnabled;
    } catch (ex) {
      this.audioEnabled = false;
      DyteTelemetry.addEventInCurrentSpan("error", "LocalMediaHandler::toggleAudio", { message: ex.message, stack: ex.stack }, true);
    }
    if (this.audioTrack) {
      this.audioTrack.enabled = this.audioEnabled;
    }
    if (this.rawAudioTrack) {
      this.rawAudioTrack.enabled = this.audioEnabled;
    }
  }
  async toggleVideo() {
    var _a3;
    if (this.permissions.video === "DENIED") {
      this.videoEnabled = false;
      return;
    }
    if (this.videoEnabled) {
      this.removeVideoTrack();
      return;
    }
    this.videoEnabled = true;
    try {
      await this.setupVideoStream((_a3 = this.currentDevices.video) == null ? void 0 : _a3.deviceId);
    } catch {
      this.videoEnabled = false;
    }
    if (this.videoTrack) {
      this.videoTrack.enabled = this.videoEnabled;
    }
    if (this.rawVideoTrack) {
      this.rawVideoTrack.enabled = this.videoEnabled;
    }
  }
  async toggleScreenShare() {
    if (this.screenShareEnabled) {
      this.removeScreenShareTracks({
        audio: !!this.screenShareTracks.audio,
        video: !!this.screenShareTracks.video
      });
      return;
    }
    try {
      await this.setupScreenShareStreams();
      this.screenShareEnabled = true;
    } catch {
      this.screenShareEnabled = false;
    }
  }
  getAllDevices() {
    return __privateGet(this, _localMediaUtils).availableDevices;
  }
  getDeviceById(deviceId, kind) {
    return __privateGet(this, _localMediaUtils).getDeviceById(deviceId, kind);
  }
  getAudioDevices() {
    return __privateGet(this, _localMediaUtils).getAudioDevices();
  }
  getVideoDevices() {
    return __privateGet(this, _localMediaUtils).getVideoDevices();
  }
  getSpeakerDevices() {
    return __privateGet(this, _localMediaUtils).getSpeakerDevices();
  }
  async onDeviceChange(changedDevices) {
    let addedDevice;
    let removedDevice;
    if (changedDevices.added.length)
      [addedDevice] = changedDevices.added;
    if (changedDevices.removed.length)
      [removedDevice] = changedDevices.removed;
    if (addedDevice) {
      if (addedDevice.kind === "audioinput") {
        await this.setupAudioStream(addedDevice.deviceId);
        this.emit("AUDIO_TRACK_CHANGE");
      } else if (addedDevice.kind === "videoinput") {
        await this.setupVideoStream(addedDevice.deviceId);
        this.emit("VIDEO_TRACK_CHANGE");
      } else if (addedDevice.kind === "audiooutput") {
        await this.setupSpeaker(addedDevice.deviceId);
      }
    }
    if (removedDevice) {
      if (removedDevice.kind === "audioinput") {
        await this.setupAudioStream();
        this.emit("AUDIO_TRACK_CHANGE");
      } else if (removedDevice.kind === "videoinput") {
        await this.setupVideoStream();
        this.emit("VIDEO_TRACK_CHANGE");
      } else if (removedDevice.kind === "audiooutput") {
        await this.setupSpeaker();
      }
    }
  }
  async onPermissionChange() {
    var _a3, _b2;
    const mic = "microphone";
    const camera = "camera";
    const micPermissions = await ((_a3 = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : _a3.query({ name: mic }));
    const cameraPermissions = await ((_b2 = navigator == null ? void 0 : navigator.permissions) == null ? void 0 : _b2.query({ name: camera }));
    const updateDevices = async () => {
      await __privateGet(this, _localMediaUtils).repopulateAvailableDevices();
    };
    if (micPermissions) {
      micPermissions.onchange = updateDevices;
    }
    if (cameraPermissions) {
      cameraPermissions.onchange = updateDevices;
    }
  }
  static async init() {
    const localMediaUtils = await LocalMediaUtils.init();
    const localMediaHandler = new _LocalMediaHandler(localMediaUtils);
    const mediaMiddlewareUtils = new MediaMiddlewareUtils(localMediaHandler);
    localMediaHandler.mediaMiddlewareUtils = mediaMiddlewareUtils;
    return localMediaHandler;
  }
  emit(event, ...args) {
    return super.emit(event, ...args);
  }
  on(event, listener) {
    return super.on(event, listener);
  }
}, _localMediaUtils = new WeakMap(), _g);
let LocalMediaHandler = _LocalMediaHandler;
__decorateClass$6([
  DyteTelemetry.trace("shouldReacquireTrack")
], LocalMediaHandler.prototype, "shouldReacquireTrack", 1);
__decorateClass$6([
  DyteTelemetry.trace("removeMediaStreamTrackListeners")
], LocalMediaHandler.prototype, "removeMediaStreamTrackListeners", 1);
__decorateClass$6([
  DyteTelemetry.trace("addMediaStreamTrackListeners")
], LocalMediaHandler.prototype, "addMediaStreamTrackListeners", 1);
__decorateClass$6([
  DyteTelemetry.trace("setupAudioStream")
], LocalMediaHandler.prototype, "setupAudioStream", 1);
__decorateClass$6([
  DyteTelemetry.trace("setupVideoStream")
], LocalMediaHandler.prototype, "setupVideoStream", 1);
__decorateClass$6([
  DyteTelemetry.trace("setupScreenShareStreams")
], LocalMediaHandler.prototype, "setupScreenShareStreams", 1);
__decorateClass$6([
  DyteTelemetry.trace("setupSpeaker")
], LocalMediaHandler.prototype, "setupSpeaker", 1);
__decorateClass$6([
  DyteTelemetry.trace("getOperationalWebcamDeviceId")
], LocalMediaHandler.prototype, "getOperationalWebcamDeviceId", 1);
__decorateClass$6([
  DyteTelemetry.trace("getOperationalMicDeviceId")
], LocalMediaHandler.prototype, "getOperationalMicDeviceId", 1);
__decorateClass$6([
  DyteTelemetry.trace("setupStreams")
], LocalMediaHandler.prototype, "setupStreams", 1);
__decorateClass$6([
  DyteTelemetry.trace("stopAudioTrack")
], LocalMediaHandler.prototype, "stopAudioTrack", 1);
__decorateClass$6([
  DyteTelemetry.trace("stopVideoTrack")
], LocalMediaHandler.prototype, "stopVideoTrack", 1);
__decorateClass$6([
  DyteTelemetry.trace("stopScreenShareTracks")
], LocalMediaHandler.prototype, "stopScreenShareTracks", 1);
__decorateClass$6([
  DyteTelemetry.trace("removeAudioTrack")
], LocalMediaHandler.prototype, "removeAudioTrack", 1);
__decorateClass$6([
  DyteTelemetry.trace("removeVideoTrack")
], LocalMediaHandler.prototype, "removeVideoTrack", 1);
__decorateClass$6([
  DyteTelemetry.trace("removeScreenShareTracks")
], LocalMediaHandler.prototype, "removeScreenShareTracks", 1);
__decorateClass$6([
  DyteTelemetry.trace("removeAllTracks")
], LocalMediaHandler.prototype, "removeAllTracks", 1);
__decorateClass$6([
  DyteTelemetry.trace("setAudioTrack")
], LocalMediaHandler.prototype, "setAudioTrack", 1);
__decorateClass$6([
  DyteTelemetry.trace("setVideoTrack")
], LocalMediaHandler.prototype, "setVideoTrack", 1);
__decorateClass$6([
  DyteTelemetry.trace("setScreenShareTracks")
], LocalMediaHandler.prototype, "setScreenShareTracks", 1);
__decorateClass$6([
  DyteTelemetry.trace("disableAudio")
], LocalMediaHandler.prototype, "disableAudio", 1);
__decorateClass$6([
  DyteTelemetry.trace("enableAudio")
], LocalMediaHandler.prototype, "enableAudio", 1);
__decorateClass$6([
  DyteTelemetry.trace("toggleAudio")
], LocalMediaHandler.prototype, "toggleAudio", 1);
__decorateClass$6([
  DyteTelemetry.trace("toggleVideo")
], LocalMediaHandler.prototype, "toggleVideo", 1);
__decorateClass$6([
  DyteTelemetry.trace("toggleScreenShare")
], LocalMediaHandler.prototype, "toggleScreenShare", 1);
var __accessCheck2 = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet2 = (obj, member, getter) => {
  __accessCheck2(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd2 = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet2 = (obj, member, value, setter) => {
  __accessCheck2(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateMethod2 = (obj, member, method) => {
  __accessCheck2(obj, member, "access private method");
  return method;
};
var _logger, _level, _ws, _url, _config, _shouldConnect, _currentTimeout, _logger2, _sendQueue, _eventEmitter, _constructWebSocketAddress, constructWebSocketAddress_fn, _onMessage, onMessage_fn, _handleErrors, handleErrors_fn, _send, send_fn;
var events = { exports: {} };
var R = typeof Reflect === "object" ? Reflect : null;
var ReflectApply2 = R && typeof R.apply === "function" ? R.apply : function ReflectApply22(target, receiver, args) {
  return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === "function") {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys2(target) {
    return Object.getOwnPropertyNames(target);
  };
}
function ProcessEmitWarning(warning) {
  if (console && console.warn)
    console.warn(warning);
}
var NumberIsNaN2 = Number.isNaN || function NumberIsNaN22(value) {
  return value !== value;
};
function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once22;
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = void 0;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = void 0;
var defaultMaxListeners = 10;
function checkListener(listener) {
  if (typeof listener !== "function") {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}
Object.defineProperty(EventEmitter, "defaultMaxListeners", {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== "number" || arg < 0 || NumberIsNaN2(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
    }
    defaultMaxListeners = arg;
  }
});
EventEmitter.init = function() {
  if (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) {
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
  }
  this._maxListeners = this._maxListeners || void 0;
};
EventEmitter.prototype.setMaxListeners = function setMaxListeners2(n) {
  if (typeof n !== "number" || n < 0 || NumberIsNaN2(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
  }
  this._maxListeners = n;
  return this;
};
function _getMaxListeners(that) {
  if (that._maxListeners === void 0)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners2() {
  return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit2(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++)
    args.push(arguments[i]);
  var doError = type === "error";
  var events2 = this._events;
  if (events2 !== void 0)
    doError = doError && events2.error === void 0;
  else if (!doError)
    return false;
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      throw er;
    }
    var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
    err.context = er;
    throw err;
  }
  var handler = events2[type];
  if (handler === void 0)
    return false;
  if (typeof handler === "function") {
    ReflectApply2(handler, this, args);
  } else {
    var len = handler.length;
    var listeners22 = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply2(listeners22[i], this, args);
  }
  return true;
};
function _addListener(target, type, listener, prepend) {
  var m;
  var events2;
  var existing;
  checkListener(listener);
  events2 = target._events;
  if (events2 === void 0) {
    events2 = target._events = /* @__PURE__ */ Object.create(null);
    target._eventsCount = 0;
  } else {
    if (events2.newListener !== void 0) {
      target.emit("newListener", type, listener.listener ? listener.listener : listener);
      events2 = target._events;
    }
    existing = events2[type];
  }
  if (existing === void 0) {
    existing = events2[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === "function") {
      existing = events2[type] = prepend ? [listener, existing] : [existing, listener];
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      w.name = "MaxListenersExceededWarning";
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }
  return target;
}
EventEmitter.prototype.addListener = function addListener2(type, listener) {
  return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener2(type, listener) {
  return _addListener(this, type, listener, true);
};
function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}
function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: void 0, target, type, listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}
EventEmitter.prototype.once = function once3(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener2(type, listener) {
  checkListener(listener);
  this.prependListener(type, _onceWrap(this, type, listener));
  return this;
};
EventEmitter.prototype.removeListener = function removeListener2(type, listener) {
  var list, events2, position, i, originalListener;
  checkListener(listener);
  events2 = this._events;
  if (events2 === void 0)
    return this;
  list = events2[type];
  if (list === void 0)
    return this;
  if (list === listener || list.listener === listener) {
    if (--this._eventsCount === 0)
      this._events = /* @__PURE__ */ Object.create(null);
    else {
      delete events2[type];
      if (events2.removeListener)
        this.emit("removeListener", type, list.listener || listener);
    }
  } else if (typeof list !== "function") {
    position = -1;
    for (i = list.length - 1; i >= 0; i--) {
      if (list[i] === listener || list[i].listener === listener) {
        originalListener = list[i].listener;
        position = i;
        break;
      }
    }
    if (position < 0)
      return this;
    if (position === 0)
      list.shift();
    else {
      spliceOne(list, position);
    }
    if (list.length === 1)
      events2[type] = list[0];
    if (events2.removeListener !== void 0)
      this.emit("removeListener", type, originalListener || listener);
  }
  return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners2(type) {
  var listeners22, events2, i;
  events2 = this._events;
  if (events2 === void 0)
    return this;
  if (events2.removeListener === void 0) {
    if (arguments.length === 0) {
      this._events = /* @__PURE__ */ Object.create(null);
      this._eventsCount = 0;
    } else if (events2[type] !== void 0) {
      if (--this._eventsCount === 0)
        this._events = /* @__PURE__ */ Object.create(null);
      else
        delete events2[type];
    }
    return this;
  }
  if (arguments.length === 0) {
    var keys = Object.keys(events2);
    var key;
    for (i = 0; i < keys.length; ++i) {
      key = keys[i];
      if (key === "removeListener")
        continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners("removeListener");
    this._events = /* @__PURE__ */ Object.create(null);
    this._eventsCount = 0;
    return this;
  }
  listeners22 = events2[type];
  if (typeof listeners22 === "function") {
    this.removeListener(type, listeners22);
  } else if (listeners22 !== void 0) {
    for (i = listeners22.length - 1; i >= 0; i--) {
      this.removeListener(type, listeners22[i]);
    }
  }
  return this;
};
function _listeners(target, type, unwrap) {
  var events2 = target._events;
  if (events2 === void 0)
    return [];
  var evlistener = events2[type];
  if (evlistener === void 0)
    return [];
  if (typeof evlistener === "function")
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners2(type) {
  return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners2(type) {
  return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === "function") {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events2 = this._events;
  if (events2 !== void 0) {
    var evlistener = events2[type];
    if (typeof evlistener === "function") {
      return 1;
    } else if (evlistener !== void 0) {
      return evlistener.length;
    }
  }
  return 0;
}
EventEmitter.prototype.eventNames = function eventNames2() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}
function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}
function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}
function once22(emitter, name) {
  return new Promise(function(resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }
    function resolver() {
      if (typeof emitter.removeListener === "function") {
        emitter.removeListener("error", errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== "error") {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === "function") {
    eventTargetAgnosticAddListener(emitter, "error", handler, flags);
  }
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === "function") {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === "function") {
    emitter.addEventListener(name, function wrapListener(arg) {
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}
var EventEmitter$1 = events.exports;
const logLevels = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3
};
class Logger {
  constructor(level) {
    __privateAdd2(this, _logger, void 0);
    __privateAdd2(this, _level, void 0);
    __privateSet2(this, _logger, console);
    __privateSet2(this, _level, level);
  }
  debug(...args) {
    if (logLevels[__privateGet2(this, _level)] > logLevels.debug) {
      return;
    }
    __privateGet2(this, _logger).debug("[Sockrates]:", ...args);
  }
  info(...args) {
    if (logLevels[__privateGet2(this, _level)] > logLevels.info) {
      return;
    }
    __privateGet2(this, _logger).info("[Sockrates]:", ...args);
  }
  warn(...args) {
    if (logLevels[__privateGet2(this, _level)] > logLevels.warn) {
      return;
    }
    __privateGet2(this, _logger).warn("[Sockrates]:", ...args);
  }
  error(...args) {
    if (logLevels[__privateGet2(this, _level)] > logLevels.error) {
      return;
    }
    __privateGet2(this, _logger).error("[Sockrates]:", ...args);
  }
}
_logger = new WeakMap();
_level = new WeakMap();
function typeofJsonValue(value) {
  let t = typeof value;
  if (t == "object") {
    if (Array.isArray(value))
      return "array";
    if (value === null)
      return "null";
  }
  return t;
}
function isJsonObject(value) {
  return value !== null && typeof value == "object" && !Array.isArray(value);
}
let encTable = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".split("");
let decTable = [];
for (let i = 0; i < encTable.length; i++)
  decTable[encTable[i].charCodeAt(0)] = i;
decTable["-".charCodeAt(0)] = encTable.indexOf("+");
decTable["_".charCodeAt(0)] = encTable.indexOf("/");
function base64decode(base64Str) {
  let es = base64Str.length * 3 / 4;
  if (base64Str[base64Str.length - 2] == "=")
    es -= 2;
  else if (base64Str[base64Str.length - 1] == "=")
    es -= 1;
  let bytes = new Uint8Array(es), bytePos = 0, groupPos = 0, b, p = 0;
  for (let i = 0; i < base64Str.length; i++) {
    b = decTable[base64Str.charCodeAt(i)];
    if (b === void 0) {
      switch (base64Str[i]) {
        case "=":
          groupPos = 0;
        case "\n":
        case "\r":
        case "	":
        case " ":
          continue;
        default:
          throw Error(`invalid base64 string.`);
      }
    }
    switch (groupPos) {
      case 0:
        p = b;
        groupPos = 1;
        break;
      case 1:
        bytes[bytePos++] = p << 2 | (b & 48) >> 4;
        p = b;
        groupPos = 2;
        break;
      case 2:
        bytes[bytePos++] = (p & 15) << 4 | (b & 60) >> 2;
        p = b;
        groupPos = 3;
        break;
      case 3:
        bytes[bytePos++] = (p & 3) << 6 | b;
        groupPos = 0;
        break;
    }
  }
  if (groupPos == 1)
    throw Error(`invalid base64 string.`);
  return bytes.subarray(0, bytePos);
}
function base64encode(bytes) {
  let base64 = "", groupPos = 0, b, p = 0;
  for (let i = 0; i < bytes.length; i++) {
    b = bytes[i];
    switch (groupPos) {
      case 0:
        base64 += encTable[b >> 2];
        p = (b & 3) << 4;
        groupPos = 1;
        break;
      case 1:
        base64 += encTable[p | b >> 4];
        p = (b & 15) << 2;
        groupPos = 2;
        break;
      case 2:
        base64 += encTable[p | b >> 6];
        base64 += encTable[b & 63];
        groupPos = 0;
        break;
    }
  }
  if (groupPos) {
    base64 += encTable[p];
    base64 += "=";
    if (groupPos == 1)
      base64 += "=";
  }
  return base64;
}
var UnknownFieldHandler;
(function(UnknownFieldHandler2) {
  UnknownFieldHandler2.symbol = Symbol.for("protobuf-ts/unknown");
  UnknownFieldHandler2.onRead = (typeName, message, fieldNo, wireType, data) => {
    let container = is(message) ? message[UnknownFieldHandler2.symbol] : message[UnknownFieldHandler2.symbol] = [];
    container.push({ no: fieldNo, wireType, data });
  };
  UnknownFieldHandler2.onWrite = (typeName, message, writer) => {
    for (let { no, wireType, data } of UnknownFieldHandler2.list(message))
      writer.tag(no, wireType).raw(data);
  };
  UnknownFieldHandler2.list = (message, fieldNo) => {
    if (is(message)) {
      let all = message[UnknownFieldHandler2.symbol];
      return fieldNo ? all.filter((uf) => uf.no == fieldNo) : all;
    }
    return [];
  };
  UnknownFieldHandler2.last = (message, fieldNo) => UnknownFieldHandler2.list(message, fieldNo).slice(-1)[0];
  const is = (message) => message && Array.isArray(message[UnknownFieldHandler2.symbol]);
})(UnknownFieldHandler || (UnknownFieldHandler = {}));
var WireType;
(function(WireType2) {
  WireType2[WireType2["Varint"] = 0] = "Varint";
  WireType2[WireType2["Bit64"] = 1] = "Bit64";
  WireType2[WireType2["LengthDelimited"] = 2] = "LengthDelimited";
  WireType2[WireType2["StartGroup"] = 3] = "StartGroup";
  WireType2[WireType2["EndGroup"] = 4] = "EndGroup";
  WireType2[WireType2["Bit32"] = 5] = "Bit32";
})(WireType || (WireType = {}));
function varint64read() {
  let lowBits = 0;
  let highBits = 0;
  for (let shift = 0; shift < 28; shift += 7) {
    let b = this.buf[this.pos++];
    lowBits |= (b & 127) << shift;
    if ((b & 128) == 0) {
      this.assertBounds();
      return [lowBits, highBits];
    }
  }
  let middleByte = this.buf[this.pos++];
  lowBits |= (middleByte & 15) << 28;
  highBits = (middleByte & 112) >> 4;
  if ((middleByte & 128) == 0) {
    this.assertBounds();
    return [lowBits, highBits];
  }
  for (let shift = 3; shift <= 31; shift += 7) {
    let b = this.buf[this.pos++];
    highBits |= (b & 127) << shift;
    if ((b & 128) == 0) {
      this.assertBounds();
      return [lowBits, highBits];
    }
  }
  throw new Error("invalid varint");
}
function varint64write(lo, hi, bytes) {
  for (let i = 0; i < 28; i = i + 7) {
    const shift = lo >>> i;
    const hasNext = !(shift >>> 7 == 0 && hi == 0);
    const byte = (hasNext ? shift | 128 : shift) & 255;
    bytes.push(byte);
    if (!hasNext) {
      return;
    }
  }
  const splitBits = lo >>> 28 & 15 | (hi & 7) << 4;
  const hasMoreBits = !(hi >> 3 == 0);
  bytes.push((hasMoreBits ? splitBits | 128 : splitBits) & 255);
  if (!hasMoreBits) {
    return;
  }
  for (let i = 3; i < 31; i = i + 7) {
    const shift = hi >>> i;
    const hasNext = !(shift >>> 7 == 0);
    const byte = (hasNext ? shift | 128 : shift) & 255;
    bytes.push(byte);
    if (!hasNext) {
      return;
    }
  }
  bytes.push(hi >>> 31 & 1);
}
const TWO_PWR_32_DBL$1 = (1 << 16) * (1 << 16);
function int64fromString(dec) {
  let minus = dec[0] == "-";
  if (minus)
    dec = dec.slice(1);
  const base = 1e6;
  let lowBits = 0;
  let highBits = 0;
  function add1e6digit(begin, end) {
    const digit1e6 = Number(dec.slice(begin, end));
    highBits *= base;
    lowBits = lowBits * base + digit1e6;
    if (lowBits >= TWO_PWR_32_DBL$1) {
      highBits = highBits + (lowBits / TWO_PWR_32_DBL$1 | 0);
      lowBits = lowBits % TWO_PWR_32_DBL$1;
    }
  }
  add1e6digit(-24, -18);
  add1e6digit(-18, -12);
  add1e6digit(-12, -6);
  add1e6digit(-6);
  return [minus, lowBits, highBits];
}
function int64toString(bitsLow, bitsHigh) {
  if (bitsHigh <= 2097151) {
    return "" + (TWO_PWR_32_DBL$1 * bitsHigh + bitsLow);
  }
  let low = bitsLow & 16777215;
  let mid = (bitsLow >>> 24 | bitsHigh << 8) >>> 0 & 16777215;
  let high = bitsHigh >> 16 & 65535;
  let digitA = low + mid * 6777216 + high * 6710656;
  let digitB = mid + high * 8147497;
  let digitC = high * 2;
  let base = 1e7;
  if (digitA >= base) {
    digitB += Math.floor(digitA / base);
    digitA %= base;
  }
  if (digitB >= base) {
    digitC += Math.floor(digitB / base);
    digitB %= base;
  }
  function decimalFrom1e7(digit1e7, needLeadingZeros) {
    let partial = digit1e7 ? String(digit1e7) : "";
    if (needLeadingZeros) {
      return "0000000".slice(partial.length) + partial;
    }
    return partial;
  }
  return decimalFrom1e7(digitC, 0) + decimalFrom1e7(digitB, digitC) + decimalFrom1e7(digitA, 1);
}
function varint32write(value, bytes) {
  if (value >= 0) {
    while (value > 127) {
      bytes.push(value & 127 | 128);
      value = value >>> 7;
    }
    bytes.push(value);
  } else {
    for (let i = 0; i < 9; i++) {
      bytes.push(value & 127 | 128);
      value = value >> 7;
    }
    bytes.push(1);
  }
}
function varint32read() {
  let b = this.buf[this.pos++];
  let result = b & 127;
  if ((b & 128) == 0) {
    this.assertBounds();
    return result;
  }
  b = this.buf[this.pos++];
  result |= (b & 127) << 7;
  if ((b & 128) == 0) {
    this.assertBounds();
    return result;
  }
  b = this.buf[this.pos++];
  result |= (b & 127) << 14;
  if ((b & 128) == 0) {
    this.assertBounds();
    return result;
  }
  b = this.buf[this.pos++];
  result |= (b & 127) << 21;
  if ((b & 128) == 0) {
    this.assertBounds();
    return result;
  }
  b = this.buf[this.pos++];
  result |= (b & 15) << 28;
  for (let readBytes = 5; (b & 128) !== 0 && readBytes < 10; readBytes++)
    b = this.buf[this.pos++];
  if ((b & 128) != 0)
    throw new Error("invalid varint");
  this.assertBounds();
  return result >>> 0;
}
function detectBi() {
  const dv = new DataView(new ArrayBuffer(8));
  const ok = globalThis.BigInt !== void 0 && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function";
  return ok ? {
    MIN: BigInt("-9223372036854775808"),
    MAX: BigInt("9223372036854775807"),
    UMIN: BigInt("0"),
    UMAX: BigInt("18446744073709551615"),
    C: BigInt,
    V: dv
  } : void 0;
}
const BI = detectBi();
function assertBi(bi) {
  if (!bi)
    throw new Error("BigInt unavailable, see https://github.com/timostamm/protobuf-ts/blob/v1.0.8/MANUAL.md#bigint-support");
}
const RE_DECIMAL_STR = /^-?[0-9]+$/;
const TWO_PWR_32_DBL = (1 << 16) * (1 << 16);
class SharedPbLong {
  constructor(lo, hi) {
    this.lo = lo | 0;
    this.hi = hi | 0;
  }
  isZero() {
    return this.lo == 0 && this.hi == 0;
  }
  toNumber() {
    let result = this.hi * TWO_PWR_32_DBL + (this.lo >>> 0);
    if (!Number.isSafeInteger(result))
      throw new Error("cannot convert to safe number");
    return result;
  }
}
class PbULong extends SharedPbLong {
  static from(value) {
    if (BI)
      switch (typeof value) {
        case "string":
          if (value == "0")
            return this.ZERO;
          if (value == "")
            throw new Error("string is no integer");
          value = BI.C(value);
        case "number":
          if (value === 0)
            return this.ZERO;
          value = BI.C(value);
        case "bigint":
          if (!value)
            return this.ZERO;
          if (value < BI.UMIN)
            throw new Error("signed value for ulong");
          if (value > BI.UMAX)
            throw new Error("ulong too large");
          BI.V.setBigUint64(0, value, true);
          return new PbULong(BI.V.getInt32(0, true), BI.V.getInt32(4, true));
      }
    else
      switch (typeof value) {
        case "string":
          if (value == "0")
            return this.ZERO;
          value = value.trim();
          if (!RE_DECIMAL_STR.test(value))
            throw new Error("string is no integer");
          let [minus, lo, hi] = int64fromString(value);
          if (minus)
            throw new Error("signed value");
          return new PbULong(lo, hi);
        case "number":
          if (value == 0)
            return this.ZERO;
          if (!Number.isSafeInteger(value))
            throw new Error("number is no integer");
          if (value < 0)
            throw new Error("signed value for ulong");
          return new PbULong(value, value / TWO_PWR_32_DBL);
      }
    throw new Error("unknown value " + typeof value);
  }
  toString() {
    return BI ? this.toBigInt().toString() : int64toString(this.lo, this.hi);
  }
  toBigInt() {
    assertBi(BI);
    BI.V.setInt32(0, this.lo, true);
    BI.V.setInt32(4, this.hi, true);
    return BI.V.getBigUint64(0, true);
  }
}
PbULong.ZERO = new PbULong(0, 0);
class PbLong extends SharedPbLong {
  static from(value) {
    if (BI)
      switch (typeof value) {
        case "string":
          if (value == "0")
            return this.ZERO;
          if (value == "")
            throw new Error("string is no integer");
          value = BI.C(value);
        case "number":
          if (value === 0)
            return this.ZERO;
          value = BI.C(value);
        case "bigint":
          if (!value)
            return this.ZERO;
          if (value < BI.MIN)
            throw new Error("ulong too small");
          if (value > BI.MAX)
            throw new Error("ulong too large");
          BI.V.setBigInt64(0, value, true);
          return new PbLong(BI.V.getInt32(0, true), BI.V.getInt32(4, true));
      }
    else
      switch (typeof value) {
        case "string":
          if (value == "0")
            return this.ZERO;
          value = value.trim();
          if (!RE_DECIMAL_STR.test(value))
            throw new Error("string is no integer");
          let [minus, lo, hi] = int64fromString(value);
          let pbl = new PbLong(lo, hi);
          return minus ? pbl.negate() : pbl;
        case "number":
          if (value == 0)
            return this.ZERO;
          if (!Number.isSafeInteger(value))
            throw new Error("number is no integer");
          return value > 0 ? new PbLong(value, value / TWO_PWR_32_DBL) : new PbLong(-value, -value / TWO_PWR_32_DBL).negate();
      }
    throw new Error("unknown value " + typeof value);
  }
  isNegative() {
    return (this.hi & 2147483648) !== 0;
  }
  negate() {
    let hi = ~this.hi, lo = this.lo;
    if (lo)
      lo = ~lo + 1;
    else
      hi += 1;
    return new PbLong(lo, hi);
  }
  toString() {
    if (BI)
      return this.toBigInt().toString();
    if (this.isNegative()) {
      let n = this.negate();
      return "-" + int64toString(n.lo, n.hi);
    }
    return int64toString(this.lo, this.hi);
  }
  toBigInt() {
    assertBi(BI);
    BI.V.setInt32(0, this.lo, true);
    BI.V.setInt32(4, this.hi, true);
    return BI.V.getBigInt64(0, true);
  }
}
PbLong.ZERO = new PbLong(0, 0);
const defaultsRead$1 = {
  readUnknownField: true,
  readerFactory: (bytes) => new BinaryReader(bytes)
};
function binaryReadOptions(options) {
  return options ? Object.assign(Object.assign({}, defaultsRead$1), options) : defaultsRead$1;
}
class BinaryReader {
  constructor(buf, textDecoder) {
    this.varint64 = varint64read;
    this.uint32 = varint32read;
    this.buf = buf;
    this.len = buf.length;
    this.pos = 0;
    this.view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
    this.textDecoder = textDecoder !== null && textDecoder !== void 0 ? textDecoder : new TextDecoder("utf-8", {
      fatal: true
    });
  }
  tag() {
    let tag = this.uint32(), fieldNo = tag >>> 3, wireType = tag & 7;
    if (fieldNo <= 0 || wireType < 0 || wireType > 5)
      throw new Error("illegal tag: field no " + fieldNo + " wire type " + wireType);
    return [fieldNo, wireType];
  }
  skip(wireType) {
    let start = this.pos;
    switch (wireType) {
      case WireType.Varint:
        while (this.buf[this.pos++] & 128) {
        }
        break;
      case WireType.Bit64:
        this.pos += 4;
      case WireType.Bit32:
        this.pos += 4;
        break;
      case WireType.LengthDelimited:
        let len = this.uint32();
        this.pos += len;
        break;
      case WireType.StartGroup:
        let t;
        while ((t = this.tag()[1]) !== WireType.EndGroup) {
          this.skip(t);
        }
        break;
      default:
        throw new Error("cant skip wire type " + wireType);
    }
    this.assertBounds();
    return this.buf.subarray(start, this.pos);
  }
  assertBounds() {
    if (this.pos > this.len)
      throw new RangeError("premature EOF");
  }
  int32() {
    return this.uint32() | 0;
  }
  sint32() {
    let zze = this.uint32();
    return zze >>> 1 ^ -(zze & 1);
  }
  int64() {
    return new PbLong(...this.varint64());
  }
  uint64() {
    return new PbULong(...this.varint64());
  }
  sint64() {
    let [lo, hi] = this.varint64();
    let s = -(lo & 1);
    lo = (lo >>> 1 | (hi & 1) << 31) ^ s;
    hi = hi >>> 1 ^ s;
    return new PbLong(lo, hi);
  }
  bool() {
    let [lo, hi] = this.varint64();
    return lo !== 0 || hi !== 0;
  }
  fixed32() {
    return this.view.getUint32((this.pos += 4) - 4, true);
  }
  sfixed32() {
    return this.view.getInt32((this.pos += 4) - 4, true);
  }
  fixed64() {
    return new PbULong(this.sfixed32(), this.sfixed32());
  }
  sfixed64() {
    return new PbLong(this.sfixed32(), this.sfixed32());
  }
  float() {
    return this.view.getFloat32((this.pos += 4) - 4, true);
  }
  double() {
    return this.view.getFloat64((this.pos += 8) - 8, true);
  }
  bytes() {
    let len = this.uint32();
    let start = this.pos;
    this.pos += len;
    this.assertBounds();
    return this.buf.subarray(start, start + len);
  }
  string() {
    return this.textDecoder.decode(this.bytes());
  }
}
function assert(condition, msg) {
  if (!condition) {
    throw new Error(msg);
  }
}
const FLOAT32_MAX = 34028234663852886e22, FLOAT32_MIN = -34028234663852886e22, UINT32_MAX = 4294967295, INT32_MAX = 2147483647, INT32_MIN = -2147483648;
function assertInt32(arg) {
  if (typeof arg !== "number")
    throw new Error("invalid int 32: " + typeof arg);
  if (!Number.isInteger(arg) || arg > INT32_MAX || arg < INT32_MIN)
    throw new Error("invalid int 32: " + arg);
}
function assertUInt32(arg) {
  if (typeof arg !== "number")
    throw new Error("invalid uint 32: " + typeof arg);
  if (!Number.isInteger(arg) || arg > UINT32_MAX || arg < 0)
    throw new Error("invalid uint 32: " + arg);
}
function assertFloat32(arg) {
  if (typeof arg !== "number")
    throw new Error("invalid float 32: " + typeof arg);
  if (!Number.isFinite(arg))
    return;
  if (arg > FLOAT32_MAX || arg < FLOAT32_MIN)
    throw new Error("invalid float 32: " + arg);
}
const defaultsWrite$1 = {
  writeUnknownFields: true,
  writerFactory: () => new BinaryWriter()
};
function binaryWriteOptions(options) {
  return options ? Object.assign(Object.assign({}, defaultsWrite$1), options) : defaultsWrite$1;
}
class BinaryWriter {
  constructor(textEncoder) {
    this.stack = [];
    this.textEncoder = textEncoder !== null && textEncoder !== void 0 ? textEncoder : new TextEncoder();
    this.chunks = [];
    this.buf = [];
  }
  finish() {
    this.chunks.push(new Uint8Array(this.buf));
    let len = 0;
    for (let i = 0; i < this.chunks.length; i++)
      len += this.chunks[i].length;
    let bytes = new Uint8Array(len);
    let offset = 0;
    for (let i = 0; i < this.chunks.length; i++) {
      bytes.set(this.chunks[i], offset);
      offset += this.chunks[i].length;
    }
    this.chunks = [];
    return bytes;
  }
  fork() {
    this.stack.push({ chunks: this.chunks, buf: this.buf });
    this.chunks = [];
    this.buf = [];
    return this;
  }
  join() {
    let chunk = this.finish();
    let prev = this.stack.pop();
    if (!prev)
      throw new Error("invalid state, fork stack empty");
    this.chunks = prev.chunks;
    this.buf = prev.buf;
    this.uint32(chunk.byteLength);
    return this.raw(chunk);
  }
  tag(fieldNo, type) {
    return this.uint32((fieldNo << 3 | type) >>> 0);
  }
  raw(chunk) {
    if (this.buf.length) {
      this.chunks.push(new Uint8Array(this.buf));
      this.buf = [];
    }
    this.chunks.push(chunk);
    return this;
  }
  uint32(value) {
    assertUInt32(value);
    while (value > 127) {
      this.buf.push(value & 127 | 128);
      value = value >>> 7;
    }
    this.buf.push(value);
    return this;
  }
  int32(value) {
    assertInt32(value);
    varint32write(value, this.buf);
    return this;
  }
  bool(value) {
    this.buf.push(value ? 1 : 0);
    return this;
  }
  bytes(value) {
    this.uint32(value.byteLength);
    return this.raw(value);
  }
  string(value) {
    let chunk = this.textEncoder.encode(value);
    this.uint32(chunk.byteLength);
    return this.raw(chunk);
  }
  float(value) {
    assertFloat32(value);
    let chunk = new Uint8Array(4);
    new DataView(chunk.buffer).setFloat32(0, value, true);
    return this.raw(chunk);
  }
  double(value) {
    let chunk = new Uint8Array(8);
    new DataView(chunk.buffer).setFloat64(0, value, true);
    return this.raw(chunk);
  }
  fixed32(value) {
    assertUInt32(value);
    let chunk = new Uint8Array(4);
    new DataView(chunk.buffer).setUint32(0, value, true);
    return this.raw(chunk);
  }
  sfixed32(value) {
    assertInt32(value);
    let chunk = new Uint8Array(4);
    new DataView(chunk.buffer).setInt32(0, value, true);
    return this.raw(chunk);
  }
  sint32(value) {
    assertInt32(value);
    value = (value << 1 ^ value >> 31) >>> 0;
    varint32write(value, this.buf);
    return this;
  }
  sfixed64(value) {
    let chunk = new Uint8Array(8);
    let view = new DataView(chunk.buffer);
    let long = PbLong.from(value);
    view.setInt32(0, long.lo, true);
    view.setInt32(4, long.hi, true);
    return this.raw(chunk);
  }
  fixed64(value) {
    let chunk = new Uint8Array(8);
    let view = new DataView(chunk.buffer);
    let long = PbULong.from(value);
    view.setInt32(0, long.lo, true);
    view.setInt32(4, long.hi, true);
    return this.raw(chunk);
  }
  int64(value) {
    let long = PbLong.from(value);
    varint64write(long.lo, long.hi, this.buf);
    return this;
  }
  sint64(value) {
    let long = PbLong.from(value), sign2 = long.hi >> 31, lo = long.lo << 1 ^ sign2, hi = (long.hi << 1 | long.lo >>> 31) ^ sign2;
    varint64write(lo, hi, this.buf);
    return this;
  }
  uint64(value) {
    let long = PbULong.from(value);
    varint64write(long.lo, long.hi, this.buf);
    return this;
  }
}
const defaultsWrite = {
  emitDefaultValues: false,
  enumAsInteger: false,
  useProtoFieldName: false,
  prettySpaces: 0
}, defaultsRead = {
  ignoreUnknownFields: false
};
function jsonReadOptions(options) {
  return options ? Object.assign(Object.assign({}, defaultsRead), options) : defaultsRead;
}
function jsonWriteOptions(options) {
  return options ? Object.assign(Object.assign({}, defaultsWrite), options) : defaultsWrite;
}
const MESSAGE_TYPE = Symbol.for("protobuf-ts/message-type");
function lowerCamelCase(snakeCase) {
  let capNext = false;
  const sb = [];
  for (let i = 0; i < snakeCase.length; i++) {
    let next = snakeCase.charAt(i);
    if (next == "_") {
      capNext = true;
    } else if (/\d/.test(next)) {
      sb.push(next);
      capNext = true;
    } else if (capNext) {
      sb.push(next.toUpperCase());
      capNext = false;
    } else if (i == 0) {
      sb.push(next.toLowerCase());
    } else {
      sb.push(next);
    }
  }
  return sb.join("");
}
var ScalarType;
(function(ScalarType2) {
  ScalarType2[ScalarType2["DOUBLE"] = 1] = "DOUBLE";
  ScalarType2[ScalarType2["FLOAT"] = 2] = "FLOAT";
  ScalarType2[ScalarType2["INT64"] = 3] = "INT64";
  ScalarType2[ScalarType2["UINT64"] = 4] = "UINT64";
  ScalarType2[ScalarType2["INT32"] = 5] = "INT32";
  ScalarType2[ScalarType2["FIXED64"] = 6] = "FIXED64";
  ScalarType2[ScalarType2["FIXED32"] = 7] = "FIXED32";
  ScalarType2[ScalarType2["BOOL"] = 8] = "BOOL";
  ScalarType2[ScalarType2["STRING"] = 9] = "STRING";
  ScalarType2[ScalarType2["BYTES"] = 12] = "BYTES";
  ScalarType2[ScalarType2["UINT32"] = 13] = "UINT32";
  ScalarType2[ScalarType2["SFIXED32"] = 15] = "SFIXED32";
  ScalarType2[ScalarType2["SFIXED64"] = 16] = "SFIXED64";
  ScalarType2[ScalarType2["SINT32"] = 17] = "SINT32";
  ScalarType2[ScalarType2["SINT64"] = 18] = "SINT64";
})(ScalarType || (ScalarType = {}));
var LongType;
(function(LongType2) {
  LongType2[LongType2["BIGINT"] = 0] = "BIGINT";
  LongType2[LongType2["STRING"] = 1] = "STRING";
  LongType2[LongType2["NUMBER"] = 2] = "NUMBER";
})(LongType || (LongType = {}));
var RepeatType;
(function(RepeatType2) {
  RepeatType2[RepeatType2["NO"] = 0] = "NO";
  RepeatType2[RepeatType2["PACKED"] = 1] = "PACKED";
  RepeatType2[RepeatType2["UNPACKED"] = 2] = "UNPACKED";
})(RepeatType || (RepeatType = {}));
function normalizeFieldInfo(field) {
  var _a3, _b2, _c2, _d2;
  field.localName = (_a3 = field.localName) !== null && _a3 !== void 0 ? _a3 : lowerCamelCase(field.name);
  field.jsonName = (_b2 = field.jsonName) !== null && _b2 !== void 0 ? _b2 : lowerCamelCase(field.name);
  field.repeat = (_c2 = field.repeat) !== null && _c2 !== void 0 ? _c2 : RepeatType.NO;
  field.opt = (_d2 = field.opt) !== null && _d2 !== void 0 ? _d2 : field.repeat ? false : field.oneof ? false : field.kind == "message";
  return field;
}
function isOneofGroup(any) {
  if (typeof any != "object" || any === null || !any.hasOwnProperty("oneofKind")) {
    return false;
  }
  switch (typeof any.oneofKind) {
    case "string":
      if (any[any.oneofKind] === void 0)
        return false;
      return Object.keys(any).length == 2;
    case "undefined":
      return Object.keys(any).length == 1;
    default:
      return false;
  }
}
class ReflectionTypeCheck {
  constructor(info) {
    var _a3;
    this.fields = (_a3 = info.fields) !== null && _a3 !== void 0 ? _a3 : [];
  }
  prepare() {
    if (this.data)
      return;
    const req = [], known = [], oneofs = [];
    for (let field of this.fields) {
      if (field.oneof) {
        if (!oneofs.includes(field.oneof)) {
          oneofs.push(field.oneof);
          req.push(field.oneof);
          known.push(field.oneof);
        }
      } else {
        known.push(field.localName);
        switch (field.kind) {
          case "scalar":
          case "enum":
            if (!field.opt || field.repeat)
              req.push(field.localName);
            break;
          case "message":
            if (field.repeat)
              req.push(field.localName);
            break;
          case "map":
            req.push(field.localName);
            break;
        }
      }
    }
    this.data = { req, known, oneofs: Object.values(oneofs) };
  }
  is(message, depth, allowExcessProperties = false) {
    if (depth < 0)
      return true;
    if (message === null || message === void 0 || typeof message != "object")
      return false;
    this.prepare();
    let keys = Object.keys(message), data = this.data;
    if (keys.length < data.req.length || data.req.some((n) => !keys.includes(n)))
      return false;
    if (!allowExcessProperties) {
      if (keys.some((k) => !data.known.includes(k)))
        return false;
    }
    if (depth < 1) {
      return true;
    }
    for (const name of data.oneofs) {
      const group = message[name];
      if (!isOneofGroup(group))
        return false;
      if (group.oneofKind === void 0)
        continue;
      const field = this.fields.find((f) => f.localName === group.oneofKind);
      if (!field)
        return false;
      if (!this.field(group[group.oneofKind], field, allowExcessProperties, depth))
        return false;
    }
    for (const field of this.fields) {
      if (field.oneof !== void 0)
        continue;
      if (!this.field(message[field.localName], field, allowExcessProperties, depth))
        return false;
    }
    return true;
  }
  field(arg, field, allowExcessProperties, depth) {
    let repeated = field.repeat;
    switch (field.kind) {
      case "scalar":
        if (arg === void 0)
          return field.opt;
        if (repeated)
          return this.scalars(arg, field.T, depth, field.L);
        return this.scalar(arg, field.T, field.L);
      case "enum":
        if (arg === void 0)
          return field.opt;
        if (repeated)
          return this.scalars(arg, ScalarType.INT32, depth);
        return this.scalar(arg, ScalarType.INT32);
      case "message":
        if (arg === void 0)
          return true;
        if (repeated)
          return this.messages(arg, field.T(), allowExcessProperties, depth);
        return this.message(arg, field.T(), allowExcessProperties, depth);
      case "map":
        if (typeof arg != "object" || arg === null)
          return false;
        if (depth < 2)
          return true;
        if (!this.mapKeys(arg, field.K, depth))
          return false;
        switch (field.V.kind) {
          case "scalar":
            return this.scalars(Object.values(arg), field.V.T, depth, field.V.L);
          case "enum":
            return this.scalars(Object.values(arg), ScalarType.INT32, depth);
          case "message":
            return this.messages(Object.values(arg), field.V.T(), allowExcessProperties, depth);
        }
        break;
    }
    return true;
  }
  message(arg, type, allowExcessProperties, depth) {
    if (allowExcessProperties) {
      return type.isAssignable(arg, depth);
    }
    return type.is(arg, depth);
  }
  messages(arg, type, allowExcessProperties, depth) {
    if (!Array.isArray(arg))
      return false;
    if (depth < 2)
      return true;
    if (allowExcessProperties) {
      for (let i = 0; i < arg.length && i < depth; i++)
        if (!type.isAssignable(arg[i], depth - 1))
          return false;
    } else {
      for (let i = 0; i < arg.length && i < depth; i++)
        if (!type.is(arg[i], depth - 1))
          return false;
    }
    return true;
  }
  scalar(arg, type, longType) {
    let argType = typeof arg;
    switch (type) {
      case ScalarType.UINT64:
      case ScalarType.FIXED64:
      case ScalarType.INT64:
      case ScalarType.SFIXED64:
      case ScalarType.SINT64:
        switch (longType) {
          case LongType.BIGINT:
            return argType == "bigint";
          case LongType.NUMBER:
            return argType == "number" && !isNaN(arg);
          default:
            return argType == "string";
        }
      case ScalarType.BOOL:
        return argType == "boolean";
      case ScalarType.STRING:
        return argType == "string";
      case ScalarType.BYTES:
        return arg instanceof Uint8Array;
      case ScalarType.DOUBLE:
      case ScalarType.FLOAT:
        return argType == "number" && !isNaN(arg);
      default:
        return argType == "number" && Number.isInteger(arg);
    }
  }
  scalars(arg, type, depth, longType) {
    if (!Array.isArray(arg))
      return false;
    if (depth < 2)
      return true;
    if (Array.isArray(arg)) {
      for (let i = 0; i < arg.length && i < depth; i++)
        if (!this.scalar(arg[i], type, longType))
          return false;
    }
    return true;
  }
  mapKeys(map, type, depth) {
    let keys = Object.keys(map);
    switch (type) {
      case ScalarType.INT32:
      case ScalarType.FIXED32:
      case ScalarType.SFIXED32:
      case ScalarType.SINT32:
      case ScalarType.UINT32:
        return this.scalars(keys.slice(0, depth).map((k) => parseInt(k)), type, depth);
      case ScalarType.BOOL:
        return this.scalars(keys.slice(0, depth).map((k) => k == "true" ? true : k == "false" ? false : k), type, depth);
      default:
        return this.scalars(keys, type, depth, LongType.STRING);
    }
  }
}
function reflectionLongConvert(long, type) {
  switch (type) {
    case LongType.BIGINT:
      return long.toBigInt();
    case LongType.NUMBER:
      return long.toNumber();
    default:
      return long.toString();
  }
}
class ReflectionJsonReader {
  constructor(info) {
    this.info = info;
  }
  prepare() {
    var _a3;
    if (this.fMap === void 0) {
      this.fMap = {};
      const fieldsInput = (_a3 = this.info.fields) !== null && _a3 !== void 0 ? _a3 : [];
      for (const field of fieldsInput) {
        this.fMap[field.name] = field;
        this.fMap[field.jsonName] = field;
        this.fMap[field.localName] = field;
      }
    }
  }
  assert(condition, fieldName, jsonValue) {
    if (!condition) {
      let what = typeofJsonValue(jsonValue);
      if (what == "number" || what == "boolean")
        what = jsonValue.toString();
      throw new Error(`Cannot parse JSON ${what} for ${this.info.typeName}#${fieldName}`);
    }
  }
  read(input, message, options) {
    this.prepare();
    const oneofsHandled = [];
    for (const [jsonKey, jsonValue] of Object.entries(input)) {
      const field = this.fMap[jsonKey];
      if (!field) {
        if (!options.ignoreUnknownFields)
          throw new Error(`Found unknown field while reading ${this.info.typeName} from JSON format. JSON key: ${jsonKey}`);
        continue;
      }
      const localName = field.localName;
      let target;
      if (field.oneof) {
        if (oneofsHandled.includes(field.oneof))
          throw new Error(`Multiple members of the oneof group "${field.oneof}" of ${this.info.typeName} are present in JSON.`);
        oneofsHandled.push(field.oneof);
        target = message[field.oneof] = {
          oneofKind: localName
        };
      } else {
        target = message;
      }
      if (field.kind == "map") {
        if (jsonValue === null) {
          continue;
        }
        this.assert(isJsonObject(jsonValue), field.name, jsonValue);
        const fieldObj = target[localName];
        for (const [jsonObjKey, jsonObjValue] of Object.entries(jsonValue)) {
          this.assert(jsonObjValue !== null, field.name + " map value", null);
          let val;
          switch (field.V.kind) {
            case "message":
              val = field.V.T().internalJsonRead(jsonObjValue, options);
              break;
            case "enum":
              val = this.enum(field.V.T(), jsonObjValue, field.name, options.ignoreUnknownFields);
              if (val === false)
                continue;
              break;
            case "scalar":
              val = this.scalar(jsonObjValue, field.V.T, field.V.L, field.name);
              break;
          }
          this.assert(val !== void 0, field.name + " map value", jsonObjValue);
          let key = jsonObjKey;
          if (field.K == ScalarType.BOOL)
            key = key == "true" ? true : key == "false" ? false : key;
          key = this.scalar(key, field.K, LongType.STRING, field.name).toString();
          fieldObj[key] = val;
        }
      } else if (field.repeat) {
        if (jsonValue === null)
          continue;
        this.assert(Array.isArray(jsonValue), field.name, jsonValue);
        const fieldArr = target[localName];
        for (const jsonItem of jsonValue) {
          this.assert(jsonItem !== null, field.name, null);
          let val;
          switch (field.kind) {
            case "message":
              val = field.T().internalJsonRead(jsonItem, options);
              break;
            case "enum":
              val = this.enum(field.T(), jsonItem, field.name, options.ignoreUnknownFields);
              if (val === false)
                continue;
              break;
            case "scalar":
              val = this.scalar(jsonItem, field.T, field.L, field.name);
              break;
          }
          this.assert(val !== void 0, field.name, jsonValue);
          fieldArr.push(val);
        }
      } else {
        switch (field.kind) {
          case "message":
            if (jsonValue === null && field.T().typeName != "google.protobuf.Value") {
              this.assert(field.oneof === void 0, field.name + " (oneof member)", null);
              continue;
            }
            target[localName] = field.T().internalJsonRead(jsonValue, options, target[localName]);
            break;
          case "enum":
            let val = this.enum(field.T(), jsonValue, field.name, options.ignoreUnknownFields);
            if (val === false)
              continue;
            target[localName] = val;
            break;
          case "scalar":
            target[localName] = this.scalar(jsonValue, field.T, field.L, field.name);
            break;
        }
      }
    }
  }
  enum(type, json, fieldName, ignoreUnknownFields) {
    if (type[0] == "google.protobuf.NullValue")
      assert(json === null, `Unable to parse field ${this.info.typeName}#${fieldName}, enum ${type[0]} only accepts null.`);
    if (json === null)
      return 0;
    switch (typeof json) {
      case "number":
        assert(Number.isInteger(json), `Unable to parse field ${this.info.typeName}#${fieldName}, enum can only be integral number, got ${json}.`);
        return json;
      case "string":
        let localEnumName = json;
        if (type[2] && json.substring(0, type[2].length) === type[2])
          localEnumName = json.substring(type[2].length);
        let enumNumber = type[1][localEnumName];
        if (typeof enumNumber === "undefined" && ignoreUnknownFields) {
          return false;
        }
        assert(typeof enumNumber == "number", `Unable to parse field ${this.info.typeName}#${fieldName}, enum ${type[0]} has no value for "${json}".`);
        return enumNumber;
    }
    assert(false, `Unable to parse field ${this.info.typeName}#${fieldName}, cannot parse enum value from ${typeof json}".`);
  }
  scalar(json, type, longType, fieldName) {
    let e;
    try {
      switch (type) {
        case ScalarType.DOUBLE:
        case ScalarType.FLOAT:
          if (json === null)
            return 0;
          if (json === "NaN")
            return Number.NaN;
          if (json === "Infinity")
            return Number.POSITIVE_INFINITY;
          if (json === "-Infinity")
            return Number.NEGATIVE_INFINITY;
          if (json === "") {
            e = "empty string";
            break;
          }
          if (typeof json == "string" && json.trim().length !== json.length) {
            e = "extra whitespace";
            break;
          }
          if (typeof json != "string" && typeof json != "number") {
            break;
          }
          let float = Number(json);
          if (Number.isNaN(float)) {
            e = "not a number";
            break;
          }
          if (!Number.isFinite(float)) {
            e = "too large or small";
            break;
          }
          if (type == ScalarType.FLOAT)
            assertFloat32(float);
          return float;
        case ScalarType.INT32:
        case ScalarType.FIXED32:
        case ScalarType.SFIXED32:
        case ScalarType.SINT32:
        case ScalarType.UINT32:
          if (json === null)
            return 0;
          let int32;
          if (typeof json == "number")
            int32 = json;
          else if (json === "")
            e = "empty string";
          else if (typeof json == "string") {
            if (json.trim().length !== json.length)
              e = "extra whitespace";
            else
              int32 = Number(json);
          }
          if (int32 === void 0)
            break;
          if (type == ScalarType.UINT32)
            assertUInt32(int32);
          else
            assertInt32(int32);
          return int32;
        case ScalarType.INT64:
        case ScalarType.SFIXED64:
        case ScalarType.SINT64:
          if (json === null)
            return reflectionLongConvert(PbLong.ZERO, longType);
          if (typeof json != "number" && typeof json != "string")
            break;
          return reflectionLongConvert(PbLong.from(json), longType);
        case ScalarType.FIXED64:
        case ScalarType.UINT64:
          if (json === null)
            return reflectionLongConvert(PbULong.ZERO, longType);
          if (typeof json != "number" && typeof json != "string")
            break;
          return reflectionLongConvert(PbULong.from(json), longType);
        case ScalarType.BOOL:
          if (json === null)
            return false;
          if (typeof json !== "boolean")
            break;
          return json;
        case ScalarType.STRING:
          if (json === null)
            return "";
          if (typeof json !== "string") {
            e = "extra whitespace";
            break;
          }
          try {
            encodeURIComponent(json);
          } catch (e2) {
            e2 = "invalid UTF8";
            break;
          }
          return json;
        case ScalarType.BYTES:
          if (json === null || json === "")
            return new Uint8Array(0);
          if (typeof json !== "string")
            break;
          return base64decode(json);
      }
    } catch (error) {
      e = error.message;
    }
    this.assert(false, fieldName + (e ? " - " + e : ""), json);
  }
}
class ReflectionJsonWriter {
  constructor(info) {
    var _a3;
    this.fields = (_a3 = info.fields) !== null && _a3 !== void 0 ? _a3 : [];
  }
  write(message, options) {
    const json = {}, source = message;
    for (const field of this.fields) {
      if (!field.oneof) {
        let jsonValue2 = this.field(field, source[field.localName], options);
        if (jsonValue2 !== void 0)
          json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue2;
        continue;
      }
      const group = source[field.oneof];
      if (group.oneofKind !== field.localName)
        continue;
      const opt = field.kind == "scalar" || field.kind == "enum" ? Object.assign(Object.assign({}, options), { emitDefaultValues: true }) : options;
      let jsonValue = this.field(field, group[field.localName], opt);
      assert(jsonValue !== void 0);
      json[options.useProtoFieldName ? field.name : field.jsonName] = jsonValue;
    }
    return json;
  }
  field(field, value, options) {
    let jsonValue = void 0;
    if (field.kind == "map") {
      assert(typeof value == "object" && value !== null);
      const jsonObj = {};
      switch (field.V.kind) {
        case "scalar":
          for (const [entryKey, entryValue] of Object.entries(value)) {
            const val = this.scalar(field.V.T, entryValue, field.name, false, true);
            assert(val !== void 0);
            jsonObj[entryKey.toString()] = val;
          }
          break;
        case "message":
          const messageType = field.V.T();
          for (const [entryKey, entryValue] of Object.entries(value)) {
            const val = this.message(messageType, entryValue, field.name, options);
            assert(val !== void 0);
            jsonObj[entryKey.toString()] = val;
          }
          break;
        case "enum":
          const enumInfo = field.V.T();
          for (const [entryKey, entryValue] of Object.entries(value)) {
            assert(entryValue === void 0 || typeof entryValue == "number");
            const val = this.enum(enumInfo, entryValue, field.name, false, true, options.enumAsInteger);
            assert(val !== void 0);
            jsonObj[entryKey.toString()] = val;
          }
          break;
      }
      if (options.emitDefaultValues || Object.keys(jsonObj).length > 0)
        jsonValue = jsonObj;
    } else if (field.repeat) {
      assert(Array.isArray(value));
      const jsonArr = [];
      switch (field.kind) {
        case "scalar":
          for (let i = 0; i < value.length; i++) {
            const val = this.scalar(field.T, value[i], field.name, field.opt, true);
            assert(val !== void 0);
            jsonArr.push(val);
          }
          break;
        case "enum":
          const enumInfo = field.T();
          for (let i = 0; i < value.length; i++) {
            assert(value[i] === void 0 || typeof value[i] == "number");
            const val = this.enum(enumInfo, value[i], field.name, field.opt, true, options.enumAsInteger);
            assert(val !== void 0);
            jsonArr.push(val);
          }
          break;
        case "message":
          const messageType = field.T();
          for (let i = 0; i < value.length; i++) {
            const val = this.message(messageType, value[i], field.name, options);
            assert(val !== void 0);
            jsonArr.push(val);
          }
          break;
      }
      if (options.emitDefaultValues || jsonArr.length > 0 || options.emitDefaultValues)
        jsonValue = jsonArr;
    } else {
      switch (field.kind) {
        case "scalar":
          jsonValue = this.scalar(field.T, value, field.name, field.opt, options.emitDefaultValues);
          break;
        case "enum":
          jsonValue = this.enum(field.T(), value, field.name, field.opt, options.emitDefaultValues, options.enumAsInteger);
          break;
        case "message":
          jsonValue = this.message(field.T(), value, field.name, options);
          break;
      }
    }
    return jsonValue;
  }
  enum(type, value, fieldName, optional, emitDefaultValues, enumAsInteger) {
    if (type[0] == "google.protobuf.NullValue")
      return null;
    if (value === void 0) {
      assert(optional);
      return void 0;
    }
    if (value === 0 && !emitDefaultValues && !optional)
      return void 0;
    assert(typeof value == "number");
    assert(Number.isInteger(value));
    if (enumAsInteger || !type[1].hasOwnProperty(value))
      return value;
    if (type[2])
      return type[2] + type[1][value];
    return type[1][value];
  }
  message(type, value, fieldName, options) {
    if (value === void 0)
      return options.emitDefaultValues ? null : void 0;
    return type.internalJsonWrite(value, options);
  }
  scalar(type, value, fieldName, optional, emitDefaultValues) {
    if (value === void 0) {
      assert(optional);
      return void 0;
    }
    const ed = emitDefaultValues || optional;
    switch (type) {
      case ScalarType.INT32:
      case ScalarType.SFIXED32:
      case ScalarType.SINT32:
        if (value === 0)
          return ed ? 0 : void 0;
        assertInt32(value);
        return value;
      case ScalarType.FIXED32:
      case ScalarType.UINT32:
        if (value === 0)
          return ed ? 0 : void 0;
        assertUInt32(value);
        return value;
      case ScalarType.FLOAT:
        assertFloat32(value);
      case ScalarType.DOUBLE:
        if (value === 0)
          return ed ? 0 : void 0;
        assert(typeof value == "number");
        if (Number.isNaN(value))
          return "NaN";
        if (value === Number.POSITIVE_INFINITY)
          return "Infinity";
        if (value === Number.NEGATIVE_INFINITY)
          return "-Infinity";
        return value;
      case ScalarType.STRING:
        if (value === "")
          return ed ? "" : void 0;
        assert(typeof value == "string");
        return value;
      case ScalarType.BOOL:
        if (value === false)
          return ed ? false : void 0;
        assert(typeof value == "boolean");
        return value;
      case ScalarType.UINT64:
      case ScalarType.FIXED64:
        assert(typeof value == "number" || typeof value == "string" || typeof value == "bigint");
        let ulong = PbULong.from(value);
        if (ulong.isZero() && !ed)
          return void 0;
        return ulong.toString();
      case ScalarType.INT64:
      case ScalarType.SFIXED64:
      case ScalarType.SINT64:
        assert(typeof value == "number" || typeof value == "string" || typeof value == "bigint");
        let long = PbLong.from(value);
        if (long.isZero() && !ed)
          return void 0;
        return long.toString();
      case ScalarType.BYTES:
        assert(value instanceof Uint8Array);
        if (!value.byteLength)
          return ed ? "" : void 0;
        return base64encode(value);
    }
  }
}
function reflectionScalarDefault(type, longType = LongType.STRING) {
  switch (type) {
    case ScalarType.BOOL:
      return false;
    case ScalarType.UINT64:
    case ScalarType.FIXED64:
      return reflectionLongConvert(PbULong.ZERO, longType);
    case ScalarType.INT64:
    case ScalarType.SFIXED64:
    case ScalarType.SINT64:
      return reflectionLongConvert(PbLong.ZERO, longType);
    case ScalarType.DOUBLE:
    case ScalarType.FLOAT:
      return 0;
    case ScalarType.BYTES:
      return new Uint8Array(0);
    case ScalarType.STRING:
      return "";
    default:
      return 0;
  }
}
class ReflectionBinaryReader {
  constructor(info) {
    this.info = info;
  }
  prepare() {
    var _a3;
    if (!this.fieldNoToField) {
      const fieldsInput = (_a3 = this.info.fields) !== null && _a3 !== void 0 ? _a3 : [];
      this.fieldNoToField = new Map(fieldsInput.map((field) => [field.no, field]));
    }
  }
  read(reader, message, options, length) {
    this.prepare();
    const end = length === void 0 ? reader.len : reader.pos + length;
    while (reader.pos < end) {
      const [fieldNo, wireType] = reader.tag(), field = this.fieldNoToField.get(fieldNo);
      if (!field) {
        let u = options.readUnknownField;
        if (u == "throw")
          throw new Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.info.typeName}`);
        let d = reader.skip(wireType);
        if (u !== false)
          (u === true ? UnknownFieldHandler.onRead : u)(this.info.typeName, message, fieldNo, wireType, d);
        continue;
      }
      let target = message, repeated = field.repeat, localName = field.localName;
      if (field.oneof) {
        target = target[field.oneof];
        if (target.oneofKind !== localName)
          target = message[field.oneof] = {
            oneofKind: localName
          };
      }
      switch (field.kind) {
        case "scalar":
        case "enum":
          let T = field.kind == "enum" ? ScalarType.INT32 : field.T;
          let L = field.kind == "scalar" ? field.L : void 0;
          if (repeated) {
            let arr = target[localName];
            if (wireType == WireType.LengthDelimited && T != ScalarType.STRING && T != ScalarType.BYTES) {
              let e = reader.uint32() + reader.pos;
              while (reader.pos < e)
                arr.push(this.scalar(reader, T, L));
            } else
              arr.push(this.scalar(reader, T, L));
          } else
            target[localName] = this.scalar(reader, T, L);
          break;
        case "message":
          if (repeated) {
            let arr = target[localName];
            let msg = field.T().internalBinaryRead(reader, reader.uint32(), options);
            arr.push(msg);
          } else
            target[localName] = field.T().internalBinaryRead(reader, reader.uint32(), options, target[localName]);
          break;
        case "map":
          let [mapKey, mapVal] = this.mapEntry(field, reader, options);
          target[localName][mapKey] = mapVal;
          break;
      }
    }
  }
  mapEntry(field, reader, options) {
    let length = reader.uint32();
    let end = reader.pos + length;
    let key = void 0;
    let val = void 0;
    while (reader.pos < end) {
      let [fieldNo, wireType] = reader.tag();
      switch (fieldNo) {
        case 1:
          if (field.K == ScalarType.BOOL)
            key = reader.bool().toString();
          else
            key = this.scalar(reader, field.K, LongType.STRING);
          break;
        case 2:
          switch (field.V.kind) {
            case "scalar":
              val = this.scalar(reader, field.V.T, field.V.L);
              break;
            case "enum":
              val = reader.int32();
              break;
            case "message":
              val = field.V.T().internalBinaryRead(reader, reader.uint32(), options);
              break;
          }
          break;
        default:
          throw new Error(`Unknown field ${fieldNo} (wire type ${wireType}) in map entry for ${this.info.typeName}#${field.name}`);
      }
    }
    if (key === void 0) {
      let keyRaw = reflectionScalarDefault(field.K);
      key = field.K == ScalarType.BOOL ? keyRaw.toString() : keyRaw;
    }
    if (val === void 0)
      switch (field.V.kind) {
        case "scalar":
          val = reflectionScalarDefault(field.V.T, field.V.L);
          break;
        case "enum":
          val = 0;
          break;
        case "message":
          val = field.V.T().create();
          break;
      }
    return [key, val];
  }
  scalar(reader, type, longType) {
    switch (type) {
      case ScalarType.INT32:
        return reader.int32();
      case ScalarType.STRING:
        return reader.string();
      case ScalarType.BOOL:
        return reader.bool();
      case ScalarType.DOUBLE:
        return reader.double();
      case ScalarType.FLOAT:
        return reader.float();
      case ScalarType.INT64:
        return reflectionLongConvert(reader.int64(), longType);
      case ScalarType.UINT64:
        return reflectionLongConvert(reader.uint64(), longType);
      case ScalarType.FIXED64:
        return reflectionLongConvert(reader.fixed64(), longType);
      case ScalarType.FIXED32:
        return reader.fixed32();
      case ScalarType.BYTES:
        return reader.bytes();
      case ScalarType.UINT32:
        return reader.uint32();
      case ScalarType.SFIXED32:
        return reader.sfixed32();
      case ScalarType.SFIXED64:
        return reflectionLongConvert(reader.sfixed64(), longType);
      case ScalarType.SINT32:
        return reader.sint32();
      case ScalarType.SINT64:
        return reflectionLongConvert(reader.sint64(), longType);
    }
  }
}
class ReflectionBinaryWriter {
  constructor(info) {
    this.info = info;
  }
  prepare() {
    if (!this.fields) {
      const fieldsInput = this.info.fields ? this.info.fields.concat() : [];
      this.fields = fieldsInput.sort((a, b) => a.no - b.no);
    }
  }
  write(message, writer, options) {
    this.prepare();
    for (const field of this.fields) {
      let value, emitDefault, repeated = field.repeat, localName = field.localName;
      if (field.oneof) {
        const group = message[field.oneof];
        if (group.oneofKind !== localName)
          continue;
        value = group[localName];
        emitDefault = true;
      } else {
        value = message[localName];
        emitDefault = false;
      }
      switch (field.kind) {
        case "scalar":
        case "enum":
          let T = field.kind == "enum" ? ScalarType.INT32 : field.T;
          if (repeated) {
            assert(Array.isArray(value));
            if (repeated == RepeatType.PACKED)
              this.packed(writer, T, field.no, value);
            else
              for (const item of value)
                this.scalar(writer, T, field.no, item, true);
          } else if (value === void 0)
            assert(field.opt);
          else
            this.scalar(writer, T, field.no, value, emitDefault || field.opt);
          break;
        case "message":
          if (repeated) {
            assert(Array.isArray(value));
            for (const item of value)
              this.message(writer, options, field.T(), field.no, item);
          } else {
            this.message(writer, options, field.T(), field.no, value);
          }
          break;
        case "map":
          assert(typeof value == "object" && value !== null);
          for (const [key, val] of Object.entries(value))
            this.mapEntry(writer, options, field, key, val);
          break;
      }
    }
    let u = options.writeUnknownFields;
    if (u !== false)
      (u === true ? UnknownFieldHandler.onWrite : u)(this.info.typeName, message, writer);
  }
  mapEntry(writer, options, field, key, value) {
    writer.tag(field.no, WireType.LengthDelimited);
    writer.fork();
    let keyValue = key;
    switch (field.K) {
      case ScalarType.INT32:
      case ScalarType.FIXED32:
      case ScalarType.UINT32:
      case ScalarType.SFIXED32:
      case ScalarType.SINT32:
        keyValue = Number.parseInt(key);
        break;
      case ScalarType.BOOL:
        assert(key == "true" || key == "false");
        keyValue = key == "true";
        break;
    }
    this.scalar(writer, field.K, 1, keyValue, true);
    switch (field.V.kind) {
      case "scalar":
        this.scalar(writer, field.V.T, 2, value, true);
        break;
      case "enum":
        this.scalar(writer, ScalarType.INT32, 2, value, true);
        break;
      case "message":
        this.message(writer, options, field.V.T(), 2, value);
        break;
    }
    writer.join();
  }
  message(writer, options, handler, fieldNo, value) {
    if (value === void 0)
      return;
    handler.internalBinaryWrite(value, writer.tag(fieldNo, WireType.LengthDelimited).fork(), options);
    writer.join();
  }
  scalar(writer, type, fieldNo, value, emitDefault) {
    let [wireType, method, isDefault] = this.scalarInfo(type, value);
    if (!isDefault || emitDefault) {
      writer.tag(fieldNo, wireType);
      writer[method](value);
    }
  }
  packed(writer, type, fieldNo, value) {
    if (!value.length)
      return;
    assert(type !== ScalarType.BYTES && type !== ScalarType.STRING);
    writer.tag(fieldNo, WireType.LengthDelimited);
    writer.fork();
    let [, method] = this.scalarInfo(type);
    for (let i = 0; i < value.length; i++)
      writer[method](value[i]);
    writer.join();
  }
  scalarInfo(type, value) {
    let t = WireType.Varint;
    let m;
    let i = value === void 0;
    let d = value === 0;
    switch (type) {
      case ScalarType.INT32:
        m = "int32";
        break;
      case ScalarType.STRING:
        d = i || !value.length;
        t = WireType.LengthDelimited;
        m = "string";
        break;
      case ScalarType.BOOL:
        d = value === false;
        m = "bool";
        break;
      case ScalarType.UINT32:
        m = "uint32";
        break;
      case ScalarType.DOUBLE:
        t = WireType.Bit64;
        m = "double";
        break;
      case ScalarType.FLOAT:
        t = WireType.Bit32;
        m = "float";
        break;
      case ScalarType.INT64:
        d = i || PbLong.from(value).isZero();
        m = "int64";
        break;
      case ScalarType.UINT64:
        d = i || PbULong.from(value).isZero();
        m = "uint64";
        break;
      case ScalarType.FIXED64:
        d = i || PbULong.from(value).isZero();
        t = WireType.Bit64;
        m = "fixed64";
        break;
      case ScalarType.BYTES:
        d = i || !value.byteLength;
        t = WireType.LengthDelimited;
        m = "bytes";
        break;
      case ScalarType.FIXED32:
        t = WireType.Bit32;
        m = "fixed32";
        break;
      case ScalarType.SFIXED32:
        t = WireType.Bit32;
        m = "sfixed32";
        break;
      case ScalarType.SFIXED64:
        d = i || PbLong.from(value).isZero();
        t = WireType.Bit64;
        m = "sfixed64";
        break;
      case ScalarType.SINT32:
        m = "sint32";
        break;
      case ScalarType.SINT64:
        d = i || PbLong.from(value).isZero();
        m = "sint64";
        break;
    }
    return [t, m, i || d];
  }
}
function reflectionCreate(type) {
  const msg = {};
  Object.defineProperty(msg, MESSAGE_TYPE, { enumerable: false, value: type });
  for (let field of type.fields) {
    let name = field.localName;
    if (field.opt)
      continue;
    if (field.oneof)
      msg[field.oneof] = { oneofKind: void 0 };
    else if (field.repeat)
      msg[name] = [];
    else
      switch (field.kind) {
        case "scalar":
          msg[name] = reflectionScalarDefault(field.T, field.L);
          break;
        case "enum":
          msg[name] = 0;
          break;
        case "map":
          msg[name] = {};
          break;
      }
  }
  return msg;
}
function reflectionMergePartial(info, target, source) {
  let fieldValue, input = source, output;
  for (let field of info.fields) {
    let name = field.localName;
    if (field.oneof) {
      const group = input[field.oneof];
      if (group == void 0) {
        continue;
      }
      fieldValue = group[name];
      output = target[field.oneof];
      output.oneofKind = group.oneofKind;
      if (fieldValue == void 0) {
        delete output[name];
        continue;
      }
    } else {
      fieldValue = input[name];
      output = target;
      if (fieldValue == void 0) {
        continue;
      }
    }
    switch (field.kind) {
      case "scalar":
      case "enum":
        if (field.repeat)
          output[name] = fieldValue.concat();
        else
          output[name] = fieldValue;
        break;
      case "message":
        let T = field.T();
        if (field.repeat)
          for (let i = 0; i < fieldValue.length; i++)
            output[name][i] = T.create(fieldValue[i]);
        else if (output[name] === void 0)
          output[name] = T.create(fieldValue);
        else
          T.mergePartial(output[name], fieldValue);
        break;
      case "map":
        switch (field.V.kind) {
          case "scalar":
          case "enum":
            Object.assign(output[name], fieldValue);
            break;
          case "message":
            let T2 = field.V.T();
            for (let k of Object.keys(fieldValue))
              output[name][k] = T2.create(fieldValue[k]);
            break;
        }
        break;
    }
  }
}
function reflectionEquals(info, a, b) {
  if (a === b)
    return true;
  if (!a || !b)
    return false;
  for (let field of info.fields) {
    let localName = field.localName;
    let val_a = field.oneof ? a[field.oneof][localName] : a[localName];
    let val_b = field.oneof ? b[field.oneof][localName] : b[localName];
    switch (field.kind) {
      case "enum":
      case "scalar":
        let t = field.kind == "enum" ? ScalarType.INT32 : field.T;
        if (!(field.repeat ? repeatedPrimitiveEq(t, val_a, val_b) : primitiveEq(t, val_a, val_b)))
          return false;
        break;
      case "map":
        if (!(field.V.kind == "message" ? repeatedMsgEq(field.V.T(), objectValues(val_a), objectValues(val_b)) : repeatedPrimitiveEq(field.V.kind == "enum" ? ScalarType.INT32 : field.V.T, objectValues(val_a), objectValues(val_b))))
          return false;
        break;
      case "message":
        let T = field.T();
        if (!(field.repeat ? repeatedMsgEq(T, val_a, val_b) : T.equals(val_a, val_b)))
          return false;
        break;
    }
  }
  return true;
}
const objectValues = Object.values;
function primitiveEq(type, a, b) {
  if (a === b)
    return true;
  if (type !== ScalarType.BYTES)
    return false;
  let ba = a;
  let bb = b;
  if (ba.length !== bb.length)
    return false;
  for (let i = 0; i < ba.length; i++)
    if (ba[i] != bb[i])
      return false;
  return true;
}
function repeatedPrimitiveEq(type, a, b) {
  if (a.length !== b.length)
    return false;
  for (let i = 0; i < a.length; i++)
    if (!primitiveEq(type, a[i], b[i]))
      return false;
  return true;
}
function repeatedMsgEq(type, a, b) {
  if (a.length !== b.length)
    return false;
  for (let i = 0; i < a.length; i++)
    if (!type.equals(a[i], b[i]))
      return false;
  return true;
}
class MessageType {
  constructor(name, fields, options) {
    this.defaultCheckDepth = 16;
    this.typeName = name;
    this.fields = fields.map(normalizeFieldInfo);
    this.options = options !== null && options !== void 0 ? options : {};
    this.refTypeCheck = new ReflectionTypeCheck(this);
    this.refJsonReader = new ReflectionJsonReader(this);
    this.refJsonWriter = new ReflectionJsonWriter(this);
    this.refBinReader = new ReflectionBinaryReader(this);
    this.refBinWriter = new ReflectionBinaryWriter(this);
  }
  create(value) {
    let message = reflectionCreate(this);
    if (value !== void 0) {
      reflectionMergePartial(this, message, value);
    }
    return message;
  }
  clone(message) {
    let copy = this.create();
    reflectionMergePartial(this, copy, message);
    return copy;
  }
  equals(a, b) {
    return reflectionEquals(this, a, b);
  }
  is(arg, depth = this.defaultCheckDepth) {
    return this.refTypeCheck.is(arg, depth, false);
  }
  isAssignable(arg, depth = this.defaultCheckDepth) {
    return this.refTypeCheck.is(arg, depth, true);
  }
  mergePartial(target, source) {
    reflectionMergePartial(this, target, source);
  }
  fromBinary(data, options) {
    let opt = binaryReadOptions(options);
    return this.internalBinaryRead(opt.readerFactory(data), data.byteLength, opt);
  }
  fromJson(json, options) {
    return this.internalJsonRead(json, jsonReadOptions(options));
  }
  fromJsonString(json, options) {
    let value = JSON.parse(json);
    return this.fromJson(value, options);
  }
  toJson(message, options) {
    return this.internalJsonWrite(message, jsonWriteOptions(options));
  }
  toJsonString(message, options) {
    var _a3;
    let value = this.toJson(message, options);
    return JSON.stringify(value, null, (_a3 = options === null || options === void 0 ? void 0 : options.prettySpaces) !== null && _a3 !== void 0 ? _a3 : 0);
  }
  toBinary(message, options) {
    let opt = binaryWriteOptions(options);
    return this.internalBinaryWrite(message, opt.writerFactory(), opt).finish();
  }
  internalJsonRead(json, options, target) {
    if (json !== null && typeof json == "object" && !Array.isArray(json)) {
      let message = target !== null && target !== void 0 ? target : this.create();
      this.refJsonReader.read(json, message, options);
      return message;
    }
    throw new Error(`Unable to parse message ${this.typeName} from JSON ${typeofJsonValue(json)}.`);
  }
  internalJsonWrite(message, options) {
    return this.refJsonWriter.write(message, options);
  }
  internalBinaryWrite(message, writer, options) {
    this.refBinWriter.write(message, writer, options);
    return writer;
  }
  internalBinaryRead(reader, length, options, target) {
    let message = target !== null && target !== void 0 ? target : this.create();
    this.refBinReader.read(reader, message, options, length);
    return message;
  }
}
class SocketMessage$Type extends MessageType {
  constructor() {
    super("message.v1.SocketMessage", [
      { no: 1, name: "event", kind: "scalar", T: 13 },
      { no: 2, name: "id", kind: "scalar", opt: true, T: 9 },
      { no: 3, name: "payload", kind: "scalar", opt: true, T: 12 }
    ]);
  }
}
const SocketMessage = new SocketMessage$Type();
class Proto {
  static encode(message) {
    return SocketMessage.toBinary(message);
  }
  static decode(message) {
    return SocketMessage.fromBinary(new Uint8Array(message));
  }
}
var WebSocketReadyStates = /* @__PURE__ */ ((WebSocketReadyStates2) => {
  WebSocketReadyStates2[WebSocketReadyStates2["CONNECTING"] = 0] = "CONNECTING";
  WebSocketReadyStates2[WebSocketReadyStates2["OPEN"] = 1] = "OPEN";
  WebSocketReadyStates2[WebSocketReadyStates2["CLOSING"] = 2] = "CLOSING";
  WebSocketReadyStates2[WebSocketReadyStates2["CLOSED"] = 3] = "CLOSED";
  return WebSocketReadyStates2;
})(WebSocketReadyStates || {});
class Sockrates {
  constructor(url, config2) {
    __privateAdd2(this, _constructWebSocketAddress);
    __privateAdd2(this, _onMessage);
    __privateAdd2(this, _handleErrors);
    __privateAdd2(this, _send);
    __privateAdd2(this, _ws, void 0);
    __privateAdd2(this, _url, void 0);
    __privateAdd2(this, _config, void 0);
    __privateAdd2(this, _shouldConnect, void 0);
    __privateAdd2(this, _currentTimeout, void 0);
    __privateAdd2(this, _logger2, void 0);
    __privateAdd2(this, _sendQueue, void 0);
    __privateAdd2(this, _eventEmitter, void 0);
    var _a3, _b2, _c2, _d2, _e2, _f2;
    __privateSet2(this, _url, url);
    __privateSet2(this, _sendQueue, []);
    __privateSet2(this, _eventEmitter, new EventEmitter$1());
    __privateSet2(this, _shouldConnect, true);
    __privateSet2(this, _config, config2 != null ? config2 : {});
    (_b2 = (_a3 = __privateGet2(this, _config)).autoReconnect) != null ? _b2 : _a3.autoReconnect = true;
    (_d2 = (_c2 = __privateGet2(this, _config)).retryConnectionInterval) != null ? _d2 : _c2.retryConnectionInterval = 1e3;
    (_f2 = (_e2 = __privateGet2(this, _config)).debug) != null ? _f2 : _e2.debug = false;
    __privateSet2(this, _logger2, new Logger(__privateGet2(this, _config).debug ? "debug" : "info"));
  }
  get readyState() {
    return __privateGet2(this, _ws).readyState;
  }
  get url() {
    return __privateGet2(this, _url);
  }
  get config() {
    return __privateGet2(this, _config);
  }
  async connect() {
    return new Promise((resolve, reject) => {
      try {
        __privateSet2(this, _ws, new WebSocket(__privateMethod2(this, _constructWebSocketAddress, constructWebSocketAddress_fn).call(this, __privateGet2(this, _url))));
        __privateGet2(this, _ws).binaryType = "arraybuffer";
        __privateGet2(this, _logger2).debug("Connecting to", __privateGet2(this, _url));
        __privateGet2(this, _ws).onopen = () => {
          __privateGet2(this, _logger2).debug(`Ready State: ${WebSocketReadyStates[__privateGet2(this, _ws).readyState]}`);
          __privateGet2(this, _sendQueue).forEach((message) => {
            __privateMethod2(this, _send, send_fn).call(this, message);
          });
          __privateGet2(this, _eventEmitter).emit("connected");
          resolve();
        };
        __privateGet2(this, _ws).onclose = (ev) => {
          try {
            const { code: code2, reason } = ev;
            __privateGet2(this, _logger2).debug("Socket closed. Close event:", ev);
            __privateGet2(this, _logger2).debug("Connection closed code:", code2);
            __privateGet2(this, _logger2).debug("Connection closed reason:", reason);
            if (__privateGet2(this, _shouldConnect) && code2 !== 1e3 && __privateGet2(this, _config).autoReconnect) {
              __privateGet2(this, _logger2).debug(`Attempting reconnection in ${__privateGet2(this, _config).retryConnectionInterval} second(s).`);
              if (__privateGet2(this, _currentTimeout)) {
                return;
              }
              __privateSet2(this, _currentTimeout, setTimeout(async () => {
                await this.connect();
                __privateGet2(this, _eventEmitter).emit("reconnected", { code: code2, reason });
                __privateSet2(this, _currentTimeout, void 0);
              }, __privateGet2(this, _config).retryConnectionInterval));
            }
            __privateGet2(this, _eventEmitter).emit("disconnected", { code: code2, reason });
          } catch (err) {
            __privateMethod2(this, _handleErrors, handleErrors_fn).call(this, err, reject);
          }
        };
        __privateGet2(this, _ws).onerror = (ev) => {
          __privateMethod2(this, _handleErrors, handleErrors_fn).call(this, ev, reject);
        };
        __privateGet2(this, _ws).onmessage = (ev) => __privateMethod2(this, _onMessage, onMessage_fn).call(this, ev);
      } catch (err) {
        __privateMethod2(this, _handleErrors, handleErrors_fn).call(this, err);
      }
    });
  }
  send(event, id, payload) {
    const message = Proto.encode({ event, id, payload });
    __privateGet2(this, _logger2).debug(`Sending message: ${message}`);
    __privateMethod2(this, _send, send_fn).call(this, message);
  }
  emit(event, id, payload) {
    this.send(event, id, payload);
  }
  receive(event, listener) {
    __privateGet2(this, _eventEmitter).on(event.toString(), listener);
  }
  on(event, listener) {
    if (typeof event === "string" && (event === "connected" || event === "disconnected" || event === "errored" || event === "reconnected")) {
      __privateGet2(this, _eventEmitter).on(event, listener);
      return;
    }
    this.receive(event, listener);
  }
  removeAllListeners() {
    __privateGet2(this, _eventEmitter).removeAllListeners();
  }
  removeReceiver(event, receiver) {
    this.removeListener(event, receiver);
  }
  removeListener(event, listener) {
    __privateGet2(this, _eventEmitter).removeListener(event.toString(), listener);
  }
  removeReceivers(event) {
    this.removeListeners(event);
  }
  removeListeners(event) {
    __privateGet2(this, _eventEmitter).listeners(event.toString()).map((listener) => this.removeListener(event, listener));
  }
  disconnect() {
    __privateSet2(this, _shouldConnect, false);
    clearTimeout(__privateGet2(this, _currentTimeout));
    __privateSet2(this, _currentTimeout, void 0);
    this.removeAllListeners();
    __privateGet2(this, _ws).close(1e3, "Sockrates disconnect method called.");
  }
}
_ws = new WeakMap();
_url = new WeakMap();
_config = new WeakMap();
_shouldConnect = new WeakMap();
_currentTimeout = new WeakMap();
_logger2 = new WeakMap();
_sendQueue = new WeakMap();
_eventEmitter = new WeakMap();
_constructWebSocketAddress = new WeakSet();
constructWebSocketAddress_fn = function(url) {
  if (url.startsWith("ws://") || url.startsWith("wss://")) {
    return url;
  }
  if (url.startsWith("https://")) {
    return `wss://${url.substring(8)}`;
  }
  if (url.startsWith("http://")) {
    return `ws://${url.substring(7)}`;
  }
  throw new Error("Invalid URL. URL must start with http(s):// or ws(s)://.");
};
_onMessage = new WeakSet();
onMessage_fn = function(ev) {
  __privateGet2(this, _logger2).debug("Received data:", ev.data);
  const message = Proto.decode(ev.data);
  const { id, payload } = message;
  __privateGet2(this, _logger2).debug(`Received message: ${message}`);
  __privateGet2(this, _eventEmitter).emit(message.event.toString(), { id, payload });
};
_handleErrors = new WeakSet();
handleErrors_fn = function(err, reject) {
  __privateGet2(this, _logger2).error("Error:", err);
  __privateGet2(this, _eventEmitter).emit("errored", { error: err });
  reject(err);
};
_send = new WeakSet();
send_fn = function(message) {
  if (!__privateGet2(this, _ws) || __privateGet2(this, _ws).readyState !== 1) {
    __privateGet2(this, _sendQueue).push(message);
    return;
  }
  __privateGet2(this, _ws).send(message);
};
class SocketService {
  constructor({ peerId, roomName, authToken }) {
    __privateAdd(this, _generateId);
    __privateAdd(this, _url2, void 0);
    __privateAdd(this, _sockrates, void 0);
    __privateAdd(this, _peerId, void 0);
    const { apiBase } = config;
    const socketHost = apiBase.includes("staging.dyte") ? "socket-edge-staging.dyte.io" : "socket-edge.dyte.io";
    __privateSet(this, _url2, `wss://${socketHost}/ws?roomID=${roomName}&peerID=${peerId}&authToken=${authToken}`);
    __privateSet(this, _sockrates, new Sockrates(__privateGet(this, _url2)));
    __privateSet(this, _peerId, peerId);
  }
  async connect() {
    const disconnectListener = ({ reason, code: code2 }) => {
      log.info(`Disconnected from socket-edge: [${code2}] ${reason}`);
      if (code2 < 4e3 || code2 > 4002)
        return;
      if (code2 === 4e3) {
        log.error(`${code2} Bad Request`);
      } else if (code2 === 4001) {
        log.error(`${code2} Unauthorized`);
      } else if (code2 === 4002) {
        log.error(`${code2} Internal Error`);
      } else {
        log.error(`${code2} Unknown Error`);
      }
      this.disconnect();
      __privateGet(this, _sockrates).removeListener("disconnected", disconnectListener);
    };
    this.onStateEvent("disconnected", disconnectListener);
    await __privateGet(this, _sockrates).connect();
  }
  disconnect() {
    return __privateGet(this, _sockrates).disconnect();
  }
  sendMessage(event, protobuf, messageId) {
    return __privateGet(this, _sockrates).send(event, messageId != null ? messageId : __privateMethod(this, _generateId, generateId_fn).call(this), protobuf);
  }
  sendMessagePromise(event, protobuf, messageId) {
    return new Promise((resolve) => {
      const mId = messageId != null ? messageId : __privateMethod(this, _generateId, generateId_fn).call(this);
      const listener = ({ id, payload }) => {
        if (mId === id) {
          resolve({ id, payload });
          __privateGet(this, _sockrates).removeListener(event, listener);
        }
      };
      __privateGet(this, _sockrates).on(event, listener);
      __privateGet(this, _sockrates).send(event, mId, protobuf);
    });
  }
  on(event, listener) {
    __privateGet(this, _sockrates).on(event, listener);
  }
  onStateEvent(event, listener) {
    __privateGet(this, _sockrates).on(event, listener);
  }
}
_url2 = new WeakMap();
_sockrates = new WeakMap();
_peerId = new WeakMap();
_generateId = new WeakSet();
generateId_fn = function() {
  return `${__privateGet(this, _peerId)}-${(Math.random() + 1).toString(36).substring(7)}`;
};
class PluginSocketHandler {
  constructor(socketService) {
    __publicField(this, "socket");
    this.socket = socketService;
  }
  addPlugin(pluginId, staggered) {
    this.socket.sendMessage(pluginEvents.addPlugin, AddPluginRequest.toBinary({ pluginId, staggered }));
  }
  removePlugin(pluginId) {
    this.socket.sendMessage(pluginEvents.removePlugin, RemovePluginRequest.toBinary({ pluginId, staggered: false }));
  }
  async getActivePlugins() {
    const { payload } = await this.socket.sendMessagePromise(pluginEvents.getPlugins);
    return payload ? EnablePluginsResponse.fromBinary(payload) : { plugins: [] };
  }
  customPluginEventToRoom(pluginId, data, messageId) {
    const req = {
      pluginId,
      pluginData: new TextEncoder().encode(JSON.stringify(data))
    };
    this.socket.sendMessage(pluginEvents.customPluginEventToRoom, PluginEventToRoomRequest.toBinary(req), messageId);
  }
  customPluginEventToPeers(pluginId, peerIds, data, messageId) {
    const req = {
      pluginId,
      peerIds,
      pluginData: new TextEncoder().encode(JSON.stringify(data))
    };
    this.socket.sendMessage(pluginEvents.customPluginEventToPeers, PluginEventToPeersRequest.toBinary(req), messageId);
  }
  enablePluginForRoom(pluginId, messageId) {
    this.socket.sendMessage(pluginEvents.enablePluginForRoom, EnablePluginForRoomRequest.toBinary({ pluginId }), messageId);
  }
  enablePluginForPeers(pluginId, peerIds, messageId) {
    this.socket.sendMessage(pluginEvents.enablePluginForPeers, EnablePluginForPeersRequest.toBinary({ pluginId, peerIds }), messageId);
  }
  disablePluginForRoom(pluginId, messageId) {
    this.socket.sendMessage(pluginEvents.disablePluginForRoom, DisablePluginForRoomRequest.toBinary({ pluginId }), messageId);
  }
  disablePluginForPeers(pluginId, peerIds, messageId) {
    this.socket.sendMessage(pluginEvents.disablePluginForPeers, DisablePluginForPeersRequest.toBinary({ pluginId, peerIds }), messageId);
  }
  storeInsertKeys(pluginId, store, insertKeys, messageId) {
    const req = {
      pluginId,
      storeName: store,
      insertKeys: insertKeys.map((item) => ({
        storeKey: item.key,
        payload: new TextEncoder().encode(JSON.stringify(item.payload))
      }))
    };
    this.socket.sendMessage(pluginEvents.storeInsertKeys, PluginStoreInsertKeysRequest.toBinary(req), messageId);
  }
  storeGetKeys(pluginId, store, getKeys, messageId) {
    const req = {
      pluginId,
      storeName: store,
      getKeys: getKeys.map((item) => ({ storeKey: item.key }))
    };
    this.socket.sendMessage(pluginEvents.storeGetKeys, PluginStoreGetKeysRequest.toBinary(req), messageId);
  }
  storeDeleteKeys(pluginId, store, deleteKeys, messageId) {
    const req = {
      pluginId,
      storeName: store,
      deleteKeys: deleteKeys.map((item) => ({ storeKey: item.key }))
    };
    this.socket.sendMessage(pluginEvents.storeDeleteKeys, PluginStoreDeleteKeysRequest.toBinary(req), messageId);
  }
  storeDelete(pluginId, store, messageId) {
    this.socket.sendMessage(pluginEvents.storeDelete, PluginStoreDeleteRequest.toBinary({ pluginId, storeName: store }), messageId);
  }
  getPluginDataOld(pluginId, store) {
    log.debug(this, pluginId, store);
  }
  storePluginDataOld(pluginId, store, data) {
    const req = {
      pluginId,
      storeName: store,
      insertKeys: [{
        storeKey: data.key,
        payload: new TextEncoder().encode(JSON.stringify(data))
      }]
    };
    this.socket.sendMessage(pluginEvents.storeInsertKeys, PluginStoreInsertKeysRequest.toBinary(req));
  }
}
var __defProp$5 = Object.defineProperty;
var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
var __decorateClass$5 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$5(target, key, result);
  return result;
};
class DyteRecording extends DyteEventEmitter {
  constructor(self2) {
    super();
    __privateAdd(this, _self11, void 0);
    __publicField(this, "recordingState", "IDLE");
    __publicField(this, "recordingId");
    __publicField(this, "recordingPeerId");
    __privateSet(this, _self11, self2);
  }
  setRecordingState(recordingState) {
    const previousState = this.recordingState;
    this.recordingState = recordingState;
    if (previousState !== recordingState)
      this.emitCurrentRecordingState();
  }
  emitCurrentRecordingState() {
    this.emit("recordingUpdate", this.recordingState);
  }
  async start() {
    if (!__privateGet(this, _self11).permissions.canRecord) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::start::permission_denied");
      throw new DyteError("User does not have permission to start recording");
    }
    if (this.recordingState === "STARTING" || this.recordingState === "RECORDING" || this.recordingState === "STOPPING") {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::start::recording_in_progress", {
        recordingState: this.recordingState
      });
      throw new DyteError(`Cant start recording, recordingState irregular: ${this.recordingState}`);
    }
    this.setRecordingState("STARTING");
    try {
      const APIClient2 = getAPIClient();
      const recordingId = await APIClient2.startRecording();
      this.recordingId = recordingId;
    } catch {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::recording_failed_to_start");
      this.setRecordingState("IDLE");
      throw new DyteError("Error while starting recording");
    }
  }
  async stop() {
    if (!__privateGet(this, _self11).permissions.canRecord) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::permission_denied");
      throw new DyteError("User does not have permission to stop recording");
    }
    if (!(this.recordingState === "RECORDING") || !this.recordingId) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::recording_not_in_progress", {
        recordingState: this.recordingState,
        recordingId: this.recordingId
      });
      await this.getRecordingId();
    }
    if (!(this.recordingState === "RECORDING") || !this.recordingId) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::recording_not_in_progress", {
        recordingState: this.recordingState,
        recordingId: this.recordingId
      });
      throw new DyteError(`Cant stop recording, recordingState irregular: ${this.recordingState}`);
    }
    this.setRecordingState("STOPPING");
    try {
      const APIClient2 = getAPIClient();
      await APIClient2.stopRecording(this.recordingId);
      this.setRecordingState("IDLE");
    } catch {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::stop::recording_failed_to_stop");
      this.setRecordingState("RECORDING");
      throw new DyteError("Error while stopping recording");
    }
  }
  async getRecordingId() {
    if (!__privateGet(this, _self11).permissions.canRecord) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::getRecordingId::permission_denied");
      throw new DyteError("User does not have permission to stop recording");
    }
    try {
      const APIClient2 = getAPIClient();
      const { status, id } = await APIClient2.getActiveRecording();
      if (status === "RECORDING") {
        this.recordingState = "RECORDING";
        this.recordingId = id;
      }
    } catch (error) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteRecording::getRecordingId::unable_to_get_recording_id");
      throw new DyteError("Unable to stop recording");
    }
  }
}
_self11 = new WeakMap();
__decorateClass$5([
  DyteTelemetry.trace("recording.start")
], DyteRecording.prototype, "start", 1);
__decorateClass$5([
  DyteTelemetry.trace("recording.stop")
], DyteRecording.prototype, "stop", 1);
__decorateClass$5([
  DyteTelemetry.trace("getRecordingId")
], DyteRecording.prototype, "getRecordingId", 1);
var __defProp$4 = Object.defineProperty;
var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
var __decorateClass$4 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$4(target, key, result);
  return result;
};
class RecordingController {
  constructor(self2) {
    __publicField(this, "recording");
    this.recording = new DyteRecording(self2);
    this.setupEvents();
  }
  setupEvents() {
    SessionStore.on(SessionEvents.PEER_JOINED, async (p) => {
      var _a3;
      if ((_a3 = p.flags) == null ? void 0 : _a3.recorder) {
        this.recording.recordingPeerId = p.id;
        this.recording.setRecordingState("RECORDING");
      }
    });
    SessionStore.on(SessionEvents.PEER_CLOSED, (p) => {
      if (p.id === this.recording.recordingPeerId) {
        this.recording.recordingPeerId = void 0;
        this.recording.setRecordingState("IDLE");
      }
    });
    SessionStore.onAsync(SessionEvents.ROOM_JOINED, async (payload) => {
      var _a3;
      DyteTelemetry.addEventInCurrentSpan("debug", "[ROOM_JOINED] resolved request to fetch recordings.");
      const recordingPeers = (_a3 = payload.peers) == null ? void 0 : _a3.filter((p) => {
        var _a4;
        return !!((_a4 = p.flags) == null ? void 0 : _a4.recorder);
      });
      if (!recordingPeers.length)
        return;
      this.recording.setRecordingState("RECORDING");
    });
    SessionStore.on(SessionEvents.RECORDING_STARTED, () => {
      this.recording.setRecordingState("RECORDING");
    });
    SessionStore.on(SessionEvents.RECORDING_STOPPED, () => {
      this.recording.recordingId = void 0;
      this.recording.recordingPeerId = void 0;
      this.recording.setRecordingState("IDLE");
    });
  }
}
__decorateClass$4([
  DyteTelemetry.trace("RecordingController.setupEvents")
], RecordingController.prototype, "setupEvents", 1);
var TabChangeSource;
(function(TabChangeSource2) {
  TabChangeSource2[TabChangeSource2["User"] = 0] = "User";
  TabChangeSource2[TabChangeSource2["Spotlight"] = 1] = "Spotlight";
})(TabChangeSource || (TabChangeSource = {}));
const _DyteSpotlight = class extends DyteEventEmitter {
  constructor(roomNodeClient, self2) {
    super();
    __publicField(this, "selfActiveTab");
    __publicField(this, "spotlighted");
    __privateAdd(this, _roomNodeClient15, void 0);
    __privateAdd(this, _self12, void 0);
    this.spotlighted = self2.permissions.canSpotlight;
    __privateSet(this, _roomNodeClient15, roomNodeClient);
    __privateSet(this, _self12, self2);
  }
  static init(roomNodeClient, self2) {
    return new _DyteSpotlight(roomNodeClient, self2);
  }
  setSpotlighted(spotlighted) {
    if (!__privateGet(this, _self12).permissions.canSpotlight) {
      DyteTelemetry.addEventInCurrentSpan("error", "DyteSpotlight::setSpotlighted::permission_denied");
      throw new DyteError("User does not have permission to toggle spotlight");
    }
    this.spotlighted = spotlighted;
    if (this.spotlighted)
      this.assertSpotlightToRoom();
  }
  setSelfActiveTab(spotlightTab, tabChangeSource) {
    var _a3;
    DyteTelemetry.addEventInCurrentSpan("info", "DyteSpotlight::setActiveTab", { spotlightTab });
    this.selfActiveTab = spotlightTab;
    if (((_a3 = __privateGet(this, _self12).permissions) == null ? void 0 : _a3.canSpotlight) && this.spotlighted && tabChangeSource === 0)
      this.assertSpotlightToRoom();
  }
  assertSpotlightToRoom() {
    __privateGet(this, _roomNodeClient15).assertSpotlightToRoom({
      spotlightedUserId: __privateGet(this, _self12).userId,
      currentTab: this.selfActiveTab,
      peerId: void 0
    });
  }
};
let DyteSpotlight = _DyteSpotlight;
_roomNodeClient15 = new WeakMap();
_self12 = new WeakMap();
var __defProp$3 = Object.defineProperty;
var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
var __decorateClass$3 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$3(target, key, result);
  return result;
};
class SpotlightController {
  constructor(self2, roomNodeClient) {
    __publicField(this, "spotlight");
    __privateAdd(this, _self13, void 0);
    __privateAdd(this, _roomNodeClient16, void 0);
    this.spotlight = DyteSpotlight.init(roomNodeClient, self2);
    __privateSet(this, _roomNodeClient16, roomNodeClient);
    __privateSet(this, _self13, self2);
    this.setupEvents();
  }
  conditionallySetActiveTab(dyteSpotlightAssertMessage) {
    var _a3;
    if ((dyteSpotlightAssertMessage == null ? void 0 : dyteSpotlightAssertMessage.currentTab) && ((_a3 = this.spotlight.selfActiveTab) == null ? void 0 : _a3.id) !== dyteSpotlightAssertMessage.currentTab.id) {
      this.spotlight.setSelfActiveTab(dyteSpotlightAssertMessage.currentTab, TabChangeSource.Spotlight);
      this.spotlight.emit("activeTabUpdate", dyteSpotlightAssertMessage.currentTab);
    }
  }
  async setupEvents() {
    if (__privateGet(this, _self13).permissions.canSpotlight) {
      DyteTelemetry.addEventInCurrentSpan("info", "DyteSpotlightController::Asserting Spotlight");
      __privateGet(this, _roomNodeClient16).assertSpotlightToRoom({
        spotlightedUserId: __privateGet(this, _self13).userId,
        currentTab: this.spotlight.selfActiveTab,
        peerId: void 0
      });
    }
    SessionStore.on(SessionEvents.PEER_JOINED, async (p) => {
      if (__privateGet(this, _self13).permissions.canSpotlight) {
        __privateGet(this, _roomNodeClient16).assertSpotlightToPeer({
          spotlightedUserId: __privateGet(this, _self13).userId,
          currentTab: this.spotlight.selfActiveTab,
          peerId: p.id
        });
      }
    });
    SessionStore.on(SessionEvents.ROOM_MESSAGE, (payload) => {
      DyteTelemetry.addEventInCurrentSpan("info", "Spotlight Assertion Received", { spotligher: payload.spotlightedUserId, currentTab: payload.currentTab });
      this.conditionallySetActiveTab(payload);
    });
    SessionStore.on(SessionEvents.MESSAGE, (payload) => {
      DyteTelemetry.addEventInCurrentSpan("info", "Spotlight Assertion Received", { spotligher: payload.spotlightedUserId, currentTab: payload.currentTab });
      this.conditionallySetActiveTab(payload);
    });
  }
}
_self13 = new WeakMap();
_roomNodeClient16 = new WeakMap();
__decorateClass$3([
  DyteTelemetry.trace("SpotlightController.setupEvents")
], SpotlightController.prototype, "setupEvents", 1);
function shuffleArray(inputArray) {
  return inputArray.sort(() => Math.random() - 0.5);
}
const StateManagerMeetingIdPrefix = "NewConnectedMeeting_";
function clone(toBeCloned) {
  return JSON.parse(JSON.stringify(toBeCloned));
}
class StateManager extends DyteEventEmitter {
  constructor(connectedMeetings) {
    super();
    __publicField(this, "connectedMeetings");
    __publicField(this, "parentMeetingParticipants", []);
    __publicField(this, "parentMeetingParticipantsMap", {});
    __publicField(this, "connectedMeetingsParticipants", []);
    __publicField(this, "connectedMeetingsParticipantsMap", {});
    __publicField(this, "clientSpecificIdToMeetingIdMap", {});
    __publicField(this, "meetingsList", []);
    this.connectedMeetings = connectedMeetings;
  }
  getUnassignedParticipants() {
    const assignedClientSpecificIds = [];
    this.meetingsList.forEach((meeting) => {
      meeting.participants.forEach((participant) => {
        assignedClientSpecificIds.push(participant.clientSpecificId);
      });
    });
    const allUnassignedParticipants = [];
    const allClientSpecificIds = Object.keys(this.parentMeetingParticipantsMap);
    allClientSpecificIds.forEach((clientSpecificId) => {
      if (!assignedClientSpecificIds.includes(clientSpecificId)) {
        allUnassignedParticipants.push(this.parentMeetingParticipantsMap[clientSpecificId]);
      }
    });
    return allUnassignedParticipants;
  }
  openTitleEditorForConnectedMeeting(meetingId) {
    const meeting = this.meetingsList.find((x) => x.id === meetingId);
    meeting.isTitleEditorOpen = true;
    this.emit("stateUpdate", { source: "openTitleEditorForConnectedMeeting" });
  }
  closeTitleEditorForConnectedMeeting(meetingId) {
    const meeting = this.meetingsList.find((x) => x.id === meetingId);
    meeting.isTitleEditorOpen = false;
    this.emit("stateUpdate", { source: "closeTitleEditorForConnectedMeeting" });
  }
  assignParticipants(meetingId, clientSpecificIds, skipEmit) {
    this.unassignParticipants(clientSpecificIds);
    const meeting = this.meetingsList.find((x) => x.id === meetingId);
    if (meeting) {
      clientSpecificIds.forEach((clientSpecificId) => {
        const participantFromConnectedMeeting = this.connectedMeetingsParticipantsMap[clientSpecificId];
        if (participantFromConnectedMeeting) {
          meeting.participants.push(participantFromConnectedMeeting);
        } else {
          meeting.participants.push(this.parentMeetingParticipantsMap[clientSpecificId]);
        }
      });
    }
    if (!skipEmit) {
      this.emit("stateUpdate", { source: "assignParticipants" });
    }
  }
  assignParticipantsRandomly(clientSpecificIds) {
    let allClientSpecificIds = [];
    if (clientSpecificIds == null ? void 0 : clientSpecificIds.length) {
      allClientSpecificIds = [...clientSpecificIds];
    } else {
      allClientSpecificIds = this.getUnassignedParticipants().map((participant) => participant.clientSpecificId);
    }
    allClientSpecificIds = shuffleArray(allClientSpecificIds);
    const activeMeetings = this.meetingsList.filter((meeting) => meeting.status === "ACTIVE" && !meeting.shouldDelete);
    const participantsToAssignPerRoom = Math.floor(allClientSpecificIds.length / activeMeetings.length);
    activeMeetings.forEach((meeting, index) => {
      const clientSpecificIdsToAssign = allClientSpecificIds.slice(index * participantsToAssignPerRoom, (index + 1) * participantsToAssignPerRoom);
      clientSpecificIdsToAssign.forEach((clientSpecificId) => {
        const participantFromConnectedMeeting = this.connectedMeetingsParticipantsMap[clientSpecificId];
        if (participantFromConnectedMeeting) {
          meeting.participants.push(participantFromConnectedMeeting);
        } else {
          meeting.participants.push(this.parentMeetingParticipantsMap[clientSpecificId]);
        }
      });
    });
    const remaininClientSpecificIds = allClientSpecificIds.slice(activeMeetings.length * participantsToAssignPerRoom);
    remaininClientSpecificIds.forEach((clientSpecificId) => {
      const randomMeetingId = activeMeetings[Math.floor(Math.random() * activeMeetings.length)].id;
      this.assignParticipants(randomMeetingId, [clientSpecificId], true);
    });
    this.emit("stateUpdate", { source: "assignParticipantsRandomly" });
  }
  unassignParticipants(clientSpecificIds) {
    this.meetingsList.forEach((meeting) => {
      meeting.participants = meeting.participants.filter((participant) => !clientSpecificIds.includes(participant.clientSpecificId));
    });
    this.emit("stateUpdate", { source: "unassignParticipants" });
  }
  unassignAllParticipants() {
    this.meetingsList.forEach((meeting) => {
      meeting.participants.splice(0);
    });
    this.emit("stateUpdate", { source: "unassignAllParticipants" });
  }
  addNewConnectedMeeting(title) {
    this.meetingsList.push({
      id: StateManagerMeetingIdPrefix + v4(),
      title: title || `Room ${this.getConnectedMeetings().length + 1}`,
      status: "ACTIVE",
      shouldPersistInDB: true,
      participants: []
    });
    this.emit("stateUpdate", { source: "addNewConnectedMeeting" });
  }
  renameConnectedMeeting(meetingId, title) {
    const meetingToRename = this.meetingsList.find((meeting) => meeting.id === meetingId);
    meetingToRename.title = title;
    meetingToRename.shouldRename = true;
    this.emit("stateUpdate", { source: "renameConnectedMeeting" });
  }
  deleteConnectedMeetings(meetingIds) {
    this.meetingsList.forEach((meeting) => {
      if (meetingIds.includes(meeting.id)) {
        Object.assign(meeting, { shouldDelete: true });
        Object.assign(meeting, { participants: [] });
      }
    });
    this.emit("stateUpdate", { source: "deleteConnectedMeeting" });
  }
  getConnectedMeetings() {
    return this.meetingsList.filter((meeting) => !meeting.shouldDelete);
  }
  async applyChanges() {
    const meetingIdsToDelete = [];
    const bulkMoveMap = {};
    const meetingsToRename = [];
    await Promise.all(this.meetingsList.map(async (meeting) => {
      var _a3, _b2, _c2;
      if (meeting.shouldDelete && !meeting.id.startsWith(StateManagerMeetingIdPrefix)) {
        meetingIdsToDelete.push(meeting.id);
        return;
      }
      if (meeting.shouldPersistInDB) {
        try {
          const res = await this.connectedMeetings.createConnectedMeetings([{ title: meeting.title }]);
          if (((_a3 = res == null ? void 0 : res.payload) == null ? void 0 : _a3.meetings) && ((_c2 = (_b2 = res == null ? void 0 : res.payload) == null ? void 0 : _b2.meetings[0]) == null ? void 0 : _c2.id)) {
            Object.assign(meeting, { id: res.payload.meetings[0].id });
          } else {
            DyteTelemetry.addEventInCurrentSpan("error", "ConnectedMeetingsState::applyChanges::replacingMeetingId", res == null ? void 0 : res.payload);
          }
        } catch (ex) {
          DyteTelemetry.addEventInCurrentSpan("error", "ConnectedMeetingsState::applyChanges::replacingMeetingId", ex);
        }
      } else if (meeting.shouldRename) {
        meetingsToRename.push({
          title: meeting.title,
          meetingId: meeting.id
        });
      }
      meeting.participants.forEach((participant) => {
        const sourceMeetingId = this.clientSpecificIdToMeetingIdMap[participant.clientSpecificId];
        const destinationMeetingId = meeting.id;
        if (sourceMeetingId !== destinationMeetingId) {
          const keyOnBulkMoveMap = `${sourceMeetingId}__${destinationMeetingId}`.toString();
          bulkMoveMap[keyOnBulkMoveMap] = bulkMoveMap[keyOnBulkMoveMap] || {
            participantIds: []
          };
          bulkMoveMap[keyOnBulkMoveMap].participantIds.push(participant.id);
        }
      });
    }));
    if (meetingsToRename.length > 0) {
      await this.connectedMeetings.updateConnectedMeetings(meetingsToRename);
    }
    const unassignedParticipants = this.getUnassignedParticipants();
    unassignedParticipants.forEach((participant) => {
      var _a3, _b2, _c2;
      const sourceMeetingId = this.clientSpecificIdToMeetingIdMap[participant.clientSpecificId];
      const destinationMeetingId = (_a3 = this.connectedMeetings) == null ? void 0 : _a3.parentMeeting.id;
      if (sourceMeetingId !== destinationMeetingId) {
        const keyOnBulkMoveMap = `${sourceMeetingId}__${destinationMeetingId}`.toString();
        bulkMoveMap[keyOnBulkMoveMap] = bulkMoveMap[keyOnBulkMoveMap] || {
          participantIds: []
        };
        const participantIdFromConnectedRooms = (_b2 = this.connectedMeetingsParticipantsMap[participant.clientSpecificId]) == null ? void 0 : _b2.id;
        const participantIdFromParentRoom = (_c2 = this.parentMeetingParticipantsMap[participant.clientSpecificId]) == null ? void 0 : _c2.id;
        bulkMoveMap[keyOnBulkMoveMap].participantIds.push(participantIdFromConnectedRooms || participantIdFromParentRoom);
      }
    });
    await Promise.all(Object.keys(bulkMoveMap).map(async (bulkMoveMapKey) => {
      const [sourceMeetingId, destinationMeetingId] = bulkMoveMapKey.split("__");
      if (!destinationMeetingId.startsWith(StateManagerMeetingIdPrefix)) {
        return this.connectedMeetings.moveParticipants({
          sourceMeetingId,
          destinationMeetingId,
          participants: bulkMoveMap[bulkMoveMapKey].participantIds
        });
      }
      DyteTelemetry.addEventInCurrentSpan("error", "ConnectedMeetingsState::applyChanges::meetingIdNotReplaced", {
        message: "Please find errors with ConnectedMeetingsState::applyChanges::replacingMeetingId to know more"
      });
      return null;
    }));
    if (meetingIdsToDelete.length > 0) {
      await this.connectedMeetings.deleteConnectedMeetings(meetingIdsToDelete);
    }
    this.reset();
  }
  async startConnectedMeetings() {
    return this.applyChanges();
  }
  reset() {
    this.meetingsList = [];
    this.emit("stateUpdate", { source: "reset" });
  }
  init() {
    var _a3, _b2, _c2;
    this.meetingsList = clone(((_a3 = this.connectedMeetings.list) == null ? void 0 : _a3.filter((x) => x.status === "ACTIVE")) || []);
    this.parentMeetingParticipants = clone(((_c2 = (_b2 = this.connectedMeetings) == null ? void 0 : _b2.parentMeeting) == null ? void 0 : _c2.participants) || []);
    this.parentMeetingParticipantsMap = {};
    this.parentMeetingParticipants.forEach((participant) => {
      var _a4, _b3;
      this.parentMeetingParticipantsMap[participant.clientSpecificId] = participant;
      this.clientSpecificIdToMeetingIdMap[participant.clientSpecificId] = (_b3 = (_a4 = this.connectedMeetings) == null ? void 0 : _a4.parentMeeting) == null ? void 0 : _b3.id;
    });
    this.connectedMeetingsParticipants = [];
    this.connectedMeetingsParticipantsMap = {};
    this.connectedMeetings.list.forEach((meeting) => {
      var _a4;
      this.connectedMeetingsParticipants = this.connectedMeetingsParticipants.concat(clone(meeting.participants || []));
      (_a4 = meeting.participants) == null ? void 0 : _a4.forEach((participant) => {
        this.connectedMeetingsParticipantsMap[participant.clientSpecificId] = clone(participant);
        this.clientSpecificIdToMeetingIdMap[participant.clientSpecificId] = meeting.id;
      });
    });
    this.emit("stateUpdate", { source: "init" });
  }
}
var __defProp$2 = Object.defineProperty;
var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
var __decorateClass$2 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$2(target, key, result);
  return result;
};
const _DyteConnectedMeetings = (_h = class extends DyteEventEmitter {
  constructor(roomNodeClient, self2) {
    super();
    __privateAdd(this, _roomNodeClient17, void 0);
    __privateAdd(this, _self14, void 0);
    __publicField(this, "stateManager");
    __publicField(this, "list", []);
    __publicField(this, "parentMeeting", null);
    __privateSet(this, _roomNodeClient17, roomNodeClient);
    __privateSet(this, _self14, self2);
    this.stateManager = new StateManager(this);
  }
  get supportsConnectedMeetings() {
    return __privateGet(this, _self14).id !== "" && constants.isV2AuthToken && dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.CONNECTED_MEETINGS);
  }
  validateConnectedMeetingsAction() {
    if (!this.supportsConnectedMeetings) {
      throw new Error(`You are not allowed to perform this action.
            Please connect with Dyte team to move you to V2 APIs & to enable connected meetings.`);
    }
  }
  async createConnectedMeetings(payload) {
    this.validateConnectedMeetingsAction();
    return __privateGet(this, _roomNodeClient17).sendMessage({ type: "createConnectedMeetings", payload });
  }
  async getConnectedMeetings() {
    this.validateConnectedMeetingsAction();
    return __privateGet(this, _roomNodeClient17).sendMessage({ type: "getConnectedMeetings" });
  }
  async updateConnectedMeetings(payload) {
    this.validateConnectedMeetingsAction();
    return __privateGet(this, _roomNodeClient17).sendMessage({ type: "updateConnectedMeetings", payload });
  }
  async deleteConnectedMeetings(meetingIds) {
    this.validateConnectedMeetingsAction();
    return __privateGet(this, _roomNodeClient17).sendMessage({ type: "deleteConnectedMeetings", payload: { meetingIds } });
  }
  async moveParticipants(payload) {
    this.validateConnectedMeetingsAction();
    const res = await __privateGet(this, _roomNodeClient17).sendMessage({ type: "moveConnectedMeeting", payload });
    return res;
  }
  canSwitchConnectedMeetings() {
    var _a3;
    const permissions = (_a3 = __privateGet(this, _self14).permissions) == null ? void 0 : _a3.connectedMeetings;
    return permissions.canSwitchConnectedMeetings;
  }
  canAlterConnectedMeetings() {
    var _a3;
    const permissions = (_a3 = __privateGet(this, _self14).permissions) == null ? void 0 : _a3.connectedMeetings;
    return permissions.canAlterConnectedMeetings;
  }
  canSwitchToParentMeeting() {
    var _a3;
    const permissions = (_a3 = __privateGet(this, _self14).permissions) == null ? void 0 : _a3.connectedMeetings;
    return permissions.canSwitchToParentMeeting;
  }
  hasActiveMeetings() {
    var _a3;
    return (_a3 = this.list) == null ? void 0 : _a3.some((connectedMeeting) => connectedMeeting.status === "ACTIVE");
  }
  async switchMeeting(options) {
    this.validateConnectedMeetingsAction();
    __privateGet(this, _self14).cleanUpTracks();
    const { roomName = config == null ? void 0 : config.roomName } = options != null ? options : {};
    const { authToken } = options != null ? options : {};
    const { apiBase = config == null ? void 0 : config.apiBase } = options != null ? options : {};
    const { defaults = config == null ? void 0 : config.defaults } = options != null ? options : {};
    const { modules = config == null ? void 0 : config.modules } = options != null ? options : {};
    const newMeeting = await DyteClient.init({
      roomName,
      authToken,
      apiBase,
      defaults,
      modules
    });
    this.emit("movedToMeeting", { meeting: newMeeting });
    return newMeeting;
  }
  async createNConnectedMeetings(count, prefix = "Breakout Room") {
    var _a3;
    this.validateConnectedMeetingsAction();
    const totalConnectedMeetings = ((_a3 = this.list) == null ? void 0 : _a3.length) || 0;
    const meetings = [];
    for (let index = 0; index < count; index += 1) {
      meetings.push({
        title: `${prefix} ${totalConnectedMeetings + index + 1}`
      });
    }
    return this.createConnectedMeetings(meetings);
  }
  static init(roomNodeClient, self2) {
    return new _DyteConnectedMeetings(roomNodeClient, self2);
  }
}, _roomNodeClient17 = new WeakMap(), _self14 = new WeakMap(), _h);
let DyteConnectedMeetings = _DyteConnectedMeetings;
__decorateClass$2([
  DyteTelemetry.trace("switchMeeting")
], DyteConnectedMeetings.prototype, "switchMeeting", 1);
var __defProp$1 = Object.defineProperty;
var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
var __decorateClass$1 = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp$1(target, key, result);
  return result;
};
class ConnectedMeetingsController {
  constructor(roomNodeClient, self2) {
    __publicField(this, "connectedMeetings");
    this.connectedMeetings = DyteConnectedMeetings.init(roomNodeClient, self2);
    if (constants.isV2AuthToken && dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.CONNECTED_MEETINGS)) {
      this.connectedMeetings.getConnectedMeetings().then((res) => {
        var _a3, _b2;
        this.connectedMeetings.list = ((_a3 = res.payload) == null ? void 0 : _a3.meetings) || [];
        this.connectedMeetings.parentMeeting = ((_b2 = res.payload) == null ? void 0 : _b2.parentMeeting) || null;
        if (res.payload) {
          this.connectedMeetings.emit("connectedMeetingState", res.payload);
        }
      }).catch((ex) => {
        DyteTelemetry.addEventInCurrentSpan("error", "MetaController:getConnectedMeetings", { ex });
      });
    }
    this.setupEvents();
  }
  setupEvents() {
    SessionStore.on(SessionEvents.CONNECTED_MEETING_STATE, (payload) => {
      this.connectedMeetings.list = payload.meetings;
      this.connectedMeetings.parentMeeting = payload.parentMeeting;
      this.connectedMeetings.emit("connectedMeetingState", payload);
    });
    SessionStore.on(SessionEvents.MOVE_TO_CONNECTED_MEETING, (payload) => {
      this.connectedMeetings.emit("moveToConnectedMeeting", payload);
    });
  }
}
__decorateClass$1([
  DyteTelemetry.trace("ConnectedMeetingsController.setupEvents")
], ConnectedMeetingsController.prototype, "setupEvents", 1);
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
const _Controller = (_i = class {
  constructor(apiBase, metaController, selfController, pluginController, participantController, chatController, pollController, remoteController, recordingController, spotlightController, socketService, roomNodeClient, connectedMeetingsController) {
    __publicField(this, "apiBase");
    __privateAdd(this, _socketService2, void 0);
    __publicField(this, "roomNodeClient");
    __publicField(this, "chatController");
    __publicField(this, "metaController");
    __publicField(this, "participantController");
    __publicField(this, "pluginController");
    __publicField(this, "pollController");
    __publicField(this, "remoteController");
    __publicField(this, "selfController");
    __publicField(this, "recordingController");
    __publicField(this, "spotlightController");
    __publicField(this, "connectedMeetingsController");
    this.apiBase = apiBase;
    this.metaController = metaController;
    this.selfController = selfController;
    this.pluginController = pluginController;
    this.participantController = participantController;
    this.chatController = chatController;
    this.pollController = pollController;
    this.remoteController = remoteController;
    this.recordingController = recordingController;
    this.spotlightController = spotlightController;
    __privateSet(this, _socketService2, socketService);
    this.roomNodeClient = roomNodeClient;
    this.connectedMeetingsController = connectedMeetingsController;
  }
  static async init(options) {
    var _a3, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2, _j;
    browserSpecs.init();
    const {
      apiBase = "https://api.cluster.dyte.in",
      defaults = { video: true, audio: true },
      authToken,
      modules = {
        chat: true,
        participant: true,
        plugin: true,
        poll: true,
        self: true,
        meta: true,
        permissions: true,
        theme: true,
        spotlight: true
      }
    } = options;
    setConfig(__spreadProps(__spreadValues({}, options), { apiBase }));
    const peerId = v4();
    const APIClient2 = setupAPIClient({ authToken, baseURL: apiBase });
    APIClient2.setHeader("dyte-tracing-id", peerId);
    APIClient2.setPeerId(peerId);
    APIClient2.setRoomName(options.roomName);
    setupMediaPolyfill();
    DyteTelemetry.init(peerId);
    DyteTelemetry.meetingMetadata.roomName = options.roomName;
    DyteTelemetry.meetingMetadata.sdkVersion = WEB_CORE_VERSION;
    DyteTelemetry.meetingMetadata.deviceInfo = browserSpecs.getDeviceInfo();
    let localMediaHandler;
    if (navigator.RNLocalMediaHandlerImpl) {
      const { RNLocalMediaHandlerImpl } = navigator;
      localMediaHandler = await RNLocalMediaHandlerImpl.init();
    } else {
      localMediaHandler = await LocalMediaHandler.init();
    }
    const [roomNodeClient, socketService] = await Promise.all([
      _Controller.createRoomNodeClient(options, localMediaHandler, peerId),
      _Controller.createSocketService(__spreadProps(__spreadValues({}, options), {
        roomName: constants.isV2AuthToken ? constants.meetingId : options.roomName,
        peerId
      }))
    ]);
    let chatController;
    let participantController;
    let pluginController;
    let pollController;
    let selfController;
    let metaController;
    let remoteController;
    let recordingController;
    let spotlightController;
    let connectedMeetingsController;
    const chatSocketHandler = new ChatSocketHandler(socketService);
    const pluginSocketHandler = new PluginSocketHandler(socketService);
    if ((_a3 = modules.self) != null ? _a3 : true) {
      [selfController] = await Promise.all([SelfController.init(socketService, roomNodeClient, { modules, defaults }, localMediaHandler), roomNodeClient.setupTransports()]);
      APIClient2.setOrganizationId(selfController.self.organizationId);
    } else {
      await roomNodeClient.setupTransports();
    }
    if ((_b2 = modules.chat) != null ? _b2 : true) {
      if (!selfController) {
        throw new DyteError("The chat module cannot be initialized without the `self` module");
      }
      chatController = await ChatController.init(chatSocketHandler, roomNodeClient, selfController.self);
    }
    if ((_c2 = modules.participant) != null ? _c2 : true) {
      if (!selfController) {
        throw new DyteError("The participant module cannot be initialized without the `self` module");
      }
      participantController = new ParticipantController(roomNodeClient, selfController.self);
    }
    if ((_d2 = modules.plugin) != null ? _d2 : true) {
      if (!selfController) {
        throw new DyteError("The plugin module cannot be initialized without the `self` module");
      }
      if (!participantController) {
        throw new DyteError("The plugin module cannot be initialized without the `participant` module");
      }
      pluginController = await PluginController.init(pluginSocketHandler, chatSocketHandler, chatController == null ? void 0 : chatController.chat, roomNodeClient, selfController.self, participantController.participants);
    }
    if ((_e2 = modules.poll) != null ? _e2 : true) {
      if (!selfController) {
        throw new DyteError("The poll cannot be initialized without the `self` module");
      }
      pollController = new PollController(roomNodeClient, selfController.self);
    }
    if ((_f2 = modules.meta) != null ? _f2 : true) {
      if (!selfController) {
        throw new DyteError("The meta module cannot be initialized without the `self` module");
      }
      metaController = new MetaController(roomNodeClient, selfController.self);
    }
    if ((_g2 = modules.connectedMeetings) != null ? _g2 : true) {
      connectedMeetingsController = new ConnectedMeetingsController(roomNodeClient, selfController.self);
    }
    if ((_h2 = modules.remoteControl) != null ? _h2 : true) {
      if (!selfController) {
        throw new DyteError("The remote controller cannot be initialized without the `self` module");
      }
      remoteController = new RemoteController(roomNodeClient, selfController.self, participantController.participants);
    }
    if ((_i2 = modules.recording) != null ? _i2 : true) {
      if (!selfController) {
        throw new DyteError("The recording controller cannot be initialized without the `self` module");
      }
      recordingController = new RecordingController(selfController.self);
    }
    if ((_j = modules.spotlight) != null ? _j : true) {
      if (!selfController) {
        throw new DyteError("The spotlight controller cannot be initialized without the `self` module");
      }
      if (dist.globalFlagsmith.hasFeature(FlagsmithFeatureFlags.FEAT_SPOTLIGHT)) {
        spotlightController = new SpotlightController(selfController.self, roomNodeClient);
      }
    }
    return new _Controller(apiBase, metaController, selfController, pluginController, participantController, chatController, pollController, remoteController, recordingController, spotlightController, socketService, roomNodeClient, connectedMeetingsController);
  }
  static async createSocketService(options) {
    const { peerId, roomName, authToken } = options;
    const socketService = new SocketService({
      peerId,
      roomName,
      authToken
    });
    try {
      await socketService.connect();
    } catch (err) {
      log.error("[Socket Service] Failed to connect to socket server:", err);
    }
    return socketService;
  }
  static async createRoomNodeClient(options, localMediaHandler, peerId) {
    const {
      roomName,
      authToken
    } = options;
    const socketRoomName = constants.isV2AuthToken ? constants.meetingId : roomName;
    const APIClient2 = getAPIClient();
    const { roomNodeUrl, meetingTitle } = await APIClient2.getRoomNodeData(socketRoomName);
    const roomNodeClient = await RoomNodeClient.init({
      roomName: socketRoomName,
      authToken,
      peerId,
      roomNodeUrl,
      meetingTitle
    }, localMediaHandler);
    return roomNodeClient;
  }
  async joinRoom() {
    return this.selfController.joinRoom();
  }
  async leaveRoom(state = "left") {
    document.removeAllListeners("visibilitychange");
    return this.selfController.leaveRoom(state);
  }
}, _socketService2 = new WeakMap(), _i);
let Controller = _Controller;
__decorateClass([
  DyteTelemetry.trace("joinRoom.Controller")
], Controller.prototype, "joinRoom", 1);
__decorateClass([
  DyteTelemetry.trace("Controller.leaveRoom")
], Controller.prototype, "leaveRoom", 1);
__decorateClass([
  DyteTelemetry.trace("createSocketService")
], Controller, "createSocketService", 1);
__decorateClass([
  DyteTelemetry.trace("createRoomNodeClient")
], Controller, "createRoomNodeClient", 1);
const _DyteClient = class {
  constructor(controller) {
    __privateAdd(this, _controller, void 0);
    __privateSet(this, _controller, controller);
  }
  static async init(options) {
    if (typeof window !== "undefined") {
      window.addEventListener("error", (event) => {
        var _a3;
        if (!((_a3 = event.filename) == null ? void 0 : _a3.includes("localhost")) && event.lineno !== 0) {
          DyteTelemetry.addEventInCurrentSpan("error", "window::error", {
            error: event.error
          }, true);
        }
      });
      window.addEventListener("unhandledrejection", (error) => {
        DyteTelemetry.addEventInCurrentSpan("error", "window::unhandledrejection", {
          reason: error.reason
        }, true);
      });
    }
    setIsV2AuthToken(options.authToken, options.roomName);
    const controller = await Controller.init(options);
    return new _DyteClient(controller);
  }
  async joinRoom() {
    return __privateGet(this, _controller).joinRoom();
  }
  async leaveRoom(state) {
    return __privateGet(this, _controller).leaveRoom(state);
  }
  get participants() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).participantController) == null ? void 0 : _a3.participants;
  }
  get self() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).selfController) == null ? void 0 : _a3.self;
  }
  get meta() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).metaController) == null ? void 0 : _a3.meta;
  }
  get plugins() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).pluginController) == null ? void 0 : _a3.plugins;
  }
  get chat() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).chatController) == null ? void 0 : _a3.chat;
  }
  get polls() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).pollController) == null ? void 0 : _a3.polls;
  }
  get remote() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).remoteController) == null ? void 0 : _a3.remote;
  }
  get connectedMeetings() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).connectedMeetingsController) == null ? void 0 : _a3.connectedMeetings;
  }
  get recording() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).recordingController) == null ? void 0 : _a3.recording;
  }
  get spotlight() {
    var _a3;
    return (_a3 = __privateGet(this, _controller).spotlightController) == null ? void 0 : _a3.spotlight;
  }
};
let DyteClient = _DyteClient;
_controller = new WeakMap();
export { DyteClient as default };
